import * as Types from '@seaber/common/graphql/types';
export * from '@seaber/common/graphql/types';
import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const ApiOrder_AdminFragmentDoc = gql`
    fragment ApiOrder_Admin on ApiOrder {
  orderId
  externalOrderId
  externalGroupingId
  chartererOrgName
  freightAmount
  freightUnit
  currency
  voyageCharterExternalId
  externalCoaId
  orderName
  cargoAmount
  cargoUnit
  marginUnit
  assortmentName
  earliestLoading
  latestLoading
  earliestDischarging
  latestDischarging
  loadPortName
  loadingRate
  loadingUnit
  dischargePortName
  dischargingRate
  dischargingUnit
  nominatedVessel
}
    `;
export const ApiShip_AdminFragmentDoc = gql`
    fragment ApiShip_Admin on ApiShip {
  shipId
  shipName
  externalId
  imo
  speed
  consumption
  type
  tag
  area
  gradeName
}
    `;
export const AssortmentExclusion_AdminFragmentDoc = gql`
    fragment AssortmentExclusion_Admin on AssortmentExclusion {
  id
  nextAssortmentGroup
  assortmentGroupByNextAssortmentGroup {
    id
    name
  }
  previousAssortmentGroup
  assortmentGroupByPreviousAssortmentGroup {
    id
    name
  }
  nextAssortment
  assortmentByNextAssortment {
    id
    name
  }
  previousAssortment
  assortmentByPreviousAssortment {
    id
    name
  }
  voyages
  tanks
}
    `;
export const AssortmentGroup_AdminFragmentDoc = gql`
    fragment AssortmentGroup_Admin on AssortmentGroup {
  id
  name
  requiresHeating
}
    `;
export const Assortment_AdminFragmentDoc = gql`
    fragment Assortment_Admin on Assortment {
  id
  name
  assortmentGroup
  requiresHeating
  organizationId
  stowageFactorMin
  stowageFactorMax
  specificGravity
  cargoType
  marginAmount
  marginUnit
  imoClass
  cargoUnitId
  cargoUnitByCargoUnitId {
    id
    name
  }
  loadingRate
  dischargingRate
  loadingUnit
  dischargingUnit
  assortmentGroupByAssortmentGroup {
    id
    name
    externalId
  }
  nameSynonyms
}
    `;
export const BunkerGradeOverride_AdminFragmentDoc = gql`
    fragment BunkerGradeOverride_Admin on BunkerGradeOverride {
  id
  organizationByOrganizationId {
    id
    name
  }
  gradeName
  carbonFactor
  ch4Factor
  lcv
  n2OFactor
  referenceGrade
  referencePort
  currency
  price
  priceAdjustment
  createdAt
  wttFactor
}
    `;
export const ChannelCostEstimate_AdminFragmentDoc = gql`
    fragment ChannelCostEstimate_Admin on ChannelCostEstimate {
  id
  channelName
  channelCostCurrency
  channelCost
  durationOverhead
  vesselId
  shipByVesselId {
    id
    name
  }
  vesselTypeId
  vesselAttributeByVesselTypeId {
    id
    name
  }
}
    `;
export const NoGoZone_AdminFragmentDoc = gql`
    fragment NoGoZone_Admin on NoGoZone {
  id
  name
  polygon {
    lat
    lng
  }
}
    `;
export const OrderAttribute_AdminFragmentDoc = gql`
    fragment OrderAttribute_Admin on OrderAttribute {
  id
  name
  description
  organizationId
  organizationByOrganizationId {
    id
    name
  }
}
    `;
export const Organization_AdminFragmentDoc = gql`
    fragment Organization_Admin on Organization {
  id
  name
  email
  charterer
  shipOwner
  portAgent
  parentOrganizationId
  organizationByParentOrganizationId {
    id
    name
  }
  receiver
  sender
  draft
  defaultCurrency
  configEventsConcurrentDefault
  configPortcallDurationBerthapiDefault
  configEnableAcceptAllUpdates
  configEnableDefaultLaycan
  configAutoAcceptUpdates
  configAutoAcceptOnlyConfirmed
  configCargoAllocationCombineAssortment
  configEnableScenarioAutoSave
  configAutoSyncUserScenarios
  configReducedUnits
  configUseMasterPorts
  configIntegrationManageOrders
  configIgnoreIntegrationCargoMargins
  configAutoUpdatePortTimezone
  configUseCalculatedLimit
  configDisablePcUpdates
  euEtsCosts
  configIntegrationHistoricalPortCalls
  configIntegrationMergeShipments
  configEnableWorldscaleFreights
  configIncludeFuelEuInCosts
  organizationAreaBunkerGradeMappingsByOrganizationId {
    nodes {
      bunkerGradeId
      vesselArea
    }
  }
  bunkerGradeMappingsByOrganizationId {
    nodes {
      id
      fromGradeId
      toGradeId
    }
  }
  portCostPriority
  broker
}
    `;
export const OrganizationFeature_AdminFragmentDoc = gql`
    fragment OrganizationFeature_Admin on OrganizationFeature {
  id
  isEnabled
  featureName
  organizationId
  organizationByOrganizationId {
    id
    name
  }
}
    `;
export const PortCommodityLdRates_AdminFragmentDoc = gql`
    fragment PortCommodityLdRates_Admin on PortCommodityLdRate {
  id
  loadingRate
  loadingUnit
  dischargeRate
  dischargeUnit
  zoneId
  zoneByZoneId {
    id
    name
  }
  portId
  locationByPortId {
    id
    name
  }
  assortmentId
  assortmentByAssortmentId {
    id
    name
  }
  assortmentGroupId
  assortmentGroupByAssortmentGroupId {
    id
    name
  }
}
    `;
export const PortCostDefault_FieldsFragmentDoc = gql`
    fragment PortCostDefault_fields on PortCostDefault {
  id
  cost
  currency
  locationId
  vesselId
  vesselTypeId
  vesselAttributeByVesselTypeId {
    id
    name
    isVesselClass
  }
}
    `;
export const PortCostDefaults_AdminFragmentDoc = gql`
    fragment PortCostDefaults_Admin on PortCostDefault {
  id
  locationByLocationId {
    id
    name
    country
  }
  shipByVesselId {
    id
    name
    primaryAttributeId
  }
  ...PortCostDefault_fields
}
    ${PortCostDefault_FieldsFragmentDoc}`;
export const PortCostEstimatesExternal_AdminFragmentDoc = gql`
    fragment PortCostEstimatesExternal_Admin on PortCostEstimatesExternal {
  id
  organizationId
  vesselName
  vesselCode
  portName
  portType
  assortment
  portCost
  portCostCurrency
  commencedDate
  completedDate
  deprecated
}
    `;
export const PortSpecialRequirement_AdminFragmentDoc = gql`
    fragment PortSpecialRequirement_Admin on LocationRequirementAssociation {
  id
  specialRequirementId
  locationId
  locationByLocationId {
    id
    name
  }
  specialRequirementBySpecialRequirementId {
    id
    name
  }
  zoneId
  zoneByZoneId {
    id
    name
  }
}
    `;
export const Port_AdminFragmentDoc = gql`
    fragment Port_Admin on Location {
  id
  name
  nameSynonyms
  country
  locode
  latitude
  longitude
  timezone
  countryId
  parentLocationId
  airDraft
  lengthOverall
  beam
  draft
  organisationId
  type
  extraPortDays
  workingHours {
    workhours {
      fromHours
      fromMinutes
      toHours
      toMinutes
    }
  }
  externalId
  extIdArray
  zoneLocationsByLocationId {
    nodes {
      id
      zoneId
      locationId
    }
  }
  maxDwt
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  english
  alpha2
  alpha3
}
    `;
export const Region_AdminFragmentDoc = gql`
    fragment Region_Admin on Region {
  id
  name
  polygon {
    lat
    lng
  }
}
    `;
export const RouteOverride_AdminFragmentDoc = gql`
    fragment RouteOverride_Admin on RouteOverride {
  id
  fromId
  toId
  distance
  avoidsChannels
  locationByFromId {
    id
    name
  }
  locationByToId {
    id
    name
  }
}
    `;
export const SpecialRequirement_AdminFragmentDoc = gql`
    fragment SpecialRequirement_Admin on SpecialRequirement {
  id
  name
  organizationId
  organizationByOrganizationId {
    id
    name
  }
  locationRequirementAssociationsBySpecialRequirementId {
    nodes {
      locationId
      zoneByZoneId {
        zoneLocationsByZoneId {
          nodes {
            locationId
          }
        }
      }
    }
  }
  vesselFulfillsRequirementAssociationsBySpecialRequirementId {
    nodes {
      vesselId
      vesselAttributeByVesselAttributeId {
        id
        vesselAttributesAssociationsByVesselAttributeId {
          nodes {
            shipId
          }
        }
        shipsByPrimaryAttributeId {
          nodes {
            id
          }
        }
      }
    }
  }
}
    `;
export const SupplyContract_AdminFragmentDoc = gql`
    fragment SupplyContract_Admin on SupplyContract {
  id
  supplyContract
  supplier
  batchCode
  year
  batchSeq
  senderOrganizationId
  organizationBySenderOrganizationId {
    id
    name
  }
}
    `;
export const UserRight_AdminFragmentDoc = gql`
    fragment UserRight_Admin on UserRight {
  id
  organizationId
  userId
  orgAdmin
  createAndEditOrders
  createAndEditVoyages
  createAndEditContracts
  accessFinancialData
  createAndEditPortCalls
  accessCargoMeasurement
  createAndEditCargoMeasurement
  accessBillOfLading
  createAndEditBillOfLading
}
    `;
export const User_AdminFragmentDoc = gql`
    fragment User_Admin on User {
  id
  name
  email
  initials
  insertedAt
  updatedAt
  userType
  isActivated
  isVerified
  organizationId
  organizationByOrganizationId {
    id
    name
  }
  userRightsByUserId {
    nodes {
      id
      ...UserRight_Admin
    }
  }
}
    ${UserRight_AdminFragmentDoc}`;
export const VesselAttributeAssortmentExclusion_AdminFragmentDoc = gql`
    fragment VesselAttributeAssortmentExclusion_Admin on VesselAttributeAssortmentExclusion {
  id
  assortmentGroupId
  assortmentGroupByAssortmentGroupId {
    id
    name
  }
  assortmentId
  assortmentByAssortmentId {
    id
    name
  }
  vesselAttributeId
  vesselAttributeByVesselAttributeId {
    id
    name
  }
}
    `;
export const VesselAttribute_AdminFragmentDoc = gql`
    fragment VesselAttribute_Admin on VesselAttribute {
  id
  name
  isVesselClass
  description
}
    `;
export const VesselFulfillsRequirementAssociation_AdminFragmentDoc = gql`
    fragment VesselFulfillsRequirementAssociation_Admin on VesselFulfillsRequirementAssociation {
  id
  specialRequirementId
  specialRequirementBySpecialRequirementId {
    id
    name
  }
  vesselId
  shipByVesselId {
    id
    name
  }
  vesselAttributeId
  vesselAttributeByVesselAttributeId {
    id
    name
    isVesselClass
  }
}
    `;
export const CargoCompartment_AdminFragmentDoc = gql`
    fragment CargoCompartment_Admin on CargoCompartment {
  id
  name
  maxVolume
  volumeUnit
  type
}
    `;
export const VesselInfo_AdminFragmentDoc = gql`
    fragment VesselInfo_Admin on VesselInfo {
  id
  imo
  mmsi
  ownerOrganisationId
  year
  flag
  callSign
  heating
  loa
  breadth
  draft
  cranes
  loadingRate
  dischargingRate
  loadingUnit
  dischargingUnit
  cargoCompartmentsByVesselId {
    nodes {
      id
      ...CargoCompartment_Admin
    }
  }
}
    ${CargoCompartment_AdminFragmentDoc}`;
export const VesselScheduleSharedToOrganization_AdminFragmentDoc = gql`
    fragment VesselScheduleSharedToOrganization_Admin on VesselScheduleSharedToOrganization {
  id
  vesselId
  organizationId
  createdAt
  updatedAt
}
    `;
export const VesselSpeedConsumption_AdminFragmentDoc = gql`
    fragment VesselSpeedConsumption_Admin on VesselSpeedConsumption {
  id
  bunkerGradeId
  tag
  type
  consumption
  speed
  area
  shipId
  bunkerGradeOverrideByBunkerGradeId {
    id
  }
}
    `;
export const VesselDraftDatapoint_AdminFragmentDoc = gql`
    fragment VesselDraftDatapoint_Admin on VesselDraftDatapoint {
  id
  cargoLoad
  draft
}
    `;
export const VoyageNamingRule_AdminFragmentDoc = gql`
    fragment VoyageNamingRule_Admin on VoyageNamingRule {
  id
  rule
  vesselFullname
  vesselImo
  vesselShortname
  year
  zerosPad
  organizationId
}
    `;
export const Ship_AdminFragmentDoc = gql`
    fragment Ship_Admin on Ship {
  id
  name
  shortName
  imo
  inactive
  organizationId
  vesselInfoId
  weightCapacity
  weightCapacityType
  massCapacity
  massUnit
  volumeCapacity
  volumeUnit
  tcRate
  loadingRate
  loadingUnit
  dischargingRate
  dischargingUnit
  year
  airDraft
  netTonnage
  grossTonnage
  flag
  href
  callSign
  draft
  loa
  breadth
  mmsi
  externalFleet
  sortId
  vesselInfoByVesselInfoId {
    id
    imo
  }
  vesselFulfillsRequirementAssociationsByVesselId {
    nodes {
      id
      vesselId
      specialRequirementId
    }
  }
  vesselAttributesAssociationsByShipId {
    nodes {
      id
      vesselAttributeId
      vesselAttributeByVesselAttributeId {
        id
        isVesselClass
        vesselFulfillsRequirementAssociationsByVesselAttributeId {
          nodes {
            id
            specialRequirementId
          }
        }
      }
    }
  }
  vesselSpeedConsumptionsByShipId {
    nodes {
      id
      ...VesselSpeedConsumption_Admin
    }
  }
  vesselDraftDatapointsByShipId {
    nodes {
      id
      ...VesselDraftDatapoint_Admin
    }
  }
  cargoCompartmentsByShipId {
    nodes {
      id
      ...CargoCompartment_Admin
    }
  }
  organizationByOrganizationId {
    id
    name
  }
  primaryAttributeId
  vesselAttributeByPrimaryAttributeId {
    id
    name
    vesselFulfillsRequirementAssociationsByVesselAttributeId {
      nodes {
        id
        specialRequirementId
      }
    }
  }
  shipVoyageNamingRuleRelationsByShipId {
    nodes {
      id
      voyageNamingRuleByRuleId {
        id
        ...VoyageNamingRule_Admin
      }
    }
  }
}
    ${VesselSpeedConsumption_AdminFragmentDoc}
${VesselDraftDatapoint_AdminFragmentDoc}
${CargoCompartment_AdminFragmentDoc}
${VoyageNamingRule_AdminFragmentDoc}`;
export const VoyageAttribute_AdminFragmentDoc = gql`
    fragment VoyageAttribute_Admin on VoyageAttribute {
  id
  name
  color
  isActive
  description
}
    `;
export const WorldscaleFreight_AdminFragmentDoc = gql`
    fragment WorldscaleFreight_Admin on WorldscaleFreight {
  id
  organizationId
  route
  locationByFromLocationId {
    id
    name
    country
  }
  locationByToLocationId {
    id
    name
    country
  }
  rate
  currency
  year
  createdAt
  updatedAt
}
    `;
export const ZonesAdmin_ZoneLocationFragmentDoc = gql`
    fragment ZonesAdmin_ZoneLocation on ZoneLocation {
  id
  locationId
  zoneId
  locationByLocationId {
    id
    name
  }
}
    `;
export const ZonesAdmin_ZoneFragmentDoc = gql`
    fragment ZonesAdmin_Zone on Zone {
  id
  name
  zoneLocationsByZoneId {
    nodes {
      ...ZonesAdmin_ZoneLocation
    }
  }
}
    ${ZonesAdmin_ZoneLocationFragmentDoc}`;
export const VesselFulfillsRequirementAssociationFragmentDoc = gql`
    fragment VesselFulfillsRequirementAssociation on VesselFulfillsRequirementAssociation {
  id
  specialRequirementId
}
    `;
export const CarbonPriceOverride_AdminFragmentDoc = gql`
    fragment CarbonPriceOverride_Admin on CarbonPriceOverride {
  id
  price
  organizationId
  organizationByOrganizationId {
    id
    name
  }
  updatedAt
}
    `;
export const InvoiceFormItemOrderFragmentDoc = gql`
    fragment InvoiceFormItemOrder on InvoiceItemOrder {
  __typename
  id
  orderId
  invoiceItemId
}
    `;
export const InvoiceFormItemFragmentDoc = gql`
    fragment InvoiceFormItem on InvoiceItem {
  __typename
  id
  amount
  costType
  note
  portCallId
  invoiceId
  invoiceItemOrdersByInvoiceItemId {
    nodes {
      id
      ...InvoiceFormItemOrder
    }
  }
}
    ${InvoiceFormItemOrderFragmentDoc}`;
export const InvoiceFormFragmentDoc = gql`
    fragment InvoiceForm on Invoice {
  __typename
  id
  currency
  dueDate
  invoiceNumber
  voyageCharterId
  payingOrganizationId
  invoiceItemsByInvoiceId {
    nodes {
      id
      ...InvoiceFormItem
    }
  }
}
    ${InvoiceFormItemFragmentDoc}`;
export const InvoiceOrderInfoFragmentDoc = gql`
    fragment InvoiceOrderInfo on Order {
  __typename
  id
  assortmentByAssortmentId {
    __typename
    id
    name
  }
  orderDetailsByOrderId {
    nodes {
      __typename
      id
      orderName
    }
  }
  orderPortCallRelationsByOrderId {
    nodes {
      __typename
      id
      isLoadPort
      portCallByPortCallId {
        __typename
        id
        locationId
        locationByLocationId {
          __typename
          id
          name
        }
      }
    }
  }
}
    `;
export const InvoiceOrdersFragmentDoc = gql`
    fragment InvoiceOrders on VoyageCharter {
  id
  orderVoyageCharterRelationsByVoyageCharterId(condition: {outgoing: true}) {
    nodes {
      __typename
      id
      coaRouteId
      orderByOrderId {
        id
        ...InvoiceOrderInfo
      }
    }
  }
}
    ${InvoiceOrderInfoFragmentDoc}`;
export const Baf_CoaBunkerFragmentDoc = gql`
    fragment Baf_CoaBunker on CoaContractBunker {
  id
  bafBunkerAmount
  bafStartFromBase
  bafStepEffect
  bafStepSize
  bafType
  bafUseStepEffectAsValue
  basePriceMax
  bunkerGrade
  coaAssortmentId
  coaRouteId
  price
}
    `;
export const Baf_CoaFragmentDoc = gql`
    fragment Baf_Coa on CoaContract {
  id
  currency
  chartererOrgId
  shipownerOrgId
  cargoUnitByAmountUnitId {
    id
    name
  }
  coaContractBunkersByCoaContractId {
    nodes {
      id
      ...Baf_CoaBunker
    }
  }
  coaContractAssortmentsByCoaContractId {
    nodes {
      id
      assortmentId
      assortmentGroupId
      minAmount
      maxAmount
      paymentUnit
    }
  }
  coaContractPortsByCoaContractId {
    nodes {
      id
      destinationId
      destinationZoneId
      originId
      originZoneId
      zoneByDestinationZoneId {
        id
        name
        zoneLocationsByZoneId {
          nodes {
            id
            zoneId
            locationId
          }
        }
      }
      zoneByOriginZoneId {
        id
        name
        zoneLocationsByZoneId {
          nodes {
            id
            zoneId
            locationId
          }
        }
      }
    }
  }
  coaContractPricesByCoaContractId {
    nodes {
      id
      price
      coaAssortmentId
      routeId
    }
  }
}
    ${Baf_CoaBunkerFragmentDoc}`;
export const Baf_VoyageCharterFragmentDoc = gql`
    fragment Baf_VoyageCharter on VoyageCharter {
  id
  voyageCharterToContractsByVoyageCharterId {
    nodes {
      id
      coaContractByCoaId {
        id
        ...Baf_Coa
      }
    }
  }
}
    ${Baf_CoaFragmentDoc}`;
export const Commission_CommissionFragmentDoc = gql`
    fragment Commission_Commission on Commission {
  id
  assortmentId
  bafApplied
  dischargePortId
  extraFreightApplied
  loadPortId
  type
  value
  organizationByOrganizationId {
    id
    name
  }
}
    `;
export const Commission_VoyageCharterFragmentDoc = gql`
    fragment Commission_VoyageCharter on VoyageCharter {
  id
  currency
  commissionsByVoyageCharterId {
    nodes {
      id
      ...Commission_Commission
    }
  }
}
    ${Commission_CommissionFragmentDoc}`;
export const VoyageIncome_CoaFragmentDoc = gql`
    fragment VoyageIncome_Coa on CoaContract {
  id
  currency
  shipownerOrgId
  cargoUnitByAmountUnitId {
    id
    name
  }
  coaContractPricesByCoaContractId {
    nodes {
      id
      coaAssortmentId
      price
      coaContractPortByRouteId {
        id
        originId
        originZoneId
        destinationId
        destinationZoneId
      }
    }
  }
  coaContractAssortmentsByCoaContractId {
    nodes {
      id
      assortmentId
      assortmentGroupId
      paymentUnit
      minAmount
      maxAmount
    }
  }
}
    `;
export const VoyageIncome_VoyageCharterToContractFragmentDoc = gql`
    fragment VoyageIncome_VoyageCharterToContract on VoyageCharterToContract {
  id
  coaId
  coaContractByCoaId {
    ...VoyageIncome_Coa
  }
}
    ${VoyageIncome_CoaFragmentDoc}`;
export const VoyageIncome_VoyageCharterExtraFreightFragmentDoc = gql`
    fragment VoyageIncome_VoyageCharterExtraFreight on VoyageCharterExtraFreight {
  id
  amount
  name
  type
  description
  ignoreInPnl
}
    `;
export const VoyageIncome_VoyageCharterFragmentDoc = gql`
    fragment VoyageIncome_VoyageCharter on VoyageCharter {
  ...Baf_VoyageCharter
  ...Commission_VoyageCharter
  id
  currency
  shipownerOrgId
  organizationByChartererOrgId {
    id
    name
  }
  voyageCharterToContractsByVoyageCharterId {
    nodes {
      id
      ...VoyageIncome_VoyageCharterToContract
    }
  }
  voyageCharterExtraFreightsByVoyageCharterId {
    nodes {
      id
      ...VoyageIncome_VoyageCharterExtraFreight
    }
  }
  lumpsum
}
    ${Baf_VoyageCharterFragmentDoc}
${Commission_VoyageCharterFragmentDoc}
${VoyageIncome_VoyageCharterToContractFragmentDoc}
${VoyageIncome_VoyageCharterExtraFreightFragmentDoc}`;
export const VoyageCosts_VoyageCharterExtraCostFragmentDoc = gql`
    fragment VoyageCosts_VoyageCharterExtraCost on VoyageCharterExtraCost {
  id
  amount
  description
  name
  type
}
    `;
export const VoyageCosts_VoyageCharterFragmentDoc = gql`
    fragment VoyageCosts_VoyageCharter on VoyageCharter {
  id
  currency
  voyageCharterExtraCostsByVoyageCharterId {
    nodes {
      id
      ...VoyageCosts_VoyageCharterExtraCost
    }
  }
}
    ${VoyageCosts_VoyageCharterExtraCostFragmentDoc}`;
export const VoyageIncomeQuery_VoyageCharterFragmentDoc = gql`
    fragment VoyageIncomeQuery_VoyageCharter on VoyageCharter {
  ...VoyageIncome_VoyageCharter
  ...VoyageCosts_VoyageCharter
}
    ${VoyageIncome_VoyageCharterFragmentDoc}
${VoyageCosts_VoyageCharterFragmentDoc}`;
export const ScenarioTimeline_VoyageCharterToContractFragmentDoc = gql`
    fragment ScenarioTimeline_VoyageCharterToContract on VoyageCharterToContract {
  id
  coaId
  voyageCharterId
}
    `;
export const ScenarioTimeline_VoyageCharterFragmentDoc = gql`
    fragment ScenarioTimeline_VoyageCharter on VoyageCharter {
  id
  isInquiry
  isPreliminary
  onSubsUntil
  ...VoyageIncomeQuery_VoyageCharter
  voyageCharterToContractsByVoyageCharterId {
    nodes {
      id
      ...ScenarioTimeline_VoyageCharterToContract
    }
  }
  voyageCharterPortDataByVoyageCharterId {
    nodes {
      id
      portDatumByPortDataId {
        id
        portId
        loadingRate
        dischargeRate
        loadingDischargeUnit
        laytimeDays {
          ho
          incExUu
          sa
          su
        }
      }
    }
  }
}
    ${VoyageIncomeQuery_VoyageCharterFragmentDoc}
${ScenarioTimeline_VoyageCharterToContractFragmentDoc}`;
export const ScenarioTimeline_OrderVoyageCharterRelationFragmentDoc = gql`
    fragment ScenarioTimeline_OrderVoyageCharterRelation on OrderVoyageCharterRelation {
  id
  orderId
  voyageCharterId
  outgoing
  coaRouteId
  voyageCharterByVoyageCharterId {
    id
    externalId
    currency
    ...ScenarioTimeline_VoyageCharter
  }
}
    ${ScenarioTimeline_VoyageCharterFragmentDoc}`;
export const ArchivePage_OrderFragmentDoc = gql`
    fragment ArchivePage_Order on Order {
  id
  coaId
  cancelling
  cargoAmount
  deliveredBefore
  layday
  rta
  nominatedVessel
  externalOrderId
  assortment: assortmentByAssortmentId {
    id
    name
  }
  cargoUnit: cargoUnitByCargoUnitId {
    id
    name
  }
  loadPort: locationByLoadPortId {
    id
    name
    timezone
  }
  dischargePort: locationByDischargePortId {
    id
    name
    timezone
  }
  organizationByChartererOrganizationId {
    id
    name
  }
  incomingVoyageCharterRelation {
    id
    ...ScenarioTimeline_OrderVoyageCharterRelation
    voyageCharterByVoyageCharterId {
      id
      externalId
      currency
      ...ScenarioTimeline_VoyageCharter
    }
    voyageCharterOrderFreightsByOrderVoyageCharterRelationId {
      nodes {
        id
        freightAmount
        freightUnit
      }
    }
  }
  orderDetails: orderDetailsByOrderId {
    nodes {
      id
      closingDate
      senderOrganisationId
      sender: organizationBySenderOrganisationId {
        id
        name
      }
      receiver: organizationByReceiverOrganisationId {
        id
        name
      }
      supplyContractId
      consignee
      orderName
      fixtureNote
      extraInfo
      imoClass
      incoTerms
      externalRemarks
    }
  }
  createdAt
  userByUserId {
    id
    name
  }
}
    ${ScenarioTimeline_OrderVoyageCharterRelationFragmentDoc}
${ScenarioTimeline_VoyageCharterFragmentDoc}`;
export const ArchivePage_QueryFragmentDoc = gql`
    fragment ArchivePage_Query on Query {
  allOrders(filter: {softDelete: {equalTo: true}}) {
    nodes {
      id
      ...ArchivePage_Order
    }
  }
}
    ${ArchivePage_OrderFragmentDoc}`;
export const ReportingTable_CargoUnitFragmentDoc = gql`
    fragment ReportingTable_CargoUnit on CargoUnit {
  id
  name
}
    `;
export const ReportingTable_AssortmentFragmentDoc = gql`
    fragment ReportingTable_Assortment on Assortment {
  id
  name
}
    `;
export const ReportingTable_LocationFragmentDoc = gql`
    fragment ReportingTable_Location on Location {
  id
  name
  timezone
}
    `;
export const ReportingTable_OrganizationFragmentDoc = gql`
    fragment ReportingTable_Organization on Organization {
  id
  name
}
    `;
export const ReportingTable_OrderDetailsFragmentDoc = gql`
    fragment ReportingTable_OrderDetails on OrderDetail {
  id
  orderName
  extraInfo
  receiverOrg: organizationByReceiverOrganisationId {
    id
    ...ReportingTable_Organization
  }
  senderOrg: organizationBySenderOrganisationId {
    id
    ...ReportingTable_Organization
  }
}
    ${ReportingTable_OrganizationFragmentDoc}`;
export const ReportingTable_BillOfLadingDatumFragmentDoc = gql`
    fragment ReportingTable_BillOfLadingDatum on BillOfLadingDatum {
  id
  volume
  volumeOnDeck
  volumeUnit
  weight
  weightOnDeck
  weightUnit
}
    `;
export const ReportingTable_CargoMeasurementFragmentDoc = gql`
    fragment ReportingTable_CargoMeasurement on CargoMeasurement {
  id
  measuredVolume
  measuredWeight
  volumeUnit
  weightUnit
}
    `;
export const ReportingTable_VesselFragmentDoc = gql`
    fragment ReportingTable_Vessel on Ship {
  id
  name
  imo
  ownerOrg: organizationByOrganizationId {
    id
    ...ReportingTable_Organization
  }
}
    ${ReportingTable_OrganizationFragmentDoc}`;
export const ReportingTable_HandledBySpotFragmentDoc = gql`
    fragment ReportingTable_HandledBySpot on HandledBySpot {
  id
  shared
  vessel: shipByVesselId {
    id
    ...ReportingTable_Vessel
  }
}
    ${ReportingTable_VesselFragmentDoc}`;
export const ReportingTable_HandledByCoaFragmentDoc = gql`
    fragment ReportingTable_HandledByCoa on HandledByCoa {
  id
  shared
  vessel: shipByVesselId {
    id
    ...ReportingTable_Vessel
  }
}
    ${ReportingTable_VesselFragmentDoc}`;
export const ReportingTable_ScheduledOrderFragmentDoc = gql`
    fragment ReportingTable_ScheduledOrder on ScheduledOrder {
  id
  shared
  vessel: shipByVesselId {
    id
    ...ReportingTable_Vessel
  }
}
    ${ReportingTable_VesselFragmentDoc}`;
export const ScenarioTimeline_PortCallFieldsFragmentDoc = gql`
    fragment ScenarioTimeline_PortCallFields on PortCall {
  id
  clientId
  vesselId
  seaDurationOverride
  plannedArrival
  plannedBerthing
  plannedDeparture
  plannedArrivalOverride
  plannedArrivalOverrideSourcedAt
  plannedArrivalOverrideSourcedFrom
  plannedBerthingOverride
  plannedBerthingOverrideSourcedAt
  plannedBerthingOverrideSourcedFrom
  plannedDepartureOverride
  plannedDepartureOverrideSourcedAt
  plannedDepartureOverrideSourcedFrom
  plannedArrivalDuration
  plannedBerthingDuration
  plannedDepartureDuration
  totalLoadDurationOverride
  totalDischargeDurationOverride
  legAvoidsChannels
  updatedAt
  archived
  locationId
  previousLocationId
  oneTimeOverrideChannelCost
  channelCostDefaultId
  oneTimeOverrideCost
  useHistoricalPortCost
  useOneTimeOverrideCost
  useIntegrationPortCost
  portCostDefaultId
  channelDurationOverhead
  bunkerOverrides
  weatherFactor
}
    `;
export const ScenarioTimeline_OrderLocationFragmentDoc = gql`
    fragment ScenarioTimeline_OrderLocation on Location {
  id
  name
  locode
  timezone
  countryId
  country
  countryByCountryId {
    id
    alpha2
  }
  draft
  latitude
  longitude
  extraPortDays
  workingHours {
    workhours {
      fromHours
      fromMinutes
      toHours
      toMinutes
    }
  }
  rootOrg
  nameSynonyms
  parentLocationId
  zoneLocationsByLocationId {
    nodes {
      id
      zoneId
      locationId
    }
  }
  externalId
  maxDwt
}
    `;
export const ScenarioTimeline_PortNoticeFragmentDoc = gql`
    fragment ScenarioTimeline_PortNotice on PortNotice {
  id
  portCallId
  eta
  berthingProspects
  etdBerth
  ataBerth
  ataPbp
  norTendered
}
    `;
export const SofForm__PortActivityFragmentDoc = gql`
    fragment SOFForm__PortActivity on PortActivity {
  id
  start
  end
  operation
}
    `;
export const ScenarioTimeline_StatementOfFactFragmentDoc = gql`
    fragment ScenarioTimeline_StatementOfFact on StatementOfFact {
  id
  portCallId
  arrivalTime
  pilotOnboard
  berthed
  noticeOfReadiness
  loadingCommenced
  loadingCompleted
  sailingTime
  portActivitiesByStatementOfFactsId {
    nodes {
      id
      ...SOFForm__PortActivity
    }
  }
}
    ${SofForm__PortActivityFragmentDoc}`;
export const ScenarioTimeline_PortCallFragmentDoc = gql`
    fragment ScenarioTimeline_PortCall on PortCall {
  id
  ...ScenarioTimeline_PortCallFields
  locationByLocationId {
    id
    ...ScenarioTimeline_OrderLocation
  }
  portNoticesByPortCallId {
    nodes {
      id
      ...ScenarioTimeline_PortNotice
    }
  }
  statementOfFactsByPortCallId {
    nodes {
      id
      ...ScenarioTimeline_StatementOfFact
    }
  }
}
    ${ScenarioTimeline_PortCallFieldsFragmentDoc}
${ScenarioTimeline_OrderLocationFragmentDoc}
${ScenarioTimeline_PortNoticeFragmentDoc}
${ScenarioTimeline_StatementOfFactFragmentDoc}`;
export const ReportingTable_SofFragmentDoc = gql`
    fragment ReportingTable_SOF on StatementOfFact {
  id
  sailingTime
  arrivalTime
}
    `;
export const ReportingTable_PortNoticeFragmentDoc = gql`
    fragment ReportingTable_PortNotice on PortNotice {
  id
  eta
  etdBerth
  ataPbp
}
    `;
export const ReportingTable_PortCallFragmentDoc = gql`
    fragment ReportingTable_PortCall on PortCall {
  ...ScenarioTimeline_PortCall
  id
  statementOfFactsByPortCallId {
    nodes {
      id
      ...ReportingTable_SOF
    }
  }
  portNoticesByPortCallId {
    nodes {
      id
      ...ReportingTable_PortNotice
    }
  }
}
    ${ScenarioTimeline_PortCallFragmentDoc}
${ReportingTable_SofFragmentDoc}
${ReportingTable_PortNoticeFragmentDoc}`;
export const ReportingTable_OrderFragmentDoc = gql`
    fragment ReportingTable_Order on Order {
  id
  layday
  cancelling
  rta
  deliveredBefore
  started
  completed
  archived
  shipmentId
  shipmentByShipmentId {
    id
    name
  }
  cargoAmount
  relatedOrgs
  cargoUnit: cargoUnitByCargoUnitId {
    id
    ...ReportingTable_CargoUnit
  }
  assortment: assortmentByAssortmentId {
    id
    ...ReportingTable_Assortment
  }
  loadPortId
  loadPort: locationByLoadPortId {
    id
    ...ReportingTable_Location
  }
  dischargePortId
  dischargePort: locationByDischargePortId {
    id
    ...ReportingTable_Location
  }
  orderDetails: orderDetailsByOrderId {
    nodes {
      id
      ...ReportingTable_OrderDetails
    }
  }
  billOfLading: billOfLadingDataByOrderId {
    nodes {
      id
      ...ReportingTable_BillOfLadingDatum
    }
  }
  cargoMeasurement: cargoMeasurementsByOrderId {
    nodes {
      id
      ...ReportingTable_CargoMeasurement
    }
  }
  chartererOrg: organizationByChartererOrganizationId {
    id
    ...ReportingTable_Organization
  }
  handledBySpot: handledBySpotByOrderId {
    id
    ...ReportingTable_HandledBySpot
  }
  handledByCoa: handledByCoaByOrderId {
    id
    ...ReportingTable_HandledByCoa
  }
  scheduledOrder: scheduledOrdersByOrderId {
    nodes {
      id
      ...ReportingTable_ScheduledOrder
    }
  }
  portCallRelations: orderPortCallRelationsByOrderId {
    nodes {
      id
      isLoadPort
      portCall: portCallByPortCallId {
        id
        ...ReportingTable_PortCall
      }
    }
  }
  orderAtributeAssociations: orderAttributeAssociationsByOrderId {
    nodes {
      id
      orderAttribute: orderAttributeByOrderAttributeId {
        id
        name
      }
    }
  }
  orderVoyageCharterRelationsByOrderId {
    nodes {
      id
      voyageCharterByVoyageCharterId {
        id
        voyageCharterToContractsByVoyageCharterId {
          nodes {
            coaId
            id
            coaContractByCoaId {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${ReportingTable_CargoUnitFragmentDoc}
${ReportingTable_AssortmentFragmentDoc}
${ReportingTable_LocationFragmentDoc}
${ReportingTable_OrderDetailsFragmentDoc}
${ReportingTable_BillOfLadingDatumFragmentDoc}
${ReportingTable_CargoMeasurementFragmentDoc}
${ReportingTable_OrganizationFragmentDoc}
${ReportingTable_HandledBySpotFragmentDoc}
${ReportingTable_HandledByCoaFragmentDoc}
${ReportingTable_ScheduledOrderFragmentDoc}
${ReportingTable_PortCallFragmentDoc}`;
export const LostContractFragmentDoc = gql`
    fragment LostContract on LostContract {
  id
  remarks
  organizationId
  freightAmount
  freightUnit
  freightCurrency
  createdAt
}
    `;
export const ArchivedAndLostTable_OrderFragmentDoc = gql`
    fragment ArchivedAndLostTable_Order on Order {
  id
  ...ReportingTable_Order
  cargoAmount
  cargoUnitByCargoUnitId {
    id
    name
  }
  marginAmount
  marginUnit
  locationByDischargePortId {
    id
    timezone
  }
  loadPortId
  locationByLoadPortId {
    id
    timezone
  }
  incomingVoyageCharterRelation {
    id
    ...ScenarioTimeline_OrderVoyageCharterRelation
    voyageCharterByVoyageCharterId {
      id
      lostContractByLostContractsId {
        id
        ...LostContract
      }
    }
  }
  handledByCoaByOrderId {
    id
  }
  handledBySpotByOrderId {
    id
  }
}
    ${ReportingTable_OrderFragmentDoc}
${ScenarioTimeline_OrderVoyageCharterRelationFragmentDoc}
${LostContractFragmentDoc}`;
export const Changelog_LocationFragmentDoc = gql`
    fragment Changelog_Location on Location {
  id
  name
  timezone
}
    `;
export const Changelog_ModifiedByUserFragmentDoc = gql`
    fragment Changelog_ModifiedByUser on User {
  id
  name
}
    `;
export const Changelog_PortCallHistoryFragmentDoc = gql`
    fragment Changelog_PortCallHistory on PortCallHistory {
  id
  plannedArrival
  plannedArrivalDuration
  plannedArrivalOverride
  plannedBerthing
  plannedBerthingDuration
  plannedBerthingOverride
  plannedDeparture
  plannedDepartureDuration
  plannedDepartureOverride
  seaDurationOverride
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_PortCallFragmentDoc = gql`
    fragment Changelog_PortCall on PortCall {
  id
  plannedArrival
  plannedArrivalDuration
  plannedArrivalOverride
  plannedBerthing
  plannedBerthingDuration
  plannedBerthingOverride
  plannedDeparture
  plannedDepartureDuration
  plannedDepartureOverride
  seaDurationOverride
  locationByLocationId {
    id
    ...Changelog_Location
  }
  portCallHistoriesById {
    nodes {
      id
      ...Changelog_PortCallHistory
    }
  }
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_LocationFragmentDoc}
${Changelog_PortCallHistoryFragmentDoc}
${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_PortNoticeHistoryFragmentDoc = gql`
    fragment Changelog_PortNoticeHistory on PortNoticeHistory {
  ataBerth
  ataPbp
  berthingProspects
  eta
  etdBerth
  id
  norTendered
  portCallId
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_PortNoticeFragmentDoc = gql`
    fragment Changelog_PortNotice on PortNotice {
  ataBerth
  ataPbp
  berthingProspects
  eta
  etdBerth
  id
  norTendered
  portCallId
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
  portNoticeHistoriesById {
    nodes {
      id
      ...Changelog_PortNoticeHistory
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}
${Changelog_PortNoticeHistoryFragmentDoc}`;
export const Changelog_StatementOfFactsHistoryFragmentDoc = gql`
    fragment Changelog_StatementOfFactsHistory on StatementOfFactsHistory {
  arrivalTime
  berthed
  id
  loadingCommenced
  loadingCompleted
  noticeOfReadiness
  pilotOnboard
  portCallId
  sailingTime
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_StatementOfFactsFragmentDoc = gql`
    fragment Changelog_StatementOfFacts on StatementOfFact {
  arrivalTime
  berthed
  id
  loadingCommenced
  loadingCompleted
  noticeOfReadiness
  pilotOnboard
  portCallId
  sailingTime
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  statementOfFactsHistoriesById {
    nodes {
      id
      ...Changelog_StatementOfFactsHistory
    }
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}
${Changelog_StatementOfFactsHistoryFragmentDoc}`;
export const Changelog_VoyageCharterHistoryFragmentDoc = gql`
    fragment Changelog_VoyageCharterHistory on VoyageCharterHistory {
  id
  vesselId
  shipByVesselId {
    id
    name
  }
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_HandledByCoaFragmentDoc = gql`
    fragment Changelog_HandledByCoa on HandledByCoa {
  id
  shared
  shipByVesselId {
    id
    name
  }
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_HandledByCoaHistoryFragmentDoc = gql`
    fragment Changelog_HandledByCoaHistory on HandledByCoaHistory {
  id
  shared
  shipByVesselId {
    id
    name
  }
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_HandledBySpotFragmentDoc = gql`
    fragment Changelog_HandledBySpot on HandledBySpot {
  id
  shared
  shipByVesselId {
    id
    name
  }
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_HandledBySpotHistoryFragmentDoc = gql`
    fragment Changelog_HandledBySpotHistory on HandledBySpotHistory {
  id
  shared
  shipByVesselId {
    id
    name
  }
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}`;
export const Changelog_VoyageChartersFragmentDoc = gql`
    fragment Changelog_VoyageCharters on VoyageCharter {
  id
  vesselId
  shipByVesselId {
    id
    name
  }
  userByModifiedByUserId {
    id
    ...Changelog_ModifiedByUser
  }
  voyageCharterHistoriesById {
    nodes {
      id
      ...Changelog_VoyageCharterHistory
    }
  }
  orderVoyageCharterRelationsByVoyageCharterId(condition: {outgoing: true}) {
    nodes {
      id
      orderByOrderId {
        id
        handledByCoaByOrderId {
          id
          ...Changelog_HandledByCoa
          handledByCoaHistoriesById {
            nodes {
              id
              ...Changelog_HandledByCoaHistory
            }
          }
        }
        handledBySpotByOrderId {
          id
          ...Changelog_HandledBySpot
          handledBySpotHistoriesById {
            nodes {
              id
              ...Changelog_HandledBySpotHistory
            }
          }
        }
      }
    }
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
}
    ${Changelog_ModifiedByUserFragmentDoc}
${Changelog_VoyageCharterHistoryFragmentDoc}
${Changelog_HandledByCoaFragmentDoc}
${Changelog_HandledByCoaHistoryFragmentDoc}
${Changelog_HandledBySpotFragmentDoc}
${Changelog_HandledBySpotHistoryFragmentDoc}`;
export const CoaForm_CargoUnitFragmentDoc = gql`
    fragment CoaForm_CargoUnit on CargoUnit {
  id
  name
}
    `;
export const CoaForm_ShipownerFragmentDoc = gql`
    fragment CoaForm_Shipowner on Organization {
  id
  name
  shipsByOrganizationId {
    nodes {
      id
      name
    }
  }
}
    `;
export const CoaForm_ChartererFragmentDoc = gql`
    fragment CoaForm_Charterer on Organization {
  id
  name
}
    `;
export const CoaForm_PortAgentFragmentDoc = gql`
    fragment CoaForm_PortAgent on Organization {
  id
  name
}
    `;
export const CoaForm_AssortmentFragmentDoc = gql`
    fragment CoaForm_Assortment on Assortment {
  id
  name
  assortmentGroup
}
    `;
export const CoaForm_AssortmentGroupFragmentDoc = gql`
    fragment CoaForm_AssortmentGroup on AssortmentGroup {
  id
  name
}
    `;
export const CoaForm_ZoneFragmentDoc = gql`
    fragment CoaForm_Zone on Zone {
  id
  name
  zoneLocationsByZoneId {
    nodes {
      id
      locationId
    }
  }
}
    `;
export const CoaFormFragmentDoc = gql`
    fragment CoaForm on Query {
  allCargoUnits {
    nodes {
      id
      ...CoaForm_CargoUnit
    }
  }
  shipowners: allOrganizations(filter: {shipOwner: {equalTo: true}}) {
    nodes {
      id
      ...CoaForm_Shipowner
    }
  }
  charterers: allOrganizations(filter: {charterer: {equalTo: true}}) {
    nodes {
      id
      ...CoaForm_Charterer
    }
  }
  portAgents: allOrganizations(filter: {portAgent: {equalTo: true}}) {
    nodes {
      id
      ...CoaForm_PortAgent
    }
  }
  allOrganizations: allOrganizations {
    nodes {
      id
      ...CoaForm_Charterer
    }
  }
  allAssortments {
    nodes {
      id
      ...CoaForm_Assortment
    }
  }
  allAssortmentGroups {
    nodes {
      id
      ...CoaForm_AssortmentGroup
    }
  }
  allZones {
    nodes {
      id
      ...CoaForm_Zone
    }
  }
}
    ${CoaForm_CargoUnitFragmentDoc}
${CoaForm_ShipownerFragmentDoc}
${CoaForm_ChartererFragmentDoc}
${CoaForm_PortAgentFragmentDoc}
${CoaForm_AssortmentFragmentDoc}
${CoaForm_AssortmentGroupFragmentDoc}
${CoaForm_ZoneFragmentDoc}`;
export const CoaForm_BaseContractFragmentDoc = gql`
    fragment CoaForm_BaseContract on CoaContract {
  id
  name
  externalId
  amountUnitId
  cargoUnitByAmountUnitId {
    id
    name
  }
  startDate
  endDate
  maxAmount
  minAmount
  shipownerOrgId
  organizationByShipownerOrgId {
    id
    name
  }
  chartererOrgId
  organizationByChartererOrgId {
    id
    name
  }
  currency
  paymentDays
  paymentTrigger
  paymentType
}
    `;
export const CoaForm_CoaBunkerFragmentDoc = gql`
    fragment CoaForm_CoaBunker on CoaContractBunker {
  id
  coaContractId
  bunkerGrade
  price
  basePriceMax
  coaAssortmentId
  coaRouteId
  bafType
  bafStepSize
  bafStepEffect
  bafStartFromBase
  bafUseStepEffectAsValue
  bafBunkerAmount
}
    `;
export const CoaForm_PortPairFragmentDoc = gql`
    fragment CoaForm_PortPair on CoaContractPort {
  id
  chartererId
  originId
  locationByOriginId {
    id
    name
    timezone
  }
  destinationId
  locationByDestinationId {
    id
    name
    timezone
  }
  originZoneId
  zoneByOriginZoneId {
    id
    name
  }
  destinationZoneId
  zoneByDestinationZoneId {
    id
    name
  }
}
    `;
export const ContractPortDatumFragmentDoc = gql`
    fragment ContractPortDatum on PortDatum {
  id
  portId
  loadingRate
  dischargeRate
  loadingDischargeUnit
  portAgentOrgId
  organizationByPortAgentOrgId {
    id
    name
  }
  pilotDeducted
  weatherPermitting
  bimcoHolidays
  laytimeExclusionStart
  laytimeExclusionEnd
  officeHoursStart
  officeHoursEnd
  laytimeStartAfterOfficeHours
  laytimeTrigger
  laytimeDays {
    sa
    su
    ho
    incExUu
  }
  laytimeNorTimeLimit
  laytimeStartBeforeNorTimeLimit
  laytimeStartAfterNorTimeLimit
}
    `;
export const CoaForm_PortDataFragmentDoc = gql`
    fragment CoaForm_PortData on CoaContractPortDatum {
  id
  coaContractId
  portDataId
  portDatumByPortDataId {
    id
    ...ContractPortDatum
  }
}
    ${ContractPortDatumFragmentDoc}`;
export const CoaForm_CoaAssortmentFragmentDoc = gql`
    fragment CoaForm_CoaAssortment on CoaContractAssortment {
  id
  coaContractId
  assortmentId
  assortmentByAssortmentId {
    id
    ...CoaForm_Assortment
  }
  assortmentGroupId
  assortmentGroupByAssortmentGroupId {
    id
    ...CoaForm_AssortmentGroup
  }
  paymentUnit
  minAmount
  maxAmount
}
    ${CoaForm_AssortmentFragmentDoc}
${CoaForm_AssortmentGroupFragmentDoc}`;
export const CoaForm_CoaPriceFragmentDoc = gql`
    fragment CoaForm_CoaPrice on CoaContractPrice {
  id
  coaContractId
  price
  coaAssortmentId
  coaContractAssortmentByCoaAssortmentId {
    id
    assortmentId
    assortmentByAssortmentId {
      id
      name
    }
  }
  coaContractId
  routeId
  shipId
  shipByShipId {
    id
    name
  }
}
    `;
export const CoaForm_CoaVesselFragmentDoc = gql`
    fragment CoaForm_CoaVessel on CoaContractShip {
  id
  demurrage
  shipId
  shipByShipId {
    id
    name
  }
}
    `;
export const CoaForm_CommissionFragmentDoc = gql`
    fragment CoaForm_Commission on CoaContractCommission {
  id
  coaRouteId
  coaAssortmentId
  commissionByCommissionId {
    id
    type
    value
    organizationByOrganizationId {
      id
      name
    }
    voyageCharterId
    bafApplied
    demurrageApplied
    extraFreightApplied
    organizationId
    loadPortId
    dischargePortId
    assortmentId
  }
}
    `;
export const CoaForm_PortCostFragmentDoc = gql`
    fragment CoaForm_PortCost on CoaContractPortCost {
  id
  locationId
  coaContractId
  locationByLocationId {
    id
    name
    timezone
  }
  shipId
  shipByShipId {
    id
    name
  }
  cost
  vesselTypeId
  vesselAttributeByVesselTypeId {
    id
    name
  }
}
    `;
export const CoaForm_CoaFragmentDoc = gql`
    fragment CoaForm_Coa on CoaContract {
  id
  ...CoaForm_BaseContract
  bunkers: coaContractBunkersByCoaContractId {
    nodes {
      id
      ...CoaForm_CoaBunker
    }
  }
  portPairs: coaContractPortsByCoaContractId {
    nodes {
      id
      ...CoaForm_PortPair
    }
  }
  portData: coaContractPortDataByCoaContractId {
    nodes {
      id
      ...CoaForm_PortData
    }
  }
  coaAssortments: coaContractAssortmentsByCoaContractId {
    nodes {
      id
      ...CoaForm_CoaAssortment
    }
  }
  prices: coaContractPricesByCoaContractId {
    nodes {
      id
      ...CoaForm_CoaPrice
    }
  }
  vessels: coaContractShipsByCoaContractId {
    nodes {
      id
      ...CoaForm_CoaVessel
    }
  }
  commissions: coaContractCommissionsByCoaContractId {
    nodes {
      id
      ...CoaForm_Commission
    }
  }
  portCosts: coaContractPortCostsByCoaContractId {
    nodes {
      id
      ...CoaForm_PortCost
    }
  }
}
    ${CoaForm_BaseContractFragmentDoc}
${CoaForm_CoaBunkerFragmentDoc}
${CoaForm_PortPairFragmentDoc}
${CoaForm_PortDataFragmentDoc}
${CoaForm_CoaAssortmentFragmentDoc}
${CoaForm_CoaPriceFragmentDoc}
${CoaForm_CoaVesselFragmentDoc}
${CoaForm_CommissionFragmentDoc}
${CoaForm_PortCostFragmentDoc}`;
export const UserWithNameFragmentDoc = gql`
    fragment UserWithName on User {
  id
  name
}
    `;
export const LastCommitFragmentDoc = gql`
    fragment LastCommit on CommitLog {
  id
  committedAt
  committedBy
  userByCommittedBy {
    id
    ...UserWithName
  }
  scenarioClientId
  masterClientId
  commitLogScenarioByMasterClientId {
    id
    clientId
  }
}
    ${UserWithNameFragmentDoc}`;
export const VoyageChartersForSpotContractsFragmentDoc = gql`
    fragment VoyageChartersForSpotContracts on Query {
  allVoyageCharters {
    nodes {
      id
      shipownerOrgId
      vesselId
      layday
      cancelling
      organizationByShipownerOrgId {
        id
        name
      }
      shipByVesselId {
        id
        name
      }
      voyageCharterToContractsByVoyageCharterId {
        nodes {
          id
          coaId
        }
      }
      orderRelations: orderVoyageCharterRelationsByVoyageCharterId(
        condition: {outgoing: true}
      ) {
        nodes {
          id
          orderByOrderId {
            id
            orderDetailsByOrderId {
              nodes {
                id
                orderName
              }
            }
            shipmentByShipmentId {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const ContractsPage_CoaFragmentDoc = gql`
    fragment ContractsPage_Coa on CoaContract {
  id
  name
  chartererOrgId
  shipownerOrgId
  inactive
  organizationByChartererOrgId {
    id
    name
  }
  organizationByShipownerOrgId {
    id
    name
  }
  startDate
  endDate
  coaContractShipsByCoaContractId {
    nodes {
      id
      shipByShipId {
        id
        name
      }
    }
  }
  externalId
}
    `;
export const ContractsPageQueryFragmentDoc = gql`
    fragment ContractsPageQuery on Query {
  allCoaContracts {
    nodes {
      id
      ...ContractsPage_Coa
    }
  }
}
    ${ContractsPage_CoaFragmentDoc}`;
export const Costs_MeasurementFragmentDoc = gql`
    fragment Costs_Measurement on CargoMeasurement {
  id
  locationId
  measuredVolume
  rejectedVolume
  rejectedWeight
  measuredWeight
  volumeUnit
  weightUnit
}
    `;
export const Costs_FreightFragmentDoc = gql`
    fragment Costs_Freight on VoyageCharterOrderFreight {
  id
  freightUnit
  freightAmount
  orderVoyageCharterRelationId
}
    `;
export const OrderForm_PortDatumFragmentDoc = gql`
    fragment OrderForm_PortDatum on PortDatum {
  id
  portId
  loadingRate
  dischargeRate
  loadingDischargeUnit
}
    `;
export const OrderForm_VoyageCharterFragmentDoc = gql`
    fragment OrderForm_VoyageCharter on VoyageCharter {
  id
  layday
  cancelling
  voyageCharterToContractsByVoyageCharterId {
    nodes {
      id
      coaContractByCoaId {
        id
        coaContractPortDataByCoaContractId {
          nodes {
            id
            portDatumByPortDataId {
              ...OrderForm_PortDatum
            }
          }
        }
      }
    }
  }
  voyageCharterPortDataByVoyageCharterId {
    nodes {
      id
      portDatumByPortDataId {
        ...OrderForm_PortDatum
      }
    }
  }
}
    ${OrderForm_PortDatumFragmentDoc}`;
export const LocationByPortIdFragmentDoc = gql`
    fragment LocationByPortId on Location {
  id
  name
  latitude
  longitude
  timezone
}
    `;
export const OrderForm_AssortmentFragmentDoc = gql`
    fragment OrderForm_Assortment on Assortment {
  id
  name
  assortmentGroup
  assortmentGroupByAssortmentGroup {
    id
    name
    externalId
  }
  stowageFactorMin
  stowageFactorMax
  specificGravity
  marginUnit
  marginAmount
  imoClass
  cargoType
  loadingUnit
  dischargingUnit
  loadingRate
  dischargingRate
  cargoUnitId
}
    `;
export const OrderTable_Order_CargoUnitFragmentDoc = gql`
    fragment OrderTable_Order_CargoUnit on CargoUnit {
  id
  name
}
    `;
export const ApiOrdersNoticeFragmentDoc = gql`
    fragment ApiOrdersNotice on ApiOrdersNotice {
  id
  notices
}
    `;
export const OrderForm_OrderFragmentDoc = gql`
    fragment OrderForm_Order on Order {
  id
  organizationId
  coaId
  chartererOrganizationId
  assortmentId
  cargoAmount
  cargoUnitId
  externalOrderId
  marginAmount
  marginUnit
  stowageFactorMin
  stowageFactorMax
  specificGravity
  loadingRate
  loadingUnit
  dischargingRate
  dischargingUnit
  rta
  layday
  cancelling
  deliveredBefore
  started
  completed
  archived
  nominatedVessel
  shipmentId
  loadingOverheadDuration
  dischargingOverheadDuration
  orderVoyageCharterRelationsByOrderId {
    nodes {
      id
      outgoing
      voyageCharterByVoyageCharterId {
        id
        ...OrderForm_VoyageCharter
      }
    }
  }
  locationByLoadPortId {
    id
    ...LocationByPortId
  }
  locationByDischargePortId {
    id
    ...LocationByPortId
  }
  orderDetailsByOrderId {
    nodes {
      id
      closingDate
      senderOrganisationId
      receiverOrganisationId
      supplyContractId
      consignee
      orderName
      fixtureNote
      extraInfo
      imoClass
      incoTerms
    }
  }
  cargoExclusionsByOrderId {
    nodes {
      id
      orderId
      assortmentGroup
      distance
      voyages
      tanks
    }
  }
  orderRequirementAssociationsByOrderId {
    nodes {
      id
      orderId
      specialRequirementId
    }
  }
  orderAttributeAssociationsByOrderId {
    nodes {
      id
      orderId
      orderAttributeId
    }
  }
  orderPortCallRelationsByOrderId {
    nodes {
      id
      portCallId
      orderId
      isLoadPort
      portCallByPortCallId {
        id
        ...ScenarioTimeline_PortCall
      }
    }
  }
  assortmentByAssortmentId {
    id
    ...OrderForm_Assortment
  }
  sysPeriod {
    end {
      value
    }
    start {
      value
    }
  }
  userByModifiedByUserId {
    id
    name
  }
  cargoUnitByCargoUnitId {
    id
    ...OrderTable_Order_CargoUnit
  }
  loadExternallyPlanned
  dischargeExternallyPlanned
  apiOrdersNoticesByOrderId {
    nodes {
      id
      ...ApiOrdersNotice
    }
  }
}
    ${OrderForm_VoyageCharterFragmentDoc}
${LocationByPortIdFragmentDoc}
${ScenarioTimeline_PortCallFragmentDoc}
${OrderForm_AssortmentFragmentDoc}
${OrderTable_Order_CargoUnitFragmentDoc}
${ApiOrdersNoticeFragmentDoc}`;
export const EditOrderModal_QueryFragmentDoc = gql`
    fragment EditOrderModal_Query on Query {
  orderById(id: $orderId) {
    id
    ...OrderForm_Order
  }
}
    ${OrderForm_OrderFragmentDoc}`;
export const IncomingEntryFragmentDoc = gql`
    fragment IncomingEntry on VwSapOrdersIntegration {
  externalId
  integrationCode
  lastUpdated
  materialId
  message
  nominationKey
  orderId
  pegId
  sapCreatedAt
  sapSourceEnv
  sapUpdatedAt
  status
  vesselName
  material
  quantity
  unit
  ports
  __typename
}
    `;
export const IntegrationLogEntryFragmentDoc = gql`
    fragment IntegrationLogEntry on IntegrationLog {
  id
  organizationId
  runtimeUuid
  message
  createdAt
  severity
  cargoId
}
    `;
export const NotificationSettingsFragmentDoc = gql`
    fragment NotificationSettings on UserSetting {
  id
  notificationAllOrders {
    dischargeDocumentUploaded
    orderVesselChanged
    orderPublishedUnassignedShipment
    orderPublishedShippingPlan
    orderPublishedEdited
    loadSofSaved
    loadNorSaved
    loadEtdChanged
    loadEtbChanged
    loadEtaChanged
    loadDocumentUploaded
    loadBlSaved
    dischargeSofSaved
    dischargeNorSaved
    dischargeMrSaved
    dischargeEtd
    dischargeEtb
    dischargeEta
  }
  notificationYourOrders {
    dischargeDocumentUploaded
    orderVesselChanged
    orderPublishedUnassignedShipment
    orderPublishedShippingPlan
    orderPublishedEdited
    loadSofSaved
    loadNorSaved
    loadEtdChanged
    loadEtaChanged
    loadEtbChanged
    loadBlSaved
    loadDocumentUploaded
    dischargeNorSaved
    dischargeSofSaved
    dischargeMrSaved
    dischargeEtd
    dischargeEtb
    dischargeEta
  }
}
    `;
export const OffHireForm_OffHireFragmentDoc = gql`
    fragment OffHireForm_OffHire on OffHire {
  id
  vesselId
  type
  start
  end
  locked
  shared
  planningOrganisationId
  userId
  locationByLocationAId {
    id
    name
  }
  locationByLocationBId {
    id
    name
  }
}
    `;
export const OpenPositionsFragmentDoc = gql`
    fragment OpenPositions on OpenPosition {
  id
  vesselId
  startTime
  startPortId
  locationByStartPortId {
    id
    name
  }
  directionId
  remark
  locationByDirectionId {
    id
    name
  }
}
    `;
export const OrderForm_AssortmentGroupFragmentDoc = gql`
    fragment OrderForm_AssortmentGroup on AssortmentGroup {
  id
  name
  assortmentExclusionsByNextAssortmentGroup {
    nodes {
      id
      voyages
      previousAssortmentGroup
      nextAssortmentGroup
    }
  }
}
    `;
export const OrderForm_CargoUnitFragmentDoc = gql`
    fragment OrderForm_CargoUnit on CargoUnit {
  id
  name
}
    `;
export const OrderForm_OrganizationFragmentDoc = gql`
    fragment OrderForm_Organization on Organization {
  id
  name
  charterer
  receiver
  sender
  parentOrganizationId
  configEnableDefaultLaycan
}
    `;
export const OrderForm_SpecialRequirementFragmentDoc = gql`
    fragment OrderForm_SpecialRequirement on SpecialRequirement {
  id
  name
  organizationId
}
    `;
export const OrderForm_OrderAttributeFragmentDoc = gql`
    fragment OrderForm_OrderAttribute on OrderAttribute {
  id
  name
  description
  organizationId
}
    `;
export const OrderForm_LocationRequirementAssociationFragmentDoc = gql`
    fragment OrderForm_LocationRequirementAssociation on LocationRequirementAssociation {
  id
  specialRequirementId
  locationId
  zoneId
  zoneByZoneId {
    id
    name
    zoneLocationsByZoneId {
      nodes {
        locationId
      }
    }
  }
}
    `;
export const OrderForm_SupplyContractFragmentDoc = gql`
    fragment OrderForm_SupplyContract on SupplyContract {
  id
  organizationId
  supplyContract
  supplier
  batchCode
  year
  batchSeq
}
    `;
export const OrderForm_QueryFragmentDoc = gql`
    fragment OrderForm_Query on Query {
  allAssortments {
    nodes {
      id
      ...OrderForm_Assortment
    }
  }
  allAssortmentGroups {
    nodes {
      id
      ...OrderForm_AssortmentGroup
    }
  }
  allCargoUnits {
    nodes {
      id
      ...OrderForm_CargoUnit
    }
  }
  allOrganizations {
    nodes {
      id
      ...OrderForm_Organization
    }
  }
  allSpecialRequirements {
    nodes {
      id
      ...OrderForm_SpecialRequirement
    }
  }
  allOrderAttributes {
    nodes {
      id
      ...OrderForm_OrderAttribute
    }
  }
  allLocationRequirementAssociations {
    nodes {
      id
      ...OrderForm_LocationRequirementAssociation
    }
  }
  allSupplyContracts {
    nodes {
      id
      ...OrderForm_SupplyContract
    }
  }
}
    ${OrderForm_AssortmentFragmentDoc}
${OrderForm_AssortmentGroupFragmentDoc}
${OrderForm_CargoUnitFragmentDoc}
${OrderForm_OrganizationFragmentDoc}
${OrderForm_SpecialRequirementFragmentDoc}
${OrderForm_OrderAttributeFragmentDoc}
${OrderForm_LocationRequirementAssociationFragmentDoc}
${OrderForm_SupplyContractFragmentDoc}`;
export const OrderForm_OrderAttributeAssociationFragmentDoc = gql`
    fragment OrderForm_OrderAttributeAssociation on OrderAttributeAssociation {
  id
  orderId
  orderAttributeId
}
    `;
export const OrderForm_CoaFragmentDoc = gql`
    fragment OrderForm_Coa on CoaContract {
  id
  inactive
  name
  amountUnitId
  cargoUnitByAmountUnitId {
    id
    name
  }
  organizationByChartererOrgId {
    id
    name
  }
  organizationByShipownerOrgId {
    name
    id
  }
  coaContractAssortmentsByCoaContractId {
    nodes {
      id
      assortmentId
    }
  }
  coaContractPortsByCoaContractId {
    nodes {
      id
      destinationId
      originId
      locationByDestinationId {
        id
        name
      }
      locationByOriginId {
        id
        name
      }
    }
  }
  coaContractPortDataByCoaContractId {
    nodes {
      id
      portDatumByPortDataId {
        id
        portId
        loadingRate
        loadingDischargeUnit
        dischargeRate
      }
    }
  }
}
    `;
export const OrderTable_OrderLocationFragmentDoc = gql`
    fragment OrderTable_OrderLocation on Location {
  id
  name
  timezone
  latitude
  longitude
}
    `;
export const OrderTable_Order_AssortmentFragmentDoc = gql`
    fragment OrderTable_Order_Assortment on Assortment {
  id
  name
}
    `;
export const OrderTable_Order_DetailsFragmentDoc = gql`
    fragment OrderTable_Order_Details on OrderDetail {
  id
  closingDate
  senderOrganisationId
  receiverOrganisationId
  supplyContractId
  consignee
  orderName
  extraInfo
  externalRemarks
  imoClass
  incoTerms
}
    `;
export const OrdersHistory_OrderFragmentDoc = gql`
    fragment OrdersHistory_Order on OrdersHistory {
  id
  started
  completed
  archived
  layday
  cancelling
  rta
  deliveredBefore
  externalOrderId
  nominatedVessel
  chartererOrganizationId
  cargoAmount
  shipmentId
  userId
  userByModifiedByUserId {
    id
    name
  }
  cargoUnitByCargoUnitId {
    id
    ...OrderTable_Order_CargoUnit
  }
  locationByLoadPortId {
    id
    ...OrderTable_OrderLocation
  }
  locationByDischargePortId {
    id
    ...OrderTable_OrderLocation
  }
  assortmentByAssortmentId {
    id
    ...OrderTable_Order_Assortment
  }
  orderById {
    id
    orderDetailsByOrderId {
      nodes {
        id
        ...OrderTable_Order_Details
      }
    }
  }
  sysPeriod {
    start {
      value
    }
  }
}
    ${OrderTable_Order_CargoUnitFragmentDoc}
${OrderTable_OrderLocationFragmentDoc}
${OrderTable_Order_AssortmentFragmentDoc}
${OrderTable_Order_DetailsFragmentDoc}`;
export const ReportingTableFragmentDoc = gql`
    fragment ReportingTable on Query {
  orders: allOrders(condition: {softDelete: false, archived: $showArchived}) {
    nodes {
      id
      ...ReportingTable_Order
    }
  }
}
    ${ReportingTable_OrderFragmentDoc}`;
export const PortCallExternalTimestampFragmentDoc = gql`
    fragment PortCallExternalTimestamp on PortCallExternalTimestamp {
  id
  sourceName
  eventType
  timestampType
  isConfirmed
  value
  updatedAt
  latestValueReceivedAt
}
    `;
export const NorForm__NoticeOfReadinessFragmentDoc = gql`
    fragment NORForm__NoticeOfReadiness on PortNotice {
  id
  ...ScenarioTimeline_PortNotice
}
    ${ScenarioTimeline_PortNoticeFragmentDoc}`;
export const SofForm__StatementOfFactsFragmentDoc = gql`
    fragment SOFForm__StatementOfFacts on StatementOfFact {
  id
  ...ScenarioTimeline_StatementOfFact
}
    ${ScenarioTimeline_StatementOfFactFragmentDoc}`;
export const PortCallsDocuments__PortCallFileFragmentDoc = gql`
    fragment PortCallsDocuments__PortCallFile on PortCallFile {
  id
  portCallId
  fileByFileId {
    id
    note
    uri
    type
    userByUserId {
      id
      email
    }
  }
}
    `;
export const BolForm__BillOfLadingDatumFragmentDoc = gql`
    fragment BOLForm__BillOfLadingDatum on BillOfLadingDatum {
  id
  billOfLadingId
  orderId
  description
  volume
  volumeUnit
  weight
  weightUnit
  volumeOnDeck
  weightOnDeck
}
    `;
export const BolForm__BillOfLadingFragmentDoc = gql`
    fragment BOLForm__BillOfLading on BillOfLading {
  id
  portCallId
  billOfLadingDataByBillOfLadingId {
    nodes {
      id
      ...BOLForm__BillOfLadingDatum
    }
  }
}
    ${BolForm__BillOfLadingDatumFragmentDoc}`;
export const PortCallsDocuments__PortCallFragmentDoc = gql`
    fragment PortCallsDocuments__PortCall on PortCall {
  id
  clientId
  portNoticesByPortCallId {
    nodes {
      id
      ...NORForm__NoticeOfReadiness
    }
  }
  statementOfFactsByPortCallId {
    nodes {
      id
      ...SOFForm__StatementOfFacts
    }
  }
  portCallFilesByPortCallId {
    nodes {
      id
      ...PortCallsDocuments__PortCallFile
    }
  }
  billOfLadingsByPortCallId {
    nodes {
      id
      ...BOLForm__BillOfLading
    }
  }
  plannedArrivalOverride
  plannedArrivalOverrideSourcedAt
  plannedArrivalOverrideSourcedFrom
  plannedBerthingOverride
  plannedBerthingOverrideSourcedAt
  plannedBerthingOverrideSourcedFrom
  plannedDepartureOverride
  plannedDepartureOverrideSourcedAt
  plannedDepartureOverrideSourcedFrom
}
    ${NorForm__NoticeOfReadinessFragmentDoc}
${SofForm__StatementOfFactsFragmentDoc}
${PortCallsDocuments__PortCallFileFragmentDoc}
${BolForm__BillOfLadingFragmentDoc}`;
export const MrForm_CargoMeasurementFragmentDoc = gql`
    fragment MRForm_CargoMeasurement on CargoMeasurement {
  id
  orderId
  locationId
  time
  measuredWeight
  rejectedWeight
  weightUnit
  measuredVolume
  rejectedVolume
  volumeUnit
}
    `;
export const PortCallsDocuments__OrganizationFragmentDoc = gql`
    fragment PortCallsDocuments__Organization on Organization {
  id
  name
}
    `;
export const PortCallsDocumentsQueryFragmentDoc = gql`
    fragment PortCallsDocumentsQuery on Query {
  allPortCalls(filter: {clientId: {in: $portCallClientIds}}) {
    nodes {
      id
      ...PortCallsDocuments__PortCall
    }
  }
  allCargoMeasurements(filter: {orderId: {in: $orderIds}}) {
    nodes {
      id
      ...MRForm_CargoMeasurement
    }
  }
  allOrganizations {
    nodes {
      id
      ...PortCallsDocuments__Organization
    }
  }
  allOrderAttributes {
    nodes {
      id
      ...OrderForm_OrderAttribute
    }
  }
}
    ${PortCallsDocuments__PortCallFragmentDoc}
${MrForm_CargoMeasurementFragmentDoc}
${PortCallsDocuments__OrganizationFragmentDoc}
${OrderForm_OrderAttributeFragmentDoc}`;
export const PortCost_FieldsFragmentDoc = gql`
    fragment PortCost_fields on PortCost {
  id
  locationId
  vesselId
  cost
  userId
  estimatedCost
  portCostCurrency
  locationByLocationId {
    id
    name
  }
  shipByVesselId {
    id
    name
  }
}
    `;
export const PortCostsByPortAndVesselName_FieldsFragmentDoc = gql`
    fragment PortCostsByPortAndVesselName_fields on PortCostsByPortAndVesselName {
  portName
  vesselName
  portCostCurrency
  avg
  min
  max
  count
  median
}
    `;
export const PortCostsByPortAndPrimaryAttributes_FieldsFragmentDoc = gql`
    fragment PortCostsByPortAndPrimaryAttributes_fields on PortCostsByPortAndPrimaryAttribute {
  portName
  primaryAttributeId
  portCostCurrency
  avg
  min
  max
  count
  median
}
    `;
export const ChannelCostEstimate_FieldsFragmentDoc = gql`
    fragment ChannelCostEstimate_fields on ChannelCostEstimate {
  id
  vesselTypeId
  vesselAttributeByVesselTypeId {
    id
    name
  }
  vesselId
  channelCost
  channelCostCurrency
  durationOverhead
  channelName
}
    `;
export const PortCostEstimatesQueryFragmentDoc = gql`
    fragment PortCostEstimatesQuery on Query {
  allPortCostsByPortAndVesselNames {
    nodes {
      ...PortCostsByPortAndVesselName_fields
    }
  }
  allPortCostsByPortAndPrimaryAttributes {
    nodes {
      ...PortCostsByPortAndPrimaryAttributes_fields
    }
  }
  allChannelCostEstimates {
    nodes {
      id
      ...ChannelCostEstimate_fields
    }
  }
  allPortCostDefaults {
    nodes {
      id
      ...PortCostDefault_fields
    }
  }
}
    ${PortCostsByPortAndVesselName_FieldsFragmentDoc}
${PortCostsByPortAndPrimaryAttributes_FieldsFragmentDoc}
${ChannelCostEstimate_FieldsFragmentDoc}
${PortCostDefault_FieldsFragmentDoc}`;
export const RequestLogEntryFragmentDoc = gql`
    fragment RequestLogEntry on RequestLog {
  id
  organizationId
  request
  response
  status
  createdAt
}
    `;
export const ScenarioTimeline_VesselFulfillsRequirementAssociationFragmentDoc = gql`
    fragment ScenarioTimeline_VesselFulfillsRequirementAssociation on VesselFulfillsRequirementAssociation {
  id
  vesselId
  specialRequirementId
  vesselAttributeId
}
    `;
export const ScenarioTimeline_CargoCompartmentFragmentDoc = gql`
    fragment ScenarioTimeline_CargoCompartment on CargoCompartment {
  id
  name
  maxVolume
  volumeUnit
  type
}
    `;
export const VesselSpeedConsumptionFragmentDoc = gql`
    fragment VesselSpeedConsumption on VesselSpeedConsumption {
  id
  speed
  consumption
  type
  tag
  area
  shipId
  bunkerGradeOverrideByBunkerGradeId {
    id
    price
    priceAdjustment
    gradeName
    referenceGrade
    referencePort
    currency
    carbonFactor
  }
}
    `;
export const VesselDraftDatapointFragmentDoc = gql`
    fragment VesselDraftDatapoint on VesselDraftDatapoint {
  id
  cargoLoad
  draft
}
    `;
export const VesselTcContractFragmentDoc = gql`
    fragment VesselTcContract on TcContract {
  id
  deliveryEndDate
  deliveryStartDate
  deliveryPortId
  externalId
  redeliveryEndDate
  redeliveryStartDate
  redeliveryPortId
  vesselId
}
    `;
export const ScenarioTimeline_ShipFragmentDoc = gql`
    fragment ScenarioTimeline_Ship on Ship {
  id
  name
  shortName
  weightCapacity
  weightCapacityType
  massCapacity
  massUnit
  volumeCapacity
  volumeUnit
  tcRate
  organizationId
  loadingRate
  loadingUnit
  dischargingRate
  dischargingUnit
  imo
  draft
  loa
  breadth
  netTonnage
  grossTonnage
  mainEngineCapacity
  esiScore
  csiScore
  inactive
  remarks
  externalFleet
  sortId
  primaryAttributeId
  vesselAttributeByPrimaryAttributeId {
    id
    name
    vesselFulfillsRequirementAssociationsByVesselAttributeId {
      nodes {
        ...ScenarioTimeline_VesselFulfillsRequirementAssociation
      }
    }
  }
  cargoCompartmentsByShipId {
    nodes {
      id
      ...ScenarioTimeline_CargoCompartment
    }
  }
  vesselFulfillsRequirementAssociationsByVesselId {
    nodes {
      ...ScenarioTimeline_VesselFulfillsRequirementAssociation
    }
  }
  vesselInfoByVesselInfoId {
    id
    loadingRate
    loadingUnit
    dischargingRate
    dischargingUnit
    cargoCompartmentsByVesselId {
      nodes {
        id
        ...ScenarioTimeline_CargoCompartment
      }
    }
  }
  vesselAttributesAssociationsByShipId {
    nodes {
      id
      vesselAttributeId
      vesselAttributeByVesselAttributeId {
        id
        name
        isVesselClass
        vesselFulfillsRequirementAssociationsByVesselAttributeId {
          nodes {
            ...ScenarioTimeline_VesselFulfillsRequirementAssociation
          }
        }
      }
    }
  }
  vesselSpeedConsumptionsByShipId {
    nodes {
      id
      ...VesselSpeedConsumption
    }
  }
  vesselDraftDatapointsByShipId {
    nodes {
      id
      ...VesselDraftDatapoint
    }
  }
  shipVoyageNamingRuleRelationsByShipId {
    nodes {
      id
      voyageNamingRuleByRuleId {
        id
        rule
        vesselFullname
        vesselImo
        vesselShortname
        year
        zerosPad
      }
    }
  }
  tcContractsByVesselId {
    nodes {
      ...VesselTcContract
    }
  }
}
    ${ScenarioTimeline_VesselFulfillsRequirementAssociationFragmentDoc}
${ScenarioTimeline_CargoCompartmentFragmentDoc}
${VesselSpeedConsumptionFragmentDoc}
${VesselDraftDatapointFragmentDoc}
${VesselTcContractFragmentDoc}`;
export const ScenarioTimeline_AssortmentFragmentDoc = gql`
    fragment ScenarioTimeline_Assortment on Assortment {
  id
  name
  assortmentGroup
  assortmentGroupByAssortmentGroup {
    id
    name
    externalId
  }
  groupName
  specificGravity
  stowageFactorMin
  stowageFactorMax
  marginAmount
  marginUnit
  cargoType
  loadingRate
  loadingUnit
  dischargingRate
  dischargingUnit
}
    `;
export const ScheduledOrderFragmentDoc = gql`
    fragment ScheduledOrder on ScheduledOrder {
  id
  vesselId
  orderId
  loadingStart
  loadingStartOverride
  loadingDuration
  loadingDurationOverride
  loadingEnd
  loadingSeaDurationOverride
  dischargingStart
  dischargingStartOverride
  dischargingDuration
  dischargingDurationOverride
  dischargingEnd
  dischargingSeaDurationOverride
  loadingConcurrent
  dischargingConcurrent
  shared
  clientId
  updatedAt
  userByCreatedByUserId {
    id
    name
  }
}
    `;
export const ScenarioTimeline_Order_OrderRequirementAssociationFragmentDoc = gql`
    fragment ScenarioTimeline_Order_OrderRequirementAssociation on OrderRequirementAssociation {
  id
  orderId
  specialRequirementId
}
    `;
export const ScenarioTimeline_Order_DetailsFragmentDoc = gql`
    fragment ScenarioTimeline_Order_Details on OrderDetail {
  id
  closingDate
  senderOrganisationId
  receiverOrganisationId
  supplyContractId
  consignee
  orderName
  fixtureNote
  extraInfo
  externalRemarks
  imoClass
  incoTerms
  cargoDeckOption
}
    `;
export const ScenarioTimeline_Order_OrderAttributeAssociationFragmentDoc = gql`
    fragment ScenarioTimeline_Order_OrderAttributeAssociation on OrderAttributeAssociation {
  id
  orderId
  orderAttributeId
}
    `;
export const VoyageIncome_VoyageCharterOrderFreightFragmentDoc = gql`
    fragment VoyageIncome_VoyageCharterOrderFreight on VoyageCharterOrderFreight {
  id
  freightUnit
  freightAmount
  orderVoyageCharterRelationId
}
    `;
export const VoyageIncome_OrderVoyageCharterRelationFragmentDoc = gql`
    fragment VoyageIncome_OrderVoyageCharterRelation on OrderVoyageCharterRelation {
  id
  orderId
  coaRouteId
  outgoing
  voyageCharterOrderFreightsByOrderVoyageCharterRelationId {
    nodes {
      id
      ...VoyageIncome_VoyageCharterOrderFreight
    }
  }
}
    ${VoyageIncome_VoyageCharterOrderFreightFragmentDoc}`;
export const ScenarioTimeline_CargoCompartmentAllocationsFragmentDoc = gql`
    fragment ScenarioTimeline_CargoCompartmentAllocations on CargoCompartmentAllocation {
  id
  clientId
  orderId
  compartmentId
  scheduledOrderClientId
  amount
}
    `;
export const ScenarioTimeline_OrderFragmentDoc = gql`
    fragment ScenarioTimeline_Order on Order {
  id
  coaId
  externalOrderId
  nominatedVessel
  started
  completed
  archived
  shipmentId
  assortmentId
  assortmentByAssortmentId {
    id
    ...ScenarioTimeline_Assortment
  }
  dischargePortId
  locationByDischargePortId {
    id
    ...ScenarioTimeline_OrderLocation
  }
  loadPortId
  locationByLoadPortId {
    id
    ...ScenarioTimeline_OrderLocation
  }
  scheduledOrdersByOrderId {
    nodes {
      id
      ...ScheduledOrder
    }
  }
  orderRequirementAssociationsByOrderId {
    nodes {
      id
      ...ScenarioTimeline_Order_OrderRequirementAssociation
    }
  }
  cargoAmount
  cargoUnitByCargoUnitId {
    id
    name
  }
  marginAmount
  marginUnit
  specificGravity
  stowageFactorMin
  stowageFactorMax
  loadingRate
  loadingUnit
  dischargingRate
  dischargingUnit
  loadingOverheadDuration
  dischargingOverheadDuration
  layday
  cancelling
  rta
  deliveredBefore
  chartererOrganizationId
  organizationByChartererOrganizationId {
    id
    name
  }
  handledBySpotByOrderId {
    id
    orderId
    vesselId
    ownerOrganisationId
    metadata
  }
  orderPortCallRelationsByOrderId {
    nodes {
      id
      portCallId
      orderId
      isLoadPort
      portCallByPortCallId {
        id
        ...ScenarioTimeline_PortCall
      }
    }
  }
  orderDetailsByOrderId {
    nodes {
      id
      ...ScenarioTimeline_Order_Details
    }
  }
  orderAttributeAssociationsByOrderId {
    nodes {
      id
      ...ScenarioTimeline_Order_OrderAttributeAssociation
    }
  }
  outgoingVoyageCharterRelation {
    id
    ...ScenarioTimeline_OrderVoyageCharterRelation
    ...VoyageIncome_OrderVoyageCharterRelation
  }
  incomingVoyageCharterRelation {
    id
    ...ScenarioTimeline_OrderVoyageCharterRelation
    ...VoyageIncome_OrderVoyageCharterRelation
  }
  cargoCompartmentAllocationsByOrderId {
    nodes {
      id
      ...ScenarioTimeline_CargoCompartmentAllocations
    }
  }
  createdAt
  apiOrdersNoticesByOrderId {
    nodes {
      id
      ...ApiOrdersNotice
    }
  }
  userByUserId {
    id
    name
  }
}
    ${ScenarioTimeline_AssortmentFragmentDoc}
${ScenarioTimeline_OrderLocationFragmentDoc}
${ScheduledOrderFragmentDoc}
${ScenarioTimeline_Order_OrderRequirementAssociationFragmentDoc}
${ScenarioTimeline_PortCallFragmentDoc}
${ScenarioTimeline_Order_DetailsFragmentDoc}
${ScenarioTimeline_Order_OrderAttributeAssociationFragmentDoc}
${ScenarioTimeline_OrderVoyageCharterRelationFragmentDoc}
${VoyageIncome_OrderVoyageCharterRelationFragmentDoc}
${ScenarioTimeline_CargoCompartmentAllocationsFragmentDoc}
${ApiOrdersNoticeFragmentDoc}`;
export const ScenarioTimeline_HandledBySpotFragmentDoc = gql`
    fragment ScenarioTimeline_HandledBySpot on HandledBySpot {
  id
  orderId
  vesselId
  ownerOrganisationId
  metadata
  loadingStart
  loadingEnd
  loadingDuration
  dischargingStart
  dischargingEnd
  dischargingDuration
  loadingStartOverride
  loadingDurationOverride
  loadingSeaDurationOverride
  dischargingSeaDurationOverride
  dischargingStartOverride
  dischargingDurationOverride
  loadingConcurrent
  dischargingConcurrent
  shared
  clientId
  updatedAt
}
    `;
export const ScenarioTimeline_SingleEventFragmentDoc = gql`
    fragment ScenarioTimeline_SingleEvent on SingleEvent {
  id
  duration
  end
  locationId
  locationByLocationId {
    id
    ...ScenarioTimeline_OrderLocation
  }
  locked
  meta
  shared
  start
  vesselId
  type
  concurrent
  startOverride
  seaDurationOverride
  singleEventPortCallRelationsBySingleEventId {
    nodes {
      id
      portCallId
      singleEventId
    }
  }
  clientId
  updatedAt
  archived
}
    ${ScenarioTimeline_OrderLocationFragmentDoc}`;
export const ScenarioTimeline_OffHireFragmentDoc = gql`
    fragment ScenarioTimeline_OffHire on OffHire {
  id
  end
  locationAId
  locationBId
  locationByLocationAId {
    id
    ...ScenarioTimeline_OrderLocation
  }
  locationByLocationBId {
    id
    ...ScenarioTimeline_OrderLocation
  }
  locked
  meta
  shared
  start
  duration
  vesselId
  type
  planningOrganisationId
  userId
  clientId
  updatedAt
  archived
}
    ${ScenarioTimeline_OrderLocationFragmentDoc}`;
export const ScenarioTimeline_PortDatumFragmentDoc = gql`
    fragment ScenarioTimeline_PortDatum on PortDatum {
  id
  portId
  loadingRate
  dischargeRate
  loadingDischargeUnit
  laytimeDays {
    ho
    incExUu
    sa
    su
  }
}
    `;
export const ScenarioTimeline_CoaFragmentDoc = gql`
    fragment ScenarioTimeline_Coa on CoaContract {
  id
  name
  chartererOrgId
  startDate
  endDate
  maxAmount
  minAmount
  inactive
  ...VoyageIncome_Coa
  ...Baf_Coa
  shipowner: organizationByShipownerOrgId {
    id
    name
  }
  vessels: coaContractShipsByCoaContractId {
    nodes {
      id
      shipId
    }
  }
  portDataRelations: coaContractPortDataByCoaContractId {
    nodes {
      id
      portData: portDatumByPortDataId {
        id
        ...ScenarioTimeline_PortDatum
      }
    }
  }
  coaAssortments: coaContractAssortmentsByCoaContractId {
    nodes {
      assortmentId
      assortmentGroupId
      id
    }
  }
  ports: coaContractPortsByCoaContractId {
    nodes {
      id
      coaContractId
      originId
      destinationId
    }
  }
}
    ${VoyageIncome_CoaFragmentDoc}
${Baf_CoaFragmentDoc}
${ScenarioTimeline_PortDatumFragmentDoc}`;
export const ScenarioTimeline_CoaAssignmentFragmentDoc = gql`
    fragment ScenarioTimeline_CoaAssignment on HandledByCoa {
  id
  coaId
  orderId
  vesselId
  metadata
  loadingStart
  loadingEnd
  loadingDuration
  dischargingStart
  dischargingEnd
  dischargingDuration
  loadingStartOverride
  loadingDurationOverride
  loadingSeaDurationOverride
  dischargingSeaDurationOverride
  dischargingStartOverride
  dischargingDurationOverride
  loadingConcurrent
  dischargingConcurrent
  shared
  clientId
  updatedAt
}
    `;
export const ScenarioTimeline_OrganizationFragmentDoc = gql`
    fragment ScenarioTimeline_Organization on Organization {
  id
  name
  draft
  configEventsConcurrentDefault
  configPortcallDurationBerthapiDefault
  configEnableAcceptAllUpdates
  configAutoAcceptOnlyConfirmed
  configEnableScenarioAutoSave
  configCargoAllocationCombineAssortment
  portCostPriority
  broker
}
    `;
export const ScenarioTimeline_PortCall_FilesFragmentDoc = gql`
    fragment ScenarioTimeline_PortCall_Files on PortCall {
  id
  portCallFilesByPortCallId {
    nodes {
      id
      fileByFileId {
        id
        note
        type
      }
    }
  }
}
    `;
export const ScenarioTimeline_ShipmentFragmentDoc = gql`
    fragment ScenarioTimeline_Shipment on Shipment {
  id
  clientId
  name
  remarks
  externalShipmentId
  shipmentExternalStatusesByShipmentId {
    nodes {
      id
      status
    }
  }
  voyageAttributeId
}
    `;
export const ScenarioTimeline_QueryFragmentDoc = gql`
    fragment ScenarioTimeline_Query on Query {
  allShips {
    nodes {
      id
      ...ScenarioTimeline_Ship
    }
  }
  allOrders(condition: {softDelete: false, archived: $showArchived}) {
    nodes {
      id
      ...ScenarioTimeline_Order
    }
  }
  allScheduledOrders(condition: {archived: $showArchived}) {
    nodes {
      id
      ...ScheduledOrder
    }
  }
  allHandledBySpots(condition: {archived: $showArchived}) {
    nodes {
      id
      ...ScenarioTimeline_HandledBySpot
    }
  }
  allSingleEvents(condition: {archived: $showArchived}) {
    nodes {
      id
      ...ScenarioTimeline_SingleEvent
    }
  }
  allOffHires(condition: {archived: $showArchived}) {
    nodes {
      id
      ...ScenarioTimeline_OffHire
    }
  }
  allCoaContracts {
    nodes {
      id
      ...ScenarioTimeline_Coa
    }
  }
  allHandledByCoas(condition: {archived: $showArchived}) {
    nodes {
      id
      ...ScenarioTimeline_CoaAssignment
    }
  }
  allOrganizations {
    nodes {
      id
      ...ScenarioTimeline_Organization
    }
  }
  allPortCalls(condition: {archived: $showArchived}) {
    nodes {
      id
      ...ScenarioTimeline_PortCall
      ...ScenarioTimeline_PortCall_Files
    }
  }
  allShipments {
    nodes {
      id
      ...ScenarioTimeline_Shipment
    }
  }
}
    ${ScenarioTimeline_ShipFragmentDoc}
${ScenarioTimeline_OrderFragmentDoc}
${ScheduledOrderFragmentDoc}
${ScenarioTimeline_HandledBySpotFragmentDoc}
${ScenarioTimeline_SingleEventFragmentDoc}
${ScenarioTimeline_OffHireFragmentDoc}
${ScenarioTimeline_CoaFragmentDoc}
${ScenarioTimeline_CoaAssignmentFragmentDoc}
${ScenarioTimeline_OrganizationFragmentDoc}
${ScenarioTimeline_PortCallFragmentDoc}
${ScenarioTimeline_PortCall_FilesFragmentDoc}
${ScenarioTimeline_ShipmentFragmentDoc}`;
export const Scenarios_ScenarioFragmentDoc = gql`
    fragment Scenarios_Scenario on Scenario {
  id
  clientId
  organizationId
  name
  description
  createdAt
  updatedAt
  createdBy
  updatedBy
  dataSchemaVersion
  data
  shared
  deletedAt
}
    `;
export const ShippingPlan_ScheduledOrderFragmentDoc = gql`
    fragment ShippingPlan_ScheduledOrder on ScheduledOrder {
  id
  loadingStart
  loadingEnd
  dischargingStart
  dischargingEnd
  vesselId
}
    `;
export const ShippingPlan_LocationFragmentDoc = gql`
    fragment ShippingPlan_Location on Location {
  id
  name
  locode
  timezone
  countryByCountryId {
    id
    alpha2
  }
}
    `;
export const ShippingPlan_ShipFragmentDoc = gql`
    fragment ShippingPlan_Ship on Ship {
  id
  name
  shortName
  weightCapacity
  weightCapacityType
  inactive
  imo
  draft
  cargoCompartmentsByShipId {
    nodes {
      id
      name
      maxVolume
    }
  }
  shipVoyageNamingRuleRelationsByShipId {
    nodes {
      id
      voyageNamingRuleByRuleId {
        id
        rule
        vesselFullname
        vesselImo
        vesselShortname
        year
        zerosPad
      }
    }
  }
}
    `;
export const SpotForm_ChartererFragmentDoc = gql`
    fragment SpotForm_Charterer on Organization {
  id
  name
}
    `;
export const SpotForm_VesselFragmentDoc = gql`
    fragment SpotForm_Vessel on Ship {
  id
  name
}
    `;
export const SpotForm_ShipownerFragmentDoc = gql`
    fragment SpotForm_Shipowner on Organization {
  id
  name
  shipsByOrganizationId {
    nodes {
      id
      ...SpotForm_Vessel
    }
  }
}
    ${SpotForm_VesselFragmentDoc}`;
export const VoyageCharterForm_AssortmentFragmentDoc = gql`
    fragment VoyageCharterForm_Assortment on Assortment {
  id
  name
  nameSynonyms
  specificGravity
  stowageFactorMin
  stowageFactorMax
  assortmentGroup
  cargoType
  marginAmount
  marginUnit
  loadingRate
  loadingUnit
  dischargingRate
  dischargingUnit
}
    `;
export const VoyageCharterForm_CoaAssortmentFragmentDoc = gql`
    fragment VoyageCharterForm_CoaAssortment on CoaContractAssortment {
  id
  assortmentId
  assortmentGroupId
  minAmount
  maxAmount
  paymentUnit
}
    `;
export const VoyageCharterForm_CoaRouteFragmentDoc = gql`
    fragment VoyageCharterForm_CoaRoute on CoaContractPort {
  id
  destinationId
  destinationZoneId
  originId
  originZoneId
  locationByDestinationId {
    id
    name
  }
  locationByOriginId {
    id
    name
    timezone
  }
  zoneByDestinationZoneId {
    id
    name
    zoneLocationsByZoneId {
      nodes {
        id
        zoneId
        locationId
      }
    }
  }
  zoneByOriginZoneId {
    id
    name
    zoneLocationsByZoneId {
      nodes {
        id
        zoneId
        locationId
      }
    }
  }
}
    `;
export const VoyageCharter_PortDatumFragmentDoc = gql`
    fragment VoyageCharter_PortDatum on PortDatum {
  id
  dischargeRate
  laytimeDays {
    ho
    incExUu
    sa
    su
  }
  loadingRate
  loadingDischargeUnit
  portId
}
    `;
export const VoyageCharterForm_CoaPriceFragmentDoc = gql`
    fragment VoyageCharterForm_CoaPrice on CoaContractPrice {
  id
  coaAssortmentId
  paymentType
  price
  routeId
}
    `;
export const VoyageCharterForm_CoaCommissionFragmentDoc = gql`
    fragment VoyageCharterForm_CoaCommission on CoaContractCommission {
  id
  coaRouteId
  coaContractPortByCoaRouteId {
    id
    originId
    destinationId
  }
  coaAssortmentId
  coaContractAssortmentByCoaAssortmentId {
    id
    assortmentId
    assortmentGroupId
  }
  commissionByCommissionId {
    id
    type
    value
    organizationByOrganizationId {
      id
      name
    }
    voyageCharterId
    bafApplied
    demurrageApplied
    extraFreightApplied
    organizationId
  }
}
    `;
export const VoyageCharterForm_CoaFragmentDoc = gql`
    fragment VoyageCharterForm_Coa on CoaContract {
  id
  inactive
  name
  amountUnitId
  endDate
  externalId
  currency
  cargoUnitByAmountUnitId {
    id
    name
  }
  organizationByChartererOrgId {
    id
    name
  }
  organizationByShipownerOrgId {
    name
    id
  }
  coaContractAssortmentsByCoaContractId {
    nodes {
      id
      ...VoyageCharterForm_CoaAssortment
    }
  }
  coaContractPortsByCoaContractId {
    nodes {
      id
      ...VoyageCharterForm_CoaRoute
    }
  }
  coaContractPortDataByCoaContractId {
    nodes {
      id
      portDatumByPortDataId {
        ...VoyageCharter_PortDatum
      }
    }
  }
  coaContractShipsByCoaContractId {
    nodes {
      id
      shipId
    }
  }
  coaContractPricesByCoaContractId {
    nodes {
      id
      ...VoyageCharterForm_CoaPrice
    }
  }
  coaContractCommissionsByCoaContractId {
    nodes {
      id
      ...VoyageCharterForm_CoaCommission
    }
  }
}
    ${VoyageCharterForm_CoaAssortmentFragmentDoc}
${VoyageCharterForm_CoaRouteFragmentDoc}
${VoyageCharter_PortDatumFragmentDoc}
${VoyageCharterForm_CoaPriceFragmentDoc}
${VoyageCharterForm_CoaCommissionFragmentDoc}`;
export const BaseContractFormFragmentDoc = gql`
    fragment BaseContractForm on Query {
  charterers: allOrganizations(filter: {charterer: {equalTo: true}}) {
    nodes {
      id
      ...SpotForm_Charterer
    }
  }
  shipowners: allOrganizations(filter: {shipOwner: {equalTo: true}}) {
    nodes {
      id
      ...SpotForm_Shipowner
    }
  }
  allOrganizations: allOrganizations {
    nodes {
      id
      ...SpotForm_Charterer
    }
  }
  allAssortments {
    nodes {
      id
      ...VoyageCharterForm_Assortment
    }
  }
  allCoaContracts {
    nodes {
      id
      ...VoyageCharterForm_Coa
    }
  }
}
    ${SpotForm_ChartererFragmentDoc}
${SpotForm_ShipownerFragmentDoc}
${VoyageCharterForm_AssortmentFragmentDoc}
${VoyageCharterForm_CoaFragmentDoc}`;
export const SpotForm_PortAgentFragmentDoc = gql`
    fragment SpotForm_PortAgent on Organization {
  id
  name
}
    `;
export const SpotForm_OrderFragmentDoc = gql`
    fragment SpotForm_Order on Order {
  id
  cargoAmount
  loadPortId
  dischargePortId
  layday
  cancelling
  rta
  deliveredBefore
  assortment: assortmentByAssortmentId {
    id
    name
  }
  cargoUnit: cargoUnitByCargoUnitId {
    id
    name
  }
  loadPort: locationByLoadPortId {
    id
    name
    timezone
  }
  dischargePort: locationByDischargePortId {
    id
    name
    timezone
  }
}
    `;
export const SpotFormFragmentDoc = gql`
    fragment SpotForm on Query {
  ...BaseContractForm
  portAgents: allOrganizations(filter: {portAgent: {equalTo: true}}) {
    nodes {
      id
      ...SpotForm_PortAgent
    }
  }
  unsavedOrders: allOrders(filter: {id: {in: $unsavedOrderIds}}) {
    nodes {
      id
      ...SpotForm_Order
      orderVoyageCharterRelationsByOrderId(condition: {outgoing: $outgoing}) {
        nodes {
          id
          orderId
          voyageCharterId
          outgoing
          coaRouteId
        }
      }
    }
  }
}
    ${BaseContractFormFragmentDoc}
${SpotForm_PortAgentFragmentDoc}
${SpotForm_OrderFragmentDoc}`;
export const SpotForm_LocationFragmentDoc = gql`
    fragment SpotForm_Location on Location {
  id
  name
  timezone
  latitude
  longitude
}
    `;
export const SpotForm_CommissionFragmentDoc = gql`
    fragment SpotForm_Commission on Commission {
  id
  type
  value
  organizationByOrganizationId {
    id
    name
  }
  demurrageApplied
  extraFreightApplied
  bafApplied
  organizationId
  loadPortId
  dischargePortId
  assortmentId
}
    `;
export const SpotForm_ExtraFreightFragmentDoc = gql`
    fragment SpotForm_ExtraFreight on VoyageCharterExtraFreight {
  id
  amount
  description
  externalId
  externalLastUpdate
  externalUpdatedBy
  name
  type
  ignoreInPnl
}
    `;
export const SpotForm_ExtraCostFragmentDoc = gql`
    fragment SpotForm_ExtraCost on VoyageCharterExtraCost {
  id
  amount
  description
  externalId
  name
  type
}
    `;
export const SpotForm_SpotContractFragmentDoc = gql`
    fragment SpotForm_SpotContract on VoyageCharter {
  id
  chartererOrgId
  shipownerOrgId
  vesselId
  cancelling
  layday
  demurrage
  organisationId
  paymentTime
  paymentTrigger
  paymentType
  currency
  lumpsum
  name
  externalId
  shipByVesselId {
    id
    name
  }
  organizationByChartererOrgId {
    id
    name
  }
  organizationByShipownerOrgId {
    id
    name
  }
  orderRelations: orderVoyageCharterRelationsByVoyageCharterId(
    condition: {outgoing: $outgoing}
  ) {
    nodes {
      id
      orderId
      voyageCharterId
      outgoing
      orderByOrderId {
        id
        ...SpotForm_Order
      }
      freight: voyageCharterOrderFreightsByOrderVoyageCharterRelationId {
        nodes {
          id
          orderVoyageCharterRelationId
          freightAmount
          freightUnit
        }
      }
    }
  }
  portDataRelations: voyageCharterPortDataByVoyageCharterId {
    nodes {
      id
      portData: portDatumByPortDataId {
        id
        ...ContractPortDatum
      }
    }
  }
  commissionsByVoyageCharterId {
    nodes {
      id
      ...SpotForm_Commission
    }
  }
  voyageCharterExtraFreightsByVoyageCharterId {
    nodes {
      id
      ...SpotForm_ExtraFreight
    }
  }
  voyageCharterExtraCostsByVoyageCharterId {
    nodes {
      id
      ...SpotForm_ExtraCost
    }
  }
}
    ${SpotForm_OrderFragmentDoc}
${ContractPortDatumFragmentDoc}
${SpotForm_CommissionFragmentDoc}
${SpotForm_ExtraFreightFragmentDoc}
${SpotForm_ExtraCostFragmentDoc}`;
export const VesselChangeForm_VesselFragmentDoc = gql`
    fragment VesselChangeForm_Vessel on Ship {
  id
  name
}
    `;
export const VesselReservationFragmentDoc = gql`
    fragment VesselReservation on VesselReservation {
  duration
  expireTime
  id
  remark
  startPortId
  endPortId
  startRegionId
  endRegionId
  startTime
  type
  vesselId
  shipByVesselId {
    id
    name
  }
  locationByStartPortId {
    id
    name
  }
  locationByEndPortId {
    id
    name
  }
  regionByStartRegionId {
    id
    name
    ordinal
  }
  regionByEndRegionId {
    id
    name
    ordinal
  }
  userByCreatedByUserId {
    id
    name
  }
}
    `;
export const VoyageCharterForm_CargoUnitFragmentDoc = gql`
    fragment VoyageCharterForm_CargoUnit on CargoUnit {
  id
  name
}
    `;
export const VoyageCharter_ContractFragmentDoc = gql`
    fragment VoyageCharter_Contract on VoyageCharterToContract {
  id
  coaId
}
    `;
export const VoyageCharter_OrderFragmentDoc = gql`
    fragment VoyageCharter_Order on Order {
  id
  assortmentId
  assortmentByAssortmentId {
    id
    name
  }
  cargoAmount
  cargoUnitId
  cargoUnitByCargoUnitId {
    id
    name
  }
  loadPortId
  locationByLoadPortId {
    id
    name
    timezone
    zoneLocationsByLocationId {
      nodes {
        id
        zoneId
        locationId
      }
    }
  }
  dischargePortId
  locationByDischargePortId {
    id
    name
    timezone
    zoneLocationsByLocationId {
      nodes {
        id
        zoneId
        locationId
      }
    }
  }
  chartererOrganizationId
  layday
  cancelling
  rta
  deliveredBefore
  loadingRate
  loadingUnit
  dischargingRate
  dischargingUnit
  loadingOverheadDuration
  dischargingOverheadDuration
  softDelete
  externalOrderId
  marginAmount
  marginUnit
  specificGravity
  stowageFactorMax
  stowageFactorMin
  cargoExclusionsByOrderId {
    nodes {
      id
      assortmentGroupByAssortmentGroup {
        id
        name
      }
      distance
      voyages
      tanks
    }
  }
  orderDetailsByOrderId {
    nodes {
      id
      extraInfo
      orderName
      fixtureNote
      imoClass
      cargoDeckOption
    }
  }
  apiOrdersNoticesByOrderId {
    nodes {
      id
      ...ApiOrdersNotice
    }
  }
}
    ${ApiOrdersNoticeFragmentDoc}`;
export const VoyageCharter_VoyageCharterFragmentDoc = gql`
    fragment VoyageCharter_VoyageCharter on VoyageCharter {
  id
  chartererOrgId
  shipownerOrgId
  vesselId
  cancelling
  layday
  demurrage
  organisationId
  paymentTime
  paymentTrigger
  paymentType
  currency
  name
  lumpsum
  externalId
  onSubsUntil
  isInquiry
  isPreliminary
  voyageCharterToContractsByVoyageCharterId {
    nodes {
      id
      ...VoyageCharter_Contract
    }
  }
  shipByVesselId {
    id
    name
  }
  organizationByChartererOrgId {
    id
    name
  }
  organizationByShipownerOrgId {
    id
    name
  }
  orderRelations: orderVoyageCharterRelationsByVoyageCharterId(
    condition: {outgoing: false}
  ) {
    nodes {
      id
      coaRouteId
      orderId
      voyageCharterId
      outgoing
      orderByOrderId {
        id
        ...VoyageCharter_Order
      }
      coaContractPortByCoaRouteId {
        id
        ...VoyageCharterForm_CoaRoute
      }
      freight: voyageCharterOrderFreightsByOrderVoyageCharterRelationId {
        nodes {
          id
          orderVoyageCharterRelationId
          freightAmount
          freightUnit
        }
      }
    }
  }
  commissionsByVoyageCharterId {
    nodes {
      id
      ...SpotForm_Commission
    }
  }
  voyageCharterExtraFreightsByVoyageCharterId {
    nodes {
      id
      ...SpotForm_ExtraFreight
    }
  }
  voyageCharterExtraCostsByVoyageCharterId {
    nodes {
      id
      ...SpotForm_ExtraCost
    }
  }
  voyageCharterPortDataByVoyageCharterId {
    nodes {
      id
      portDataId
      portDatumByPortDataId {
        id
        ...VoyageCharter_PortDatum
      }
    }
  }
}
    ${VoyageCharter_ContractFragmentDoc}
${VoyageCharter_OrderFragmentDoc}
${VoyageCharterForm_CoaRouteFragmentDoc}
${SpotForm_CommissionFragmentDoc}
${SpotForm_ExtraFreightFragmentDoc}
${SpotForm_ExtraCostFragmentDoc}
${VoyageCharter_PortDatumFragmentDoc}`;
export const VoyageCharterUpdates_UpdateFragmentDoc = gql`
    fragment VoyageCharterUpdates_Update on VoyageCharterUpdate {
  id
  createdByUserId
  createdAt
  cancelling
  accepted
  layday
  vesselId
  voyageCharterId
  userByCreatedByUserId {
    id
    email
  }
  shipByVesselId {
    id
    name
  }
}
    `;
export const VoyageCharterUpdates_VoyageCharterFragmentDoc = gql`
    fragment VoyageCharterUpdates_VoyageCharter on VwVoyageCharterShipownerNonfinancial {
  id
  vesselId
  cancelling
  layday
  shipownerOrgId
}
    `;
export const PlanningOrderUpdateFragmentDoc = gql`
    fragment PlanningOrderUpdate on Order {
  id
  softDelete
  ...ScenarioTimeline_Order
  handledBySpotByOrderId {
    id
    ...ScenarioTimeline_HandledBySpot
  }
  handledByCoaByOrderId {
    id
    ...ScenarioTimeline_CoaAssignment
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}
${ScenarioTimeline_HandledBySpotFragmentDoc}
${ScenarioTimeline_CoaAssignmentFragmentDoc}`;
export const CreateApiOrderDocument = gql`
    mutation CreateApiOrder($input: CreateApiOrderInput!) {
  createApiOrder(input: $input) {
    apiOrder {
      ...ApiOrder_Admin
    }
  }
}
    ${ApiOrder_AdminFragmentDoc}`;
export type CreateApiOrderMutationFn = Apollo.MutationFunction<Types.CreateApiOrderMutation, Types.CreateApiOrderMutationVariables>;

/**
 * __useCreateApiOrderMutation__
 *
 * To run a mutation, you first call `useCreateApiOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiOrderMutation, { data, loading, error }] = useCreateApiOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateApiOrderMutation, Types.CreateApiOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateApiOrderMutation, Types.CreateApiOrderMutationVariables>(CreateApiOrderDocument, options);
      }
export type CreateApiOrderMutationHookResult = ReturnType<typeof useCreateApiOrderMutation>;
export type CreateApiOrderMutationResult = Apollo.MutationResult<Types.CreateApiOrderMutation>;
export type CreateApiOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateApiOrderMutation, Types.CreateApiOrderMutationVariables>;
export const AllApiShipsDocument = gql`
    query AllApiShips {
  allApiShips {
    nodes {
      ...ApiShip_Admin
    }
  }
}
    ${ApiShip_AdminFragmentDoc}`;

/**
 * __useAllApiShipsQuery__
 *
 * To run a query within a React component, call `useAllApiShipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllApiShipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllApiShipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllApiShipsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllApiShipsQuery, Types.AllApiShipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllApiShipsQuery, Types.AllApiShipsQueryVariables>(AllApiShipsDocument, options);
      }
export function useAllApiShipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllApiShipsQuery, Types.AllApiShipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllApiShipsQuery, Types.AllApiShipsQueryVariables>(AllApiShipsDocument, options);
        }
export function useAllApiShipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllApiShipsQuery, Types.AllApiShipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllApiShipsQuery, Types.AllApiShipsQueryVariables>(AllApiShipsDocument, options);
        }
export type AllApiShipsQueryHookResult = ReturnType<typeof useAllApiShipsQuery>;
export type AllApiShipsLazyQueryHookResult = ReturnType<typeof useAllApiShipsLazyQuery>;
export type AllApiShipsSuspenseQueryHookResult = ReturnType<typeof useAllApiShipsSuspenseQuery>;
export type AllApiShipsQueryResult = Apollo.QueryResult<Types.AllApiShipsQuery, Types.AllApiShipsQueryVariables>;
export const CreateApiShipDocument = gql`
    mutation createApiShip($input: CreateApiShipInput!) {
  createApiShip(input: $input) {
    apiShip {
      ...ApiShip_Admin
    }
  }
}
    ${ApiShip_AdminFragmentDoc}`;
export type CreateApiShipMutationFn = Apollo.MutationFunction<Types.CreateApiShipMutation, Types.CreateApiShipMutationVariables>;

/**
 * __useCreateApiShipMutation__
 *
 * To run a mutation, you first call `useCreateApiShipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiShipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiShipMutation, { data, loading, error }] = useCreateApiShipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiShipMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateApiShipMutation, Types.CreateApiShipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateApiShipMutation, Types.CreateApiShipMutationVariables>(CreateApiShipDocument, options);
      }
export type CreateApiShipMutationHookResult = ReturnType<typeof useCreateApiShipMutation>;
export type CreateApiShipMutationResult = Apollo.MutationResult<Types.CreateApiShipMutation>;
export type CreateApiShipMutationOptions = Apollo.BaseMutationOptions<Types.CreateApiShipMutation, Types.CreateApiShipMutationVariables>;
export const AllAssortmentExclusionsDocument = gql`
    query AllAssortmentExclusions($orderBy: [AssortmentExclusionsOrderBy!]) {
  allAssortmentExclusions(orderBy: $orderBy) {
    nodes {
      id
      ...AssortmentExclusion_Admin
    }
  }
}
    ${AssortmentExclusion_AdminFragmentDoc}`;

/**
 * __useAllAssortmentExclusionsQuery__
 *
 * To run a query within a React component, call `useAllAssortmentExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssortmentExclusionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssortmentExclusionsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllAssortmentExclusionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllAssortmentExclusionsQuery, Types.AllAssortmentExclusionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllAssortmentExclusionsQuery, Types.AllAssortmentExclusionsQueryVariables>(AllAssortmentExclusionsDocument, options);
      }
export function useAllAssortmentExclusionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllAssortmentExclusionsQuery, Types.AllAssortmentExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllAssortmentExclusionsQuery, Types.AllAssortmentExclusionsQueryVariables>(AllAssortmentExclusionsDocument, options);
        }
export function useAllAssortmentExclusionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllAssortmentExclusionsQuery, Types.AllAssortmentExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllAssortmentExclusionsQuery, Types.AllAssortmentExclusionsQueryVariables>(AllAssortmentExclusionsDocument, options);
        }
export type AllAssortmentExclusionsQueryHookResult = ReturnType<typeof useAllAssortmentExclusionsQuery>;
export type AllAssortmentExclusionsLazyQueryHookResult = ReturnType<typeof useAllAssortmentExclusionsLazyQuery>;
export type AllAssortmentExclusionsSuspenseQueryHookResult = ReturnType<typeof useAllAssortmentExclusionsSuspenseQuery>;
export type AllAssortmentExclusionsQueryResult = Apollo.QueryResult<Types.AllAssortmentExclusionsQuery, Types.AllAssortmentExclusionsQueryVariables>;
export const CreateAssortmentExclusionDocument = gql`
    mutation CreateAssortmentExclusion($input: CreateAssortmentExclusionInput!) {
  createAssortmentExclusion(input: $input) {
    assortmentExclusion {
      id
      ...AssortmentExclusion_Admin
    }
  }
}
    ${AssortmentExclusion_AdminFragmentDoc}`;
export type CreateAssortmentExclusionMutationFn = Apollo.MutationFunction<Types.CreateAssortmentExclusionMutation, Types.CreateAssortmentExclusionMutationVariables>;

/**
 * __useCreateAssortmentExclusionMutation__
 *
 * To run a mutation, you first call `useCreateAssortmentExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssortmentExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssortmentExclusionMutation, { data, loading, error }] = useCreateAssortmentExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssortmentExclusionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAssortmentExclusionMutation, Types.CreateAssortmentExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAssortmentExclusionMutation, Types.CreateAssortmentExclusionMutationVariables>(CreateAssortmentExclusionDocument, options);
      }
export type CreateAssortmentExclusionMutationHookResult = ReturnType<typeof useCreateAssortmentExclusionMutation>;
export type CreateAssortmentExclusionMutationResult = Apollo.MutationResult<Types.CreateAssortmentExclusionMutation>;
export type CreateAssortmentExclusionMutationOptions = Apollo.BaseMutationOptions<Types.CreateAssortmentExclusionMutation, Types.CreateAssortmentExclusionMutationVariables>;
export const UpdateAssortmentExclusionDocument = gql`
    mutation UpdateAssortmentExclusion($input: UpdateAssortmentExclusionByIdInput!) {
  updateAssortmentExclusionById(input: $input) {
    assortmentExclusion {
      id
      ...AssortmentExclusion_Admin
    }
  }
}
    ${AssortmentExclusion_AdminFragmentDoc}`;
export type UpdateAssortmentExclusionMutationFn = Apollo.MutationFunction<Types.UpdateAssortmentExclusionMutation, Types.UpdateAssortmentExclusionMutationVariables>;

/**
 * __useUpdateAssortmentExclusionMutation__
 *
 * To run a mutation, you first call `useUpdateAssortmentExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssortmentExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssortmentExclusionMutation, { data, loading, error }] = useUpdateAssortmentExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssortmentExclusionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAssortmentExclusionMutation, Types.UpdateAssortmentExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAssortmentExclusionMutation, Types.UpdateAssortmentExclusionMutationVariables>(UpdateAssortmentExclusionDocument, options);
      }
export type UpdateAssortmentExclusionMutationHookResult = ReturnType<typeof useUpdateAssortmentExclusionMutation>;
export type UpdateAssortmentExclusionMutationResult = Apollo.MutationResult<Types.UpdateAssortmentExclusionMutation>;
export type UpdateAssortmentExclusionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAssortmentExclusionMutation, Types.UpdateAssortmentExclusionMutationVariables>;
export const DeleteAssortmentExclusionByIdDocument = gql`
    mutation DeleteAssortmentExclusionById($input: DeleteAssortmentExclusionByIdInput!) {
  deleteAssortmentExclusionById(input: $input) {
    assortmentExclusion {
      id
      ...AssortmentExclusion_Admin
    }
  }
}
    ${AssortmentExclusion_AdminFragmentDoc}`;
export type DeleteAssortmentExclusionByIdMutationFn = Apollo.MutationFunction<Types.DeleteAssortmentExclusionByIdMutation, Types.DeleteAssortmentExclusionByIdMutationVariables>;

/**
 * __useDeleteAssortmentExclusionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteAssortmentExclusionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssortmentExclusionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssortmentExclusionByIdMutation, { data, loading, error }] = useDeleteAssortmentExclusionByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAssortmentExclusionByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAssortmentExclusionByIdMutation, Types.DeleteAssortmentExclusionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAssortmentExclusionByIdMutation, Types.DeleteAssortmentExclusionByIdMutationVariables>(DeleteAssortmentExclusionByIdDocument, options);
      }
export type DeleteAssortmentExclusionByIdMutationHookResult = ReturnType<typeof useDeleteAssortmentExclusionByIdMutation>;
export type DeleteAssortmentExclusionByIdMutationResult = Apollo.MutationResult<Types.DeleteAssortmentExclusionByIdMutation>;
export type DeleteAssortmentExclusionByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAssortmentExclusionByIdMutation, Types.DeleteAssortmentExclusionByIdMutationVariables>;
export const AllAssortmentGroupsDocument = gql`
    query AllAssortmentGroups($orderBy: [AssortmentGroupsOrderBy!]) {
  allAssortmentGroups(orderBy: $orderBy) {
    nodes {
      id
      ...AssortmentGroup_Admin
    }
  }
}
    ${AssortmentGroup_AdminFragmentDoc}`;

/**
 * __useAllAssortmentGroupsQuery__
 *
 * To run a query within a React component, call `useAllAssortmentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssortmentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssortmentGroupsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllAssortmentGroupsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllAssortmentGroupsQuery, Types.AllAssortmentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllAssortmentGroupsQuery, Types.AllAssortmentGroupsQueryVariables>(AllAssortmentGroupsDocument, options);
      }
export function useAllAssortmentGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllAssortmentGroupsQuery, Types.AllAssortmentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllAssortmentGroupsQuery, Types.AllAssortmentGroupsQueryVariables>(AllAssortmentGroupsDocument, options);
        }
export function useAllAssortmentGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllAssortmentGroupsQuery, Types.AllAssortmentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllAssortmentGroupsQuery, Types.AllAssortmentGroupsQueryVariables>(AllAssortmentGroupsDocument, options);
        }
export type AllAssortmentGroupsQueryHookResult = ReturnType<typeof useAllAssortmentGroupsQuery>;
export type AllAssortmentGroupsLazyQueryHookResult = ReturnType<typeof useAllAssortmentGroupsLazyQuery>;
export type AllAssortmentGroupsSuspenseQueryHookResult = ReturnType<typeof useAllAssortmentGroupsSuspenseQuery>;
export type AllAssortmentGroupsQueryResult = Apollo.QueryResult<Types.AllAssortmentGroupsQuery, Types.AllAssortmentGroupsQueryVariables>;
export const CreateAssortmentGroupDocument = gql`
    mutation CreateAssortmentGroup($input: CreateAssortmentGroupInput!) {
  createAssortmentGroup(input: $input) {
    assortmentGroup {
      id
      ...AssortmentGroup_Admin
    }
  }
}
    ${AssortmentGroup_AdminFragmentDoc}`;
export type CreateAssortmentGroupMutationFn = Apollo.MutationFunction<Types.CreateAssortmentGroupMutation, Types.CreateAssortmentGroupMutationVariables>;

/**
 * __useCreateAssortmentGroupMutation__
 *
 * To run a mutation, you first call `useCreateAssortmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssortmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssortmentGroupMutation, { data, loading, error }] = useCreateAssortmentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssortmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAssortmentGroupMutation, Types.CreateAssortmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAssortmentGroupMutation, Types.CreateAssortmentGroupMutationVariables>(CreateAssortmentGroupDocument, options);
      }
export type CreateAssortmentGroupMutationHookResult = ReturnType<typeof useCreateAssortmentGroupMutation>;
export type CreateAssortmentGroupMutationResult = Apollo.MutationResult<Types.CreateAssortmentGroupMutation>;
export type CreateAssortmentGroupMutationOptions = Apollo.BaseMutationOptions<Types.CreateAssortmentGroupMutation, Types.CreateAssortmentGroupMutationVariables>;
export const UpdateAssortmentGroupDocument = gql`
    mutation UpdateAssortmentGroup($input: UpdateAssortmentGroupByIdInput!) {
  updateAssortmentGroupById(input: $input) {
    assortmentGroup {
      id
      ...AssortmentGroup_Admin
    }
  }
}
    ${AssortmentGroup_AdminFragmentDoc}`;
export type UpdateAssortmentGroupMutationFn = Apollo.MutationFunction<Types.UpdateAssortmentGroupMutation, Types.UpdateAssortmentGroupMutationVariables>;

/**
 * __useUpdateAssortmentGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAssortmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssortmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssortmentGroupMutation, { data, loading, error }] = useUpdateAssortmentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssortmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAssortmentGroupMutation, Types.UpdateAssortmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAssortmentGroupMutation, Types.UpdateAssortmentGroupMutationVariables>(UpdateAssortmentGroupDocument, options);
      }
export type UpdateAssortmentGroupMutationHookResult = ReturnType<typeof useUpdateAssortmentGroupMutation>;
export type UpdateAssortmentGroupMutationResult = Apollo.MutationResult<Types.UpdateAssortmentGroupMutation>;
export type UpdateAssortmentGroupMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAssortmentGroupMutation, Types.UpdateAssortmentGroupMutationVariables>;
export const DeleteAssortmentGroupByIdDocument = gql`
    mutation DeleteAssortmentGroupById($input: DeleteAssortmentGroupByIdInput!) {
  deleteAssortmentGroupById(input: $input) {
    assortmentGroup {
      id
      ...AssortmentGroup_Admin
    }
  }
}
    ${AssortmentGroup_AdminFragmentDoc}`;
export type DeleteAssortmentGroupByIdMutationFn = Apollo.MutationFunction<Types.DeleteAssortmentGroupByIdMutation, Types.DeleteAssortmentGroupByIdMutationVariables>;

/**
 * __useDeleteAssortmentGroupByIdMutation__
 *
 * To run a mutation, you first call `useDeleteAssortmentGroupByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssortmentGroupByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssortmentGroupByIdMutation, { data, loading, error }] = useDeleteAssortmentGroupByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAssortmentGroupByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAssortmentGroupByIdMutation, Types.DeleteAssortmentGroupByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAssortmentGroupByIdMutation, Types.DeleteAssortmentGroupByIdMutationVariables>(DeleteAssortmentGroupByIdDocument, options);
      }
export type DeleteAssortmentGroupByIdMutationHookResult = ReturnType<typeof useDeleteAssortmentGroupByIdMutation>;
export type DeleteAssortmentGroupByIdMutationResult = Apollo.MutationResult<Types.DeleteAssortmentGroupByIdMutation>;
export type DeleteAssortmentGroupByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAssortmentGroupByIdMutation, Types.DeleteAssortmentGroupByIdMutationVariables>;
export const AllAssortmentsDocument = gql`
    query AllAssortments($orderBy: [AssortmentsOrderBy!]) {
  allAssortments(orderBy: $orderBy) {
    nodes {
      id
      ...Assortment_Admin
    }
  }
}
    ${Assortment_AdminFragmentDoc}`;

/**
 * __useAllAssortmentsQuery__
 *
 * To run a query within a React component, call `useAllAssortmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssortmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssortmentsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllAssortmentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllAssortmentsQuery, Types.AllAssortmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllAssortmentsQuery, Types.AllAssortmentsQueryVariables>(AllAssortmentsDocument, options);
      }
export function useAllAssortmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllAssortmentsQuery, Types.AllAssortmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllAssortmentsQuery, Types.AllAssortmentsQueryVariables>(AllAssortmentsDocument, options);
        }
export function useAllAssortmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllAssortmentsQuery, Types.AllAssortmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllAssortmentsQuery, Types.AllAssortmentsQueryVariables>(AllAssortmentsDocument, options);
        }
export type AllAssortmentsQueryHookResult = ReturnType<typeof useAllAssortmentsQuery>;
export type AllAssortmentsLazyQueryHookResult = ReturnType<typeof useAllAssortmentsLazyQuery>;
export type AllAssortmentsSuspenseQueryHookResult = ReturnType<typeof useAllAssortmentsSuspenseQuery>;
export type AllAssortmentsQueryResult = Apollo.QueryResult<Types.AllAssortmentsQuery, Types.AllAssortmentsQueryVariables>;
export const AllCargoUnitsDocument = gql`
    query AllCargoUnits {
  allCargoUnits {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAllCargoUnitsQuery__
 *
 * To run a query within a React component, call `useAllCargoUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCargoUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCargoUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCargoUnitsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllCargoUnitsQuery, Types.AllCargoUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllCargoUnitsQuery, Types.AllCargoUnitsQueryVariables>(AllCargoUnitsDocument, options);
      }
export function useAllCargoUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllCargoUnitsQuery, Types.AllCargoUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllCargoUnitsQuery, Types.AllCargoUnitsQueryVariables>(AllCargoUnitsDocument, options);
        }
export function useAllCargoUnitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllCargoUnitsQuery, Types.AllCargoUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllCargoUnitsQuery, Types.AllCargoUnitsQueryVariables>(AllCargoUnitsDocument, options);
        }
export type AllCargoUnitsQueryHookResult = ReturnType<typeof useAllCargoUnitsQuery>;
export type AllCargoUnitsLazyQueryHookResult = ReturnType<typeof useAllCargoUnitsLazyQuery>;
export type AllCargoUnitsSuspenseQueryHookResult = ReturnType<typeof useAllCargoUnitsSuspenseQuery>;
export type AllCargoUnitsQueryResult = Apollo.QueryResult<Types.AllCargoUnitsQuery, Types.AllCargoUnitsQueryVariables>;
export const CreateAssortmentDocument = gql`
    mutation CreateAssortment($input: CreateAssortmentInput!) {
  createAssortment(input: $input) {
    assortment {
      id
      ...Assortment_Admin
    }
  }
}
    ${Assortment_AdminFragmentDoc}`;
export type CreateAssortmentMutationFn = Apollo.MutationFunction<Types.CreateAssortmentMutation, Types.CreateAssortmentMutationVariables>;

/**
 * __useCreateAssortmentMutation__
 *
 * To run a mutation, you first call `useCreateAssortmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssortmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssortmentMutation, { data, loading, error }] = useCreateAssortmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssortmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAssortmentMutation, Types.CreateAssortmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAssortmentMutation, Types.CreateAssortmentMutationVariables>(CreateAssortmentDocument, options);
      }
export type CreateAssortmentMutationHookResult = ReturnType<typeof useCreateAssortmentMutation>;
export type CreateAssortmentMutationResult = Apollo.MutationResult<Types.CreateAssortmentMutation>;
export type CreateAssortmentMutationOptions = Apollo.BaseMutationOptions<Types.CreateAssortmentMutation, Types.CreateAssortmentMutationVariables>;
export const UpdateAssortmentDocument = gql`
    mutation UpdateAssortment($input: UpdateAssortmentByIdInput!) {
  updateAssortmentById(input: $input) {
    assortment {
      id
      ...Assortment_Admin
    }
  }
}
    ${Assortment_AdminFragmentDoc}`;
export type UpdateAssortmentMutationFn = Apollo.MutationFunction<Types.UpdateAssortmentMutation, Types.UpdateAssortmentMutationVariables>;

/**
 * __useUpdateAssortmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssortmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssortmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssortmentMutation, { data, loading, error }] = useUpdateAssortmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssortmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAssortmentMutation, Types.UpdateAssortmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAssortmentMutation, Types.UpdateAssortmentMutationVariables>(UpdateAssortmentDocument, options);
      }
export type UpdateAssortmentMutationHookResult = ReturnType<typeof useUpdateAssortmentMutation>;
export type UpdateAssortmentMutationResult = Apollo.MutationResult<Types.UpdateAssortmentMutation>;
export type UpdateAssortmentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAssortmentMutation, Types.UpdateAssortmentMutationVariables>;
export const DeleteAssortmentByIdDocument = gql`
    mutation DeleteAssortmentById($input: DeleteAssortmentByIdInput!) {
  deleteAssortmentById(input: $input) {
    assortment {
      id
      ...Assortment_Admin
    }
  }
}
    ${Assortment_AdminFragmentDoc}`;
export type DeleteAssortmentByIdMutationFn = Apollo.MutationFunction<Types.DeleteAssortmentByIdMutation, Types.DeleteAssortmentByIdMutationVariables>;

/**
 * __useDeleteAssortmentByIdMutation__
 *
 * To run a mutation, you first call `useDeleteAssortmentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssortmentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssortmentByIdMutation, { data, loading, error }] = useDeleteAssortmentByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAssortmentByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAssortmentByIdMutation, Types.DeleteAssortmentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAssortmentByIdMutation, Types.DeleteAssortmentByIdMutationVariables>(DeleteAssortmentByIdDocument, options);
      }
export type DeleteAssortmentByIdMutationHookResult = ReturnType<typeof useDeleteAssortmentByIdMutation>;
export type DeleteAssortmentByIdMutationResult = Apollo.MutationResult<Types.DeleteAssortmentByIdMutation>;
export type DeleteAssortmentByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAssortmentByIdMutation, Types.DeleteAssortmentByIdMutationVariables>;
export const AllBunkerGradeOverridesDocument = gql`
    query AllBunkerGradeOverrides($orderBy: [BunkerGradeOverridesOrderBy!], $filter: BunkerGradeOverrideFilter) {
  allBunkerGradeOverrides(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      ...BunkerGradeOverride_Admin
    }
  }
}
    ${BunkerGradeOverride_AdminFragmentDoc}`;

/**
 * __useAllBunkerGradeOverridesQuery__
 *
 * To run a query within a React component, call `useAllBunkerGradeOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBunkerGradeOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBunkerGradeOverridesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllBunkerGradeOverridesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllBunkerGradeOverridesQuery, Types.AllBunkerGradeOverridesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllBunkerGradeOverridesQuery, Types.AllBunkerGradeOverridesQueryVariables>(AllBunkerGradeOverridesDocument, options);
      }
export function useAllBunkerGradeOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllBunkerGradeOverridesQuery, Types.AllBunkerGradeOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllBunkerGradeOverridesQuery, Types.AllBunkerGradeOverridesQueryVariables>(AllBunkerGradeOverridesDocument, options);
        }
export function useAllBunkerGradeOverridesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllBunkerGradeOverridesQuery, Types.AllBunkerGradeOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllBunkerGradeOverridesQuery, Types.AllBunkerGradeOverridesQueryVariables>(AllBunkerGradeOverridesDocument, options);
        }
export type AllBunkerGradeOverridesQueryHookResult = ReturnType<typeof useAllBunkerGradeOverridesQuery>;
export type AllBunkerGradeOverridesLazyQueryHookResult = ReturnType<typeof useAllBunkerGradeOverridesLazyQuery>;
export type AllBunkerGradeOverridesSuspenseQueryHookResult = ReturnType<typeof useAllBunkerGradeOverridesSuspenseQuery>;
export type AllBunkerGradeOverridesQueryResult = Apollo.QueryResult<Types.AllBunkerGradeOverridesQuery, Types.AllBunkerGradeOverridesQueryVariables>;
export const CreateBunkerGradeOverrideDocument = gql`
    mutation CreateBunkerGradeOverride($input: CreateBunkerGradeOverrideInput!) {
  createBunkerGradeOverride(input: $input) {
    bunkerGradeOverride {
      id
      ...BunkerGradeOverride_Admin
    }
  }
}
    ${BunkerGradeOverride_AdminFragmentDoc}`;
export type CreateBunkerGradeOverrideMutationFn = Apollo.MutationFunction<Types.CreateBunkerGradeOverrideMutation, Types.CreateBunkerGradeOverrideMutationVariables>;

/**
 * __useCreateBunkerGradeOverrideMutation__
 *
 * To run a mutation, you first call `useCreateBunkerGradeOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBunkerGradeOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBunkerGradeOverrideMutation, { data, loading, error }] = useCreateBunkerGradeOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBunkerGradeOverrideMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBunkerGradeOverrideMutation, Types.CreateBunkerGradeOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBunkerGradeOverrideMutation, Types.CreateBunkerGradeOverrideMutationVariables>(CreateBunkerGradeOverrideDocument, options);
      }
export type CreateBunkerGradeOverrideMutationHookResult = ReturnType<typeof useCreateBunkerGradeOverrideMutation>;
export type CreateBunkerGradeOverrideMutationResult = Apollo.MutationResult<Types.CreateBunkerGradeOverrideMutation>;
export type CreateBunkerGradeOverrideMutationOptions = Apollo.BaseMutationOptions<Types.CreateBunkerGradeOverrideMutation, Types.CreateBunkerGradeOverrideMutationVariables>;
export const UpdateBunkerGradeOverrideDocument = gql`
    mutation UpdateBunkerGradeOverride($input: UpdateBunkerGradeOverrideByIdInput!) {
  updateBunkerGradeOverrideById(input: $input) {
    bunkerGradeOverride {
      id
      ...BunkerGradeOverride_Admin
    }
  }
}
    ${BunkerGradeOverride_AdminFragmentDoc}`;
export type UpdateBunkerGradeOverrideMutationFn = Apollo.MutationFunction<Types.UpdateBunkerGradeOverrideMutation, Types.UpdateBunkerGradeOverrideMutationVariables>;

/**
 * __useUpdateBunkerGradeOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateBunkerGradeOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBunkerGradeOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBunkerGradeOverrideMutation, { data, loading, error }] = useUpdateBunkerGradeOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBunkerGradeOverrideMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBunkerGradeOverrideMutation, Types.UpdateBunkerGradeOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBunkerGradeOverrideMutation, Types.UpdateBunkerGradeOverrideMutationVariables>(UpdateBunkerGradeOverrideDocument, options);
      }
export type UpdateBunkerGradeOverrideMutationHookResult = ReturnType<typeof useUpdateBunkerGradeOverrideMutation>;
export type UpdateBunkerGradeOverrideMutationResult = Apollo.MutationResult<Types.UpdateBunkerGradeOverrideMutation>;
export type UpdateBunkerGradeOverrideMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBunkerGradeOverrideMutation, Types.UpdateBunkerGradeOverrideMutationVariables>;
export const DeleteBunkerGradeOverrideByIdDocument = gql`
    mutation DeleteBunkerGradeOverrideById($input: DeleteBunkerGradeOverrideByIdInput!) {
  deleteBunkerGradeOverrideById(input: $input) {
    bunkerGradeOverride {
      id
      ...BunkerGradeOverride_Admin
    }
  }
}
    ${BunkerGradeOverride_AdminFragmentDoc}`;
export type DeleteBunkerGradeOverrideByIdMutationFn = Apollo.MutationFunction<Types.DeleteBunkerGradeOverrideByIdMutation, Types.DeleteBunkerGradeOverrideByIdMutationVariables>;

/**
 * __useDeleteBunkerGradeOverrideByIdMutation__
 *
 * To run a mutation, you first call `useDeleteBunkerGradeOverrideByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBunkerGradeOverrideByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBunkerGradeOverrideByIdMutation, { data, loading, error }] = useDeleteBunkerGradeOverrideByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBunkerGradeOverrideByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteBunkerGradeOverrideByIdMutation, Types.DeleteBunkerGradeOverrideByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteBunkerGradeOverrideByIdMutation, Types.DeleteBunkerGradeOverrideByIdMutationVariables>(DeleteBunkerGradeOverrideByIdDocument, options);
      }
export type DeleteBunkerGradeOverrideByIdMutationHookResult = ReturnType<typeof useDeleteBunkerGradeOverrideByIdMutation>;
export type DeleteBunkerGradeOverrideByIdMutationResult = Apollo.MutationResult<Types.DeleteBunkerGradeOverrideByIdMutation>;
export type DeleteBunkerGradeOverrideByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteBunkerGradeOverrideByIdMutation, Types.DeleteBunkerGradeOverrideByIdMutationVariables>;
export const CreateCargoCompartmentDocument = gql`
    mutation CreateCargoCompartment($input: CreateCargoCompartmentInput!) {
  createCargoCompartment(input: $input) {
    vesselInfoByVesselId {
      id
      ...VesselInfo_Admin
    }
    shipByShipId {
      id
      ...Ship_Admin
    }
    cargoCompartment {
      id
      ...CargoCompartment_Admin
    }
  }
}
    ${VesselInfo_AdminFragmentDoc}
${Ship_AdminFragmentDoc}
${CargoCompartment_AdminFragmentDoc}`;
export type CreateCargoCompartmentMutationFn = Apollo.MutationFunction<Types.CreateCargoCompartmentMutation, Types.CreateCargoCompartmentMutationVariables>;

/**
 * __useCreateCargoCompartmentMutation__
 *
 * To run a mutation, you first call `useCreateCargoCompartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCargoCompartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCargoCompartmentMutation, { data, loading, error }] = useCreateCargoCompartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCargoCompartmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCargoCompartmentMutation, Types.CreateCargoCompartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCargoCompartmentMutation, Types.CreateCargoCompartmentMutationVariables>(CreateCargoCompartmentDocument, options);
      }
export type CreateCargoCompartmentMutationHookResult = ReturnType<typeof useCreateCargoCompartmentMutation>;
export type CreateCargoCompartmentMutationResult = Apollo.MutationResult<Types.CreateCargoCompartmentMutation>;
export type CreateCargoCompartmentMutationOptions = Apollo.BaseMutationOptions<Types.CreateCargoCompartmentMutation, Types.CreateCargoCompartmentMutationVariables>;
export const DeleteCargoCompartmentDocument = gql`
    mutation DeleteCargoCompartment($input: DeleteCargoCompartmentByIdInput!) {
  deleteCargoCompartmentById(input: $input) {
    vesselInfoByVesselId {
      id
      ...VesselInfo_Admin
    }
    shipByShipId {
      id
      ...Ship_Admin
    }
    cargoCompartment {
      id
      ...CargoCompartment_Admin
    }
  }
}
    ${VesselInfo_AdminFragmentDoc}
${Ship_AdminFragmentDoc}
${CargoCompartment_AdminFragmentDoc}`;
export type DeleteCargoCompartmentMutationFn = Apollo.MutationFunction<Types.DeleteCargoCompartmentMutation, Types.DeleteCargoCompartmentMutationVariables>;

/**
 * __useDeleteCargoCompartmentMutation__
 *
 * To run a mutation, you first call `useDeleteCargoCompartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCargoCompartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCargoCompartmentMutation, { data, loading, error }] = useDeleteCargoCompartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCargoCompartmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCargoCompartmentMutation, Types.DeleteCargoCompartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCargoCompartmentMutation, Types.DeleteCargoCompartmentMutationVariables>(DeleteCargoCompartmentDocument, options);
      }
export type DeleteCargoCompartmentMutationHookResult = ReturnType<typeof useDeleteCargoCompartmentMutation>;
export type DeleteCargoCompartmentMutationResult = Apollo.MutationResult<Types.DeleteCargoCompartmentMutation>;
export type DeleteCargoCompartmentMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCargoCompartmentMutation, Types.DeleteCargoCompartmentMutationVariables>;
export const UpdateCargoCompartmentDocument = gql`
    mutation UpdateCargoCompartment($input: UpdateCargoCompartmentByIdInput!) {
  updateCargoCompartmentById(input: $input) {
    cargoCompartment {
      id
      ...CargoCompartment_Admin
    }
  }
}
    ${CargoCompartment_AdminFragmentDoc}`;
export type UpdateCargoCompartmentMutationFn = Apollo.MutationFunction<Types.UpdateCargoCompartmentMutation, Types.UpdateCargoCompartmentMutationVariables>;

/**
 * __useUpdateCargoCompartmentMutation__
 *
 * To run a mutation, you first call `useUpdateCargoCompartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCargoCompartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCargoCompartmentMutation, { data, loading, error }] = useUpdateCargoCompartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCargoCompartmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCargoCompartmentMutation, Types.UpdateCargoCompartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCargoCompartmentMutation, Types.UpdateCargoCompartmentMutationVariables>(UpdateCargoCompartmentDocument, options);
      }
export type UpdateCargoCompartmentMutationHookResult = ReturnType<typeof useUpdateCargoCompartmentMutation>;
export type UpdateCargoCompartmentMutationResult = Apollo.MutationResult<Types.UpdateCargoCompartmentMutation>;
export type UpdateCargoCompartmentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCargoCompartmentMutation, Types.UpdateCargoCompartmentMutationVariables>;
export const AllChannelCostEstimatesDocument = gql`
    query AllChannelCostEstimates($orderBy: [ChannelCostEstimatesOrderBy!], $filter: ChannelCostEstimateFilter) {
  allChannelCostEstimates(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      ...ChannelCostEstimate_Admin
    }
  }
}
    ${ChannelCostEstimate_AdminFragmentDoc}`;

/**
 * __useAllChannelCostEstimatesQuery__
 *
 * To run a query within a React component, call `useAllChannelCostEstimatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChannelCostEstimatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChannelCostEstimatesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllChannelCostEstimatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllChannelCostEstimatesQuery, Types.AllChannelCostEstimatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllChannelCostEstimatesQuery, Types.AllChannelCostEstimatesQueryVariables>(AllChannelCostEstimatesDocument, options);
      }
export function useAllChannelCostEstimatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllChannelCostEstimatesQuery, Types.AllChannelCostEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllChannelCostEstimatesQuery, Types.AllChannelCostEstimatesQueryVariables>(AllChannelCostEstimatesDocument, options);
        }
export function useAllChannelCostEstimatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllChannelCostEstimatesQuery, Types.AllChannelCostEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllChannelCostEstimatesQuery, Types.AllChannelCostEstimatesQueryVariables>(AllChannelCostEstimatesDocument, options);
        }
export type AllChannelCostEstimatesQueryHookResult = ReturnType<typeof useAllChannelCostEstimatesQuery>;
export type AllChannelCostEstimatesLazyQueryHookResult = ReturnType<typeof useAllChannelCostEstimatesLazyQuery>;
export type AllChannelCostEstimatesSuspenseQueryHookResult = ReturnType<typeof useAllChannelCostEstimatesSuspenseQuery>;
export type AllChannelCostEstimatesQueryResult = Apollo.QueryResult<Types.AllChannelCostEstimatesQuery, Types.AllChannelCostEstimatesQueryVariables>;
export const CreateChannelCostEstimateDocument = gql`
    mutation CreateChannelCostEstimate($input: CreateChannelCostEstimateInput!) {
  createChannelCostEstimate(input: $input) {
    channelCostEstimate {
      id
      ...ChannelCostEstimate_Admin
    }
  }
}
    ${ChannelCostEstimate_AdminFragmentDoc}`;
export type CreateChannelCostEstimateMutationFn = Apollo.MutationFunction<Types.CreateChannelCostEstimateMutation, Types.CreateChannelCostEstimateMutationVariables>;

/**
 * __useCreateChannelCostEstimateMutation__
 *
 * To run a mutation, you first call `useCreateChannelCostEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelCostEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelCostEstimateMutation, { data, loading, error }] = useCreateChannelCostEstimateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChannelCostEstimateMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateChannelCostEstimateMutation, Types.CreateChannelCostEstimateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateChannelCostEstimateMutation, Types.CreateChannelCostEstimateMutationVariables>(CreateChannelCostEstimateDocument, options);
      }
export type CreateChannelCostEstimateMutationHookResult = ReturnType<typeof useCreateChannelCostEstimateMutation>;
export type CreateChannelCostEstimateMutationResult = Apollo.MutationResult<Types.CreateChannelCostEstimateMutation>;
export type CreateChannelCostEstimateMutationOptions = Apollo.BaseMutationOptions<Types.CreateChannelCostEstimateMutation, Types.CreateChannelCostEstimateMutationVariables>;
export const UpdateChannelCostEstimateDocument = gql`
    mutation UpdateChannelCostEstimate($input: UpdateChannelCostEstimateByIdInput!) {
  updateChannelCostEstimateById(input: $input) {
    channelCostEstimate {
      id
      ...ChannelCostEstimate_Admin
    }
  }
}
    ${ChannelCostEstimate_AdminFragmentDoc}`;
export type UpdateChannelCostEstimateMutationFn = Apollo.MutationFunction<Types.UpdateChannelCostEstimateMutation, Types.UpdateChannelCostEstimateMutationVariables>;

/**
 * __useUpdateChannelCostEstimateMutation__
 *
 * To run a mutation, you first call `useUpdateChannelCostEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelCostEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelCostEstimateMutation, { data, loading, error }] = useUpdateChannelCostEstimateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelCostEstimateMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChannelCostEstimateMutation, Types.UpdateChannelCostEstimateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChannelCostEstimateMutation, Types.UpdateChannelCostEstimateMutationVariables>(UpdateChannelCostEstimateDocument, options);
      }
export type UpdateChannelCostEstimateMutationHookResult = ReturnType<typeof useUpdateChannelCostEstimateMutation>;
export type UpdateChannelCostEstimateMutationResult = Apollo.MutationResult<Types.UpdateChannelCostEstimateMutation>;
export type UpdateChannelCostEstimateMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChannelCostEstimateMutation, Types.UpdateChannelCostEstimateMutationVariables>;
export const DeleteChannelCostEstimateByIdDocument = gql`
    mutation DeleteChannelCostEstimateById($input: DeleteChannelCostEstimateByIdInput!) {
  deleteChannelCostEstimateById(input: $input) {
    channelCostEstimate {
      id
      ...ChannelCostEstimate_Admin
    }
  }
}
    ${ChannelCostEstimate_AdminFragmentDoc}`;
export type DeleteChannelCostEstimateByIdMutationFn = Apollo.MutationFunction<Types.DeleteChannelCostEstimateByIdMutation, Types.DeleteChannelCostEstimateByIdMutationVariables>;

/**
 * __useDeleteChannelCostEstimateByIdMutation__
 *
 * To run a mutation, you first call `useDeleteChannelCostEstimateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelCostEstimateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelCostEstimateByIdMutation, { data, loading, error }] = useDeleteChannelCostEstimateByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChannelCostEstimateByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteChannelCostEstimateByIdMutation, Types.DeleteChannelCostEstimateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteChannelCostEstimateByIdMutation, Types.DeleteChannelCostEstimateByIdMutationVariables>(DeleteChannelCostEstimateByIdDocument, options);
      }
export type DeleteChannelCostEstimateByIdMutationHookResult = ReturnType<typeof useDeleteChannelCostEstimateByIdMutation>;
export type DeleteChannelCostEstimateByIdMutationResult = Apollo.MutationResult<Types.DeleteChannelCostEstimateByIdMutation>;
export type DeleteChannelCostEstimateByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteChannelCostEstimateByIdMutation, Types.DeleteChannelCostEstimateByIdMutationVariables>;
export const GetOrderByExternalIdDocument = gql`
    query GetOrderByExternalId($externalOrderId: String!) {
  allOrders(condition: {externalOrderId: $externalOrderId}) {
    nodes {
      id
      orderDetailsByOrderId {
        nodes {
          id
        }
      }
      orderVoyageCharterRelationsByOrderId {
        nodes {
          id
          voyageCharterId
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrderByExternalIdQuery__
 *
 * To run a query within a React component, call `useGetOrderByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderByExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderByExternalIdQuery({
 *   variables: {
 *      externalOrderId: // value for 'externalOrderId'
 *   },
 * });
 */
export function useGetOrderByExternalIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrderByExternalIdQuery, Types.GetOrderByExternalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrderByExternalIdQuery, Types.GetOrderByExternalIdQueryVariables>(GetOrderByExternalIdDocument, options);
      }
export function useGetOrderByExternalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrderByExternalIdQuery, Types.GetOrderByExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrderByExternalIdQuery, Types.GetOrderByExternalIdQueryVariables>(GetOrderByExternalIdDocument, options);
        }
export function useGetOrderByExternalIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrderByExternalIdQuery, Types.GetOrderByExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrderByExternalIdQuery, Types.GetOrderByExternalIdQueryVariables>(GetOrderByExternalIdDocument, options);
        }
export type GetOrderByExternalIdQueryHookResult = ReturnType<typeof useGetOrderByExternalIdQuery>;
export type GetOrderByExternalIdLazyQueryHookResult = ReturnType<typeof useGetOrderByExternalIdLazyQuery>;
export type GetOrderByExternalIdSuspenseQueryHookResult = ReturnType<typeof useGetOrderByExternalIdSuspenseQuery>;
export type GetOrderByExternalIdQueryResult = Apollo.QueryResult<Types.GetOrderByExternalIdQuery, Types.GetOrderByExternalIdQueryVariables>;
export const GetVoyageCharterByIdDocument = gql`
    query GetVoyageCharterById($id: Int!) {
  vcById: voyageCharterById(id: $id) {
    id
    orderVoyageCharterRelationsByVoyageCharterId {
      nodes {
        id
        voyageCharterOrderFreightsByOrderVoyageCharterRelationId {
          nodes {
            id
          }
        }
      }
    }
    voyageCharterToContractsByVoyageCharterId {
      nodes {
        id
      }
    }
  }
}
    `;

/**
 * __useGetVoyageCharterByIdQuery__
 *
 * To run a query within a React component, call `useGetVoyageCharterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoyageCharterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoyageCharterByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVoyageCharterByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetVoyageCharterByIdQuery, Types.GetVoyageCharterByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetVoyageCharterByIdQuery, Types.GetVoyageCharterByIdQueryVariables>(GetVoyageCharterByIdDocument, options);
      }
export function useGetVoyageCharterByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetVoyageCharterByIdQuery, Types.GetVoyageCharterByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetVoyageCharterByIdQuery, Types.GetVoyageCharterByIdQueryVariables>(GetVoyageCharterByIdDocument, options);
        }
export function useGetVoyageCharterByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetVoyageCharterByIdQuery, Types.GetVoyageCharterByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetVoyageCharterByIdQuery, Types.GetVoyageCharterByIdQueryVariables>(GetVoyageCharterByIdDocument, options);
        }
export type GetVoyageCharterByIdQueryHookResult = ReturnType<typeof useGetVoyageCharterByIdQuery>;
export type GetVoyageCharterByIdLazyQueryHookResult = ReturnType<typeof useGetVoyageCharterByIdLazyQuery>;
export type GetVoyageCharterByIdSuspenseQueryHookResult = ReturnType<typeof useGetVoyageCharterByIdSuspenseQuery>;
export type GetVoyageCharterByIdQueryResult = Apollo.QueryResult<Types.GetVoyageCharterByIdQuery, Types.GetVoyageCharterByIdQueryVariables>;
export const UpdateOrderByExternalIdDocument = gql`
    mutation UpdateOrderByExternalId($orderInput: UpdateOrderByIdInput!, $orderDetails: UpdateOrderDetailByIdInput!, $vc: UpdateVoyageCharterByIdInput!) {
  updateOrderById(input: $orderInput) {
    order {
      id
      ...ScenarioTimeline_Order
    }
  }
  updateOrderDetailById(input: $orderDetails) {
    orderDetail {
      id
      ...ScenarioTimeline_Order_Details
    }
  }
  updateVoyageCharterById(input: $vc) {
    voyageCharter {
      id
      ...ScenarioTimeline_VoyageCharter
    }
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}
${ScenarioTimeline_Order_DetailsFragmentDoc}
${ScenarioTimeline_VoyageCharterFragmentDoc}`;
export type UpdateOrderByExternalIdMutationFn = Apollo.MutationFunction<Types.UpdateOrderByExternalIdMutation, Types.UpdateOrderByExternalIdMutationVariables>;

/**
 * __useUpdateOrderByExternalIdMutation__
 *
 * To run a mutation, you first call `useUpdateOrderByExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderByExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderByExternalIdMutation, { data, loading, error }] = useUpdateOrderByExternalIdMutation({
 *   variables: {
 *      orderInput: // value for 'orderInput'
 *      orderDetails: // value for 'orderDetails'
 *      vc: // value for 'vc'
 *   },
 * });
 */
export function useUpdateOrderByExternalIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderByExternalIdMutation, Types.UpdateOrderByExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderByExternalIdMutation, Types.UpdateOrderByExternalIdMutationVariables>(UpdateOrderByExternalIdDocument, options);
      }
export type UpdateOrderByExternalIdMutationHookResult = ReturnType<typeof useUpdateOrderByExternalIdMutation>;
export type UpdateOrderByExternalIdMutationResult = Apollo.MutationResult<Types.UpdateOrderByExternalIdMutation>;
export type UpdateOrderByExternalIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderByExternalIdMutation, Types.UpdateOrderByExternalIdMutationVariables>;
export const UpdateVcOrderFreightByIdDocument = gql`
    mutation UpdateVCOrderFreightById($vcFreight: UpdateVoyageCharterOrderFreightByIdInput!) {
  updateVoyageCharterOrderFreightById(input: $vcFreight) {
    voyageCharterOrderFreight {
      id
    }
  }
}
    `;
export type UpdateVcOrderFreightByIdMutationFn = Apollo.MutationFunction<Types.UpdateVcOrderFreightByIdMutation, Types.UpdateVcOrderFreightByIdMutationVariables>;

/**
 * __useUpdateVcOrderFreightByIdMutation__
 *
 * To run a mutation, you first call `useUpdateVcOrderFreightByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVcOrderFreightByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVcOrderFreightByIdMutation, { data, loading, error }] = useUpdateVcOrderFreightByIdMutation({
 *   variables: {
 *      vcFreight: // value for 'vcFreight'
 *   },
 * });
 */
export function useUpdateVcOrderFreightByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVcOrderFreightByIdMutation, Types.UpdateVcOrderFreightByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVcOrderFreightByIdMutation, Types.UpdateVcOrderFreightByIdMutationVariables>(UpdateVcOrderFreightByIdDocument, options);
      }
export type UpdateVcOrderFreightByIdMutationHookResult = ReturnType<typeof useUpdateVcOrderFreightByIdMutation>;
export type UpdateVcOrderFreightByIdMutationResult = Apollo.MutationResult<Types.UpdateVcOrderFreightByIdMutation>;
export type UpdateVcOrderFreightByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVcOrderFreightByIdMutation, Types.UpdateVcOrderFreightByIdMutationVariables>;
export const UpdateVcToContractByIdDocument = gql`
    mutation UpdateVCToContractById($vcContract: UpdateVoyageCharterToContractByIdInput!) {
  updateVoyageCharterToContractById(input: $vcContract) {
    voyageCharterToContract {
      id
    }
  }
}
    `;
export type UpdateVcToContractByIdMutationFn = Apollo.MutationFunction<Types.UpdateVcToContractByIdMutation, Types.UpdateVcToContractByIdMutationVariables>;

/**
 * __useUpdateVcToContractByIdMutation__
 *
 * To run a mutation, you first call `useUpdateVcToContractByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVcToContractByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVcToContractByIdMutation, { data, loading, error }] = useUpdateVcToContractByIdMutation({
 *   variables: {
 *      vcContract: // value for 'vcContract'
 *   },
 * });
 */
export function useUpdateVcToContractByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVcToContractByIdMutation, Types.UpdateVcToContractByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVcToContractByIdMutation, Types.UpdateVcToContractByIdMutationVariables>(UpdateVcToContractByIdDocument, options);
      }
export type UpdateVcToContractByIdMutationHookResult = ReturnType<typeof useUpdateVcToContractByIdMutation>;
export type UpdateVcToContractByIdMutationResult = Apollo.MutationResult<Types.UpdateVcToContractByIdMutation>;
export type UpdateVcToContractByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVcToContractByIdMutation, Types.UpdateVcToContractByIdMutationVariables>;
export const GenericOrderImportDocument = gql`
    mutation genericOrderImport($input: [GenericOrderInput]!) {
  genericOrderImport(input: $input) {
    updatedOrderIds
    insertedOrderIds
  }
}
    `;
export type GenericOrderImportMutationFn = Apollo.MutationFunction<Types.GenericOrderImportMutation, Types.GenericOrderImportMutationVariables>;

/**
 * __useGenericOrderImportMutation__
 *
 * To run a mutation, you first call `useGenericOrderImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenericOrderImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [genericOrderImportMutation, { data, loading, error }] = useGenericOrderImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenericOrderImportMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenericOrderImportMutation, Types.GenericOrderImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenericOrderImportMutation, Types.GenericOrderImportMutationVariables>(GenericOrderImportDocument, options);
      }
export type GenericOrderImportMutationHookResult = ReturnType<typeof useGenericOrderImportMutation>;
export type GenericOrderImportMutationResult = Apollo.MutationResult<Types.GenericOrderImportMutation>;
export type GenericOrderImportMutationOptions = Apollo.BaseMutationOptions<Types.GenericOrderImportMutation, Types.GenericOrderImportMutationVariables>;
export const AllLocationRequirementAssociationsDocument = gql`
    query AllLocationRequirementAssociations($orderBy: [LocationRequirementAssociationsOrderBy!]) {
  items: allLocationRequirementAssociations(orderBy: $orderBy) {
    nodes {
      id
      ...OrderForm_LocationRequirementAssociation
    }
  }
}
    ${OrderForm_LocationRequirementAssociationFragmentDoc}`;

/**
 * __useAllLocationRequirementAssociationsQuery__
 *
 * To run a query within a React component, call `useAllLocationRequirementAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationRequirementAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationRequirementAssociationsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllLocationRequirementAssociationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllLocationRequirementAssociationsQuery, Types.AllLocationRequirementAssociationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllLocationRequirementAssociationsQuery, Types.AllLocationRequirementAssociationsQueryVariables>(AllLocationRequirementAssociationsDocument, options);
      }
export function useAllLocationRequirementAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllLocationRequirementAssociationsQuery, Types.AllLocationRequirementAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllLocationRequirementAssociationsQuery, Types.AllLocationRequirementAssociationsQueryVariables>(AllLocationRequirementAssociationsDocument, options);
        }
export function useAllLocationRequirementAssociationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllLocationRequirementAssociationsQuery, Types.AllLocationRequirementAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllLocationRequirementAssociationsQuery, Types.AllLocationRequirementAssociationsQueryVariables>(AllLocationRequirementAssociationsDocument, options);
        }
export type AllLocationRequirementAssociationsQueryHookResult = ReturnType<typeof useAllLocationRequirementAssociationsQuery>;
export type AllLocationRequirementAssociationsLazyQueryHookResult = ReturnType<typeof useAllLocationRequirementAssociationsLazyQuery>;
export type AllLocationRequirementAssociationsSuspenseQueryHookResult = ReturnType<typeof useAllLocationRequirementAssociationsSuspenseQuery>;
export type AllLocationRequirementAssociationsQueryResult = Apollo.QueryResult<Types.AllLocationRequirementAssociationsQuery, Types.AllLocationRequirementAssociationsQueryVariables>;
export const CreateLocationRequirementAssociationDocument = gql`
    mutation CreateLocationRequirementAssociation($input: CreateLocationRequirementAssociationInput!) {
  createLocationRequirementAssociation(input: $input) {
    locationRequirementAssociation {
      id
      ...OrderForm_LocationRequirementAssociation
    }
  }
}
    ${OrderForm_LocationRequirementAssociationFragmentDoc}`;
export type CreateLocationRequirementAssociationMutationFn = Apollo.MutationFunction<Types.CreateLocationRequirementAssociationMutation, Types.CreateLocationRequirementAssociationMutationVariables>;

/**
 * __useCreateLocationRequirementAssociationMutation__
 *
 * To run a mutation, you first call `useCreateLocationRequirementAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationRequirementAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationRequirementAssociationMutation, { data, loading, error }] = useCreateLocationRequirementAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationRequirementAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLocationRequirementAssociationMutation, Types.CreateLocationRequirementAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLocationRequirementAssociationMutation, Types.CreateLocationRequirementAssociationMutationVariables>(CreateLocationRequirementAssociationDocument, options);
      }
export type CreateLocationRequirementAssociationMutationHookResult = ReturnType<typeof useCreateLocationRequirementAssociationMutation>;
export type CreateLocationRequirementAssociationMutationResult = Apollo.MutationResult<Types.CreateLocationRequirementAssociationMutation>;
export type CreateLocationRequirementAssociationMutationOptions = Apollo.BaseMutationOptions<Types.CreateLocationRequirementAssociationMutation, Types.CreateLocationRequirementAssociationMutationVariables>;
export const UpdateLocationRequirementAssociationDocument = gql`
    mutation UpdateLocationRequirementAssociation($input: UpdateLocationRequirementAssociationByIdInput!) {
  updateLocationRequirementAssociationById(input: $input) {
    locationRequirementAssociation {
      id
      ...OrderForm_LocationRequirementAssociation
    }
  }
}
    ${OrderForm_LocationRequirementAssociationFragmentDoc}`;
export type UpdateLocationRequirementAssociationMutationFn = Apollo.MutationFunction<Types.UpdateLocationRequirementAssociationMutation, Types.UpdateLocationRequirementAssociationMutationVariables>;

/**
 * __useUpdateLocationRequirementAssociationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationRequirementAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationRequirementAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationRequirementAssociationMutation, { data, loading, error }] = useUpdateLocationRequirementAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationRequirementAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLocationRequirementAssociationMutation, Types.UpdateLocationRequirementAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLocationRequirementAssociationMutation, Types.UpdateLocationRequirementAssociationMutationVariables>(UpdateLocationRequirementAssociationDocument, options);
      }
export type UpdateLocationRequirementAssociationMutationHookResult = ReturnType<typeof useUpdateLocationRequirementAssociationMutation>;
export type UpdateLocationRequirementAssociationMutationResult = Apollo.MutationResult<Types.UpdateLocationRequirementAssociationMutation>;
export type UpdateLocationRequirementAssociationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLocationRequirementAssociationMutation, Types.UpdateLocationRequirementAssociationMutationVariables>;
export const DeleteLocationRequirementAssociationByIdDocument = gql`
    mutation deleteLocationRequirementAssociationById($input: DeleteLocationRequirementAssociationByIdInput!) {
  deleteLocationRequirementAssociationById(input: $input) {
    locationRequirementAssociation {
      id
      ...OrderForm_LocationRequirementAssociation
    }
  }
}
    ${OrderForm_LocationRequirementAssociationFragmentDoc}`;
export type DeleteLocationRequirementAssociationByIdMutationFn = Apollo.MutationFunction<Types.DeleteLocationRequirementAssociationByIdMutation, Types.DeleteLocationRequirementAssociationByIdMutationVariables>;

/**
 * __useDeleteLocationRequirementAssociationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteLocationRequirementAssociationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationRequirementAssociationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationRequirementAssociationByIdMutation, { data, loading, error }] = useDeleteLocationRequirementAssociationByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocationRequirementAssociationByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteLocationRequirementAssociationByIdMutation, Types.DeleteLocationRequirementAssociationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteLocationRequirementAssociationByIdMutation, Types.DeleteLocationRequirementAssociationByIdMutationVariables>(DeleteLocationRequirementAssociationByIdDocument, options);
      }
export type DeleteLocationRequirementAssociationByIdMutationHookResult = ReturnType<typeof useDeleteLocationRequirementAssociationByIdMutation>;
export type DeleteLocationRequirementAssociationByIdMutationResult = Apollo.MutationResult<Types.DeleteLocationRequirementAssociationByIdMutation>;
export type DeleteLocationRequirementAssociationByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteLocationRequirementAssociationByIdMutation, Types.DeleteLocationRequirementAssociationByIdMutationVariables>;
export const AllNoGoZonesDocument = gql`
    query AllNoGoZones($orderBy: [NoGoZonesOrderBy!]) {
  allNoGoZones(orderBy: $orderBy) {
    nodes {
      id
      ...NoGoZone_Admin
    }
  }
}
    ${NoGoZone_AdminFragmentDoc}`;

/**
 * __useAllNoGoZonesQuery__
 *
 * To run a query within a React component, call `useAllNoGoZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNoGoZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNoGoZonesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllNoGoZonesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllNoGoZonesQuery, Types.AllNoGoZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllNoGoZonesQuery, Types.AllNoGoZonesQueryVariables>(AllNoGoZonesDocument, options);
      }
export function useAllNoGoZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllNoGoZonesQuery, Types.AllNoGoZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllNoGoZonesQuery, Types.AllNoGoZonesQueryVariables>(AllNoGoZonesDocument, options);
        }
export function useAllNoGoZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllNoGoZonesQuery, Types.AllNoGoZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllNoGoZonesQuery, Types.AllNoGoZonesQueryVariables>(AllNoGoZonesDocument, options);
        }
export type AllNoGoZonesQueryHookResult = ReturnType<typeof useAllNoGoZonesQuery>;
export type AllNoGoZonesLazyQueryHookResult = ReturnType<typeof useAllNoGoZonesLazyQuery>;
export type AllNoGoZonesSuspenseQueryHookResult = ReturnType<typeof useAllNoGoZonesSuspenseQuery>;
export type AllNoGoZonesQueryResult = Apollo.QueryResult<Types.AllNoGoZonesQuery, Types.AllNoGoZonesQueryVariables>;
export const CreateNoGoZoneDocument = gql`
    mutation CreateNoGoZone($input: CreateNoGoZoneInput!) {
  createNoGoZone(input: $input) {
    noGoZone {
      id
      ...NoGoZone_Admin
    }
  }
}
    ${NoGoZone_AdminFragmentDoc}`;
export type CreateNoGoZoneMutationFn = Apollo.MutationFunction<Types.CreateNoGoZoneMutation, Types.CreateNoGoZoneMutationVariables>;

/**
 * __useCreateNoGoZoneMutation__
 *
 * To run a mutation, you first call `useCreateNoGoZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoGoZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoGoZoneMutation, { data, loading, error }] = useCreateNoGoZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoGoZoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateNoGoZoneMutation, Types.CreateNoGoZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateNoGoZoneMutation, Types.CreateNoGoZoneMutationVariables>(CreateNoGoZoneDocument, options);
      }
export type CreateNoGoZoneMutationHookResult = ReturnType<typeof useCreateNoGoZoneMutation>;
export type CreateNoGoZoneMutationResult = Apollo.MutationResult<Types.CreateNoGoZoneMutation>;
export type CreateNoGoZoneMutationOptions = Apollo.BaseMutationOptions<Types.CreateNoGoZoneMutation, Types.CreateNoGoZoneMutationVariables>;
export const UpdateNoGoZoneDocument = gql`
    mutation UpdateNoGoZone($input: UpdateNoGoZoneByIdInput!) {
  updateNoGoZoneById(input: $input) {
    noGoZone {
      id
      ...NoGoZone_Admin
    }
  }
}
    ${NoGoZone_AdminFragmentDoc}`;
export type UpdateNoGoZoneMutationFn = Apollo.MutationFunction<Types.UpdateNoGoZoneMutation, Types.UpdateNoGoZoneMutationVariables>;

/**
 * __useUpdateNoGoZoneMutation__
 *
 * To run a mutation, you first call `useUpdateNoGoZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoGoZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoGoZoneMutation, { data, loading, error }] = useUpdateNoGoZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoGoZoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateNoGoZoneMutation, Types.UpdateNoGoZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateNoGoZoneMutation, Types.UpdateNoGoZoneMutationVariables>(UpdateNoGoZoneDocument, options);
      }
export type UpdateNoGoZoneMutationHookResult = ReturnType<typeof useUpdateNoGoZoneMutation>;
export type UpdateNoGoZoneMutationResult = Apollo.MutationResult<Types.UpdateNoGoZoneMutation>;
export type UpdateNoGoZoneMutationOptions = Apollo.BaseMutationOptions<Types.UpdateNoGoZoneMutation, Types.UpdateNoGoZoneMutationVariables>;
export const DeleteNoGoZoneByIdDocument = gql`
    mutation DeleteNoGoZoneById($input: DeleteNoGoZoneByIdInput!) {
  deleteNoGoZoneById(input: $input) {
    noGoZone {
      id
      ...NoGoZone_Admin
    }
  }
}
    ${NoGoZone_AdminFragmentDoc}`;
export type DeleteNoGoZoneByIdMutationFn = Apollo.MutationFunction<Types.DeleteNoGoZoneByIdMutation, Types.DeleteNoGoZoneByIdMutationVariables>;

/**
 * __useDeleteNoGoZoneByIdMutation__
 *
 * To run a mutation, you first call `useDeleteNoGoZoneByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoGoZoneByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoGoZoneByIdMutation, { data, loading, error }] = useDeleteNoGoZoneByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNoGoZoneByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteNoGoZoneByIdMutation, Types.DeleteNoGoZoneByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteNoGoZoneByIdMutation, Types.DeleteNoGoZoneByIdMutationVariables>(DeleteNoGoZoneByIdDocument, options);
      }
export type DeleteNoGoZoneByIdMutationHookResult = ReturnType<typeof useDeleteNoGoZoneByIdMutation>;
export type DeleteNoGoZoneByIdMutationResult = Apollo.MutationResult<Types.DeleteNoGoZoneByIdMutation>;
export type DeleteNoGoZoneByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteNoGoZoneByIdMutation, Types.DeleteNoGoZoneByIdMutationVariables>;
export const AllOrderAttributesDocument = gql`
    query AllOrderAttributes($orderBy: [OrderAttributesOrderBy!]) {
  allOrderAttributes(orderBy: $orderBy) {
    nodes {
      id
      ...OrderAttribute_Admin
    }
  }
}
    ${OrderAttribute_AdminFragmentDoc}`;

/**
 * __useAllOrderAttributesQuery__
 *
 * To run a query within a React component, call `useAllOrderAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrderAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrderAttributesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllOrderAttributesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllOrderAttributesQuery, Types.AllOrderAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllOrderAttributesQuery, Types.AllOrderAttributesQueryVariables>(AllOrderAttributesDocument, options);
      }
export function useAllOrderAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllOrderAttributesQuery, Types.AllOrderAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllOrderAttributesQuery, Types.AllOrderAttributesQueryVariables>(AllOrderAttributesDocument, options);
        }
export function useAllOrderAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllOrderAttributesQuery, Types.AllOrderAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllOrderAttributesQuery, Types.AllOrderAttributesQueryVariables>(AllOrderAttributesDocument, options);
        }
export type AllOrderAttributesQueryHookResult = ReturnType<typeof useAllOrderAttributesQuery>;
export type AllOrderAttributesLazyQueryHookResult = ReturnType<typeof useAllOrderAttributesLazyQuery>;
export type AllOrderAttributesSuspenseQueryHookResult = ReturnType<typeof useAllOrderAttributesSuspenseQuery>;
export type AllOrderAttributesQueryResult = Apollo.QueryResult<Types.AllOrderAttributesQuery, Types.AllOrderAttributesQueryVariables>;
export const CreateOrderAttributeDocument = gql`
    mutation CreateOrderAttribute($input: CreateOrderAttributeInput!) {
  createOrderAttribute(input: $input) {
    orderAttribute {
      id
      ...OrderAttribute_Admin
    }
  }
}
    ${OrderAttribute_AdminFragmentDoc}`;
export type CreateOrderAttributeMutationFn = Apollo.MutationFunction<Types.CreateOrderAttributeMutation, Types.CreateOrderAttributeMutationVariables>;

/**
 * __useCreateOrderAttributeMutation__
 *
 * To run a mutation, you first call `useCreateOrderAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderAttributeMutation, { data, loading, error }] = useCreateOrderAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderAttributeMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderAttributeMutation, Types.CreateOrderAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderAttributeMutation, Types.CreateOrderAttributeMutationVariables>(CreateOrderAttributeDocument, options);
      }
export type CreateOrderAttributeMutationHookResult = ReturnType<typeof useCreateOrderAttributeMutation>;
export type CreateOrderAttributeMutationResult = Apollo.MutationResult<Types.CreateOrderAttributeMutation>;
export type CreateOrderAttributeMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderAttributeMutation, Types.CreateOrderAttributeMutationVariables>;
export const UpdateOrderAttributeDocument = gql`
    mutation UpdateOrderAttribute($input: UpdateOrderAttributeByIdInput!) {
  updateOrderAttributeById(input: $input) {
    orderAttribute {
      id
      ...OrderAttribute_Admin
    }
  }
}
    ${OrderAttribute_AdminFragmentDoc}`;
export type UpdateOrderAttributeMutationFn = Apollo.MutationFunction<Types.UpdateOrderAttributeMutation, Types.UpdateOrderAttributeMutationVariables>;

/**
 * __useUpdateOrderAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateOrderAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderAttributeMutation, { data, loading, error }] = useUpdateOrderAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderAttributeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderAttributeMutation, Types.UpdateOrderAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderAttributeMutation, Types.UpdateOrderAttributeMutationVariables>(UpdateOrderAttributeDocument, options);
      }
export type UpdateOrderAttributeMutationHookResult = ReturnType<typeof useUpdateOrderAttributeMutation>;
export type UpdateOrderAttributeMutationResult = Apollo.MutationResult<Types.UpdateOrderAttributeMutation>;
export type UpdateOrderAttributeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderAttributeMutation, Types.UpdateOrderAttributeMutationVariables>;
export const DeleteOrderAttributeByIdDocument = gql`
    mutation DeleteOrderAttributeById($input: DeleteOrderAttributeByIdInput!) {
  deleteOrderAttributeById(input: $input) {
    orderAttribute {
      id
      ...OrderAttribute_Admin
    }
  }
}
    ${OrderAttribute_AdminFragmentDoc}`;
export type DeleteOrderAttributeByIdMutationFn = Apollo.MutationFunction<Types.DeleteOrderAttributeByIdMutation, Types.DeleteOrderAttributeByIdMutationVariables>;

/**
 * __useDeleteOrderAttributeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrderAttributeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderAttributeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderAttributeByIdMutation, { data, loading, error }] = useDeleteOrderAttributeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderAttributeByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderAttributeByIdMutation, Types.DeleteOrderAttributeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderAttributeByIdMutation, Types.DeleteOrderAttributeByIdMutationVariables>(DeleteOrderAttributeByIdDocument, options);
      }
export type DeleteOrderAttributeByIdMutationHookResult = ReturnType<typeof useDeleteOrderAttributeByIdMutation>;
export type DeleteOrderAttributeByIdMutationResult = Apollo.MutationResult<Types.DeleteOrderAttributeByIdMutation>;
export type DeleteOrderAttributeByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderAttributeByIdMutation, Types.DeleteOrderAttributeByIdMutationVariables>;
export const AllOrganizationsDocument = gql`
    query AllOrganizations($filter: OrganizationFilter) {
  allOrganizations(filter: $filter) {
    nodes {
      id
      ...Organization_Admin
    }
  }
}
    ${Organization_AdminFragmentDoc}`;

/**
 * __useAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrganizationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllOrganizationsQuery, Types.AllOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllOrganizationsQuery, Types.AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
      }
export function useAllOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllOrganizationsQuery, Types.AllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllOrganizationsQuery, Types.AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
        }
export function useAllOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllOrganizationsQuery, Types.AllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllOrganizationsQuery, Types.AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
        }
export type AllOrganizationsQueryHookResult = ReturnType<typeof useAllOrganizationsQuery>;
export type AllOrganizationsLazyQueryHookResult = ReturnType<typeof useAllOrganizationsLazyQuery>;
export type AllOrganizationsSuspenseQueryHookResult = ReturnType<typeof useAllOrganizationsSuspenseQuery>;
export type AllOrganizationsQueryResult = Apollo.QueryResult<Types.AllOrganizationsQuery, Types.AllOrganizationsQueryVariables>;
export const AllOrganizationFeaturesDocument = gql`
    query AllOrganizationFeatures($orderBy: [OrganizationFeaturesOrderBy!]) {
  allOrganizationFeatures(orderBy: $orderBy) {
    nodes {
      id
      ...OrganizationFeature_Admin
    }
  }
}
    ${OrganizationFeature_AdminFragmentDoc}`;

/**
 * __useAllOrganizationFeaturesQuery__
 *
 * To run a query within a React component, call `useAllOrganizationFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrganizationFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrganizationFeaturesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllOrganizationFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllOrganizationFeaturesQuery, Types.AllOrganizationFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllOrganizationFeaturesQuery, Types.AllOrganizationFeaturesQueryVariables>(AllOrganizationFeaturesDocument, options);
      }
export function useAllOrganizationFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllOrganizationFeaturesQuery, Types.AllOrganizationFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllOrganizationFeaturesQuery, Types.AllOrganizationFeaturesQueryVariables>(AllOrganizationFeaturesDocument, options);
        }
export function useAllOrganizationFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllOrganizationFeaturesQuery, Types.AllOrganizationFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllOrganizationFeaturesQuery, Types.AllOrganizationFeaturesQueryVariables>(AllOrganizationFeaturesDocument, options);
        }
export type AllOrganizationFeaturesQueryHookResult = ReturnType<typeof useAllOrganizationFeaturesQuery>;
export type AllOrganizationFeaturesLazyQueryHookResult = ReturnType<typeof useAllOrganizationFeaturesLazyQuery>;
export type AllOrganizationFeaturesSuspenseQueryHookResult = ReturnType<typeof useAllOrganizationFeaturesSuspenseQuery>;
export type AllOrganizationFeaturesQueryResult = Apollo.QueryResult<Types.AllOrganizationFeaturesQuery, Types.AllOrganizationFeaturesQueryVariables>;
export const AllFeaturesDocument = gql`
    query AllFeatures {
  allFeatures {
    nodes {
      featureName
    }
  }
}
    `;

/**
 * __useAllFeaturesQuery__
 *
 * To run a query within a React component, call `useAllFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllFeaturesQuery, Types.AllFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllFeaturesQuery, Types.AllFeaturesQueryVariables>(AllFeaturesDocument, options);
      }
export function useAllFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllFeaturesQuery, Types.AllFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllFeaturesQuery, Types.AllFeaturesQueryVariables>(AllFeaturesDocument, options);
        }
export function useAllFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllFeaturesQuery, Types.AllFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllFeaturesQuery, Types.AllFeaturesQueryVariables>(AllFeaturesDocument, options);
        }
export type AllFeaturesQueryHookResult = ReturnType<typeof useAllFeaturesQuery>;
export type AllFeaturesLazyQueryHookResult = ReturnType<typeof useAllFeaturesLazyQuery>;
export type AllFeaturesSuspenseQueryHookResult = ReturnType<typeof useAllFeaturesSuspenseQuery>;
export type AllFeaturesQueryResult = Apollo.QueryResult<Types.AllFeaturesQuery, Types.AllFeaturesQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    organization {
      id
      ...Organization_Admin
    }
  }
}
    ${Organization_AdminFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<Types.CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationByIdInput!) {
  updateOrganizationById(input: $input) {
    organization {
      id
      ...Organization_Admin
    }
  }
}
    ${Organization_AdminFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<Types.UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>;
export const DeleteOrganizationByIdDocument = gql`
    mutation deleteOrganizationById($input: DeleteOrganizationByIdInput!) {
  deleteOrganizationById(input: $input) {
    organization {
      id
      ...Organization_Admin
    }
  }
}
    ${Organization_AdminFragmentDoc}`;
export type DeleteOrganizationByIdMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationByIdMutation, Types.DeleteOrganizationByIdMutationVariables>;

/**
 * __useDeleteOrganizationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationByIdMutation, { data, loading, error }] = useDeleteOrganizationByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationByIdMutation, Types.DeleteOrganizationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationByIdMutation, Types.DeleteOrganizationByIdMutationVariables>(DeleteOrganizationByIdDocument, options);
      }
export type DeleteOrganizationByIdMutationHookResult = ReturnType<typeof useDeleteOrganizationByIdMutation>;
export type DeleteOrganizationByIdMutationResult = Apollo.MutationResult<Types.DeleteOrganizationByIdMutation>;
export type DeleteOrganizationByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationByIdMutation, Types.DeleteOrganizationByIdMutationVariables>;
export const CreateOrganizationFeatureDocument = gql`
    mutation CreateOrganizationFeature($input: CreateOrganizationFeatureInput!) {
  createOrganizationFeature(input: $input) {
    organizationFeature {
      id
      ...OrganizationFeature_Admin
    }
  }
}
    ${OrganizationFeature_AdminFragmentDoc}`;
export type CreateOrganizationFeatureMutationFn = Apollo.MutationFunction<Types.CreateOrganizationFeatureMutation, Types.CreateOrganizationFeatureMutationVariables>;

/**
 * __useCreateOrganizationFeatureMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationFeatureMutation, { data, loading, error }] = useCreateOrganizationFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationFeatureMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationFeatureMutation, Types.CreateOrganizationFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationFeatureMutation, Types.CreateOrganizationFeatureMutationVariables>(CreateOrganizationFeatureDocument, options);
      }
export type CreateOrganizationFeatureMutationHookResult = ReturnType<typeof useCreateOrganizationFeatureMutation>;
export type CreateOrganizationFeatureMutationResult = Apollo.MutationResult<Types.CreateOrganizationFeatureMutation>;
export type CreateOrganizationFeatureMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationFeatureMutation, Types.CreateOrganizationFeatureMutationVariables>;
export const UpdateOrganizationFeatureDocument = gql`
    mutation UpdateOrganizationFeature($input: UpdateOrganizationFeatureByIdInput!) {
  updateOrganizationFeatureById(input: $input) {
    organizationFeature {
      id
      ...OrganizationFeature_Admin
    }
  }
}
    ${OrganizationFeature_AdminFragmentDoc}`;
export type UpdateOrganizationFeatureMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationFeatureMutation, Types.UpdateOrganizationFeatureMutationVariables>;

/**
 * __useUpdateOrganizationFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationFeatureMutation, { data, loading, error }] = useUpdateOrganizationFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationFeatureMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationFeatureMutation, Types.UpdateOrganizationFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationFeatureMutation, Types.UpdateOrganizationFeatureMutationVariables>(UpdateOrganizationFeatureDocument, options);
      }
export type UpdateOrganizationFeatureMutationHookResult = ReturnType<typeof useUpdateOrganizationFeatureMutation>;
export type UpdateOrganizationFeatureMutationResult = Apollo.MutationResult<Types.UpdateOrganizationFeatureMutation>;
export type UpdateOrganizationFeatureMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationFeatureMutation, Types.UpdateOrganizationFeatureMutationVariables>;
export const DeleteOrganizationFeatureByIdDocument = gql`
    mutation DeleteOrganizationFeatureById($input: DeleteOrganizationFeatureByIdInput!) {
  deleteOrganizationFeatureById(input: $input) {
    organizationFeature {
      id
      ...OrganizationFeature_Admin
    }
  }
}
    ${OrganizationFeature_AdminFragmentDoc}`;
export type DeleteOrganizationFeatureByIdMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationFeatureByIdMutation, Types.DeleteOrganizationFeatureByIdMutationVariables>;

/**
 * __useDeleteOrganizationFeatureByIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationFeatureByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationFeatureByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationFeatureByIdMutation, { data, loading, error }] = useDeleteOrganizationFeatureByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationFeatureByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationFeatureByIdMutation, Types.DeleteOrganizationFeatureByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationFeatureByIdMutation, Types.DeleteOrganizationFeatureByIdMutationVariables>(DeleteOrganizationFeatureByIdDocument, options);
      }
export type DeleteOrganizationFeatureByIdMutationHookResult = ReturnType<typeof useDeleteOrganizationFeatureByIdMutation>;
export type DeleteOrganizationFeatureByIdMutationResult = Apollo.MutationResult<Types.DeleteOrganizationFeatureByIdMutation>;
export type DeleteOrganizationFeatureByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationFeatureByIdMutation, Types.DeleteOrganizationFeatureByIdMutationVariables>;
export const UpdateOrganizationAreaBunkerGradeDocument = gql`
    mutation UpdateOrganizationAreaBunkerGrade($input: UpdateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput!) {
  updateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea(
    input: $input
  ) {
    organizationByOrganizationId {
      id
      organizationAreaBunkerGradeMappingsByOrganizationId {
        nodes {
          bunkerGradeId
          vesselArea
        }
      }
    }
  }
}
    `;
export type UpdateOrganizationAreaBunkerGradeMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationAreaBunkerGradeMutation, Types.UpdateOrganizationAreaBunkerGradeMutationVariables>;

/**
 * __useUpdateOrganizationAreaBunkerGradeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAreaBunkerGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAreaBunkerGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAreaBunkerGradeMutation, { data, loading, error }] = useUpdateOrganizationAreaBunkerGradeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAreaBunkerGradeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationAreaBunkerGradeMutation, Types.UpdateOrganizationAreaBunkerGradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationAreaBunkerGradeMutation, Types.UpdateOrganizationAreaBunkerGradeMutationVariables>(UpdateOrganizationAreaBunkerGradeDocument, options);
      }
export type UpdateOrganizationAreaBunkerGradeMutationHookResult = ReturnType<typeof useUpdateOrganizationAreaBunkerGradeMutation>;
export type UpdateOrganizationAreaBunkerGradeMutationResult = Apollo.MutationResult<Types.UpdateOrganizationAreaBunkerGradeMutation>;
export type UpdateOrganizationAreaBunkerGradeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationAreaBunkerGradeMutation, Types.UpdateOrganizationAreaBunkerGradeMutationVariables>;
export const CreateOrganizationAreaBunkerGradeDocument = gql`
    mutation CreateOrganizationAreaBunkerGrade($input: CreateOrganizationAreaBunkerGradeMappingInput!) {
  createOrganizationAreaBunkerGradeMapping(input: $input) {
    organizationByOrganizationId {
      id
      organizationAreaBunkerGradeMappingsByOrganizationId {
        nodes {
          bunkerGradeId
          vesselArea
        }
      }
    }
  }
}
    `;
export type CreateOrganizationAreaBunkerGradeMutationFn = Apollo.MutationFunction<Types.CreateOrganizationAreaBunkerGradeMutation, Types.CreateOrganizationAreaBunkerGradeMutationVariables>;

/**
 * __useCreateOrganizationAreaBunkerGradeMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAreaBunkerGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAreaBunkerGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAreaBunkerGradeMutation, { data, loading, error }] = useCreateOrganizationAreaBunkerGradeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationAreaBunkerGradeMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationAreaBunkerGradeMutation, Types.CreateOrganizationAreaBunkerGradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationAreaBunkerGradeMutation, Types.CreateOrganizationAreaBunkerGradeMutationVariables>(CreateOrganizationAreaBunkerGradeDocument, options);
      }
export type CreateOrganizationAreaBunkerGradeMutationHookResult = ReturnType<typeof useCreateOrganizationAreaBunkerGradeMutation>;
export type CreateOrganizationAreaBunkerGradeMutationResult = Apollo.MutationResult<Types.CreateOrganizationAreaBunkerGradeMutation>;
export type CreateOrganizationAreaBunkerGradeMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationAreaBunkerGradeMutation, Types.CreateOrganizationAreaBunkerGradeMutationVariables>;
export const DeleteOrganizationAreaBunkerGradeDocument = gql`
    mutation DeleteOrganizationAreaBunkerGrade($input: DeleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput!) {
  deleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea(
    input: $input
  ) {
    organizationByOrganizationId {
      id
      organizationAreaBunkerGradeMappingsByOrganizationId {
        nodes {
          bunkerGradeId
          vesselArea
        }
      }
    }
  }
}
    `;
export type DeleteOrganizationAreaBunkerGradeMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationAreaBunkerGradeMutation, Types.DeleteOrganizationAreaBunkerGradeMutationVariables>;

/**
 * __useDeleteOrganizationAreaBunkerGradeMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationAreaBunkerGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationAreaBunkerGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationAreaBunkerGradeMutation, { data, loading, error }] = useDeleteOrganizationAreaBunkerGradeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationAreaBunkerGradeMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationAreaBunkerGradeMutation, Types.DeleteOrganizationAreaBunkerGradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationAreaBunkerGradeMutation, Types.DeleteOrganizationAreaBunkerGradeMutationVariables>(DeleteOrganizationAreaBunkerGradeDocument, options);
      }
export type DeleteOrganizationAreaBunkerGradeMutationHookResult = ReturnType<typeof useDeleteOrganizationAreaBunkerGradeMutation>;
export type DeleteOrganizationAreaBunkerGradeMutationResult = Apollo.MutationResult<Types.DeleteOrganizationAreaBunkerGradeMutation>;
export type DeleteOrganizationAreaBunkerGradeMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationAreaBunkerGradeMutation, Types.DeleteOrganizationAreaBunkerGradeMutationVariables>;
export const CreateBunkerGradeMappingDocument = gql`
    mutation CreateBunkerGradeMapping($input: CreateBunkerGradeMappingInput!) {
  createBunkerGradeMapping(input: $input) {
    bunkerGradeMapping {
      id
      fromGradeId
      toGradeId
    }
  }
}
    `;
export type CreateBunkerGradeMappingMutationFn = Apollo.MutationFunction<Types.CreateBunkerGradeMappingMutation, Types.CreateBunkerGradeMappingMutationVariables>;

/**
 * __useCreateBunkerGradeMappingMutation__
 *
 * To run a mutation, you first call `useCreateBunkerGradeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBunkerGradeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBunkerGradeMappingMutation, { data, loading, error }] = useCreateBunkerGradeMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBunkerGradeMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBunkerGradeMappingMutation, Types.CreateBunkerGradeMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBunkerGradeMappingMutation, Types.CreateBunkerGradeMappingMutationVariables>(CreateBunkerGradeMappingDocument, options);
      }
export type CreateBunkerGradeMappingMutationHookResult = ReturnType<typeof useCreateBunkerGradeMappingMutation>;
export type CreateBunkerGradeMappingMutationResult = Apollo.MutationResult<Types.CreateBunkerGradeMappingMutation>;
export type CreateBunkerGradeMappingMutationOptions = Apollo.BaseMutationOptions<Types.CreateBunkerGradeMappingMutation, Types.CreateBunkerGradeMappingMutationVariables>;
export const UpdateBunkerGradeMappingDocument = gql`
    mutation UpdateBunkerGradeMapping($input: UpdateBunkerGradeMappingByIdInput!) {
  updateBunkerGradeMappingById(input: $input) {
    bunkerGradeMapping {
      id
      fromGradeId
      toGradeId
    }
  }
}
    `;
export type UpdateBunkerGradeMappingMutationFn = Apollo.MutationFunction<Types.UpdateBunkerGradeMappingMutation, Types.UpdateBunkerGradeMappingMutationVariables>;

/**
 * __useUpdateBunkerGradeMappingMutation__
 *
 * To run a mutation, you first call `useUpdateBunkerGradeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBunkerGradeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBunkerGradeMappingMutation, { data, loading, error }] = useUpdateBunkerGradeMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBunkerGradeMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBunkerGradeMappingMutation, Types.UpdateBunkerGradeMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBunkerGradeMappingMutation, Types.UpdateBunkerGradeMappingMutationVariables>(UpdateBunkerGradeMappingDocument, options);
      }
export type UpdateBunkerGradeMappingMutationHookResult = ReturnType<typeof useUpdateBunkerGradeMappingMutation>;
export type UpdateBunkerGradeMappingMutationResult = Apollo.MutationResult<Types.UpdateBunkerGradeMappingMutation>;
export type UpdateBunkerGradeMappingMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBunkerGradeMappingMutation, Types.UpdateBunkerGradeMappingMutationVariables>;
export const DeleteBunkerGradeMappingDocument = gql`
    mutation DeleteBunkerGradeMapping($input: DeleteBunkerGradeMappingByIdInput!) {
  deleteBunkerGradeMappingById(input: $input) {
    bunkerGradeMapping {
      id
    }
  }
}
    `;
export type DeleteBunkerGradeMappingMutationFn = Apollo.MutationFunction<Types.DeleteBunkerGradeMappingMutation, Types.DeleteBunkerGradeMappingMutationVariables>;

/**
 * __useDeleteBunkerGradeMappingMutation__
 *
 * To run a mutation, you first call `useDeleteBunkerGradeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBunkerGradeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBunkerGradeMappingMutation, { data, loading, error }] = useDeleteBunkerGradeMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBunkerGradeMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteBunkerGradeMappingMutation, Types.DeleteBunkerGradeMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteBunkerGradeMappingMutation, Types.DeleteBunkerGradeMappingMutationVariables>(DeleteBunkerGradeMappingDocument, options);
      }
export type DeleteBunkerGradeMappingMutationHookResult = ReturnType<typeof useDeleteBunkerGradeMappingMutation>;
export type DeleteBunkerGradeMappingMutationResult = Apollo.MutationResult<Types.DeleteBunkerGradeMappingMutation>;
export type DeleteBunkerGradeMappingMutationOptions = Apollo.BaseMutationOptions<Types.DeleteBunkerGradeMappingMutation, Types.DeleteBunkerGradeMappingMutationVariables>;
export const AllPortCommodityLdRatesDocument = gql`
    query AllPortCommodityLdRates($orderBy: [PortCommodityLdRatesOrderBy!]) {
  allPortCommodityLdRates(orderBy: $orderBy) {
    nodes {
      id
      ...PortCommodityLdRates_Admin
    }
  }
}
    ${PortCommodityLdRates_AdminFragmentDoc}`;

/**
 * __useAllPortCommodityLdRatesQuery__
 *
 * To run a query within a React component, call `useAllPortCommodityLdRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPortCommodityLdRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPortCommodityLdRatesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllPortCommodityLdRatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllPortCommodityLdRatesQuery, Types.AllPortCommodityLdRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllPortCommodityLdRatesQuery, Types.AllPortCommodityLdRatesQueryVariables>(AllPortCommodityLdRatesDocument, options);
      }
export function useAllPortCommodityLdRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllPortCommodityLdRatesQuery, Types.AllPortCommodityLdRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllPortCommodityLdRatesQuery, Types.AllPortCommodityLdRatesQueryVariables>(AllPortCommodityLdRatesDocument, options);
        }
export function useAllPortCommodityLdRatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllPortCommodityLdRatesQuery, Types.AllPortCommodityLdRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllPortCommodityLdRatesQuery, Types.AllPortCommodityLdRatesQueryVariables>(AllPortCommodityLdRatesDocument, options);
        }
export type AllPortCommodityLdRatesQueryHookResult = ReturnType<typeof useAllPortCommodityLdRatesQuery>;
export type AllPortCommodityLdRatesLazyQueryHookResult = ReturnType<typeof useAllPortCommodityLdRatesLazyQuery>;
export type AllPortCommodityLdRatesSuspenseQueryHookResult = ReturnType<typeof useAllPortCommodityLdRatesSuspenseQuery>;
export type AllPortCommodityLdRatesQueryResult = Apollo.QueryResult<Types.AllPortCommodityLdRatesQuery, Types.AllPortCommodityLdRatesQueryVariables>;
export const CreatePortCommodityLdRateDocument = gql`
    mutation CreatePortCommodityLdRate($input: CreatePortCommodityLdRateInput!) {
  createPortCommodityLdRate(input: $input) {
    portCommodityLdRate {
      id
      ...PortCommodityLdRates_Admin
    }
    organizationByOrganizationId {
      id
      portCommodityLdRatesByOrganizationId {
        nodes {
          id
        }
      }
    }
  }
}
    ${PortCommodityLdRates_AdminFragmentDoc}`;
export type CreatePortCommodityLdRateMutationFn = Apollo.MutationFunction<Types.CreatePortCommodityLdRateMutation, Types.CreatePortCommodityLdRateMutationVariables>;

/**
 * __useCreatePortCommodityLdRateMutation__
 *
 * To run a mutation, you first call `useCreatePortCommodityLdRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortCommodityLdRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortCommodityLdRateMutation, { data, loading, error }] = useCreatePortCommodityLdRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortCommodityLdRateMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortCommodityLdRateMutation, Types.CreatePortCommodityLdRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortCommodityLdRateMutation, Types.CreatePortCommodityLdRateMutationVariables>(CreatePortCommodityLdRateDocument, options);
      }
export type CreatePortCommodityLdRateMutationHookResult = ReturnType<typeof useCreatePortCommodityLdRateMutation>;
export type CreatePortCommodityLdRateMutationResult = Apollo.MutationResult<Types.CreatePortCommodityLdRateMutation>;
export type CreatePortCommodityLdRateMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortCommodityLdRateMutation, Types.CreatePortCommodityLdRateMutationVariables>;
export const UpdatePortCommodityLdRateDocument = gql`
    mutation UpdatePortCommodityLdRate($input: UpdatePortCommodityLdRateByIdInput!) {
  updatePortCommodityLdRateById(input: $input) {
    portCommodityLdRate {
      id
      ...PortCommodityLdRates_Admin
    }
  }
}
    ${PortCommodityLdRates_AdminFragmentDoc}`;
export type UpdatePortCommodityLdRateMutationFn = Apollo.MutationFunction<Types.UpdatePortCommodityLdRateMutation, Types.UpdatePortCommodityLdRateMutationVariables>;

/**
 * __useUpdatePortCommodityLdRateMutation__
 *
 * To run a mutation, you first call `useUpdatePortCommodityLdRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortCommodityLdRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortCommodityLdRateMutation, { data, loading, error }] = useUpdatePortCommodityLdRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortCommodityLdRateMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortCommodityLdRateMutation, Types.UpdatePortCommodityLdRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortCommodityLdRateMutation, Types.UpdatePortCommodityLdRateMutationVariables>(UpdatePortCommodityLdRateDocument, options);
      }
export type UpdatePortCommodityLdRateMutationHookResult = ReturnType<typeof useUpdatePortCommodityLdRateMutation>;
export type UpdatePortCommodityLdRateMutationResult = Apollo.MutationResult<Types.UpdatePortCommodityLdRateMutation>;
export type UpdatePortCommodityLdRateMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortCommodityLdRateMutation, Types.UpdatePortCommodityLdRateMutationVariables>;
export const DeletePortCommodityLdRateDocument = gql`
    mutation DeletePortCommodityLdRate($input: DeletePortCommodityLdRateByIdInput!) {
  deletePortCommodityLdRateById(input: $input) {
    portCommodityLdRate {
      id
      ...PortCommodityLdRates_Admin
    }
  }
}
    ${PortCommodityLdRates_AdminFragmentDoc}`;
export type DeletePortCommodityLdRateMutationFn = Apollo.MutationFunction<Types.DeletePortCommodityLdRateMutation, Types.DeletePortCommodityLdRateMutationVariables>;

/**
 * __useDeletePortCommodityLdRateMutation__
 *
 * To run a mutation, you first call `useDeletePortCommodityLdRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortCommodityLdRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortCommodityLdRateMutation, { data, loading, error }] = useDeletePortCommodityLdRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePortCommodityLdRateMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePortCommodityLdRateMutation, Types.DeletePortCommodityLdRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePortCommodityLdRateMutation, Types.DeletePortCommodityLdRateMutationVariables>(DeletePortCommodityLdRateDocument, options);
      }
export type DeletePortCommodityLdRateMutationHookResult = ReturnType<typeof useDeletePortCommodityLdRateMutation>;
export type DeletePortCommodityLdRateMutationResult = Apollo.MutationResult<Types.DeletePortCommodityLdRateMutation>;
export type DeletePortCommodityLdRateMutationOptions = Apollo.BaseMutationOptions<Types.DeletePortCommodityLdRateMutation, Types.DeletePortCommodityLdRateMutationVariables>;
export const AllPortCostDefaultsDocument = gql`
    query AllPortCostDefaults($filter: PortCostDefaultFilter) {
  allPortCostDefaults(filter: $filter) {
    nodes {
      id
      ...PortCostDefaults_Admin
    }
  }
}
    ${PortCostDefaults_AdminFragmentDoc}`;

/**
 * __useAllPortCostDefaultsQuery__
 *
 * To run a query within a React component, call `useAllPortCostDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPortCostDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPortCostDefaultsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllPortCostDefaultsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllPortCostDefaultsQuery, Types.AllPortCostDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllPortCostDefaultsQuery, Types.AllPortCostDefaultsQueryVariables>(AllPortCostDefaultsDocument, options);
      }
export function useAllPortCostDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllPortCostDefaultsQuery, Types.AllPortCostDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllPortCostDefaultsQuery, Types.AllPortCostDefaultsQueryVariables>(AllPortCostDefaultsDocument, options);
        }
export function useAllPortCostDefaultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllPortCostDefaultsQuery, Types.AllPortCostDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllPortCostDefaultsQuery, Types.AllPortCostDefaultsQueryVariables>(AllPortCostDefaultsDocument, options);
        }
export type AllPortCostDefaultsQueryHookResult = ReturnType<typeof useAllPortCostDefaultsQuery>;
export type AllPortCostDefaultsLazyQueryHookResult = ReturnType<typeof useAllPortCostDefaultsLazyQuery>;
export type AllPortCostDefaultsSuspenseQueryHookResult = ReturnType<typeof useAllPortCostDefaultsSuspenseQuery>;
export type AllPortCostDefaultsQueryResult = Apollo.QueryResult<Types.AllPortCostDefaultsQuery, Types.AllPortCostDefaultsQueryVariables>;
export const CreatePortCostDefaultDocument = gql`
    mutation CreatePortCostDefault($input: CreatePortCostDefaultInput!) {
  createPortCostDefault(input: $input) {
    portCostDefault {
      id
      ...PortCostDefaults_Admin
    }
  }
}
    ${PortCostDefaults_AdminFragmentDoc}`;
export type CreatePortCostDefaultMutationFn = Apollo.MutationFunction<Types.CreatePortCostDefaultMutation, Types.CreatePortCostDefaultMutationVariables>;

/**
 * __useCreatePortCostDefaultMutation__
 *
 * To run a mutation, you first call `useCreatePortCostDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortCostDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortCostDefaultMutation, { data, loading, error }] = useCreatePortCostDefaultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortCostDefaultMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortCostDefaultMutation, Types.CreatePortCostDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortCostDefaultMutation, Types.CreatePortCostDefaultMutationVariables>(CreatePortCostDefaultDocument, options);
      }
export type CreatePortCostDefaultMutationHookResult = ReturnType<typeof useCreatePortCostDefaultMutation>;
export type CreatePortCostDefaultMutationResult = Apollo.MutationResult<Types.CreatePortCostDefaultMutation>;
export type CreatePortCostDefaultMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortCostDefaultMutation, Types.CreatePortCostDefaultMutationVariables>;
export const UpdatePortCostDefaultByIdDocument = gql`
    mutation UpdatePortCostDefaultById($input: UpdatePortCostDefaultByIdInput!) {
  updatePortCostDefaultById(input: $input) {
    portCostDefault {
      id
      ...PortCostDefaults_Admin
    }
  }
}
    ${PortCostDefaults_AdminFragmentDoc}`;
export type UpdatePortCostDefaultByIdMutationFn = Apollo.MutationFunction<Types.UpdatePortCostDefaultByIdMutation, Types.UpdatePortCostDefaultByIdMutationVariables>;

/**
 * __useUpdatePortCostDefaultByIdMutation__
 *
 * To run a mutation, you first call `useUpdatePortCostDefaultByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortCostDefaultByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortCostDefaultByIdMutation, { data, loading, error }] = useUpdatePortCostDefaultByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortCostDefaultByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortCostDefaultByIdMutation, Types.UpdatePortCostDefaultByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortCostDefaultByIdMutation, Types.UpdatePortCostDefaultByIdMutationVariables>(UpdatePortCostDefaultByIdDocument, options);
      }
export type UpdatePortCostDefaultByIdMutationHookResult = ReturnType<typeof useUpdatePortCostDefaultByIdMutation>;
export type UpdatePortCostDefaultByIdMutationResult = Apollo.MutationResult<Types.UpdatePortCostDefaultByIdMutation>;
export type UpdatePortCostDefaultByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortCostDefaultByIdMutation, Types.UpdatePortCostDefaultByIdMutationVariables>;
export const DeletePortCostDefaultByIdDocument = gql`
    mutation DeletePortCostDefaultById($input: DeletePortCostDefaultByIdInput!) {
  deletePortCostDefaultById(input: $input) {
    portCostDefault {
      id
      ...PortCostDefaults_Admin
    }
  }
}
    ${PortCostDefaults_AdminFragmentDoc}`;
export type DeletePortCostDefaultByIdMutationFn = Apollo.MutationFunction<Types.DeletePortCostDefaultByIdMutation, Types.DeletePortCostDefaultByIdMutationVariables>;

/**
 * __useDeletePortCostDefaultByIdMutation__
 *
 * To run a mutation, you first call `useDeletePortCostDefaultByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortCostDefaultByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortCostDefaultByIdMutation, { data, loading, error }] = useDeletePortCostDefaultByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePortCostDefaultByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePortCostDefaultByIdMutation, Types.DeletePortCostDefaultByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePortCostDefaultByIdMutation, Types.DeletePortCostDefaultByIdMutationVariables>(DeletePortCostDefaultByIdDocument, options);
      }
export type DeletePortCostDefaultByIdMutationHookResult = ReturnType<typeof useDeletePortCostDefaultByIdMutation>;
export type DeletePortCostDefaultByIdMutationResult = Apollo.MutationResult<Types.DeletePortCostDefaultByIdMutation>;
export type DeletePortCostDefaultByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeletePortCostDefaultByIdMutation, Types.DeletePortCostDefaultByIdMutationVariables>;
export const PortCostDefaultsImportDocument = gql`
    mutation portCostDefaultsImport($input: [PortCostDefaultsImportInput!]) {
  portCostDefaultsImport(input: $input) {
    totalImportSucess
    errors
  }
}
    `;
export type PortCostDefaultsImportMutationFn = Apollo.MutationFunction<Types.PortCostDefaultsImportMutation, Types.PortCostDefaultsImportMutationVariables>;

/**
 * __usePortCostDefaultsImportMutation__
 *
 * To run a mutation, you first call `usePortCostDefaultsImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortCostDefaultsImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portCostDefaultsImportMutation, { data, loading, error }] = usePortCostDefaultsImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortCostDefaultsImportMutation(baseOptions?: Apollo.MutationHookOptions<Types.PortCostDefaultsImportMutation, Types.PortCostDefaultsImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PortCostDefaultsImportMutation, Types.PortCostDefaultsImportMutationVariables>(PortCostDefaultsImportDocument, options);
      }
export type PortCostDefaultsImportMutationHookResult = ReturnType<typeof usePortCostDefaultsImportMutation>;
export type PortCostDefaultsImportMutationResult = Apollo.MutationResult<Types.PortCostDefaultsImportMutation>;
export type PortCostDefaultsImportMutationOptions = Apollo.BaseMutationOptions<Types.PortCostDefaultsImportMutation, Types.PortCostDefaultsImportMutationVariables>;
export const CreatePortCostEstimatesExternalDocument = gql`
    mutation CreatePortCostEstimatesExternal($input: CreatePortCostEstimatesExternalInput!) {
  createPortCostEstimatesExternal(input: $input) {
    portCostEstimatesExternal {
      id
      ...PortCostEstimatesExternal_Admin
    }
  }
}
    ${PortCostEstimatesExternal_AdminFragmentDoc}`;
export type CreatePortCostEstimatesExternalMutationFn = Apollo.MutationFunction<Types.CreatePortCostEstimatesExternalMutation, Types.CreatePortCostEstimatesExternalMutationVariables>;

/**
 * __useCreatePortCostEstimatesExternalMutation__
 *
 * To run a mutation, you first call `useCreatePortCostEstimatesExternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortCostEstimatesExternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortCostEstimatesExternalMutation, { data, loading, error }] = useCreatePortCostEstimatesExternalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortCostEstimatesExternalMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortCostEstimatesExternalMutation, Types.CreatePortCostEstimatesExternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortCostEstimatesExternalMutation, Types.CreatePortCostEstimatesExternalMutationVariables>(CreatePortCostEstimatesExternalDocument, options);
      }
export type CreatePortCostEstimatesExternalMutationHookResult = ReturnType<typeof useCreatePortCostEstimatesExternalMutation>;
export type CreatePortCostEstimatesExternalMutationResult = Apollo.MutationResult<Types.CreatePortCostEstimatesExternalMutation>;
export type CreatePortCostEstimatesExternalMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortCostEstimatesExternalMutation, Types.CreatePortCostEstimatesExternalMutationVariables>;
export const PortCostEstimatesExternalImportDocument = gql`
    mutation portCostEstimatesExternalImport($input: [CreatePortCostEstimatesExternalInput!]) {
  portCostEstimatesExternalImport(input: $input) {
    totalImportSucess
    errors
  }
}
    `;
export type PortCostEstimatesExternalImportMutationFn = Apollo.MutationFunction<Types.PortCostEstimatesExternalImportMutation, Types.PortCostEstimatesExternalImportMutationVariables>;

/**
 * __usePortCostEstimatesExternalImportMutation__
 *
 * To run a mutation, you first call `usePortCostEstimatesExternalImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortCostEstimatesExternalImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portCostEstimatesExternalImportMutation, { data, loading, error }] = usePortCostEstimatesExternalImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortCostEstimatesExternalImportMutation(baseOptions?: Apollo.MutationHookOptions<Types.PortCostEstimatesExternalImportMutation, Types.PortCostEstimatesExternalImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PortCostEstimatesExternalImportMutation, Types.PortCostEstimatesExternalImportMutationVariables>(PortCostEstimatesExternalImportDocument, options);
      }
export type PortCostEstimatesExternalImportMutationHookResult = ReturnType<typeof usePortCostEstimatesExternalImportMutation>;
export type PortCostEstimatesExternalImportMutationResult = Apollo.MutationResult<Types.PortCostEstimatesExternalImportMutation>;
export type PortCostEstimatesExternalImportMutationOptions = Apollo.BaseMutationOptions<Types.PortCostEstimatesExternalImportMutation, Types.PortCostEstimatesExternalImportMutationVariables>;
export const AllPortSpecialRequirementsDocument = gql`
    query AllPortSpecialRequirements($orderBy: [LocationRequirementAssociationsOrderBy!]) {
  allLocationRequirementAssociations(orderBy: $orderBy) {
    nodes {
      id
      ...PortSpecialRequirement_Admin
    }
  }
}
    ${PortSpecialRequirement_AdminFragmentDoc}`;

/**
 * __useAllPortSpecialRequirementsQuery__
 *
 * To run a query within a React component, call `useAllPortSpecialRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPortSpecialRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPortSpecialRequirementsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllPortSpecialRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllPortSpecialRequirementsQuery, Types.AllPortSpecialRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllPortSpecialRequirementsQuery, Types.AllPortSpecialRequirementsQueryVariables>(AllPortSpecialRequirementsDocument, options);
      }
export function useAllPortSpecialRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllPortSpecialRequirementsQuery, Types.AllPortSpecialRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllPortSpecialRequirementsQuery, Types.AllPortSpecialRequirementsQueryVariables>(AllPortSpecialRequirementsDocument, options);
        }
export function useAllPortSpecialRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllPortSpecialRequirementsQuery, Types.AllPortSpecialRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllPortSpecialRequirementsQuery, Types.AllPortSpecialRequirementsQueryVariables>(AllPortSpecialRequirementsDocument, options);
        }
export type AllPortSpecialRequirementsQueryHookResult = ReturnType<typeof useAllPortSpecialRequirementsQuery>;
export type AllPortSpecialRequirementsLazyQueryHookResult = ReturnType<typeof useAllPortSpecialRequirementsLazyQuery>;
export type AllPortSpecialRequirementsSuspenseQueryHookResult = ReturnType<typeof useAllPortSpecialRequirementsSuspenseQuery>;
export type AllPortSpecialRequirementsQueryResult = Apollo.QueryResult<Types.AllPortSpecialRequirementsQuery, Types.AllPortSpecialRequirementsQueryVariables>;
export const CreatePortSpecialRequirementDocument = gql`
    mutation CreatePortSpecialRequirement($input: CreateLocationRequirementAssociationInput!) {
  createLocationRequirementAssociation(input: $input) {
    locationRequirementAssociation {
      id
      ...PortSpecialRequirement_Admin
    }
  }
}
    ${PortSpecialRequirement_AdminFragmentDoc}`;
export type CreatePortSpecialRequirementMutationFn = Apollo.MutationFunction<Types.CreatePortSpecialRequirementMutation, Types.CreatePortSpecialRequirementMutationVariables>;

/**
 * __useCreatePortSpecialRequirementMutation__
 *
 * To run a mutation, you first call `useCreatePortSpecialRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortSpecialRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortSpecialRequirementMutation, { data, loading, error }] = useCreatePortSpecialRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortSpecialRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortSpecialRequirementMutation, Types.CreatePortSpecialRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortSpecialRequirementMutation, Types.CreatePortSpecialRequirementMutationVariables>(CreatePortSpecialRequirementDocument, options);
      }
export type CreatePortSpecialRequirementMutationHookResult = ReturnType<typeof useCreatePortSpecialRequirementMutation>;
export type CreatePortSpecialRequirementMutationResult = Apollo.MutationResult<Types.CreatePortSpecialRequirementMutation>;
export type CreatePortSpecialRequirementMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortSpecialRequirementMutation, Types.CreatePortSpecialRequirementMutationVariables>;
export const UpdatePortSpecialRequirementDocument = gql`
    mutation UpdatePortSpecialRequirement($input: UpdateLocationRequirementAssociationByIdInput!) {
  updateLocationRequirementAssociationById(input: $input) {
    locationRequirementAssociation {
      id
      ...PortSpecialRequirement_Admin
    }
  }
}
    ${PortSpecialRequirement_AdminFragmentDoc}`;
export type UpdatePortSpecialRequirementMutationFn = Apollo.MutationFunction<Types.UpdatePortSpecialRequirementMutation, Types.UpdatePortSpecialRequirementMutationVariables>;

/**
 * __useUpdatePortSpecialRequirementMutation__
 *
 * To run a mutation, you first call `useUpdatePortSpecialRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortSpecialRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortSpecialRequirementMutation, { data, loading, error }] = useUpdatePortSpecialRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortSpecialRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortSpecialRequirementMutation, Types.UpdatePortSpecialRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortSpecialRequirementMutation, Types.UpdatePortSpecialRequirementMutationVariables>(UpdatePortSpecialRequirementDocument, options);
      }
export type UpdatePortSpecialRequirementMutationHookResult = ReturnType<typeof useUpdatePortSpecialRequirementMutation>;
export type UpdatePortSpecialRequirementMutationResult = Apollo.MutationResult<Types.UpdatePortSpecialRequirementMutation>;
export type UpdatePortSpecialRequirementMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortSpecialRequirementMutation, Types.UpdatePortSpecialRequirementMutationVariables>;
export const DeletePortSpecialRequirementByIdDocument = gql`
    mutation DeletePortSpecialRequirementById($input: DeleteLocationRequirementAssociationByIdInput!) {
  deleteLocationRequirementAssociationById(input: $input) {
    locationRequirementAssociation {
      id
      ...PortSpecialRequirement_Admin
    }
  }
}
    ${PortSpecialRequirement_AdminFragmentDoc}`;
export type DeletePortSpecialRequirementByIdMutationFn = Apollo.MutationFunction<Types.DeletePortSpecialRequirementByIdMutation, Types.DeletePortSpecialRequirementByIdMutationVariables>;

/**
 * __useDeletePortSpecialRequirementByIdMutation__
 *
 * To run a mutation, you first call `useDeletePortSpecialRequirementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortSpecialRequirementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortSpecialRequirementByIdMutation, { data, loading, error }] = useDeletePortSpecialRequirementByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePortSpecialRequirementByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePortSpecialRequirementByIdMutation, Types.DeletePortSpecialRequirementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePortSpecialRequirementByIdMutation, Types.DeletePortSpecialRequirementByIdMutationVariables>(DeletePortSpecialRequirementByIdDocument, options);
      }
export type DeletePortSpecialRequirementByIdMutationHookResult = ReturnType<typeof useDeletePortSpecialRequirementByIdMutation>;
export type DeletePortSpecialRequirementByIdMutationResult = Apollo.MutationResult<Types.DeletePortSpecialRequirementByIdMutation>;
export type DeletePortSpecialRequirementByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeletePortSpecialRequirementByIdMutation, Types.DeletePortSpecialRequirementByIdMutationVariables>;
export const AllPortsDocument = gql`
    query AllPorts($filter: LocationFilter) {
  allLocations(filter: $filter) {
    nodes {
      id
      ...Port_Admin
    }
  }
}
    ${Port_AdminFragmentDoc}`;

/**
 * __useAllPortsQuery__
 *
 * To run a query within a React component, call `useAllPortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPortsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllPortsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllPortsQuery, Types.AllPortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllPortsQuery, Types.AllPortsQueryVariables>(AllPortsDocument, options);
      }
export function useAllPortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllPortsQuery, Types.AllPortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllPortsQuery, Types.AllPortsQueryVariables>(AllPortsDocument, options);
        }
export function useAllPortsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllPortsQuery, Types.AllPortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllPortsQuery, Types.AllPortsQueryVariables>(AllPortsDocument, options);
        }
export type AllPortsQueryHookResult = ReturnType<typeof useAllPortsQuery>;
export type AllPortsLazyQueryHookResult = ReturnType<typeof useAllPortsLazyQuery>;
export type AllPortsSuspenseQueryHookResult = ReturnType<typeof useAllPortsSuspenseQuery>;
export type AllPortsQueryResult = Apollo.QueryResult<Types.AllPortsQuery, Types.AllPortsQueryVariables>;
export const AllCountriesDocument = gql`
    query AllCountries($orderBy: [CountriesOrderBy!]) {
  allCountries(orderBy: $orderBy) {
    nodes {
      id
      ...Country
    }
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useAllCountriesQuery__
 *
 * To run a query within a React component, call `useAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCountriesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllCountriesQuery, Types.AllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllCountriesQuery, Types.AllCountriesQueryVariables>(AllCountriesDocument, options);
      }
export function useAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllCountriesQuery, Types.AllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllCountriesQuery, Types.AllCountriesQueryVariables>(AllCountriesDocument, options);
        }
export function useAllCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllCountriesQuery, Types.AllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllCountriesQuery, Types.AllCountriesQueryVariables>(AllCountriesDocument, options);
        }
export type AllCountriesQueryHookResult = ReturnType<typeof useAllCountriesQuery>;
export type AllCountriesLazyQueryHookResult = ReturnType<typeof useAllCountriesLazyQuery>;
export type AllCountriesSuspenseQueryHookResult = ReturnType<typeof useAllCountriesSuspenseQuery>;
export type AllCountriesQueryResult = Apollo.QueryResult<Types.AllCountriesQuery, Types.AllCountriesQueryVariables>;
export const CreatePortDocument = gql`
    mutation CreatePort($input: CreateLocationInput!) {
  createLocation(input: $input) {
    location {
      id
      ...Port_Admin
    }
  }
}
    ${Port_AdminFragmentDoc}`;
export type CreatePortMutationFn = Apollo.MutationFunction<Types.CreatePortMutation, Types.CreatePortMutationVariables>;

/**
 * __useCreatePortMutation__
 *
 * To run a mutation, you first call `useCreatePortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortMutation, { data, loading, error }] = useCreatePortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortMutation, Types.CreatePortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortMutation, Types.CreatePortMutationVariables>(CreatePortDocument, options);
      }
export type CreatePortMutationHookResult = ReturnType<typeof useCreatePortMutation>;
export type CreatePortMutationResult = Apollo.MutationResult<Types.CreatePortMutation>;
export type CreatePortMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortMutation, Types.CreatePortMutationVariables>;
export const UpdatePortDocument = gql`
    mutation UpdatePort($input: UpdateLocationByIdInput!) {
  updateLocationById(input: $input) {
    location {
      id
      ...Port_Admin
    }
  }
}
    ${Port_AdminFragmentDoc}`;
export type UpdatePortMutationFn = Apollo.MutationFunction<Types.UpdatePortMutation, Types.UpdatePortMutationVariables>;

/**
 * __useUpdatePortMutation__
 *
 * To run a mutation, you first call `useUpdatePortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortMutation, { data, loading, error }] = useUpdatePortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortMutation, Types.UpdatePortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortMutation, Types.UpdatePortMutationVariables>(UpdatePortDocument, options);
      }
export type UpdatePortMutationHookResult = ReturnType<typeof useUpdatePortMutation>;
export type UpdatePortMutationResult = Apollo.MutationResult<Types.UpdatePortMutation>;
export type UpdatePortMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortMutation, Types.UpdatePortMutationVariables>;
export const DeletePortByIdDocument = gql`
    mutation DeletePortById($input: DeleteLocationByIdInput!) {
  deleteLocationById(input: $input) {
    location {
      id
      ...Port_Admin
    }
  }
}
    ${Port_AdminFragmentDoc}`;
export type DeletePortByIdMutationFn = Apollo.MutationFunction<Types.DeletePortByIdMutation, Types.DeletePortByIdMutationVariables>;

/**
 * __useDeletePortByIdMutation__
 *
 * To run a mutation, you first call `useDeletePortByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortByIdMutation, { data, loading, error }] = useDeletePortByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePortByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePortByIdMutation, Types.DeletePortByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePortByIdMutation, Types.DeletePortByIdMutationVariables>(DeletePortByIdDocument, options);
      }
export type DeletePortByIdMutationHookResult = ReturnType<typeof useDeletePortByIdMutation>;
export type DeletePortByIdMutationResult = Apollo.MutationResult<Types.DeletePortByIdMutation>;
export type DeletePortByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeletePortByIdMutation, Types.DeletePortByIdMutationVariables>;
export const UpdatePortMissedTimezoneDocument = gql`
    mutation UpdatePortMissedTimezone {
  updatePortMissedTimezone {
    totalUpdateSuccess
    errors
    warning
  }
}
    `;
export type UpdatePortMissedTimezoneMutationFn = Apollo.MutationFunction<Types.UpdatePortMissedTimezoneMutation, Types.UpdatePortMissedTimezoneMutationVariables>;

/**
 * __useUpdatePortMissedTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdatePortMissedTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortMissedTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortMissedTimezoneMutation, { data, loading, error }] = useUpdatePortMissedTimezoneMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdatePortMissedTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortMissedTimezoneMutation, Types.UpdatePortMissedTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortMissedTimezoneMutation, Types.UpdatePortMissedTimezoneMutationVariables>(UpdatePortMissedTimezoneDocument, options);
      }
export type UpdatePortMissedTimezoneMutationHookResult = ReturnType<typeof useUpdatePortMissedTimezoneMutation>;
export type UpdatePortMissedTimezoneMutationResult = Apollo.MutationResult<Types.UpdatePortMissedTimezoneMutation>;
export type UpdatePortMissedTimezoneMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortMissedTimezoneMutation, Types.UpdatePortMissedTimezoneMutationVariables>;
export const AllRegionsDocument = gql`
    query AllRegions($orderBy: [RegionsOrderBy!]) {
  allRegions(orderBy: $orderBy) {
    nodes {
      id
      ...Region_Admin
    }
  }
}
    ${Region_AdminFragmentDoc}`;

/**
 * __useAllRegionsQuery__
 *
 * To run a query within a React component, call `useAllRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllRegionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllRegionsQuery, Types.AllRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllRegionsQuery, Types.AllRegionsQueryVariables>(AllRegionsDocument, options);
      }
export function useAllRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllRegionsQuery, Types.AllRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllRegionsQuery, Types.AllRegionsQueryVariables>(AllRegionsDocument, options);
        }
export function useAllRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllRegionsQuery, Types.AllRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllRegionsQuery, Types.AllRegionsQueryVariables>(AllRegionsDocument, options);
        }
export type AllRegionsQueryHookResult = ReturnType<typeof useAllRegionsQuery>;
export type AllRegionsLazyQueryHookResult = ReturnType<typeof useAllRegionsLazyQuery>;
export type AllRegionsSuspenseQueryHookResult = ReturnType<typeof useAllRegionsSuspenseQuery>;
export type AllRegionsQueryResult = Apollo.QueryResult<Types.AllRegionsQuery, Types.AllRegionsQueryVariables>;
export const CreateRegionDocument = gql`
    mutation CreateRegion($input: CreateRegionInput!) {
  createRegion(input: $input) {
    region {
      id
      ...Region_Admin
    }
  }
}
    ${Region_AdminFragmentDoc}`;
export type CreateRegionMutationFn = Apollo.MutationFunction<Types.CreateRegionMutation, Types.CreateRegionMutationVariables>;

/**
 * __useCreateRegionMutation__
 *
 * To run a mutation, you first call `useCreateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionMutation, { data, loading, error }] = useCreateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateRegionMutation, Types.CreateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateRegionMutation, Types.CreateRegionMutationVariables>(CreateRegionDocument, options);
      }
export type CreateRegionMutationHookResult = ReturnType<typeof useCreateRegionMutation>;
export type CreateRegionMutationResult = Apollo.MutationResult<Types.CreateRegionMutation>;
export type CreateRegionMutationOptions = Apollo.BaseMutationOptions<Types.CreateRegionMutation, Types.CreateRegionMutationVariables>;
export const UpdateRegionDocument = gql`
    mutation UpdateRegion($input: UpdateRegionByIdInput!) {
  updateRegionById(input: $input) {
    region {
      id
      ...Region_Admin
    }
  }
}
    ${Region_AdminFragmentDoc}`;
export type UpdateRegionMutationFn = Apollo.MutationFunction<Types.UpdateRegionMutation, Types.UpdateRegionMutationVariables>;

/**
 * __useUpdateRegionMutation__
 *
 * To run a mutation, you first call `useUpdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionMutation, { data, loading, error }] = useUpdateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRegionMutation, Types.UpdateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRegionMutation, Types.UpdateRegionMutationVariables>(UpdateRegionDocument, options);
      }
export type UpdateRegionMutationHookResult = ReturnType<typeof useUpdateRegionMutation>;
export type UpdateRegionMutationResult = Apollo.MutationResult<Types.UpdateRegionMutation>;
export type UpdateRegionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRegionMutation, Types.UpdateRegionMutationVariables>;
export const DeleteRegionByIdDocument = gql`
    mutation DeleteRegionById($input: DeleteRegionByIdInput!) {
  deleteRegionById(input: $input) {
    region {
      id
      ...Region_Admin
    }
  }
}
    ${Region_AdminFragmentDoc}`;
export type DeleteRegionByIdMutationFn = Apollo.MutationFunction<Types.DeleteRegionByIdMutation, Types.DeleteRegionByIdMutationVariables>;

/**
 * __useDeleteRegionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteRegionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionByIdMutation, { data, loading, error }] = useDeleteRegionByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegionByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRegionByIdMutation, Types.DeleteRegionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRegionByIdMutation, Types.DeleteRegionByIdMutationVariables>(DeleteRegionByIdDocument, options);
      }
export type DeleteRegionByIdMutationHookResult = ReturnType<typeof useDeleteRegionByIdMutation>;
export type DeleteRegionByIdMutationResult = Apollo.MutationResult<Types.DeleteRegionByIdMutation>;
export type DeleteRegionByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRegionByIdMutation, Types.DeleteRegionByIdMutationVariables>;
export const AllRouteOverridesDocument = gql`
    query AllRouteOverrides($orderBy: [RouteOverridesOrderBy!], $filter: RouteOverrideFilter) {
  allRouteOverrides(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      ...RouteOverride_Admin
    }
  }
}
    ${RouteOverride_AdminFragmentDoc}`;

/**
 * __useAllRouteOverridesQuery__
 *
 * To run a query within a React component, call `useAllRouteOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRouteOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRouteOverridesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllRouteOverridesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllRouteOverridesQuery, Types.AllRouteOverridesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllRouteOverridesQuery, Types.AllRouteOverridesQueryVariables>(AllRouteOverridesDocument, options);
      }
export function useAllRouteOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllRouteOverridesQuery, Types.AllRouteOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllRouteOverridesQuery, Types.AllRouteOverridesQueryVariables>(AllRouteOverridesDocument, options);
        }
export function useAllRouteOverridesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllRouteOverridesQuery, Types.AllRouteOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllRouteOverridesQuery, Types.AllRouteOverridesQueryVariables>(AllRouteOverridesDocument, options);
        }
export type AllRouteOverridesQueryHookResult = ReturnType<typeof useAllRouteOverridesQuery>;
export type AllRouteOverridesLazyQueryHookResult = ReturnType<typeof useAllRouteOverridesLazyQuery>;
export type AllRouteOverridesSuspenseQueryHookResult = ReturnType<typeof useAllRouteOverridesSuspenseQuery>;
export type AllRouteOverridesQueryResult = Apollo.QueryResult<Types.AllRouteOverridesQuery, Types.AllRouteOverridesQueryVariables>;
export const CreateRouteOverrideDocument = gql`
    mutation CreateRouteOverride($input: CreateRouteOverrideInput!) {
  createRouteOverride(input: $input) {
    routeOverride {
      id
      ...RouteOverride_Admin
    }
  }
}
    ${RouteOverride_AdminFragmentDoc}`;
export type CreateRouteOverrideMutationFn = Apollo.MutationFunction<Types.CreateRouteOverrideMutation, Types.CreateRouteOverrideMutationVariables>;

/**
 * __useCreateRouteOverrideMutation__
 *
 * To run a mutation, you first call `useCreateRouteOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRouteOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRouteOverrideMutation, { data, loading, error }] = useCreateRouteOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRouteOverrideMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateRouteOverrideMutation, Types.CreateRouteOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateRouteOverrideMutation, Types.CreateRouteOverrideMutationVariables>(CreateRouteOverrideDocument, options);
      }
export type CreateRouteOverrideMutationHookResult = ReturnType<typeof useCreateRouteOverrideMutation>;
export type CreateRouteOverrideMutationResult = Apollo.MutationResult<Types.CreateRouteOverrideMutation>;
export type CreateRouteOverrideMutationOptions = Apollo.BaseMutationOptions<Types.CreateRouteOverrideMutation, Types.CreateRouteOverrideMutationVariables>;
export const UpdateRouteOverrideDocument = gql`
    mutation UpdateRouteOverride($input: UpdateRouteOverrideByIdInput!) {
  updateRouteOverrideById(input: $input) {
    routeOverride {
      id
      ...RouteOverride_Admin
    }
  }
}
    ${RouteOverride_AdminFragmentDoc}`;
export type UpdateRouteOverrideMutationFn = Apollo.MutationFunction<Types.UpdateRouteOverrideMutation, Types.UpdateRouteOverrideMutationVariables>;

/**
 * __useUpdateRouteOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateRouteOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteOverrideMutation, { data, loading, error }] = useUpdateRouteOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRouteOverrideMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRouteOverrideMutation, Types.UpdateRouteOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRouteOverrideMutation, Types.UpdateRouteOverrideMutationVariables>(UpdateRouteOverrideDocument, options);
      }
export type UpdateRouteOverrideMutationHookResult = ReturnType<typeof useUpdateRouteOverrideMutation>;
export type UpdateRouteOverrideMutationResult = Apollo.MutationResult<Types.UpdateRouteOverrideMutation>;
export type UpdateRouteOverrideMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRouteOverrideMutation, Types.UpdateRouteOverrideMutationVariables>;
export const DeleteRouteOverrideByIdDocument = gql`
    mutation DeleteRouteOverrideById($input: DeleteRouteOverrideByIdInput!) {
  deleteRouteOverrideById(input: $input) {
    routeOverride {
      id
      ...RouteOverride_Admin
    }
  }
}
    ${RouteOverride_AdminFragmentDoc}`;
export type DeleteRouteOverrideByIdMutationFn = Apollo.MutationFunction<Types.DeleteRouteOverrideByIdMutation, Types.DeleteRouteOverrideByIdMutationVariables>;

/**
 * __useDeleteRouteOverrideByIdMutation__
 *
 * To run a mutation, you first call `useDeleteRouteOverrideByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRouteOverrideByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRouteOverrideByIdMutation, { data, loading, error }] = useDeleteRouteOverrideByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRouteOverrideByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRouteOverrideByIdMutation, Types.DeleteRouteOverrideByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRouteOverrideByIdMutation, Types.DeleteRouteOverrideByIdMutationVariables>(DeleteRouteOverrideByIdDocument, options);
      }
export type DeleteRouteOverrideByIdMutationHookResult = ReturnType<typeof useDeleteRouteOverrideByIdMutation>;
export type DeleteRouteOverrideByIdMutationResult = Apollo.MutationResult<Types.DeleteRouteOverrideByIdMutation>;
export type DeleteRouteOverrideByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRouteOverrideByIdMutation, Types.DeleteRouteOverrideByIdMutationVariables>;
export const AllSpecialRequirementsDocument = gql`
    query AllSpecialRequirements($orderBy: [SpecialRequirementsOrderBy!]) {
  allSpecialRequirements(orderBy: $orderBy) {
    nodes {
      id
      ...SpecialRequirement_Admin
    }
  }
}
    ${SpecialRequirement_AdminFragmentDoc}`;

/**
 * __useAllSpecialRequirementsQuery__
 *
 * To run a query within a React component, call `useAllSpecialRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSpecialRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSpecialRequirementsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllSpecialRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllSpecialRequirementsQuery, Types.AllSpecialRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllSpecialRequirementsQuery, Types.AllSpecialRequirementsQueryVariables>(AllSpecialRequirementsDocument, options);
      }
export function useAllSpecialRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllSpecialRequirementsQuery, Types.AllSpecialRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllSpecialRequirementsQuery, Types.AllSpecialRequirementsQueryVariables>(AllSpecialRequirementsDocument, options);
        }
export function useAllSpecialRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllSpecialRequirementsQuery, Types.AllSpecialRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllSpecialRequirementsQuery, Types.AllSpecialRequirementsQueryVariables>(AllSpecialRequirementsDocument, options);
        }
export type AllSpecialRequirementsQueryHookResult = ReturnType<typeof useAllSpecialRequirementsQuery>;
export type AllSpecialRequirementsLazyQueryHookResult = ReturnType<typeof useAllSpecialRequirementsLazyQuery>;
export type AllSpecialRequirementsSuspenseQueryHookResult = ReturnType<typeof useAllSpecialRequirementsSuspenseQuery>;
export type AllSpecialRequirementsQueryResult = Apollo.QueryResult<Types.AllSpecialRequirementsQuery, Types.AllSpecialRequirementsQueryVariables>;
export const CreateSpecialRequirementDocument = gql`
    mutation createSpecialRequirement($input: CreateSpecialRequirementInput!) {
  createSpecialRequirement(input: $input) {
    specialRequirement {
      id
      ...SpecialRequirement_Admin
    }
  }
}
    ${SpecialRequirement_AdminFragmentDoc}`;
export type CreateSpecialRequirementMutationFn = Apollo.MutationFunction<Types.CreateSpecialRequirementMutation, Types.CreateSpecialRequirementMutationVariables>;

/**
 * __useCreateSpecialRequirementMutation__
 *
 * To run a mutation, you first call `useCreateSpecialRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialRequirementMutation, { data, loading, error }] = useCreateSpecialRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpecialRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSpecialRequirementMutation, Types.CreateSpecialRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSpecialRequirementMutation, Types.CreateSpecialRequirementMutationVariables>(CreateSpecialRequirementDocument, options);
      }
export type CreateSpecialRequirementMutationHookResult = ReturnType<typeof useCreateSpecialRequirementMutation>;
export type CreateSpecialRequirementMutationResult = Apollo.MutationResult<Types.CreateSpecialRequirementMutation>;
export type CreateSpecialRequirementMutationOptions = Apollo.BaseMutationOptions<Types.CreateSpecialRequirementMutation, Types.CreateSpecialRequirementMutationVariables>;
export const UpdateSpecialRequirementDocument = gql`
    mutation UpdateSpecialRequirement($input: UpdateSpecialRequirementByIdInput!) {
  updateSpecialRequirementById(input: $input) {
    specialRequirement {
      id
      ...SpecialRequirement_Admin
    }
  }
}
    ${SpecialRequirement_AdminFragmentDoc}`;
export type UpdateSpecialRequirementMutationFn = Apollo.MutationFunction<Types.UpdateSpecialRequirementMutation, Types.UpdateSpecialRequirementMutationVariables>;

/**
 * __useUpdateSpecialRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialRequirementMutation, { data, loading, error }] = useUpdateSpecialRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSpecialRequirementMutation, Types.UpdateSpecialRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSpecialRequirementMutation, Types.UpdateSpecialRequirementMutationVariables>(UpdateSpecialRequirementDocument, options);
      }
export type UpdateSpecialRequirementMutationHookResult = ReturnType<typeof useUpdateSpecialRequirementMutation>;
export type UpdateSpecialRequirementMutationResult = Apollo.MutationResult<Types.UpdateSpecialRequirementMutation>;
export type UpdateSpecialRequirementMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSpecialRequirementMutation, Types.UpdateSpecialRequirementMutationVariables>;
export const DeleteSpecialRequirementByIdDocument = gql`
    mutation DeleteSpecialRequirementById($input: DeleteSpecialRequirementByIdInput!) {
  deleteSpecialRequirementById(input: $input) {
    specialRequirement {
      id
      ...SpecialRequirement_Admin
    }
  }
}
    ${SpecialRequirement_AdminFragmentDoc}`;
export type DeleteSpecialRequirementByIdMutationFn = Apollo.MutationFunction<Types.DeleteSpecialRequirementByIdMutation, Types.DeleteSpecialRequirementByIdMutationVariables>;

/**
 * __useDeleteSpecialRequirementByIdMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialRequirementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialRequirementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialRequirementByIdMutation, { data, loading, error }] = useDeleteSpecialRequirementByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSpecialRequirementByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSpecialRequirementByIdMutation, Types.DeleteSpecialRequirementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSpecialRequirementByIdMutation, Types.DeleteSpecialRequirementByIdMutationVariables>(DeleteSpecialRequirementByIdDocument, options);
      }
export type DeleteSpecialRequirementByIdMutationHookResult = ReturnType<typeof useDeleteSpecialRequirementByIdMutation>;
export type DeleteSpecialRequirementByIdMutationResult = Apollo.MutationResult<Types.DeleteSpecialRequirementByIdMutation>;
export type DeleteSpecialRequirementByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSpecialRequirementByIdMutation, Types.DeleteSpecialRequirementByIdMutationVariables>;
export const AllSupplyContractsDocument = gql`
    query AllSupplyContracts($orderBy: [SupplyContractsOrderBy!]) {
  allSupplyContracts(orderBy: $orderBy) {
    nodes {
      id
      ...SupplyContract_Admin
    }
  }
}
    ${SupplyContract_AdminFragmentDoc}`;

/**
 * __useAllSupplyContractsQuery__
 *
 * To run a query within a React component, call `useAllSupplyContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSupplyContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSupplyContractsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllSupplyContractsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllSupplyContractsQuery, Types.AllSupplyContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllSupplyContractsQuery, Types.AllSupplyContractsQueryVariables>(AllSupplyContractsDocument, options);
      }
export function useAllSupplyContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllSupplyContractsQuery, Types.AllSupplyContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllSupplyContractsQuery, Types.AllSupplyContractsQueryVariables>(AllSupplyContractsDocument, options);
        }
export function useAllSupplyContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllSupplyContractsQuery, Types.AllSupplyContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllSupplyContractsQuery, Types.AllSupplyContractsQueryVariables>(AllSupplyContractsDocument, options);
        }
export type AllSupplyContractsQueryHookResult = ReturnType<typeof useAllSupplyContractsQuery>;
export type AllSupplyContractsLazyQueryHookResult = ReturnType<typeof useAllSupplyContractsLazyQuery>;
export type AllSupplyContractsSuspenseQueryHookResult = ReturnType<typeof useAllSupplyContractsSuspenseQuery>;
export type AllSupplyContractsQueryResult = Apollo.QueryResult<Types.AllSupplyContractsQuery, Types.AllSupplyContractsQueryVariables>;
export const CreateSupplyContractDocument = gql`
    mutation CreateSupplyContract($input: CreateSupplyContractInput!) {
  createSupplyContract(input: $input) {
    supplyContract {
      id
      ...SupplyContract_Admin
    }
  }
}
    ${SupplyContract_AdminFragmentDoc}`;
export type CreateSupplyContractMutationFn = Apollo.MutationFunction<Types.CreateSupplyContractMutation, Types.CreateSupplyContractMutationVariables>;

/**
 * __useCreateSupplyContractMutation__
 *
 * To run a mutation, you first call `useCreateSupplyContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyContractMutation, { data, loading, error }] = useCreateSupplyContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplyContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSupplyContractMutation, Types.CreateSupplyContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSupplyContractMutation, Types.CreateSupplyContractMutationVariables>(CreateSupplyContractDocument, options);
      }
export type CreateSupplyContractMutationHookResult = ReturnType<typeof useCreateSupplyContractMutation>;
export type CreateSupplyContractMutationResult = Apollo.MutationResult<Types.CreateSupplyContractMutation>;
export type CreateSupplyContractMutationOptions = Apollo.BaseMutationOptions<Types.CreateSupplyContractMutation, Types.CreateSupplyContractMutationVariables>;
export const UpdateSupplyContractDocument = gql`
    mutation UpdateSupplyContract($input: UpdateSupplyContractByIdInput!) {
  updateSupplyContractById(input: $input) {
    supplyContract {
      id
      ...SupplyContract_Admin
    }
  }
}
    ${SupplyContract_AdminFragmentDoc}`;
export type UpdateSupplyContractMutationFn = Apollo.MutationFunction<Types.UpdateSupplyContractMutation, Types.UpdateSupplyContractMutationVariables>;

/**
 * __useUpdateSupplyContractMutation__
 *
 * To run a mutation, you first call `useUpdateSupplyContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplyContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplyContractMutation, { data, loading, error }] = useUpdateSupplyContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplyContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSupplyContractMutation, Types.UpdateSupplyContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSupplyContractMutation, Types.UpdateSupplyContractMutationVariables>(UpdateSupplyContractDocument, options);
      }
export type UpdateSupplyContractMutationHookResult = ReturnType<typeof useUpdateSupplyContractMutation>;
export type UpdateSupplyContractMutationResult = Apollo.MutationResult<Types.UpdateSupplyContractMutation>;
export type UpdateSupplyContractMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSupplyContractMutation, Types.UpdateSupplyContractMutationVariables>;
export const DeleteSupplyContractByIdDocument = gql`
    mutation DeleteSupplyContractById($input: DeleteSupplyContractByIdInput!) {
  deleteSupplyContractById(input: $input) {
    supplyContract {
      id
      ...SupplyContract_Admin
    }
  }
}
    ${SupplyContract_AdminFragmentDoc}`;
export type DeleteSupplyContractByIdMutationFn = Apollo.MutationFunction<Types.DeleteSupplyContractByIdMutation, Types.DeleteSupplyContractByIdMutationVariables>;

/**
 * __useDeleteSupplyContractByIdMutation__
 *
 * To run a mutation, you first call `useDeleteSupplyContractByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplyContractByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplyContractByIdMutation, { data, loading, error }] = useDeleteSupplyContractByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSupplyContractByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSupplyContractByIdMutation, Types.DeleteSupplyContractByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSupplyContractByIdMutation, Types.DeleteSupplyContractByIdMutationVariables>(DeleteSupplyContractByIdDocument, options);
      }
export type DeleteSupplyContractByIdMutationHookResult = ReturnType<typeof useDeleteSupplyContractByIdMutation>;
export type DeleteSupplyContractByIdMutationResult = Apollo.MutationResult<Types.DeleteSupplyContractByIdMutation>;
export type DeleteSupplyContractByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSupplyContractByIdMutation, Types.DeleteSupplyContractByIdMutationVariables>;
export const AllUsersDocument = gql`
    query AllUsers($filter: UserFilter) {
  allUsers(filter: $filter) {
    nodes {
      id
      ...User_Admin
    }
  }
}
    ${User_AdminFragmentDoc}`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllUsersQuery, Types.AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllUsersQuery, Types.AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllUsersQuery, Types.AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllUsersQuery, Types.AllUsersQueryVariables>(AllUsersDocument, options);
        }
export function useAllUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllUsersQuery, Types.AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllUsersQuery, Types.AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersSuspenseQueryHookResult = ReturnType<typeof useAllUsersSuspenseQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<Types.AllUsersQuery, Types.AllUsersQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      id
      ...User_Admin
    }
  }
}
    ${User_AdminFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<Types.CreateUserMutation, Types.CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateUserMutation, Types.CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateUserMutation, Types.CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<Types.CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<Types.CreateUserMutation, Types.CreateUserMutationVariables>;
export const CreateUserRightDocument = gql`
    mutation CreateUserRight($input: CreateUserRightInput!) {
  createUserRight(input: $input) {
    userRight {
      id
    }
    userByUserId {
      id
      ...User_Admin
    }
  }
}
    ${User_AdminFragmentDoc}`;
export type CreateUserRightMutationFn = Apollo.MutationFunction<Types.CreateUserRightMutation, Types.CreateUserRightMutationVariables>;

/**
 * __useCreateUserRightMutation__
 *
 * To run a mutation, you first call `useCreateUserRightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRightMutation, { data, loading, error }] = useCreateUserRightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserRightMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateUserRightMutation, Types.CreateUserRightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateUserRightMutation, Types.CreateUserRightMutationVariables>(CreateUserRightDocument, options);
      }
export type CreateUserRightMutationHookResult = ReturnType<typeof useCreateUserRightMutation>;
export type CreateUserRightMutationResult = Apollo.MutationResult<Types.CreateUserRightMutation>;
export type CreateUserRightMutationOptions = Apollo.BaseMutationOptions<Types.CreateUserRightMutation, Types.CreateUserRightMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserByIdInput!) {
  updateUserById(input: $input) {
    user {
      id
      ...User_Admin
    }
  }
}
    ${User_AdminFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Types.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export const UpdateUserRightDocument = gql`
    mutation UpdateUserRight($input: UpdateUserRightByIdInput!) {
  updateUserRightById(input: $input) {
    userByUserId {
      id
      ...User_Admin
    }
  }
}
    ${User_AdminFragmentDoc}`;
export type UpdateUserRightMutationFn = Apollo.MutationFunction<Types.UpdateUserRightMutation, Types.UpdateUserRightMutationVariables>;

/**
 * __useUpdateUserRightMutation__
 *
 * To run a mutation, you first call `useUpdateUserRightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRightMutation, { data, loading, error }] = useUpdateUserRightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRightMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserRightMutation, Types.UpdateUserRightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserRightMutation, Types.UpdateUserRightMutationVariables>(UpdateUserRightDocument, options);
      }
export type UpdateUserRightMutationHookResult = ReturnType<typeof useUpdateUserRightMutation>;
export type UpdateUserRightMutationResult = Apollo.MutationResult<Types.UpdateUserRightMutation>;
export type UpdateUserRightMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserRightMutation, Types.UpdateUserRightMutationVariables>;
export const DeleteUserByIdDocument = gql`
    mutation DeleteUserById($input: DeleteUserByIdInput!) {
  deleteUserById(input: $input) {
    user {
      id
      ...User_Admin
    }
  }
}
    ${User_AdminFragmentDoc}`;
export type DeleteUserByIdMutationFn = Apollo.MutationFunction<Types.DeleteUserByIdMutation, Types.DeleteUserByIdMutationVariables>;

/**
 * __useDeleteUserByIdMutation__
 *
 * To run a mutation, you first call `useDeleteUserByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserByIdMutation, { data, loading, error }] = useDeleteUserByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteUserByIdMutation, Types.DeleteUserByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteUserByIdMutation, Types.DeleteUserByIdMutationVariables>(DeleteUserByIdDocument, options);
      }
export type DeleteUserByIdMutationHookResult = ReturnType<typeof useDeleteUserByIdMutation>;
export type DeleteUserByIdMutationResult = Apollo.MutationResult<Types.DeleteUserByIdMutation>;
export type DeleteUserByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteUserByIdMutation, Types.DeleteUserByIdMutationVariables>;
export const DeleteUserRightDocument = gql`
    mutation DeleteUserRight($input: DeleteUserRightByIdInput!) {
  deleteUserRightById(input: $input) {
    userByUserId {
      id
      ...User_Admin
    }
  }
}
    ${User_AdminFragmentDoc}`;
export type DeleteUserRightMutationFn = Apollo.MutationFunction<Types.DeleteUserRightMutation, Types.DeleteUserRightMutationVariables>;

/**
 * __useDeleteUserRightMutation__
 *
 * To run a mutation, you first call `useDeleteUserRightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRightMutation, { data, loading, error }] = useDeleteUserRightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserRightMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteUserRightMutation, Types.DeleteUserRightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteUserRightMutation, Types.DeleteUserRightMutationVariables>(DeleteUserRightDocument, options);
      }
export type DeleteUserRightMutationHookResult = ReturnType<typeof useDeleteUserRightMutation>;
export type DeleteUserRightMutationResult = Apollo.MutationResult<Types.DeleteUserRightMutation>;
export type DeleteUserRightMutationOptions = Apollo.BaseMutationOptions<Types.DeleteUserRightMutation, Types.DeleteUserRightMutationVariables>;
export const SetUserActivatedDocument = gql`
    mutation SetUserActivated($uid: Int!, $activated: Boolean!) {
  setUserActivated(input: {uid: $uid, activated: $activated}) {
    query {
      userById(id: $uid) {
        id
        ...User_Admin
      }
    }
  }
}
    ${User_AdminFragmentDoc}`;
export type SetUserActivatedMutationFn = Apollo.MutationFunction<Types.SetUserActivatedMutation, Types.SetUserActivatedMutationVariables>;

/**
 * __useSetUserActivatedMutation__
 *
 * To run a mutation, you first call `useSetUserActivatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserActivatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserActivatedMutation, { data, loading, error }] = useSetUserActivatedMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      activated: // value for 'activated'
 *   },
 * });
 */
export function useSetUserActivatedMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetUserActivatedMutation, Types.SetUserActivatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetUserActivatedMutation, Types.SetUserActivatedMutationVariables>(SetUserActivatedDocument, options);
      }
export type SetUserActivatedMutationHookResult = ReturnType<typeof useSetUserActivatedMutation>;
export type SetUserActivatedMutationResult = Apollo.MutationResult<Types.SetUserActivatedMutation>;
export type SetUserActivatedMutationOptions = Apollo.BaseMutationOptions<Types.SetUserActivatedMutation, Types.SetUserActivatedMutationVariables>;
export const AllVesselAttributeAssortmentExclusionsDocument = gql`
    query AllVesselAttributeAssortmentExclusions($orderBy: [VesselAttributeAssortmentExclusionsOrderBy!]) {
  allVesselAttributeAssortmentExclusions(orderBy: $orderBy) {
    nodes {
      id
      ...VesselAttributeAssortmentExclusion_Admin
    }
  }
}
    ${VesselAttributeAssortmentExclusion_AdminFragmentDoc}`;

/**
 * __useAllVesselAttributeAssortmentExclusionsQuery__
 *
 * To run a query within a React component, call `useAllVesselAttributeAssortmentExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVesselAttributeAssortmentExclusionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVesselAttributeAssortmentExclusionsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllVesselAttributeAssortmentExclusionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVesselAttributeAssortmentExclusionsQuery, Types.AllVesselAttributeAssortmentExclusionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVesselAttributeAssortmentExclusionsQuery, Types.AllVesselAttributeAssortmentExclusionsQueryVariables>(AllVesselAttributeAssortmentExclusionsDocument, options);
      }
export function useAllVesselAttributeAssortmentExclusionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVesselAttributeAssortmentExclusionsQuery, Types.AllVesselAttributeAssortmentExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVesselAttributeAssortmentExclusionsQuery, Types.AllVesselAttributeAssortmentExclusionsQueryVariables>(AllVesselAttributeAssortmentExclusionsDocument, options);
        }
export function useAllVesselAttributeAssortmentExclusionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVesselAttributeAssortmentExclusionsQuery, Types.AllVesselAttributeAssortmentExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVesselAttributeAssortmentExclusionsQuery, Types.AllVesselAttributeAssortmentExclusionsQueryVariables>(AllVesselAttributeAssortmentExclusionsDocument, options);
        }
export type AllVesselAttributeAssortmentExclusionsQueryHookResult = ReturnType<typeof useAllVesselAttributeAssortmentExclusionsQuery>;
export type AllVesselAttributeAssortmentExclusionsLazyQueryHookResult = ReturnType<typeof useAllVesselAttributeAssortmentExclusionsLazyQuery>;
export type AllVesselAttributeAssortmentExclusionsSuspenseQueryHookResult = ReturnType<typeof useAllVesselAttributeAssortmentExclusionsSuspenseQuery>;
export type AllVesselAttributeAssortmentExclusionsQueryResult = Apollo.QueryResult<Types.AllVesselAttributeAssortmentExclusionsQuery, Types.AllVesselAttributeAssortmentExclusionsQueryVariables>;
export const CreateVesselAttributeAssortmentExclusionDocument = gql`
    mutation CreateVesselAttributeAssortmentExclusion($input: CreateVesselAttributeAssortmentExclusionInput!) {
  createVesselAttributeAssortmentExclusion(input: $input) {
    vesselAttributeAssortmentExclusion {
      id
      ...VesselAttributeAssortmentExclusion_Admin
    }
  }
}
    ${VesselAttributeAssortmentExclusion_AdminFragmentDoc}`;
export type CreateVesselAttributeAssortmentExclusionMutationFn = Apollo.MutationFunction<Types.CreateVesselAttributeAssortmentExclusionMutation, Types.CreateVesselAttributeAssortmentExclusionMutationVariables>;

/**
 * __useCreateVesselAttributeAssortmentExclusionMutation__
 *
 * To run a mutation, you first call `useCreateVesselAttributeAssortmentExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselAttributeAssortmentExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselAttributeAssortmentExclusionMutation, { data, loading, error }] = useCreateVesselAttributeAssortmentExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselAttributeAssortmentExclusionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselAttributeAssortmentExclusionMutation, Types.CreateVesselAttributeAssortmentExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselAttributeAssortmentExclusionMutation, Types.CreateVesselAttributeAssortmentExclusionMutationVariables>(CreateVesselAttributeAssortmentExclusionDocument, options);
      }
export type CreateVesselAttributeAssortmentExclusionMutationHookResult = ReturnType<typeof useCreateVesselAttributeAssortmentExclusionMutation>;
export type CreateVesselAttributeAssortmentExclusionMutationResult = Apollo.MutationResult<Types.CreateVesselAttributeAssortmentExclusionMutation>;
export type CreateVesselAttributeAssortmentExclusionMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselAttributeAssortmentExclusionMutation, Types.CreateVesselAttributeAssortmentExclusionMutationVariables>;
export const UpdateVesselAttributeAssortmentExclusionDocument = gql`
    mutation UpdateVesselAttributeAssortmentExclusion($input: UpdateVesselAttributeAssortmentExclusionByIdInput!) {
  updateVesselAttributeAssortmentExclusionById(input: $input) {
    vesselAttributeAssortmentExclusion {
      id
      ...VesselAttributeAssortmentExclusion_Admin
    }
  }
}
    ${VesselAttributeAssortmentExclusion_AdminFragmentDoc}`;
export type UpdateVesselAttributeAssortmentExclusionMutationFn = Apollo.MutationFunction<Types.UpdateVesselAttributeAssortmentExclusionMutation, Types.UpdateVesselAttributeAssortmentExclusionMutationVariables>;

/**
 * __useUpdateVesselAttributeAssortmentExclusionMutation__
 *
 * To run a mutation, you first call `useUpdateVesselAttributeAssortmentExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselAttributeAssortmentExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselAttributeAssortmentExclusionMutation, { data, loading, error }] = useUpdateVesselAttributeAssortmentExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselAttributeAssortmentExclusionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselAttributeAssortmentExclusionMutation, Types.UpdateVesselAttributeAssortmentExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselAttributeAssortmentExclusionMutation, Types.UpdateVesselAttributeAssortmentExclusionMutationVariables>(UpdateVesselAttributeAssortmentExclusionDocument, options);
      }
export type UpdateVesselAttributeAssortmentExclusionMutationHookResult = ReturnType<typeof useUpdateVesselAttributeAssortmentExclusionMutation>;
export type UpdateVesselAttributeAssortmentExclusionMutationResult = Apollo.MutationResult<Types.UpdateVesselAttributeAssortmentExclusionMutation>;
export type UpdateVesselAttributeAssortmentExclusionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselAttributeAssortmentExclusionMutation, Types.UpdateVesselAttributeAssortmentExclusionMutationVariables>;
export const DeleteVesselAttributeAssortmentExclusionByIdDocument = gql`
    mutation DeleteVesselAttributeAssortmentExclusionById($input: DeleteVesselAttributeAssortmentExclusionByIdInput!) {
  deleteVesselAttributeAssortmentExclusionById(input: $input) {
    vesselAttributeAssortmentExclusion {
      id
      ...VesselAttributeAssortmentExclusion_Admin
    }
  }
}
    ${VesselAttributeAssortmentExclusion_AdminFragmentDoc}`;
export type DeleteVesselAttributeAssortmentExclusionByIdMutationFn = Apollo.MutationFunction<Types.DeleteVesselAttributeAssortmentExclusionByIdMutation, Types.DeleteVesselAttributeAssortmentExclusionByIdMutationVariables>;

/**
 * __useDeleteVesselAttributeAssortmentExclusionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteVesselAttributeAssortmentExclusionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselAttributeAssortmentExclusionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselAttributeAssortmentExclusionByIdMutation, { data, loading, error }] = useDeleteVesselAttributeAssortmentExclusionByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVesselAttributeAssortmentExclusionByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselAttributeAssortmentExclusionByIdMutation, Types.DeleteVesselAttributeAssortmentExclusionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselAttributeAssortmentExclusionByIdMutation, Types.DeleteVesselAttributeAssortmentExclusionByIdMutationVariables>(DeleteVesselAttributeAssortmentExclusionByIdDocument, options);
      }
export type DeleteVesselAttributeAssortmentExclusionByIdMutationHookResult = ReturnType<typeof useDeleteVesselAttributeAssortmentExclusionByIdMutation>;
export type DeleteVesselAttributeAssortmentExclusionByIdMutationResult = Apollo.MutationResult<Types.DeleteVesselAttributeAssortmentExclusionByIdMutation>;
export type DeleteVesselAttributeAssortmentExclusionByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselAttributeAssortmentExclusionByIdMutation, Types.DeleteVesselAttributeAssortmentExclusionByIdMutationVariables>;
export const AllVesselAttributesDocument = gql`
    query AllVesselAttributes($orderBy: [VesselAttributesOrderBy!]) {
  allVesselAttributes(orderBy: $orderBy) {
    nodes {
      id
      ...VesselAttribute_Admin
    }
  }
}
    ${VesselAttribute_AdminFragmentDoc}`;

/**
 * __useAllVesselAttributesQuery__
 *
 * To run a query within a React component, call `useAllVesselAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVesselAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVesselAttributesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllVesselAttributesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVesselAttributesQuery, Types.AllVesselAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVesselAttributesQuery, Types.AllVesselAttributesQueryVariables>(AllVesselAttributesDocument, options);
      }
export function useAllVesselAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVesselAttributesQuery, Types.AllVesselAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVesselAttributesQuery, Types.AllVesselAttributesQueryVariables>(AllVesselAttributesDocument, options);
        }
export function useAllVesselAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVesselAttributesQuery, Types.AllVesselAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVesselAttributesQuery, Types.AllVesselAttributesQueryVariables>(AllVesselAttributesDocument, options);
        }
export type AllVesselAttributesQueryHookResult = ReturnType<typeof useAllVesselAttributesQuery>;
export type AllVesselAttributesLazyQueryHookResult = ReturnType<typeof useAllVesselAttributesLazyQuery>;
export type AllVesselAttributesSuspenseQueryHookResult = ReturnType<typeof useAllVesselAttributesSuspenseQuery>;
export type AllVesselAttributesQueryResult = Apollo.QueryResult<Types.AllVesselAttributesQuery, Types.AllVesselAttributesQueryVariables>;
export const CreateVesselAttributeDocument = gql`
    mutation CreateVesselAttribute($input: CreateVesselAttributeInput!) {
  createVesselAttribute(input: $input) {
    vesselAttribute {
      id
      ...VesselAttribute_Admin
    }
  }
}
    ${VesselAttribute_AdminFragmentDoc}`;
export type CreateVesselAttributeMutationFn = Apollo.MutationFunction<Types.CreateVesselAttributeMutation, Types.CreateVesselAttributeMutationVariables>;

/**
 * __useCreateVesselAttributeMutation__
 *
 * To run a mutation, you first call `useCreateVesselAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselAttributeMutation, { data, loading, error }] = useCreateVesselAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselAttributeMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselAttributeMutation, Types.CreateVesselAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselAttributeMutation, Types.CreateVesselAttributeMutationVariables>(CreateVesselAttributeDocument, options);
      }
export type CreateVesselAttributeMutationHookResult = ReturnType<typeof useCreateVesselAttributeMutation>;
export type CreateVesselAttributeMutationResult = Apollo.MutationResult<Types.CreateVesselAttributeMutation>;
export type CreateVesselAttributeMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselAttributeMutation, Types.CreateVesselAttributeMutationVariables>;
export const UpdateVesselAttributeByIdDocument = gql`
    mutation UpdateVesselAttributeById($input: UpdateVesselAttributeByIdInput!) {
  updateVesselAttributeById(input: $input) {
    vesselAttribute {
      id
      ...VesselAttribute_Admin
    }
  }
}
    ${VesselAttribute_AdminFragmentDoc}`;
export type UpdateVesselAttributeByIdMutationFn = Apollo.MutationFunction<Types.UpdateVesselAttributeByIdMutation, Types.UpdateVesselAttributeByIdMutationVariables>;

/**
 * __useUpdateVesselAttributeByIdMutation__
 *
 * To run a mutation, you first call `useUpdateVesselAttributeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselAttributeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselAttributeByIdMutation, { data, loading, error }] = useUpdateVesselAttributeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselAttributeByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselAttributeByIdMutation, Types.UpdateVesselAttributeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselAttributeByIdMutation, Types.UpdateVesselAttributeByIdMutationVariables>(UpdateVesselAttributeByIdDocument, options);
      }
export type UpdateVesselAttributeByIdMutationHookResult = ReturnType<typeof useUpdateVesselAttributeByIdMutation>;
export type UpdateVesselAttributeByIdMutationResult = Apollo.MutationResult<Types.UpdateVesselAttributeByIdMutation>;
export type UpdateVesselAttributeByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselAttributeByIdMutation, Types.UpdateVesselAttributeByIdMutationVariables>;
export const DeleteVesselAttributeByIdDocument = gql`
    mutation DeleteVesselAttributeById($input: DeleteVesselAttributeByIdInput!) {
  deleteVesselAttributeById(input: $input) {
    vesselAttribute {
      id
      ...VesselAttribute_Admin
    }
  }
}
    ${VesselAttribute_AdminFragmentDoc}`;
export type DeleteVesselAttributeByIdMutationFn = Apollo.MutationFunction<Types.DeleteVesselAttributeByIdMutation, Types.DeleteVesselAttributeByIdMutationVariables>;

/**
 * __useDeleteVesselAttributeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteVesselAttributeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselAttributeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselAttributeByIdMutation, { data, loading, error }] = useDeleteVesselAttributeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVesselAttributeByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselAttributeByIdMutation, Types.DeleteVesselAttributeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselAttributeByIdMutation, Types.DeleteVesselAttributeByIdMutationVariables>(DeleteVesselAttributeByIdDocument, options);
      }
export type DeleteVesselAttributeByIdMutationHookResult = ReturnType<typeof useDeleteVesselAttributeByIdMutation>;
export type DeleteVesselAttributeByIdMutationResult = Apollo.MutationResult<Types.DeleteVesselAttributeByIdMutation>;
export type DeleteVesselAttributeByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselAttributeByIdMutation, Types.DeleteVesselAttributeByIdMutationVariables>;
export const CreateVesselAttributesAssociationDocument = gql`
    mutation CreateVesselAttributesAssociation($input: CreateVesselAttributesAssociationInput!) {
  createVesselAttributesAssociation(input: $input) {
    shipByShipId {
      id
      ...Ship_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}`;
export type CreateVesselAttributesAssociationMutationFn = Apollo.MutationFunction<Types.CreateVesselAttributesAssociationMutation, Types.CreateVesselAttributesAssociationMutationVariables>;

/**
 * __useCreateVesselAttributesAssociationMutation__
 *
 * To run a mutation, you first call `useCreateVesselAttributesAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselAttributesAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselAttributesAssociationMutation, { data, loading, error }] = useCreateVesselAttributesAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselAttributesAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselAttributesAssociationMutation, Types.CreateVesselAttributesAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselAttributesAssociationMutation, Types.CreateVesselAttributesAssociationMutationVariables>(CreateVesselAttributesAssociationDocument, options);
      }
export type CreateVesselAttributesAssociationMutationHookResult = ReturnType<typeof useCreateVesselAttributesAssociationMutation>;
export type CreateVesselAttributesAssociationMutationResult = Apollo.MutationResult<Types.CreateVesselAttributesAssociationMutation>;
export type CreateVesselAttributesAssociationMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselAttributesAssociationMutation, Types.CreateVesselAttributesAssociationMutationVariables>;
export const DeleteVesselAttributesAssociationByIdDocument = gql`
    mutation DeleteVesselAttributesAssociationById($associationId: Int!) {
  deleteVesselAttributesAssociationById(input: {id: $associationId}) {
    shipByShipId {
      id
      ...Ship_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}`;
export type DeleteVesselAttributesAssociationByIdMutationFn = Apollo.MutationFunction<Types.DeleteVesselAttributesAssociationByIdMutation, Types.DeleteVesselAttributesAssociationByIdMutationVariables>;

/**
 * __useDeleteVesselAttributesAssociationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteVesselAttributesAssociationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselAttributesAssociationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselAttributesAssociationByIdMutation, { data, loading, error }] = useDeleteVesselAttributesAssociationByIdMutation({
 *   variables: {
 *      associationId: // value for 'associationId'
 *   },
 * });
 */
export function useDeleteVesselAttributesAssociationByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselAttributesAssociationByIdMutation, Types.DeleteVesselAttributesAssociationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselAttributesAssociationByIdMutation, Types.DeleteVesselAttributesAssociationByIdMutationVariables>(DeleteVesselAttributesAssociationByIdDocument, options);
      }
export type DeleteVesselAttributesAssociationByIdMutationHookResult = ReturnType<typeof useDeleteVesselAttributesAssociationByIdMutation>;
export type DeleteVesselAttributesAssociationByIdMutationResult = Apollo.MutationResult<Types.DeleteVesselAttributesAssociationByIdMutation>;
export type DeleteVesselAttributesAssociationByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselAttributesAssociationByIdMutation, Types.DeleteVesselAttributesAssociationByIdMutationVariables>;
export const CreateVesselDraftDatapointDocument = gql`
    mutation CreateVesselDraftDatapoint($input: CreateVesselDraftDatapointInput!) {
  createVesselDraftDatapoint(input: $input) {
    shipByShipId {
      id
      ...Ship_Admin
    }
    vesselDraftDatapoint {
      id
      ...VesselDraftDatapoint_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}
${VesselDraftDatapoint_AdminFragmentDoc}`;
export type CreateVesselDraftDatapointMutationFn = Apollo.MutationFunction<Types.CreateVesselDraftDatapointMutation, Types.CreateVesselDraftDatapointMutationVariables>;

/**
 * __useCreateVesselDraftDatapointMutation__
 *
 * To run a mutation, you first call `useCreateVesselDraftDatapointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselDraftDatapointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselDraftDatapointMutation, { data, loading, error }] = useCreateVesselDraftDatapointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselDraftDatapointMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselDraftDatapointMutation, Types.CreateVesselDraftDatapointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselDraftDatapointMutation, Types.CreateVesselDraftDatapointMutationVariables>(CreateVesselDraftDatapointDocument, options);
      }
export type CreateVesselDraftDatapointMutationHookResult = ReturnType<typeof useCreateVesselDraftDatapointMutation>;
export type CreateVesselDraftDatapointMutationResult = Apollo.MutationResult<Types.CreateVesselDraftDatapointMutation>;
export type CreateVesselDraftDatapointMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselDraftDatapointMutation, Types.CreateVesselDraftDatapointMutationVariables>;
export const UpdateVesselDraftDatapointDocument = gql`
    mutation UpdateVesselDraftDatapoint($input: UpdateVesselDraftDatapointByIdInput!) {
  updateVesselDraftDatapointById(input: $input) {
    shipByShipId {
      id
      ...Ship_Admin
    }
    vesselDraftDatapoint {
      id
      ...VesselDraftDatapoint_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}
${VesselDraftDatapoint_AdminFragmentDoc}`;
export type UpdateVesselDraftDatapointMutationFn = Apollo.MutationFunction<Types.UpdateVesselDraftDatapointMutation, Types.UpdateVesselDraftDatapointMutationVariables>;

/**
 * __useUpdateVesselDraftDatapointMutation__
 *
 * To run a mutation, you first call `useUpdateVesselDraftDatapointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselDraftDatapointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselDraftDatapointMutation, { data, loading, error }] = useUpdateVesselDraftDatapointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselDraftDatapointMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselDraftDatapointMutation, Types.UpdateVesselDraftDatapointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselDraftDatapointMutation, Types.UpdateVesselDraftDatapointMutationVariables>(UpdateVesselDraftDatapointDocument, options);
      }
export type UpdateVesselDraftDatapointMutationHookResult = ReturnType<typeof useUpdateVesselDraftDatapointMutation>;
export type UpdateVesselDraftDatapointMutationResult = Apollo.MutationResult<Types.UpdateVesselDraftDatapointMutation>;
export type UpdateVesselDraftDatapointMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselDraftDatapointMutation, Types.UpdateVesselDraftDatapointMutationVariables>;
export const DeleteVesselDraftDatapointDocument = gql`
    mutation DeleteVesselDraftDatapoint($input: DeleteVesselDraftDatapointByIdInput!) {
  deleteVesselDraftDatapointById(input: $input) {
    vesselDraftDatapoint {
      id
      ...VesselDraftDatapoint_Admin
    }
  }
}
    ${VesselDraftDatapoint_AdminFragmentDoc}`;
export type DeleteVesselDraftDatapointMutationFn = Apollo.MutationFunction<Types.DeleteVesselDraftDatapointMutation, Types.DeleteVesselDraftDatapointMutationVariables>;

/**
 * __useDeleteVesselDraftDatapointMutation__
 *
 * To run a mutation, you first call `useDeleteVesselDraftDatapointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselDraftDatapointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselDraftDatapointMutation, { data, loading, error }] = useDeleteVesselDraftDatapointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVesselDraftDatapointMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselDraftDatapointMutation, Types.DeleteVesselDraftDatapointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselDraftDatapointMutation, Types.DeleteVesselDraftDatapointMutationVariables>(DeleteVesselDraftDatapointDocument, options);
      }
export type DeleteVesselDraftDatapointMutationHookResult = ReturnType<typeof useDeleteVesselDraftDatapointMutation>;
export type DeleteVesselDraftDatapointMutationResult = Apollo.MutationResult<Types.DeleteVesselDraftDatapointMutation>;
export type DeleteVesselDraftDatapointMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselDraftDatapointMutation, Types.DeleteVesselDraftDatapointMutationVariables>;
export const AllVesselFulfillsRequirementsDocument = gql`
    query AllVesselFulfillsRequirements($orderBy: [VesselFulfillsRequirementAssociationsOrderBy!]) {
  allVesselFulfillsRequirementAssociations(orderBy: $orderBy) {
    nodes {
      id
      ...VesselFulfillsRequirementAssociation_Admin
    }
  }
}
    ${VesselFulfillsRequirementAssociation_AdminFragmentDoc}`;

/**
 * __useAllVesselFulfillsRequirementsQuery__
 *
 * To run a query within a React component, call `useAllVesselFulfillsRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVesselFulfillsRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVesselFulfillsRequirementsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllVesselFulfillsRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVesselFulfillsRequirementsQuery, Types.AllVesselFulfillsRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVesselFulfillsRequirementsQuery, Types.AllVesselFulfillsRequirementsQueryVariables>(AllVesselFulfillsRequirementsDocument, options);
      }
export function useAllVesselFulfillsRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVesselFulfillsRequirementsQuery, Types.AllVesselFulfillsRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVesselFulfillsRequirementsQuery, Types.AllVesselFulfillsRequirementsQueryVariables>(AllVesselFulfillsRequirementsDocument, options);
        }
export function useAllVesselFulfillsRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVesselFulfillsRequirementsQuery, Types.AllVesselFulfillsRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVesselFulfillsRequirementsQuery, Types.AllVesselFulfillsRequirementsQueryVariables>(AllVesselFulfillsRequirementsDocument, options);
        }
export type AllVesselFulfillsRequirementsQueryHookResult = ReturnType<typeof useAllVesselFulfillsRequirementsQuery>;
export type AllVesselFulfillsRequirementsLazyQueryHookResult = ReturnType<typeof useAllVesselFulfillsRequirementsLazyQuery>;
export type AllVesselFulfillsRequirementsSuspenseQueryHookResult = ReturnType<typeof useAllVesselFulfillsRequirementsSuspenseQuery>;
export type AllVesselFulfillsRequirementsQueryResult = Apollo.QueryResult<Types.AllVesselFulfillsRequirementsQuery, Types.AllVesselFulfillsRequirementsQueryVariables>;
export const CreateVesselFulfillsRequirementDocument = gql`
    mutation CreateVesselFulfillsRequirement($input: CreateVesselFulfillsRequirementAssociationInput!) {
  createVesselFulfillsRequirementAssociation(input: $input) {
    vesselFulfillsRequirementAssociation {
      id
      ...VesselFulfillsRequirementAssociation_Admin
    }
  }
}
    ${VesselFulfillsRequirementAssociation_AdminFragmentDoc}`;
export type CreateVesselFulfillsRequirementMutationFn = Apollo.MutationFunction<Types.CreateVesselFulfillsRequirementMutation, Types.CreateVesselFulfillsRequirementMutationVariables>;

/**
 * __useCreateVesselFulfillsRequirementMutation__
 *
 * To run a mutation, you first call `useCreateVesselFulfillsRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselFulfillsRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselFulfillsRequirementMutation, { data, loading, error }] = useCreateVesselFulfillsRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselFulfillsRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselFulfillsRequirementMutation, Types.CreateVesselFulfillsRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselFulfillsRequirementMutation, Types.CreateVesselFulfillsRequirementMutationVariables>(CreateVesselFulfillsRequirementDocument, options);
      }
export type CreateVesselFulfillsRequirementMutationHookResult = ReturnType<typeof useCreateVesselFulfillsRequirementMutation>;
export type CreateVesselFulfillsRequirementMutationResult = Apollo.MutationResult<Types.CreateVesselFulfillsRequirementMutation>;
export type CreateVesselFulfillsRequirementMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselFulfillsRequirementMutation, Types.CreateVesselFulfillsRequirementMutationVariables>;
export const UpdateVesselFulfillsRequirementDocument = gql`
    mutation UpdateVesselFulfillsRequirement($input: UpdateVesselFulfillsRequirementAssociationByIdInput!) {
  updateVesselFulfillsRequirementAssociationById(input: $input) {
    vesselFulfillsRequirementAssociation {
      id
      ...VesselFulfillsRequirementAssociation_Admin
    }
  }
}
    ${VesselFulfillsRequirementAssociation_AdminFragmentDoc}`;
export type UpdateVesselFulfillsRequirementMutationFn = Apollo.MutationFunction<Types.UpdateVesselFulfillsRequirementMutation, Types.UpdateVesselFulfillsRequirementMutationVariables>;

/**
 * __useUpdateVesselFulfillsRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateVesselFulfillsRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselFulfillsRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselFulfillsRequirementMutation, { data, loading, error }] = useUpdateVesselFulfillsRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselFulfillsRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselFulfillsRequirementMutation, Types.UpdateVesselFulfillsRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselFulfillsRequirementMutation, Types.UpdateVesselFulfillsRequirementMutationVariables>(UpdateVesselFulfillsRequirementDocument, options);
      }
export type UpdateVesselFulfillsRequirementMutationHookResult = ReturnType<typeof useUpdateVesselFulfillsRequirementMutation>;
export type UpdateVesselFulfillsRequirementMutationResult = Apollo.MutationResult<Types.UpdateVesselFulfillsRequirementMutation>;
export type UpdateVesselFulfillsRequirementMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselFulfillsRequirementMutation, Types.UpdateVesselFulfillsRequirementMutationVariables>;
export const DeleteVesselFulfillsRequirementByIdDocument = gql`
    mutation DeleteVesselFulfillsRequirementById($input: DeleteVesselFulfillsRequirementAssociationByIdInput!) {
  deleteVesselFulfillsRequirementAssociationById(input: $input) {
    vesselFulfillsRequirementAssociation {
      id
      ...VesselFulfillsRequirementAssociation_Admin
    }
  }
}
    ${VesselFulfillsRequirementAssociation_AdminFragmentDoc}`;
export type DeleteVesselFulfillsRequirementByIdMutationFn = Apollo.MutationFunction<Types.DeleteVesselFulfillsRequirementByIdMutation, Types.DeleteVesselFulfillsRequirementByIdMutationVariables>;

/**
 * __useDeleteVesselFulfillsRequirementByIdMutation__
 *
 * To run a mutation, you first call `useDeleteVesselFulfillsRequirementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselFulfillsRequirementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselFulfillsRequirementByIdMutation, { data, loading, error }] = useDeleteVesselFulfillsRequirementByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVesselFulfillsRequirementByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselFulfillsRequirementByIdMutation, Types.DeleteVesselFulfillsRequirementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselFulfillsRequirementByIdMutation, Types.DeleteVesselFulfillsRequirementByIdMutationVariables>(DeleteVesselFulfillsRequirementByIdDocument, options);
      }
export type DeleteVesselFulfillsRequirementByIdMutationHookResult = ReturnType<typeof useDeleteVesselFulfillsRequirementByIdMutation>;
export type DeleteVesselFulfillsRequirementByIdMutationResult = Apollo.MutationResult<Types.DeleteVesselFulfillsRequirementByIdMutation>;
export type DeleteVesselFulfillsRequirementByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselFulfillsRequirementByIdMutation, Types.DeleteVesselFulfillsRequirementByIdMutationVariables>;
export const AllVesselInfosDocument = gql`
    query AllVesselInfos($orderBy: [VesselInfosOrderBy!]) {
  allVesselInfos(orderBy: $orderBy) {
    nodes {
      id
      ...VesselInfo_Admin
    }
  }
}
    ${VesselInfo_AdminFragmentDoc}`;

/**
 * __useAllVesselInfosQuery__
 *
 * To run a query within a React component, call `useAllVesselInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVesselInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVesselInfosQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllVesselInfosQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVesselInfosQuery, Types.AllVesselInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVesselInfosQuery, Types.AllVesselInfosQueryVariables>(AllVesselInfosDocument, options);
      }
export function useAllVesselInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVesselInfosQuery, Types.AllVesselInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVesselInfosQuery, Types.AllVesselInfosQueryVariables>(AllVesselInfosDocument, options);
        }
export function useAllVesselInfosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVesselInfosQuery, Types.AllVesselInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVesselInfosQuery, Types.AllVesselInfosQueryVariables>(AllVesselInfosDocument, options);
        }
export type AllVesselInfosQueryHookResult = ReturnType<typeof useAllVesselInfosQuery>;
export type AllVesselInfosLazyQueryHookResult = ReturnType<typeof useAllVesselInfosLazyQuery>;
export type AllVesselInfosSuspenseQueryHookResult = ReturnType<typeof useAllVesselInfosSuspenseQuery>;
export type AllVesselInfosQueryResult = Apollo.QueryResult<Types.AllVesselInfosQuery, Types.AllVesselInfosQueryVariables>;
export const CreateVesselInfoDocument = gql`
    mutation CreateVesselInfo($input: CreateVesselInfoInput!) {
  createVesselInfo(input: $input) {
    vesselInfo {
      id
      ...VesselInfo_Admin
    }
  }
}
    ${VesselInfo_AdminFragmentDoc}`;
export type CreateVesselInfoMutationFn = Apollo.MutationFunction<Types.CreateVesselInfoMutation, Types.CreateVesselInfoMutationVariables>;

/**
 * __useCreateVesselInfoMutation__
 *
 * To run a mutation, you first call `useCreateVesselInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselInfoMutation, { data, loading, error }] = useCreateVesselInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselInfoMutation, Types.CreateVesselInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselInfoMutation, Types.CreateVesselInfoMutationVariables>(CreateVesselInfoDocument, options);
      }
export type CreateVesselInfoMutationHookResult = ReturnType<typeof useCreateVesselInfoMutation>;
export type CreateVesselInfoMutationResult = Apollo.MutationResult<Types.CreateVesselInfoMutation>;
export type CreateVesselInfoMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselInfoMutation, Types.CreateVesselInfoMutationVariables>;
export const UpdateVesselInfoDocument = gql`
    mutation UpdateVesselInfo($input: UpdateVesselInfoByIdInput!) {
  updateVesselInfoById(input: $input) {
    vesselInfo {
      id
      ...VesselInfo_Admin
    }
  }
}
    ${VesselInfo_AdminFragmentDoc}`;
export type UpdateVesselInfoMutationFn = Apollo.MutationFunction<Types.UpdateVesselInfoMutation, Types.UpdateVesselInfoMutationVariables>;

/**
 * __useUpdateVesselInfoMutation__
 *
 * To run a mutation, you first call `useUpdateVesselInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselInfoMutation, { data, loading, error }] = useUpdateVesselInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselInfoMutation, Types.UpdateVesselInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselInfoMutation, Types.UpdateVesselInfoMutationVariables>(UpdateVesselInfoDocument, options);
      }
export type UpdateVesselInfoMutationHookResult = ReturnType<typeof useUpdateVesselInfoMutation>;
export type UpdateVesselInfoMutationResult = Apollo.MutationResult<Types.UpdateVesselInfoMutation>;
export type UpdateVesselInfoMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselInfoMutation, Types.UpdateVesselInfoMutationVariables>;
export const DeleteVesselInfoByIdDocument = gql`
    mutation DeleteVesselInfoById($input: DeleteVesselInfoByIdInput!) {
  deleteVesselInfoById(input: $input) {
    vesselInfo {
      id
      ...VesselInfo_Admin
    }
  }
}
    ${VesselInfo_AdminFragmentDoc}`;
export type DeleteVesselInfoByIdMutationFn = Apollo.MutationFunction<Types.DeleteVesselInfoByIdMutation, Types.DeleteVesselInfoByIdMutationVariables>;

/**
 * __useDeleteVesselInfoByIdMutation__
 *
 * To run a mutation, you first call `useDeleteVesselInfoByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselInfoByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselInfoByIdMutation, { data, loading, error }] = useDeleteVesselInfoByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVesselInfoByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselInfoByIdMutation, Types.DeleteVesselInfoByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselInfoByIdMutation, Types.DeleteVesselInfoByIdMutationVariables>(DeleteVesselInfoByIdDocument, options);
      }
export type DeleteVesselInfoByIdMutationHookResult = ReturnType<typeof useDeleteVesselInfoByIdMutation>;
export type DeleteVesselInfoByIdMutationResult = Apollo.MutationResult<Types.DeleteVesselInfoByIdMutation>;
export type DeleteVesselInfoByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselInfoByIdMutation, Types.DeleteVesselInfoByIdMutationVariables>;
export const AllVesselScheduleSharedToOrganizationsDocument = gql`
    query AllVesselScheduleSharedToOrganizations($filter: VesselScheduleSharedToOrganizationFilter) {
  allVesselScheduleSharedToOrganizations(
    filter: $filter
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      id
      ...VesselScheduleSharedToOrganization_Admin
    }
  }
}
    ${VesselScheduleSharedToOrganization_AdminFragmentDoc}`;

/**
 * __useAllVesselScheduleSharedToOrganizationsQuery__
 *
 * To run a query within a React component, call `useAllVesselScheduleSharedToOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVesselScheduleSharedToOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVesselScheduleSharedToOrganizationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllVesselScheduleSharedToOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVesselScheduleSharedToOrganizationsQuery, Types.AllVesselScheduleSharedToOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVesselScheduleSharedToOrganizationsQuery, Types.AllVesselScheduleSharedToOrganizationsQueryVariables>(AllVesselScheduleSharedToOrganizationsDocument, options);
      }
export function useAllVesselScheduleSharedToOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVesselScheduleSharedToOrganizationsQuery, Types.AllVesselScheduleSharedToOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVesselScheduleSharedToOrganizationsQuery, Types.AllVesselScheduleSharedToOrganizationsQueryVariables>(AllVesselScheduleSharedToOrganizationsDocument, options);
        }
export function useAllVesselScheduleSharedToOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVesselScheduleSharedToOrganizationsQuery, Types.AllVesselScheduleSharedToOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVesselScheduleSharedToOrganizationsQuery, Types.AllVesselScheduleSharedToOrganizationsQueryVariables>(AllVesselScheduleSharedToOrganizationsDocument, options);
        }
export type AllVesselScheduleSharedToOrganizationsQueryHookResult = ReturnType<typeof useAllVesselScheduleSharedToOrganizationsQuery>;
export type AllVesselScheduleSharedToOrganizationsLazyQueryHookResult = ReturnType<typeof useAllVesselScheduleSharedToOrganizationsLazyQuery>;
export type AllVesselScheduleSharedToOrganizationsSuspenseQueryHookResult = ReturnType<typeof useAllVesselScheduleSharedToOrganizationsSuspenseQuery>;
export type AllVesselScheduleSharedToOrganizationsQueryResult = Apollo.QueryResult<Types.AllVesselScheduleSharedToOrganizationsQuery, Types.AllVesselScheduleSharedToOrganizationsQueryVariables>;
export const CreateVesselScheduleSharedToOrganizationDocument = gql`
    mutation CreateVesselScheduleSharedToOrganization($input: CreateVesselScheduleSharedToOrganizationInput!) {
  createVesselScheduleSharedToOrganization(input: $input) {
    vesselScheduleSharedToOrganization {
      id
      ...VesselScheduleSharedToOrganization_Admin
    }
  }
}
    ${VesselScheduleSharedToOrganization_AdminFragmentDoc}`;
export type CreateVesselScheduleSharedToOrganizationMutationFn = Apollo.MutationFunction<Types.CreateVesselScheduleSharedToOrganizationMutation, Types.CreateVesselScheduleSharedToOrganizationMutationVariables>;

/**
 * __useCreateVesselScheduleSharedToOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateVesselScheduleSharedToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselScheduleSharedToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselScheduleSharedToOrganizationMutation, { data, loading, error }] = useCreateVesselScheduleSharedToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselScheduleSharedToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselScheduleSharedToOrganizationMutation, Types.CreateVesselScheduleSharedToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselScheduleSharedToOrganizationMutation, Types.CreateVesselScheduleSharedToOrganizationMutationVariables>(CreateVesselScheduleSharedToOrganizationDocument, options);
      }
export type CreateVesselScheduleSharedToOrganizationMutationHookResult = ReturnType<typeof useCreateVesselScheduleSharedToOrganizationMutation>;
export type CreateVesselScheduleSharedToOrganizationMutationResult = Apollo.MutationResult<Types.CreateVesselScheduleSharedToOrganizationMutation>;
export type CreateVesselScheduleSharedToOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselScheduleSharedToOrganizationMutation, Types.CreateVesselScheduleSharedToOrganizationMutationVariables>;
export const UpdateVesselScheduleSharedToOrganizationDocument = gql`
    mutation UpdateVesselScheduleSharedToOrganization($input: UpdateVesselScheduleSharedToOrganizationByIdInput!) {
  updateVesselScheduleSharedToOrganizationById(input: $input) {
    vesselScheduleSharedToOrganization {
      id
      ...VesselScheduleSharedToOrganization_Admin
    }
  }
}
    ${VesselScheduleSharedToOrganization_AdminFragmentDoc}`;
export type UpdateVesselScheduleSharedToOrganizationMutationFn = Apollo.MutationFunction<Types.UpdateVesselScheduleSharedToOrganizationMutation, Types.UpdateVesselScheduleSharedToOrganizationMutationVariables>;

/**
 * __useUpdateVesselScheduleSharedToOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateVesselScheduleSharedToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselScheduleSharedToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselScheduleSharedToOrganizationMutation, { data, loading, error }] = useUpdateVesselScheduleSharedToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselScheduleSharedToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselScheduleSharedToOrganizationMutation, Types.UpdateVesselScheduleSharedToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselScheduleSharedToOrganizationMutation, Types.UpdateVesselScheduleSharedToOrganizationMutationVariables>(UpdateVesselScheduleSharedToOrganizationDocument, options);
      }
export type UpdateVesselScheduleSharedToOrganizationMutationHookResult = ReturnType<typeof useUpdateVesselScheduleSharedToOrganizationMutation>;
export type UpdateVesselScheduleSharedToOrganizationMutationResult = Apollo.MutationResult<Types.UpdateVesselScheduleSharedToOrganizationMutation>;
export type UpdateVesselScheduleSharedToOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselScheduleSharedToOrganizationMutation, Types.UpdateVesselScheduleSharedToOrganizationMutationVariables>;
export const DeleteVesselScheduleSharedToOrganizationDocument = gql`
    mutation DeleteVesselScheduleSharedToOrganization($input: DeleteVesselScheduleSharedToOrganizationByIdInput!) {
  deleteVesselScheduleSharedToOrganizationById(input: $input) {
    vesselScheduleSharedToOrganization {
      id
      ...VesselScheduleSharedToOrganization_Admin
    }
  }
}
    ${VesselScheduleSharedToOrganization_AdminFragmentDoc}`;
export type DeleteVesselScheduleSharedToOrganizationMutationFn = Apollo.MutationFunction<Types.DeleteVesselScheduleSharedToOrganizationMutation, Types.DeleteVesselScheduleSharedToOrganizationMutationVariables>;

/**
 * __useDeleteVesselScheduleSharedToOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteVesselScheduleSharedToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselScheduleSharedToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselScheduleSharedToOrganizationMutation, { data, loading, error }] = useDeleteVesselScheduleSharedToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVesselScheduleSharedToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselScheduleSharedToOrganizationMutation, Types.DeleteVesselScheduleSharedToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselScheduleSharedToOrganizationMutation, Types.DeleteVesselScheduleSharedToOrganizationMutationVariables>(DeleteVesselScheduleSharedToOrganizationDocument, options);
      }
export type DeleteVesselScheduleSharedToOrganizationMutationHookResult = ReturnType<typeof useDeleteVesselScheduleSharedToOrganizationMutation>;
export type DeleteVesselScheduleSharedToOrganizationMutationResult = Apollo.MutationResult<Types.DeleteVesselScheduleSharedToOrganizationMutation>;
export type DeleteVesselScheduleSharedToOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselScheduleSharedToOrganizationMutation, Types.DeleteVesselScheduleSharedToOrganizationMutationVariables>;
export const CreateVesselSpeedConsumptionDocument = gql`
    mutation CreateVesselSpeedConsumption($input: CreateVesselSpeedConsumptionInput!) {
  createVesselSpeedConsumption(input: $input) {
    shipByShipId {
      id
      ...Ship_Admin
    }
    vesselSpeedConsumption {
      id
      ...VesselSpeedConsumption_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}
${VesselSpeedConsumption_AdminFragmentDoc}`;
export type CreateVesselSpeedConsumptionMutationFn = Apollo.MutationFunction<Types.CreateVesselSpeedConsumptionMutation, Types.CreateVesselSpeedConsumptionMutationVariables>;

/**
 * __useCreateVesselSpeedConsumptionMutation__
 *
 * To run a mutation, you first call `useCreateVesselSpeedConsumptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselSpeedConsumptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselSpeedConsumptionMutation, { data, loading, error }] = useCreateVesselSpeedConsumptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselSpeedConsumptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselSpeedConsumptionMutation, Types.CreateVesselSpeedConsumptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselSpeedConsumptionMutation, Types.CreateVesselSpeedConsumptionMutationVariables>(CreateVesselSpeedConsumptionDocument, options);
      }
export type CreateVesselSpeedConsumptionMutationHookResult = ReturnType<typeof useCreateVesselSpeedConsumptionMutation>;
export type CreateVesselSpeedConsumptionMutationResult = Apollo.MutationResult<Types.CreateVesselSpeedConsumptionMutation>;
export type CreateVesselSpeedConsumptionMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselSpeedConsumptionMutation, Types.CreateVesselSpeedConsumptionMutationVariables>;
export const UpdateVesselSpeedConsumptionDocument = gql`
    mutation UpdateVesselSpeedConsumption($input: UpdateVesselSpeedConsumptionByIdInput!) {
  updateVesselSpeedConsumptionById(input: $input) {
    shipByShipId {
      id
      ...Ship_Admin
    }
    vesselSpeedConsumption {
      id
      ...VesselSpeedConsumption_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}
${VesselSpeedConsumption_AdminFragmentDoc}`;
export type UpdateVesselSpeedConsumptionMutationFn = Apollo.MutationFunction<Types.UpdateVesselSpeedConsumptionMutation, Types.UpdateVesselSpeedConsumptionMutationVariables>;

/**
 * __useUpdateVesselSpeedConsumptionMutation__
 *
 * To run a mutation, you first call `useUpdateVesselSpeedConsumptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselSpeedConsumptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselSpeedConsumptionMutation, { data, loading, error }] = useUpdateVesselSpeedConsumptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselSpeedConsumptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselSpeedConsumptionMutation, Types.UpdateVesselSpeedConsumptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselSpeedConsumptionMutation, Types.UpdateVesselSpeedConsumptionMutationVariables>(UpdateVesselSpeedConsumptionDocument, options);
      }
export type UpdateVesselSpeedConsumptionMutationHookResult = ReturnType<typeof useUpdateVesselSpeedConsumptionMutation>;
export type UpdateVesselSpeedConsumptionMutationResult = Apollo.MutationResult<Types.UpdateVesselSpeedConsumptionMutation>;
export type UpdateVesselSpeedConsumptionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselSpeedConsumptionMutation, Types.UpdateVesselSpeedConsumptionMutationVariables>;
export const DeleteVesselSpeedConsumptionDocument = gql`
    mutation DeleteVesselSpeedConsumption($input: DeleteVesselSpeedConsumptionByIdInput!) {
  deleteVesselSpeedConsumptionById(input: $input) {
    vesselSpeedConsumption {
      id
      ...VesselSpeedConsumption_Admin
    }
  }
}
    ${VesselSpeedConsumption_AdminFragmentDoc}`;
export type DeleteVesselSpeedConsumptionMutationFn = Apollo.MutationFunction<Types.DeleteVesselSpeedConsumptionMutation, Types.DeleteVesselSpeedConsumptionMutationVariables>;

/**
 * __useDeleteVesselSpeedConsumptionMutation__
 *
 * To run a mutation, you first call `useDeleteVesselSpeedConsumptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselSpeedConsumptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselSpeedConsumptionMutation, { data, loading, error }] = useDeleteVesselSpeedConsumptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVesselSpeedConsumptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselSpeedConsumptionMutation, Types.DeleteVesselSpeedConsumptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselSpeedConsumptionMutation, Types.DeleteVesselSpeedConsumptionMutationVariables>(DeleteVesselSpeedConsumptionDocument, options);
      }
export type DeleteVesselSpeedConsumptionMutationHookResult = ReturnType<typeof useDeleteVesselSpeedConsumptionMutation>;
export type DeleteVesselSpeedConsumptionMutationResult = Apollo.MutationResult<Types.DeleteVesselSpeedConsumptionMutation>;
export type DeleteVesselSpeedConsumptionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselSpeedConsumptionMutation, Types.DeleteVesselSpeedConsumptionMutationVariables>;
export const AllShipsDocument = gql`
    query AllShips($filter: ShipFilter) {
  allShips(filter: $filter) {
    nodes {
      id
      ...Ship_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}`;

/**
 * __useAllShipsQuery__
 *
 * To run a query within a React component, call `useAllShipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShipsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllShipsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllShipsQuery, Types.AllShipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllShipsQuery, Types.AllShipsQueryVariables>(AllShipsDocument, options);
      }
export function useAllShipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllShipsQuery, Types.AllShipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllShipsQuery, Types.AllShipsQueryVariables>(AllShipsDocument, options);
        }
export function useAllShipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllShipsQuery, Types.AllShipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllShipsQuery, Types.AllShipsQueryVariables>(AllShipsDocument, options);
        }
export type AllShipsQueryHookResult = ReturnType<typeof useAllShipsQuery>;
export type AllShipsLazyQueryHookResult = ReturnType<typeof useAllShipsLazyQuery>;
export type AllShipsSuspenseQueryHookResult = ReturnType<typeof useAllShipsSuspenseQuery>;
export type AllShipsQueryResult = Apollo.QueryResult<Types.AllShipsQuery, Types.AllShipsQueryVariables>;
export const CreateShipAdminDocument = gql`
    mutation CreateShipAdmin($input: CreateShipInput!) {
  createShip(input: $input) {
    ship {
      id
      ...Ship_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}`;
export type CreateShipAdminMutationFn = Apollo.MutationFunction<Types.CreateShipAdminMutation, Types.CreateShipAdminMutationVariables>;

/**
 * __useCreateShipAdminMutation__
 *
 * To run a mutation, you first call `useCreateShipAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipAdminMutation, { data, loading, error }] = useCreateShipAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipAdminMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateShipAdminMutation, Types.CreateShipAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateShipAdminMutation, Types.CreateShipAdminMutationVariables>(CreateShipAdminDocument, options);
      }
export type CreateShipAdminMutationHookResult = ReturnType<typeof useCreateShipAdminMutation>;
export type CreateShipAdminMutationResult = Apollo.MutationResult<Types.CreateShipAdminMutation>;
export type CreateShipAdminMutationOptions = Apollo.BaseMutationOptions<Types.CreateShipAdminMutation, Types.CreateShipAdminMutationVariables>;
export const UpdateShipDocument = gql`
    mutation UpdateShip($input: UpdateShipByIdInput!) {
  updateShipById(input: $input) {
    ship {
      id
      ...Ship_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}`;
export type UpdateShipMutationFn = Apollo.MutationFunction<Types.UpdateShipMutation, Types.UpdateShipMutationVariables>;

/**
 * __useUpdateShipMutation__
 *
 * To run a mutation, you first call `useUpdateShipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipMutation, { data, loading, error }] = useUpdateShipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShipMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipMutation, Types.UpdateShipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipMutation, Types.UpdateShipMutationVariables>(UpdateShipDocument, options);
      }
export type UpdateShipMutationHookResult = ReturnType<typeof useUpdateShipMutation>;
export type UpdateShipMutationResult = Apollo.MutationResult<Types.UpdateShipMutation>;
export type UpdateShipMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipMutation, Types.UpdateShipMutationVariables>;
export const DeleteShipByIdDocument = gql`
    mutation DeleteShipById($input: DeleteShipByIdInput!) {
  deleteShipById(input: $input) {
    ship {
      id
      ...Ship_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}`;
export type DeleteShipByIdMutationFn = Apollo.MutationFunction<Types.DeleteShipByIdMutation, Types.DeleteShipByIdMutationVariables>;

/**
 * __useDeleteShipByIdMutation__
 *
 * To run a mutation, you first call `useDeleteShipByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipByIdMutation, { data, loading, error }] = useDeleteShipByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShipByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteShipByIdMutation, Types.DeleteShipByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteShipByIdMutation, Types.DeleteShipByIdMutationVariables>(DeleteShipByIdDocument, options);
      }
export type DeleteShipByIdMutationHookResult = ReturnType<typeof useDeleteShipByIdMutation>;
export type DeleteShipByIdMutationResult = Apollo.MutationResult<Types.DeleteShipByIdMutation>;
export type DeleteShipByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteShipByIdMutation, Types.DeleteShipByIdMutationVariables>;
export const AllVoyageAttributesDocument = gql`
    query AllVoyageAttributes($orderBy: [VoyageAttributesOrderBy!]) {
  allVoyageAttributes(orderBy: $orderBy) {
    nodes {
      id
      ...VoyageAttribute_Admin
    }
  }
}
    ${VoyageAttribute_AdminFragmentDoc}`;

/**
 * __useAllVoyageAttributesQuery__
 *
 * To run a query within a React component, call `useAllVoyageAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVoyageAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVoyageAttributesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllVoyageAttributesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVoyageAttributesQuery, Types.AllVoyageAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVoyageAttributesQuery, Types.AllVoyageAttributesQueryVariables>(AllVoyageAttributesDocument, options);
      }
export function useAllVoyageAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVoyageAttributesQuery, Types.AllVoyageAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVoyageAttributesQuery, Types.AllVoyageAttributesQueryVariables>(AllVoyageAttributesDocument, options);
        }
export function useAllVoyageAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVoyageAttributesQuery, Types.AllVoyageAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVoyageAttributesQuery, Types.AllVoyageAttributesQueryVariables>(AllVoyageAttributesDocument, options);
        }
export type AllVoyageAttributesQueryHookResult = ReturnType<typeof useAllVoyageAttributesQuery>;
export type AllVoyageAttributesLazyQueryHookResult = ReturnType<typeof useAllVoyageAttributesLazyQuery>;
export type AllVoyageAttributesSuspenseQueryHookResult = ReturnType<typeof useAllVoyageAttributesSuspenseQuery>;
export type AllVoyageAttributesQueryResult = Apollo.QueryResult<Types.AllVoyageAttributesQuery, Types.AllVoyageAttributesQueryVariables>;
export const CreateVoyageAttributeDocument = gql`
    mutation CreateVoyageAttribute($input: CreateVoyageAttributeInput!) {
  createVoyageAttribute(input: $input) {
    voyageAttribute {
      id
      ...VoyageAttribute_Admin
    }
  }
}
    ${VoyageAttribute_AdminFragmentDoc}`;
export type CreateVoyageAttributeMutationFn = Apollo.MutationFunction<Types.CreateVoyageAttributeMutation, Types.CreateVoyageAttributeMutationVariables>;

/**
 * __useCreateVoyageAttributeMutation__
 *
 * To run a mutation, you first call `useCreateVoyageAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoyageAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoyageAttributeMutation, { data, loading, error }] = useCreateVoyageAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoyageAttributeMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVoyageAttributeMutation, Types.CreateVoyageAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVoyageAttributeMutation, Types.CreateVoyageAttributeMutationVariables>(CreateVoyageAttributeDocument, options);
      }
export type CreateVoyageAttributeMutationHookResult = ReturnType<typeof useCreateVoyageAttributeMutation>;
export type CreateVoyageAttributeMutationResult = Apollo.MutationResult<Types.CreateVoyageAttributeMutation>;
export type CreateVoyageAttributeMutationOptions = Apollo.BaseMutationOptions<Types.CreateVoyageAttributeMutation, Types.CreateVoyageAttributeMutationVariables>;
export const UpdateVoyageAttributeByIdDocument = gql`
    mutation UpdateVoyageAttributeById($input: UpdateVoyageAttributeByIdInput!) {
  updateVoyageAttributeById(input: $input) {
    voyageAttribute {
      id
      ...VoyageAttribute_Admin
    }
  }
}
    ${VoyageAttribute_AdminFragmentDoc}`;
export type UpdateVoyageAttributeByIdMutationFn = Apollo.MutationFunction<Types.UpdateVoyageAttributeByIdMutation, Types.UpdateVoyageAttributeByIdMutationVariables>;

/**
 * __useUpdateVoyageAttributeByIdMutation__
 *
 * To run a mutation, you first call `useUpdateVoyageAttributeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoyageAttributeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoyageAttributeByIdMutation, { data, loading, error }] = useUpdateVoyageAttributeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVoyageAttributeByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVoyageAttributeByIdMutation, Types.UpdateVoyageAttributeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVoyageAttributeByIdMutation, Types.UpdateVoyageAttributeByIdMutationVariables>(UpdateVoyageAttributeByIdDocument, options);
      }
export type UpdateVoyageAttributeByIdMutationHookResult = ReturnType<typeof useUpdateVoyageAttributeByIdMutation>;
export type UpdateVoyageAttributeByIdMutationResult = Apollo.MutationResult<Types.UpdateVoyageAttributeByIdMutation>;
export type UpdateVoyageAttributeByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVoyageAttributeByIdMutation, Types.UpdateVoyageAttributeByIdMutationVariables>;
export const DeleteVoyageAttributeByIdDocument = gql`
    mutation DeleteVoyageAttributeById($input: DeleteVoyageAttributeByIdInput!) {
  deleteVoyageAttributeById(input: $input) {
    voyageAttribute {
      id
      ...VoyageAttribute_Admin
    }
  }
}
    ${VoyageAttribute_AdminFragmentDoc}`;
export type DeleteVoyageAttributeByIdMutationFn = Apollo.MutationFunction<Types.DeleteVoyageAttributeByIdMutation, Types.DeleteVoyageAttributeByIdMutationVariables>;

/**
 * __useDeleteVoyageAttributeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteVoyageAttributeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoyageAttributeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoyageAttributeByIdMutation, { data, loading, error }] = useDeleteVoyageAttributeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVoyageAttributeByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVoyageAttributeByIdMutation, Types.DeleteVoyageAttributeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVoyageAttributeByIdMutation, Types.DeleteVoyageAttributeByIdMutationVariables>(DeleteVoyageAttributeByIdDocument, options);
      }
export type DeleteVoyageAttributeByIdMutationHookResult = ReturnType<typeof useDeleteVoyageAttributeByIdMutation>;
export type DeleteVoyageAttributeByIdMutationResult = Apollo.MutationResult<Types.DeleteVoyageAttributeByIdMutation>;
export type DeleteVoyageAttributeByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVoyageAttributeByIdMutation, Types.DeleteVoyageAttributeByIdMutationVariables>;
export const AllVoyageNamingRulesDocument = gql`
    query AllVoyageNamingRules {
  allVoyageNamingRules {
    nodes {
      id
      ...VoyageNamingRule_Admin
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}`;

/**
 * __useAllVoyageNamingRulesQuery__
 *
 * To run a query within a React component, call `useAllVoyageNamingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVoyageNamingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVoyageNamingRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVoyageNamingRulesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVoyageNamingRulesQuery, Types.AllVoyageNamingRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVoyageNamingRulesQuery, Types.AllVoyageNamingRulesQueryVariables>(AllVoyageNamingRulesDocument, options);
      }
export function useAllVoyageNamingRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVoyageNamingRulesQuery, Types.AllVoyageNamingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVoyageNamingRulesQuery, Types.AllVoyageNamingRulesQueryVariables>(AllVoyageNamingRulesDocument, options);
        }
export function useAllVoyageNamingRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVoyageNamingRulesQuery, Types.AllVoyageNamingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVoyageNamingRulesQuery, Types.AllVoyageNamingRulesQueryVariables>(AllVoyageNamingRulesDocument, options);
        }
export type AllVoyageNamingRulesQueryHookResult = ReturnType<typeof useAllVoyageNamingRulesQuery>;
export type AllVoyageNamingRulesLazyQueryHookResult = ReturnType<typeof useAllVoyageNamingRulesLazyQuery>;
export type AllVoyageNamingRulesSuspenseQueryHookResult = ReturnType<typeof useAllVoyageNamingRulesSuspenseQuery>;
export type AllVoyageNamingRulesQueryResult = Apollo.QueryResult<Types.AllVoyageNamingRulesQuery, Types.AllVoyageNamingRulesQueryVariables>;
export const AllShipVoyageNamingRuleRelationsDocument = gql`
    query AllShipVoyageNamingRuleRelations {
  allShipVoyageNamingRuleRelations {
    nodes {
      id
      shipId
      ruleId
      shipByShipId {
        id
        ...Ship_Admin
      }
      voyageNamingRuleByRuleId {
        id
        ...VoyageNamingRule_Admin
      }
    }
  }
}
    ${Ship_AdminFragmentDoc}
${VoyageNamingRule_AdminFragmentDoc}`;

/**
 * __useAllShipVoyageNamingRuleRelationsQuery__
 *
 * To run a query within a React component, call `useAllShipVoyageNamingRuleRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShipVoyageNamingRuleRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShipVoyageNamingRuleRelationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllShipVoyageNamingRuleRelationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllShipVoyageNamingRuleRelationsQuery, Types.AllShipVoyageNamingRuleRelationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllShipVoyageNamingRuleRelationsQuery, Types.AllShipVoyageNamingRuleRelationsQueryVariables>(AllShipVoyageNamingRuleRelationsDocument, options);
      }
export function useAllShipVoyageNamingRuleRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllShipVoyageNamingRuleRelationsQuery, Types.AllShipVoyageNamingRuleRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllShipVoyageNamingRuleRelationsQuery, Types.AllShipVoyageNamingRuleRelationsQueryVariables>(AllShipVoyageNamingRuleRelationsDocument, options);
        }
export function useAllShipVoyageNamingRuleRelationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllShipVoyageNamingRuleRelationsQuery, Types.AllShipVoyageNamingRuleRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllShipVoyageNamingRuleRelationsQuery, Types.AllShipVoyageNamingRuleRelationsQueryVariables>(AllShipVoyageNamingRuleRelationsDocument, options);
        }
export type AllShipVoyageNamingRuleRelationsQueryHookResult = ReturnType<typeof useAllShipVoyageNamingRuleRelationsQuery>;
export type AllShipVoyageNamingRuleRelationsLazyQueryHookResult = ReturnType<typeof useAllShipVoyageNamingRuleRelationsLazyQuery>;
export type AllShipVoyageNamingRuleRelationsSuspenseQueryHookResult = ReturnType<typeof useAllShipVoyageNamingRuleRelationsSuspenseQuery>;
export type AllShipVoyageNamingRuleRelationsQueryResult = Apollo.QueryResult<Types.AllShipVoyageNamingRuleRelationsQuery, Types.AllShipVoyageNamingRuleRelationsQueryVariables>;
export const CreateVoyageNamingRuleDocument = gql`
    mutation CreateVoyageNamingRule($input: CreateVoyageNamingRuleInput!) {
  createVoyageNamingRule(input: $input) {
    voyageNamingRule {
      id
      ...VoyageNamingRule_Admin
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}`;
export type CreateVoyageNamingRuleMutationFn = Apollo.MutationFunction<Types.CreateVoyageNamingRuleMutation, Types.CreateVoyageNamingRuleMutationVariables>;

/**
 * __useCreateVoyageNamingRuleMutation__
 *
 * To run a mutation, you first call `useCreateVoyageNamingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoyageNamingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoyageNamingRuleMutation, { data, loading, error }] = useCreateVoyageNamingRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoyageNamingRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVoyageNamingRuleMutation, Types.CreateVoyageNamingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVoyageNamingRuleMutation, Types.CreateVoyageNamingRuleMutationVariables>(CreateVoyageNamingRuleDocument, options);
      }
export type CreateVoyageNamingRuleMutationHookResult = ReturnType<typeof useCreateVoyageNamingRuleMutation>;
export type CreateVoyageNamingRuleMutationResult = Apollo.MutationResult<Types.CreateVoyageNamingRuleMutation>;
export type CreateVoyageNamingRuleMutationOptions = Apollo.BaseMutationOptions<Types.CreateVoyageNamingRuleMutation, Types.CreateVoyageNamingRuleMutationVariables>;
export const UpdateVoyageNamingRuleDocument = gql`
    mutation UpdateVoyageNamingRule($input: UpdateVoyageNamingRuleByIdInput!) {
  updateVoyageNamingRuleById(input: $input) {
    voyageNamingRule {
      id
      ...VoyageNamingRule_Admin
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}`;
export type UpdateVoyageNamingRuleMutationFn = Apollo.MutationFunction<Types.UpdateVoyageNamingRuleMutation, Types.UpdateVoyageNamingRuleMutationVariables>;

/**
 * __useUpdateVoyageNamingRuleMutation__
 *
 * To run a mutation, you first call `useUpdateVoyageNamingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoyageNamingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoyageNamingRuleMutation, { data, loading, error }] = useUpdateVoyageNamingRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVoyageNamingRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVoyageNamingRuleMutation, Types.UpdateVoyageNamingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVoyageNamingRuleMutation, Types.UpdateVoyageNamingRuleMutationVariables>(UpdateVoyageNamingRuleDocument, options);
      }
export type UpdateVoyageNamingRuleMutationHookResult = ReturnType<typeof useUpdateVoyageNamingRuleMutation>;
export type UpdateVoyageNamingRuleMutationResult = Apollo.MutationResult<Types.UpdateVoyageNamingRuleMutation>;
export type UpdateVoyageNamingRuleMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVoyageNamingRuleMutation, Types.UpdateVoyageNamingRuleMutationVariables>;
export const DeleteVoygeNamingRuleDocument = gql`
    mutation DeleteVoygeNamingRule($input: DeleteVoyageNamingRuleByIdInput!) {
  deleteVoyageNamingRuleById(input: $input) {
    voyageNamingRule {
      id
      ...VoyageNamingRule_Admin
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}`;
export type DeleteVoygeNamingRuleMutationFn = Apollo.MutationFunction<Types.DeleteVoygeNamingRuleMutation, Types.DeleteVoygeNamingRuleMutationVariables>;

/**
 * __useDeleteVoygeNamingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteVoygeNamingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoygeNamingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoygeNamingRuleMutation, { data, loading, error }] = useDeleteVoygeNamingRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVoygeNamingRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVoygeNamingRuleMutation, Types.DeleteVoygeNamingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVoygeNamingRuleMutation, Types.DeleteVoygeNamingRuleMutationVariables>(DeleteVoygeNamingRuleDocument, options);
      }
export type DeleteVoygeNamingRuleMutationHookResult = ReturnType<typeof useDeleteVoygeNamingRuleMutation>;
export type DeleteVoygeNamingRuleMutationResult = Apollo.MutationResult<Types.DeleteVoygeNamingRuleMutation>;
export type DeleteVoygeNamingRuleMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVoygeNamingRuleMutation, Types.DeleteVoygeNamingRuleMutationVariables>;
export const CreateShipVoyageNamingRuleRelationDocument = gql`
    mutation CreateShipVoyageNamingRuleRelation($input: CreateShipVoyageNamingRuleRelationInput!) {
  createShipVoyageNamingRuleRelation(input: $input) {
    shipVoyageNamingRuleRelation {
      id
      voyageNamingRuleByRuleId {
        id
        ...VoyageNamingRule_Admin
      }
      shipByShipId {
        id
        ...Ship_Admin
      }
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}
${Ship_AdminFragmentDoc}`;
export type CreateShipVoyageNamingRuleRelationMutationFn = Apollo.MutationFunction<Types.CreateShipVoyageNamingRuleRelationMutation, Types.CreateShipVoyageNamingRuleRelationMutationVariables>;

/**
 * __useCreateShipVoyageNamingRuleRelationMutation__
 *
 * To run a mutation, you first call `useCreateShipVoyageNamingRuleRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipVoyageNamingRuleRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipVoyageNamingRuleRelationMutation, { data, loading, error }] = useCreateShipVoyageNamingRuleRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipVoyageNamingRuleRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateShipVoyageNamingRuleRelationMutation, Types.CreateShipVoyageNamingRuleRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateShipVoyageNamingRuleRelationMutation, Types.CreateShipVoyageNamingRuleRelationMutationVariables>(CreateShipVoyageNamingRuleRelationDocument, options);
      }
export type CreateShipVoyageNamingRuleRelationMutationHookResult = ReturnType<typeof useCreateShipVoyageNamingRuleRelationMutation>;
export type CreateShipVoyageNamingRuleRelationMutationResult = Apollo.MutationResult<Types.CreateShipVoyageNamingRuleRelationMutation>;
export type CreateShipVoyageNamingRuleRelationMutationOptions = Apollo.BaseMutationOptions<Types.CreateShipVoyageNamingRuleRelationMutation, Types.CreateShipVoyageNamingRuleRelationMutationVariables>;
export const UpdateShipVoyageNamingRuleRelationByIdDocument = gql`
    mutation UpdateShipVoyageNamingRuleRelationById($input: UpdateShipVoyageNamingRuleRelationByIdInput!) {
  updateShipVoyageNamingRuleRelationById(input: $input) {
    shipVoyageNamingRuleRelation {
      id
      voyageNamingRuleByRuleId {
        id
        ...VoyageNamingRule_Admin
      }
      shipByShipId {
        id
        ...Ship_Admin
      }
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}
${Ship_AdminFragmentDoc}`;
export type UpdateShipVoyageNamingRuleRelationByIdMutationFn = Apollo.MutationFunction<Types.UpdateShipVoyageNamingRuleRelationByIdMutation, Types.UpdateShipVoyageNamingRuleRelationByIdMutationVariables>;

/**
 * __useUpdateShipVoyageNamingRuleRelationByIdMutation__
 *
 * To run a mutation, you first call `useUpdateShipVoyageNamingRuleRelationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipVoyageNamingRuleRelationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipVoyageNamingRuleRelationByIdMutation, { data, loading, error }] = useUpdateShipVoyageNamingRuleRelationByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShipVoyageNamingRuleRelationByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipVoyageNamingRuleRelationByIdMutation, Types.UpdateShipVoyageNamingRuleRelationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipVoyageNamingRuleRelationByIdMutation, Types.UpdateShipVoyageNamingRuleRelationByIdMutationVariables>(UpdateShipVoyageNamingRuleRelationByIdDocument, options);
      }
export type UpdateShipVoyageNamingRuleRelationByIdMutationHookResult = ReturnType<typeof useUpdateShipVoyageNamingRuleRelationByIdMutation>;
export type UpdateShipVoyageNamingRuleRelationByIdMutationResult = Apollo.MutationResult<Types.UpdateShipVoyageNamingRuleRelationByIdMutation>;
export type UpdateShipVoyageNamingRuleRelationByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipVoyageNamingRuleRelationByIdMutation, Types.UpdateShipVoyageNamingRuleRelationByIdMutationVariables>;
export const DeleteShipVoyageNamingRuleRelationByIdDocument = gql`
    mutation DeleteShipVoyageNamingRuleRelationById($input: DeleteShipVoyageNamingRuleRelationByIdInput!) {
  deleteShipVoyageNamingRuleRelationById(input: $input) {
    shipVoyageNamingRuleRelation {
      id
      voyageNamingRuleByRuleId {
        id
        ...VoyageNamingRule_Admin
      }
      shipByShipId {
        id
        ...Ship_Admin
      }
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}
${Ship_AdminFragmentDoc}`;
export type DeleteShipVoyageNamingRuleRelationByIdMutationFn = Apollo.MutationFunction<Types.DeleteShipVoyageNamingRuleRelationByIdMutation, Types.DeleteShipVoyageNamingRuleRelationByIdMutationVariables>;

/**
 * __useDeleteShipVoyageNamingRuleRelationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteShipVoyageNamingRuleRelationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipVoyageNamingRuleRelationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipVoyageNamingRuleRelationByIdMutation, { data, loading, error }] = useDeleteShipVoyageNamingRuleRelationByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShipVoyageNamingRuleRelationByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteShipVoyageNamingRuleRelationByIdMutation, Types.DeleteShipVoyageNamingRuleRelationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteShipVoyageNamingRuleRelationByIdMutation, Types.DeleteShipVoyageNamingRuleRelationByIdMutationVariables>(DeleteShipVoyageNamingRuleRelationByIdDocument, options);
      }
export type DeleteShipVoyageNamingRuleRelationByIdMutationHookResult = ReturnType<typeof useDeleteShipVoyageNamingRuleRelationByIdMutation>;
export type DeleteShipVoyageNamingRuleRelationByIdMutationResult = Apollo.MutationResult<Types.DeleteShipVoyageNamingRuleRelationByIdMutation>;
export type DeleteShipVoyageNamingRuleRelationByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteShipVoyageNamingRuleRelationByIdMutation, Types.DeleteShipVoyageNamingRuleRelationByIdMutationVariables>;
export const AllWorldscaleFreightsDocument = gql`
    query AllWorldscaleFreights($filter: WorldscaleFreightFilter) {
  allWorldscaleFreights(filter: $filter, orderBy: YEAR_DESC) {
    nodes {
      id
      ...WorldscaleFreight_Admin
    }
  }
}
    ${WorldscaleFreight_AdminFragmentDoc}`;

/**
 * __useAllWorldscaleFreightsQuery__
 *
 * To run a query within a React component, call `useAllWorldscaleFreightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWorldscaleFreightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWorldscaleFreightsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllWorldscaleFreightsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllWorldscaleFreightsQuery, Types.AllWorldscaleFreightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllWorldscaleFreightsQuery, Types.AllWorldscaleFreightsQueryVariables>(AllWorldscaleFreightsDocument, options);
      }
export function useAllWorldscaleFreightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllWorldscaleFreightsQuery, Types.AllWorldscaleFreightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllWorldscaleFreightsQuery, Types.AllWorldscaleFreightsQueryVariables>(AllWorldscaleFreightsDocument, options);
        }
export function useAllWorldscaleFreightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllWorldscaleFreightsQuery, Types.AllWorldscaleFreightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllWorldscaleFreightsQuery, Types.AllWorldscaleFreightsQueryVariables>(AllWorldscaleFreightsDocument, options);
        }
export type AllWorldscaleFreightsQueryHookResult = ReturnType<typeof useAllWorldscaleFreightsQuery>;
export type AllWorldscaleFreightsLazyQueryHookResult = ReturnType<typeof useAllWorldscaleFreightsLazyQuery>;
export type AllWorldscaleFreightsSuspenseQueryHookResult = ReturnType<typeof useAllWorldscaleFreightsSuspenseQuery>;
export type AllWorldscaleFreightsQueryResult = Apollo.QueryResult<Types.AllWorldscaleFreightsQuery, Types.AllWorldscaleFreightsQueryVariables>;
export const CreateWorldscaleFreightDocument = gql`
    mutation CreateWorldscaleFreight($input: CreateWorldscaleFreightInput!) {
  createWorldscaleFreight(input: $input) {
    worldscaleFreight {
      id
      ...WorldscaleFreight_Admin
    }
  }
}
    ${WorldscaleFreight_AdminFragmentDoc}`;
export type CreateWorldscaleFreightMutationFn = Apollo.MutationFunction<Types.CreateWorldscaleFreightMutation, Types.CreateWorldscaleFreightMutationVariables>;

/**
 * __useCreateWorldscaleFreightMutation__
 *
 * To run a mutation, you first call `useCreateWorldscaleFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorldscaleFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorldscaleFreightMutation, { data, loading, error }] = useCreateWorldscaleFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorldscaleFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateWorldscaleFreightMutation, Types.CreateWorldscaleFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateWorldscaleFreightMutation, Types.CreateWorldscaleFreightMutationVariables>(CreateWorldscaleFreightDocument, options);
      }
export type CreateWorldscaleFreightMutationHookResult = ReturnType<typeof useCreateWorldscaleFreightMutation>;
export type CreateWorldscaleFreightMutationResult = Apollo.MutationResult<Types.CreateWorldscaleFreightMutation>;
export type CreateWorldscaleFreightMutationOptions = Apollo.BaseMutationOptions<Types.CreateWorldscaleFreightMutation, Types.CreateWorldscaleFreightMutationVariables>;
export const UpdateWorldscaleFreightDocument = gql`
    mutation UpdateWorldscaleFreight($input: UpdateWorldscaleFreightByIdInput!) {
  updateWorldscaleFreightById(input: $input) {
    worldscaleFreight {
      id
      ...WorldscaleFreight_Admin
    }
  }
}
    ${WorldscaleFreight_AdminFragmentDoc}`;
export type UpdateWorldscaleFreightMutationFn = Apollo.MutationFunction<Types.UpdateWorldscaleFreightMutation, Types.UpdateWorldscaleFreightMutationVariables>;

/**
 * __useUpdateWorldscaleFreightMutation__
 *
 * To run a mutation, you first call `useUpdateWorldscaleFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorldscaleFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorldscaleFreightMutation, { data, loading, error }] = useUpdateWorldscaleFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorldscaleFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateWorldscaleFreightMutation, Types.UpdateWorldscaleFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateWorldscaleFreightMutation, Types.UpdateWorldscaleFreightMutationVariables>(UpdateWorldscaleFreightDocument, options);
      }
export type UpdateWorldscaleFreightMutationHookResult = ReturnType<typeof useUpdateWorldscaleFreightMutation>;
export type UpdateWorldscaleFreightMutationResult = Apollo.MutationResult<Types.UpdateWorldscaleFreightMutation>;
export type UpdateWorldscaleFreightMutationOptions = Apollo.BaseMutationOptions<Types.UpdateWorldscaleFreightMutation, Types.UpdateWorldscaleFreightMutationVariables>;
export const DeleteWorldscaleFreightDocument = gql`
    mutation DeleteWorldscaleFreight($input: DeleteWorldscaleFreightByIdInput!) {
  deleteWorldscaleFreightById(input: $input) {
    worldscaleFreight {
      id
      ...WorldscaleFreight_Admin
    }
  }
}
    ${WorldscaleFreight_AdminFragmentDoc}`;
export type DeleteWorldscaleFreightMutationFn = Apollo.MutationFunction<Types.DeleteWorldscaleFreightMutation, Types.DeleteWorldscaleFreightMutationVariables>;

/**
 * __useDeleteWorldscaleFreightMutation__
 *
 * To run a mutation, you first call `useDeleteWorldscaleFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorldscaleFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorldscaleFreightMutation, { data, loading, error }] = useDeleteWorldscaleFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorldscaleFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteWorldscaleFreightMutation, Types.DeleteWorldscaleFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteWorldscaleFreightMutation, Types.DeleteWorldscaleFreightMutationVariables>(DeleteWorldscaleFreightDocument, options);
      }
export type DeleteWorldscaleFreightMutationHookResult = ReturnType<typeof useDeleteWorldscaleFreightMutation>;
export type DeleteWorldscaleFreightMutationResult = Apollo.MutationResult<Types.DeleteWorldscaleFreightMutation>;
export type DeleteWorldscaleFreightMutationOptions = Apollo.BaseMutationOptions<Types.DeleteWorldscaleFreightMutation, Types.DeleteWorldscaleFreightMutationVariables>;
export const ZonesAdminDocument = gql`
    query ZonesAdmin {
  allZones {
    nodes {
      ...ZonesAdmin_Zone
    }
  }
}
    ${ZonesAdmin_ZoneFragmentDoc}`;

/**
 * __useZonesAdminQuery__
 *
 * To run a query within a React component, call `useZonesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useZonesAdminQuery(baseOptions?: Apollo.QueryHookOptions<Types.ZonesAdminQuery, Types.ZonesAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ZonesAdminQuery, Types.ZonesAdminQueryVariables>(ZonesAdminDocument, options);
      }
export function useZonesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ZonesAdminQuery, Types.ZonesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ZonesAdminQuery, Types.ZonesAdminQueryVariables>(ZonesAdminDocument, options);
        }
export function useZonesAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ZonesAdminQuery, Types.ZonesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ZonesAdminQuery, Types.ZonesAdminQueryVariables>(ZonesAdminDocument, options);
        }
export type ZonesAdminQueryHookResult = ReturnType<typeof useZonesAdminQuery>;
export type ZonesAdminLazyQueryHookResult = ReturnType<typeof useZonesAdminLazyQuery>;
export type ZonesAdminSuspenseQueryHookResult = ReturnType<typeof useZonesAdminSuspenseQuery>;
export type ZonesAdminQueryResult = Apollo.QueryResult<Types.ZonesAdminQuery, Types.ZonesAdminQueryVariables>;
export const CreateZoneDocument = gql`
    mutation CreateZone($input: CreateZoneInput!) {
  createZone(input: $input) {
    zone {
      id
      ...ZonesAdmin_Zone
    }
  }
}
    ${ZonesAdmin_ZoneFragmentDoc}`;
export type CreateZoneMutationFn = Apollo.MutationFunction<Types.CreateZoneMutation, Types.CreateZoneMutationVariables>;

/**
 * __useCreateZoneMutation__
 *
 * To run a mutation, you first call `useCreateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZoneMutation, { data, loading, error }] = useCreateZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateZoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateZoneMutation, Types.CreateZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateZoneMutation, Types.CreateZoneMutationVariables>(CreateZoneDocument, options);
      }
export type CreateZoneMutationHookResult = ReturnType<typeof useCreateZoneMutation>;
export type CreateZoneMutationResult = Apollo.MutationResult<Types.CreateZoneMutation>;
export type CreateZoneMutationOptions = Apollo.BaseMutationOptions<Types.CreateZoneMutation, Types.CreateZoneMutationVariables>;
export const UpdateZoneDocument = gql`
    mutation UpdateZone($input: UpdateZoneByIdInput!) {
  updateZoneById(input: $input) {
    zone {
      id
      ...ZonesAdmin_Zone
    }
  }
}
    ${ZonesAdmin_ZoneFragmentDoc}`;
export type UpdateZoneMutationFn = Apollo.MutationFunction<Types.UpdateZoneMutation, Types.UpdateZoneMutationVariables>;

/**
 * __useUpdateZoneMutation__
 *
 * To run a mutation, you first call `useUpdateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneMutation, { data, loading, error }] = useUpdateZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateZoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateZoneMutation, Types.UpdateZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateZoneMutation, Types.UpdateZoneMutationVariables>(UpdateZoneDocument, options);
      }
export type UpdateZoneMutationHookResult = ReturnType<typeof useUpdateZoneMutation>;
export type UpdateZoneMutationResult = Apollo.MutationResult<Types.UpdateZoneMutation>;
export type UpdateZoneMutationOptions = Apollo.BaseMutationOptions<Types.UpdateZoneMutation, Types.UpdateZoneMutationVariables>;
export const DeleteZoneDocument = gql`
    mutation DeleteZone($input: DeleteZoneByIdInput!) {
  deleteZoneById(input: $input) {
    zone {
      id
    }
  }
}
    `;
export type DeleteZoneMutationFn = Apollo.MutationFunction<Types.DeleteZoneMutation, Types.DeleteZoneMutationVariables>;

/**
 * __useDeleteZoneMutation__
 *
 * To run a mutation, you first call `useDeleteZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteZoneMutation, { data, loading, error }] = useDeleteZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteZoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteZoneMutation, Types.DeleteZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteZoneMutation, Types.DeleteZoneMutationVariables>(DeleteZoneDocument, options);
      }
export type DeleteZoneMutationHookResult = ReturnType<typeof useDeleteZoneMutation>;
export type DeleteZoneMutationResult = Apollo.MutationResult<Types.DeleteZoneMutation>;
export type DeleteZoneMutationOptions = Apollo.BaseMutationOptions<Types.DeleteZoneMutation, Types.DeleteZoneMutationVariables>;
export const CreateZoneLocationDocument = gql`
    mutation CreateZoneLocation($input: CreateZoneLocationInput!) {
  createZoneLocation(input: $input) {
    zoneLocation {
      id
      ...ZonesAdmin_ZoneLocation
    }
  }
}
    ${ZonesAdmin_ZoneLocationFragmentDoc}`;
export type CreateZoneLocationMutationFn = Apollo.MutationFunction<Types.CreateZoneLocationMutation, Types.CreateZoneLocationMutationVariables>;

/**
 * __useCreateZoneLocationMutation__
 *
 * To run a mutation, you first call `useCreateZoneLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZoneLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZoneLocationMutation, { data, loading, error }] = useCreateZoneLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateZoneLocationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateZoneLocationMutation, Types.CreateZoneLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateZoneLocationMutation, Types.CreateZoneLocationMutationVariables>(CreateZoneLocationDocument, options);
      }
export type CreateZoneLocationMutationHookResult = ReturnType<typeof useCreateZoneLocationMutation>;
export type CreateZoneLocationMutationResult = Apollo.MutationResult<Types.CreateZoneLocationMutation>;
export type CreateZoneLocationMutationOptions = Apollo.BaseMutationOptions<Types.CreateZoneLocationMutation, Types.CreateZoneLocationMutationVariables>;
export const DeleteZoneLocationDocument = gql`
    mutation DeleteZoneLocation($input: DeleteZoneLocationByIdInput!) {
  deleteZoneLocationById(input: $input) {
    zoneLocation {
      ...ZonesAdmin_ZoneLocation
    }
  }
}
    ${ZonesAdmin_ZoneLocationFragmentDoc}`;
export type DeleteZoneLocationMutationFn = Apollo.MutationFunction<Types.DeleteZoneLocationMutation, Types.DeleteZoneLocationMutationVariables>;

/**
 * __useDeleteZoneLocationMutation__
 *
 * To run a mutation, you first call `useDeleteZoneLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteZoneLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteZoneLocationMutation, { data, loading, error }] = useDeleteZoneLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteZoneLocationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteZoneLocationMutation, Types.DeleteZoneLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteZoneLocationMutation, Types.DeleteZoneLocationMutationVariables>(DeleteZoneLocationDocument, options);
      }
export type DeleteZoneLocationMutationHookResult = ReturnType<typeof useDeleteZoneLocationMutation>;
export type DeleteZoneLocationMutationResult = Apollo.MutationResult<Types.DeleteZoneLocationMutation>;
export type DeleteZoneLocationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteZoneLocationMutation, Types.DeleteZoneLocationMutationVariables>;
export const ZonesAdminFormDocument = gql`
    query ZonesAdminForm {
  allLocations(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useZonesAdminFormQuery__
 *
 * To run a query within a React component, call `useZonesAdminFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesAdminFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesAdminFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useZonesAdminFormQuery(baseOptions?: Apollo.QueryHookOptions<Types.ZonesAdminFormQuery, Types.ZonesAdminFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ZonesAdminFormQuery, Types.ZonesAdminFormQueryVariables>(ZonesAdminFormDocument, options);
      }
export function useZonesAdminFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ZonesAdminFormQuery, Types.ZonesAdminFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ZonesAdminFormQuery, Types.ZonesAdminFormQueryVariables>(ZonesAdminFormDocument, options);
        }
export function useZonesAdminFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ZonesAdminFormQuery, Types.ZonesAdminFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ZonesAdminFormQuery, Types.ZonesAdminFormQueryVariables>(ZonesAdminFormDocument, options);
        }
export type ZonesAdminFormQueryHookResult = ReturnType<typeof useZonesAdminFormQuery>;
export type ZonesAdminFormLazyQueryHookResult = ReturnType<typeof useZonesAdminFormLazyQuery>;
export type ZonesAdminFormSuspenseQueryHookResult = ReturnType<typeof useZonesAdminFormSuspenseQuery>;
export type ZonesAdminFormQueryResult = Apollo.QueryResult<Types.ZonesAdminFormQuery, Types.ZonesAdminFormQueryVariables>;
export const ArchiveByIdsDocument = gql`
    mutation ArchiveByIds($orderIds: [Int!], $portCallIds: [Int!], $scheduledOrderIds: [Int!], $handledBySpotIds: [Int!], $handledByCoaIds: [Int!], $singleEventIds: [Int!], $offHireIds: [Int!]) {
  archiveByIds(
    input: {orderIds: $orderIds, portCallIds: $portCallIds, scheduledOrderIds: $scheduledOrderIds, handledBySpotIds: $handledBySpotIds, handledByCoaIds: $handledByCoaIds, singleEventIds: $singleEventIds, offHireIds: $offHireIds}
  )
}
    `;
export type ArchiveByIdsMutationFn = Apollo.MutationFunction<Types.ArchiveByIdsMutation, Types.ArchiveByIdsMutationVariables>;

/**
 * __useArchiveByIdsMutation__
 *
 * To run a mutation, you first call `useArchiveByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveByIdsMutation, { data, loading, error }] = useArchiveByIdsMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      portCallIds: // value for 'portCallIds'
 *      scheduledOrderIds: // value for 'scheduledOrderIds'
 *      handledBySpotIds: // value for 'handledBySpotIds'
 *      handledByCoaIds: // value for 'handledByCoaIds'
 *      singleEventIds: // value for 'singleEventIds'
 *      offHireIds: // value for 'offHireIds'
 *   },
 * });
 */
export function useArchiveByIdsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ArchiveByIdsMutation, Types.ArchiveByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ArchiveByIdsMutation, Types.ArchiveByIdsMutationVariables>(ArchiveByIdsDocument, options);
      }
export type ArchiveByIdsMutationHookResult = ReturnType<typeof useArchiveByIdsMutation>;
export type ArchiveByIdsMutationResult = Apollo.MutationResult<Types.ArchiveByIdsMutation>;
export type ArchiveByIdsMutationOptions = Apollo.BaseMutationOptions<Types.ArchiveByIdsMutation, Types.ArchiveByIdsMutationVariables>;
export const UnarchiveByIdsDocument = gql`
    mutation UnarchiveByIds($orderIds: [Int!], $portCallIds: [Int!], $scheduledOrderIds: [Int!], $handledBySpotIds: [Int!], $handledByCoaIds: [Int!]) {
  unarchiveByIds(
    input: {orderIds: $orderIds, portCallIds: $portCallIds, scheduledOrderIds: $scheduledOrderIds, handledBySpotIds: $handledBySpotIds, handledByCoaIds: $handledByCoaIds}
  )
}
    `;
export type UnarchiveByIdsMutationFn = Apollo.MutationFunction<Types.UnarchiveByIdsMutation, Types.UnarchiveByIdsMutationVariables>;

/**
 * __useUnarchiveByIdsMutation__
 *
 * To run a mutation, you first call `useUnarchiveByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveByIdsMutation, { data, loading, error }] = useUnarchiveByIdsMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      portCallIds: // value for 'portCallIds'
 *      scheduledOrderIds: // value for 'scheduledOrderIds'
 *      handledBySpotIds: // value for 'handledBySpotIds'
 *      handledByCoaIds: // value for 'handledByCoaIds'
 *   },
 * });
 */
export function useUnarchiveByIdsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UnarchiveByIdsMutation, Types.UnarchiveByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnarchiveByIdsMutation, Types.UnarchiveByIdsMutationVariables>(UnarchiveByIdsDocument, options);
      }
export type UnarchiveByIdsMutationHookResult = ReturnType<typeof useUnarchiveByIdsMutation>;
export type UnarchiveByIdsMutationResult = Apollo.MutationResult<Types.UnarchiveByIdsMutation>;
export type UnarchiveByIdsMutationOptions = Apollo.BaseMutationOptions<Types.UnarchiveByIdsMutation, Types.UnarchiveByIdsMutationVariables>;
export const AuthenticateDocument = gql`
    mutation Authenticate($input: AuthenticateInput!) {
  authenticate(input: $input) {
    jwtToken
  }
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<Types.AuthenticateMutation, Types.AuthenticateMutationVariables>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<Types.AuthenticateMutation, Types.AuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AuthenticateMutation, Types.AuthenticateMutationVariables>(AuthenticateDocument, options);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = Apollo.MutationResult<Types.AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<Types.AuthenticateMutation, Types.AuthenticateMutationVariables>;
export const GoogleAuthenticateDocument = gql`
    mutation GoogleAuthenticate($input: GoogleAuthenticateInput!) {
  googleAuthenticate(input: $input) {
    jwtToken
  }
}
    `;
export type GoogleAuthenticateMutationFn = Apollo.MutationFunction<Types.GoogleAuthenticateMutation, Types.GoogleAuthenticateMutationVariables>;

/**
 * __useGoogleAuthenticateMutation__
 *
 * To run a mutation, you first call `useGoogleAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleAuthenticateMutation, { data, loading, error }] = useGoogleAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<Types.GoogleAuthenticateMutation, Types.GoogleAuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GoogleAuthenticateMutation, Types.GoogleAuthenticateMutationVariables>(GoogleAuthenticateDocument, options);
      }
export type GoogleAuthenticateMutationHookResult = ReturnType<typeof useGoogleAuthenticateMutation>;
export type GoogleAuthenticateMutationResult = Apollo.MutationResult<Types.GoogleAuthenticateMutation>;
export type GoogleAuthenticateMutationOptions = Apollo.BaseMutationOptions<Types.GoogleAuthenticateMutation, Types.GoogleAuthenticateMutationVariables>;
export const MicrosoftAuthenticateDocument = gql`
    mutation MicrosoftAuthenticate($input: MicrosoftAuthenticateInput!) {
  microsoftAuthenticate(input: $input) {
    jwtToken
  }
}
    `;
export type MicrosoftAuthenticateMutationFn = Apollo.MutationFunction<Types.MicrosoftAuthenticateMutation, Types.MicrosoftAuthenticateMutationVariables>;

/**
 * __useMicrosoftAuthenticateMutation__
 *
 * To run a mutation, you first call `useMicrosoftAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [microsoftAuthenticateMutation, { data, loading, error }] = useMicrosoftAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMicrosoftAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<Types.MicrosoftAuthenticateMutation, Types.MicrosoftAuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MicrosoftAuthenticateMutation, Types.MicrosoftAuthenticateMutationVariables>(MicrosoftAuthenticateDocument, options);
      }
export type MicrosoftAuthenticateMutationHookResult = ReturnType<typeof useMicrosoftAuthenticateMutation>;
export type MicrosoftAuthenticateMutationResult = Apollo.MutationResult<Types.MicrosoftAuthenticateMutation>;
export type MicrosoftAuthenticateMutationOptions = Apollo.BaseMutationOptions<Types.MicrosoftAuthenticateMutation, Types.MicrosoftAuthenticateMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    jwtToken
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<Types.ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    clientMutationId
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<Types.ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation RequestResetPassword($input: RequestResetPasswordInput!) {
  requestResetPassword(input: $input) {
    clientMutationId
  }
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<Types.RequestResetPasswordMutation, Types.RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.RequestResetPasswordMutation, Types.RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RequestResetPasswordMutation, Types.RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<Types.RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<Types.RequestResetPasswordMutation, Types.RequestResetPasswordMutationVariables>;
export const CreateBolDocument = gql`
    mutation CreateBOL($input: CreateBillOfLadingInput!) {
  createBillOfLading(input: $input) {
    billOfLading {
      id
      ...BOLForm__BillOfLading
    }
  }
}
    ${BolForm__BillOfLadingFragmentDoc}`;
export type CreateBolMutationFn = Apollo.MutationFunction<Types.CreateBolMutation, Types.CreateBolMutationVariables>;

/**
 * __useCreateBolMutation__
 *
 * To run a mutation, you first call `useCreateBolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBolMutation, { data, loading, error }] = useCreateBolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBolMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBolMutation, Types.CreateBolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBolMutation, Types.CreateBolMutationVariables>(CreateBolDocument, options);
      }
export type CreateBolMutationHookResult = ReturnType<typeof useCreateBolMutation>;
export type CreateBolMutationResult = Apollo.MutationResult<Types.CreateBolMutation>;
export type CreateBolMutationOptions = Apollo.BaseMutationOptions<Types.CreateBolMutation, Types.CreateBolMutationVariables>;
export const CreateBolDatumDocument = gql`
    mutation CreateBOLDatum($input: CreateBillOfLadingDatumInput!) {
  createBillOfLadingDatum(input: $input) {
    billOfLadingDatum {
      id
      ...BOLForm__BillOfLadingDatum
    }
  }
}
    ${BolForm__BillOfLadingDatumFragmentDoc}`;
export type CreateBolDatumMutationFn = Apollo.MutationFunction<Types.CreateBolDatumMutation, Types.CreateBolDatumMutationVariables>;

/**
 * __useCreateBolDatumMutation__
 *
 * To run a mutation, you first call `useCreateBolDatumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBolDatumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBolDatumMutation, { data, loading, error }] = useCreateBolDatumMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBolDatumMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBolDatumMutation, Types.CreateBolDatumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBolDatumMutation, Types.CreateBolDatumMutationVariables>(CreateBolDatumDocument, options);
      }
export type CreateBolDatumMutationHookResult = ReturnType<typeof useCreateBolDatumMutation>;
export type CreateBolDatumMutationResult = Apollo.MutationResult<Types.CreateBolDatumMutation>;
export type CreateBolDatumMutationOptions = Apollo.BaseMutationOptions<Types.CreateBolDatumMutation, Types.CreateBolDatumMutationVariables>;
export const UpdateBolDatumDocument = gql`
    mutation UpdateBOLDatum($input: UpdateBillOfLadingDatumByIdInput!) {
  updateBillOfLadingDatumById(input: $input) {
    billOfLadingDatum {
      id
      ...BOLForm__BillOfLadingDatum
    }
  }
}
    ${BolForm__BillOfLadingDatumFragmentDoc}`;
export type UpdateBolDatumMutationFn = Apollo.MutationFunction<Types.UpdateBolDatumMutation, Types.UpdateBolDatumMutationVariables>;

/**
 * __useUpdateBolDatumMutation__
 *
 * To run a mutation, you first call `useUpdateBolDatumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBolDatumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBolDatumMutation, { data, loading, error }] = useUpdateBolDatumMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBolDatumMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBolDatumMutation, Types.UpdateBolDatumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBolDatumMutation, Types.UpdateBolDatumMutationVariables>(UpdateBolDatumDocument, options);
      }
export type UpdateBolDatumMutationHookResult = ReturnType<typeof useUpdateBolDatumMutation>;
export type UpdateBolDatumMutationResult = Apollo.MutationResult<Types.UpdateBolDatumMutation>;
export type UpdateBolDatumMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBolDatumMutation, Types.UpdateBolDatumMutationVariables>;
export const BunkerExDocument = gql`
    mutation BunkerEx {
  bunkerEx {
    message
    prices {
      Price
      Grade
      PortCode
      Port
    }
  }
}
    `;
export type BunkerExMutationFn = Apollo.MutationFunction<Types.BunkerExMutation, Types.BunkerExMutationVariables>;

/**
 * __useBunkerExMutation__
 *
 * To run a mutation, you first call `useBunkerExMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBunkerExMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bunkerExMutation, { data, loading, error }] = useBunkerExMutation({
 *   variables: {
 *   },
 * });
 */
export function useBunkerExMutation(baseOptions?: Apollo.MutationHookOptions<Types.BunkerExMutation, Types.BunkerExMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BunkerExMutation, Types.BunkerExMutationVariables>(BunkerExDocument, options);
      }
export type BunkerExMutationHookResult = ReturnType<typeof useBunkerExMutation>;
export type BunkerExMutationResult = Apollo.MutationResult<Types.BunkerExMutation>;
export type BunkerExMutationOptions = Apollo.BaseMutationOptions<Types.BunkerExMutation, Types.BunkerExMutationVariables>;
export const CreateCoaAssignmentDocument = gql`
    mutation CreateCoaAssignment($input: CreateHandledByCoaInput!) {
  createHandledByCoa(input: $input) {
    handledByCoa {
      id
      ...ScenarioTimeline_CoaAssignment
    }
  }
}
    ${ScenarioTimeline_CoaAssignmentFragmentDoc}`;
export type CreateCoaAssignmentMutationFn = Apollo.MutationFunction<Types.CreateCoaAssignmentMutation, Types.CreateCoaAssignmentMutationVariables>;

/**
 * __useCreateCoaAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateCoaAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaAssignmentMutation, { data, loading, error }] = useCreateCoaAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaAssignmentMutation, Types.CreateCoaAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaAssignmentMutation, Types.CreateCoaAssignmentMutationVariables>(CreateCoaAssignmentDocument, options);
      }
export type CreateCoaAssignmentMutationHookResult = ReturnType<typeof useCreateCoaAssignmentMutation>;
export type CreateCoaAssignmentMutationResult = Apollo.MutationResult<Types.CreateCoaAssignmentMutation>;
export type CreateCoaAssignmentMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaAssignmentMutation, Types.CreateCoaAssignmentMutationVariables>;
export const UpdateCoaAssignmentDocument = gql`
    mutation UpdateCoaAssignment($input: UpdateHandledByCoaByIdInput!) {
  updateHandledByCoaById(input: $input) {
    handledByCoa {
      id
      ...ScenarioTimeline_CoaAssignment
    }
  }
}
    ${ScenarioTimeline_CoaAssignmentFragmentDoc}`;
export type UpdateCoaAssignmentMutationFn = Apollo.MutationFunction<Types.UpdateCoaAssignmentMutation, Types.UpdateCoaAssignmentMutationVariables>;

/**
 * __useUpdateCoaAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateCoaAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaAssignmentMutation, { data, loading, error }] = useUpdateCoaAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaAssignmentMutation, Types.UpdateCoaAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaAssignmentMutation, Types.UpdateCoaAssignmentMutationVariables>(UpdateCoaAssignmentDocument, options);
      }
export type UpdateCoaAssignmentMutationHookResult = ReturnType<typeof useUpdateCoaAssignmentMutation>;
export type UpdateCoaAssignmentMutationResult = Apollo.MutationResult<Types.UpdateCoaAssignmentMutation>;
export type UpdateCoaAssignmentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaAssignmentMutation, Types.UpdateCoaAssignmentMutationVariables>;
export const DeleteCoaAssignmentDocument = gql`
    mutation DeleteCoaAssignment($input: DeleteHandledByCoaByIdInput!) {
  deleteHandledByCoaById(input: $input) {
    deletedHandledByCoaId
  }
}
    `;
export type DeleteCoaAssignmentMutationFn = Apollo.MutationFunction<Types.DeleteCoaAssignmentMutation, Types.DeleteCoaAssignmentMutationVariables>;

/**
 * __useDeleteCoaAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteCoaAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaAssignmentMutation, { data, loading, error }] = useDeleteCoaAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaAssignmentMutation, Types.DeleteCoaAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaAssignmentMutation, Types.DeleteCoaAssignmentMutationVariables>(DeleteCoaAssignmentDocument, options);
      }
export type DeleteCoaAssignmentMutationHookResult = ReturnType<typeof useDeleteCoaAssignmentMutation>;
export type DeleteCoaAssignmentMutationResult = Apollo.MutationResult<Types.DeleteCoaAssignmentMutation>;
export type DeleteCoaAssignmentMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaAssignmentMutation, Types.DeleteCoaAssignmentMutationVariables>;
export const CreateOffHireDocument = gql`
    mutation CreateOffHire($input: CreateOffHireInput!) {
  createOffHire(input: $input) {
    offHire {
      id
      ...ScenarioTimeline_OffHire
    }
  }
}
    ${ScenarioTimeline_OffHireFragmentDoc}`;
export type CreateOffHireMutationFn = Apollo.MutationFunction<Types.CreateOffHireMutation, Types.CreateOffHireMutationVariables>;

/**
 * __useCreateOffHireMutation__
 *
 * To run a mutation, you first call `useCreateOffHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOffHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOffHireMutation, { data, loading, error }] = useCreateOffHireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOffHireMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOffHireMutation, Types.CreateOffHireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOffHireMutation, Types.CreateOffHireMutationVariables>(CreateOffHireDocument, options);
      }
export type CreateOffHireMutationHookResult = ReturnType<typeof useCreateOffHireMutation>;
export type CreateOffHireMutationResult = Apollo.MutationResult<Types.CreateOffHireMutation>;
export type CreateOffHireMutationOptions = Apollo.BaseMutationOptions<Types.CreateOffHireMutation, Types.CreateOffHireMutationVariables>;
export const UpdateOffHireDocument = gql`
    mutation UpdateOffHire($input: UpdateOffHireByIdInput!) {
  updateOffHireById(input: $input) {
    offHire {
      id
      ...ScenarioTimeline_OffHire
    }
  }
}
    ${ScenarioTimeline_OffHireFragmentDoc}`;
export type UpdateOffHireMutationFn = Apollo.MutationFunction<Types.UpdateOffHireMutation, Types.UpdateOffHireMutationVariables>;

/**
 * __useUpdateOffHireMutation__
 *
 * To run a mutation, you first call `useUpdateOffHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOffHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOffHireMutation, { data, loading, error }] = useUpdateOffHireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOffHireMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOffHireMutation, Types.UpdateOffHireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOffHireMutation, Types.UpdateOffHireMutationVariables>(UpdateOffHireDocument, options);
      }
export type UpdateOffHireMutationHookResult = ReturnType<typeof useUpdateOffHireMutation>;
export type UpdateOffHireMutationResult = Apollo.MutationResult<Types.UpdateOffHireMutation>;
export type UpdateOffHireMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOffHireMutation, Types.UpdateOffHireMutationVariables>;
export const DeleteOffHireDocument = gql`
    mutation DeleteOffHire($offHireId: Int!) {
  deleteOffHireById(input: {id: $offHireId}) {
    deletedOffHireId
  }
}
    `;
export type DeleteOffHireMutationFn = Apollo.MutationFunction<Types.DeleteOffHireMutation, Types.DeleteOffHireMutationVariables>;

/**
 * __useDeleteOffHireMutation__
 *
 * To run a mutation, you first call `useDeleteOffHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOffHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOffHireMutation, { data, loading, error }] = useDeleteOffHireMutation({
 *   variables: {
 *      offHireId: // value for 'offHireId'
 *   },
 * });
 */
export function useDeleteOffHireMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOffHireMutation, Types.DeleteOffHireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOffHireMutation, Types.DeleteOffHireMutationVariables>(DeleteOffHireDocument, options);
      }
export type DeleteOffHireMutationHookResult = ReturnType<typeof useDeleteOffHireMutation>;
export type DeleteOffHireMutationResult = Apollo.MutationResult<Types.DeleteOffHireMutation>;
export type DeleteOffHireMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOffHireMutation, Types.DeleteOffHireMutationVariables>;
export const CreateOpenPositionDocument = gql`
    mutation CreateOpenPosition($input: CreateOpenPositionInput!) {
  createOpenPosition(input: $input) {
    openPosition {
      id
      ...OpenPositions
    }
  }
}
    ${OpenPositionsFragmentDoc}`;
export type CreateOpenPositionMutationFn = Apollo.MutationFunction<Types.CreateOpenPositionMutation, Types.CreateOpenPositionMutationVariables>;

/**
 * __useCreateOpenPositionMutation__
 *
 * To run a mutation, you first call `useCreateOpenPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpenPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpenPositionMutation, { data, loading, error }] = useCreateOpenPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpenPositionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOpenPositionMutation, Types.CreateOpenPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOpenPositionMutation, Types.CreateOpenPositionMutationVariables>(CreateOpenPositionDocument, options);
      }
export type CreateOpenPositionMutationHookResult = ReturnType<typeof useCreateOpenPositionMutation>;
export type CreateOpenPositionMutationResult = Apollo.MutationResult<Types.CreateOpenPositionMutation>;
export type CreateOpenPositionMutationOptions = Apollo.BaseMutationOptions<Types.CreateOpenPositionMutation, Types.CreateOpenPositionMutationVariables>;
export const UpdateOpenPositionDocument = gql`
    mutation UpdateOpenPosition($input: UpdateOpenPositionByIdInput!) {
  updateOpenPositionById(input: $input) {
    openPosition {
      id
      ...OpenPositions
    }
  }
}
    ${OpenPositionsFragmentDoc}`;
export type UpdateOpenPositionMutationFn = Apollo.MutationFunction<Types.UpdateOpenPositionMutation, Types.UpdateOpenPositionMutationVariables>;

/**
 * __useUpdateOpenPositionMutation__
 *
 * To run a mutation, you first call `useUpdateOpenPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpenPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpenPositionMutation, { data, loading, error }] = useUpdateOpenPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpenPositionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOpenPositionMutation, Types.UpdateOpenPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOpenPositionMutation, Types.UpdateOpenPositionMutationVariables>(UpdateOpenPositionDocument, options);
      }
export type UpdateOpenPositionMutationHookResult = ReturnType<typeof useUpdateOpenPositionMutation>;
export type UpdateOpenPositionMutationResult = Apollo.MutationResult<Types.UpdateOpenPositionMutation>;
export type UpdateOpenPositionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOpenPositionMutation, Types.UpdateOpenPositionMutationVariables>;
export const DeleteOpenPositionDocument = gql`
    mutation DeleteOpenPosition($openPositionId: Int!) {
  deleteOpenPositionById(input: {id: $openPositionId}) {
    deletedOpenPositionId
  }
}
    `;
export type DeleteOpenPositionMutationFn = Apollo.MutationFunction<Types.DeleteOpenPositionMutation, Types.DeleteOpenPositionMutationVariables>;

/**
 * __useDeleteOpenPositionMutation__
 *
 * To run a mutation, you first call `useDeleteOpenPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpenPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpenPositionMutation, { data, loading, error }] = useDeleteOpenPositionMutation({
 *   variables: {
 *      openPositionId: // value for 'openPositionId'
 *   },
 * });
 */
export function useDeleteOpenPositionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOpenPositionMutation, Types.DeleteOpenPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOpenPositionMutation, Types.DeleteOpenPositionMutationVariables>(DeleteOpenPositionDocument, options);
      }
export type DeleteOpenPositionMutationHookResult = ReturnType<typeof useDeleteOpenPositionMutation>;
export type DeleteOpenPositionMutationResult = Apollo.MutationResult<Types.DeleteOpenPositionMutation>;
export type DeleteOpenPositionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOpenPositionMutation, Types.DeleteOpenPositionMutationVariables>;
export const CreateScenarioDocument = gql`
    mutation CreateScenario($input: CreateScenarioInput!) {
  createScenario(input: $input) {
    scenario {
      id
      ...Scenarios_Scenario
    }
  }
}
    ${Scenarios_ScenarioFragmentDoc}`;
export type CreateScenarioMutationFn = Apollo.MutationFunction<Types.CreateScenarioMutation, Types.CreateScenarioMutationVariables>;

/**
 * __useCreateScenarioMutation__
 *
 * To run a mutation, you first call `useCreateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScenarioMutation, { data, loading, error }] = useCreateScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateScenarioMutation, Types.CreateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateScenarioMutation, Types.CreateScenarioMutationVariables>(CreateScenarioDocument, options);
      }
export type CreateScenarioMutationHookResult = ReturnType<typeof useCreateScenarioMutation>;
export type CreateScenarioMutationResult = Apollo.MutationResult<Types.CreateScenarioMutation>;
export type CreateScenarioMutationOptions = Apollo.BaseMutationOptions<Types.CreateScenarioMutation, Types.CreateScenarioMutationVariables>;
export const UpdateScenarioDocument = gql`
    mutation UpdateScenario($input: UpdateScenarioByIdInput!) {
  updateScenarioById(input: $input) {
    scenario {
      id
      ...Scenarios_Scenario
    }
  }
}
    ${Scenarios_ScenarioFragmentDoc}`;
export type UpdateScenarioMutationFn = Apollo.MutationFunction<Types.UpdateScenarioMutation, Types.UpdateScenarioMutationVariables>;

/**
 * __useUpdateScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioMutation, { data, loading, error }] = useUpdateScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateScenarioMutation, Types.UpdateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateScenarioMutation, Types.UpdateScenarioMutationVariables>(UpdateScenarioDocument, options);
      }
export type UpdateScenarioMutationHookResult = ReturnType<typeof useUpdateScenarioMutation>;
export type UpdateScenarioMutationResult = Apollo.MutationResult<Types.UpdateScenarioMutation>;
export type UpdateScenarioMutationOptions = Apollo.BaseMutationOptions<Types.UpdateScenarioMutation, Types.UpdateScenarioMutationVariables>;
export const DeleteScenarioDocument = gql`
    mutation DeleteScenario($input: DeleteScenarioByIdInput!) {
  deleteScenarioById(input: $input) {
    deletedScenarioId
  }
}
    `;
export type DeleteScenarioMutationFn = Apollo.MutationFunction<Types.DeleteScenarioMutation, Types.DeleteScenarioMutationVariables>;

/**
 * __useDeleteScenarioMutation__
 *
 * To run a mutation, you first call `useDeleteScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScenarioMutation, { data, loading, error }] = useDeleteScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteScenarioMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteScenarioMutation, Types.DeleteScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteScenarioMutation, Types.DeleteScenarioMutationVariables>(DeleteScenarioDocument, options);
      }
export type DeleteScenarioMutationHookResult = ReturnType<typeof useDeleteScenarioMutation>;
export type DeleteScenarioMutationResult = Apollo.MutationResult<Types.DeleteScenarioMutation>;
export type DeleteScenarioMutationOptions = Apollo.BaseMutationOptions<Types.DeleteScenarioMutation, Types.DeleteScenarioMutationVariables>;
export const CreateVesselReservationDocument = gql`
    mutation CreateVesselReservation($input: CreateVesselReservationInput!) {
  createVesselReservation(input: $input) {
    vesselReservation {
      id
      ...VesselReservation
    }
  }
}
    ${VesselReservationFragmentDoc}`;
export type CreateVesselReservationMutationFn = Apollo.MutationFunction<Types.CreateVesselReservationMutation, Types.CreateVesselReservationMutationVariables>;

/**
 * __useCreateVesselReservationMutation__
 *
 * To run a mutation, you first call `useCreateVesselReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVesselReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVesselReservationMutation, { data, loading, error }] = useCreateVesselReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVesselReservationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVesselReservationMutation, Types.CreateVesselReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVesselReservationMutation, Types.CreateVesselReservationMutationVariables>(CreateVesselReservationDocument, options);
      }
export type CreateVesselReservationMutationHookResult = ReturnType<typeof useCreateVesselReservationMutation>;
export type CreateVesselReservationMutationResult = Apollo.MutationResult<Types.CreateVesselReservationMutation>;
export type CreateVesselReservationMutationOptions = Apollo.BaseMutationOptions<Types.CreateVesselReservationMutation, Types.CreateVesselReservationMutationVariables>;
export const UpdateVesselReservationDocument = gql`
    mutation UpdateVesselReservation($input: UpdateVesselReservationByIdInput!) {
  updateVesselReservationById(input: $input) {
    vesselReservation {
      id
      ...VesselReservation
    }
  }
}
    ${VesselReservationFragmentDoc}`;
export type UpdateVesselReservationMutationFn = Apollo.MutationFunction<Types.UpdateVesselReservationMutation, Types.UpdateVesselReservationMutationVariables>;

/**
 * __useUpdateVesselReservationMutation__
 *
 * To run a mutation, you first call `useUpdateVesselReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesselReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesselReservationMutation, { data, loading, error }] = useUpdateVesselReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVesselReservationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesselReservationMutation, Types.UpdateVesselReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesselReservationMutation, Types.UpdateVesselReservationMutationVariables>(UpdateVesselReservationDocument, options);
      }
export type UpdateVesselReservationMutationHookResult = ReturnType<typeof useUpdateVesselReservationMutation>;
export type UpdateVesselReservationMutationResult = Apollo.MutationResult<Types.UpdateVesselReservationMutation>;
export type UpdateVesselReservationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesselReservationMutation, Types.UpdateVesselReservationMutationVariables>;
export const DeleteVesselReservationDocument = gql`
    mutation DeleteVesselReservation($id: Int!) {
  deleteVesselReservationById(input: {id: $id}) {
    deletedVesselReservationId
  }
}
    `;
export type DeleteVesselReservationMutationFn = Apollo.MutationFunction<Types.DeleteVesselReservationMutation, Types.DeleteVesselReservationMutationVariables>;

/**
 * __useDeleteVesselReservationMutation__
 *
 * To run a mutation, you first call `useDeleteVesselReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVesselReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVesselReservationMutation, { data, loading, error }] = useDeleteVesselReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVesselReservationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVesselReservationMutation, Types.DeleteVesselReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVesselReservationMutation, Types.DeleteVesselReservationMutationVariables>(DeleteVesselReservationDocument, options);
      }
export type DeleteVesselReservationMutationHookResult = ReturnType<typeof useDeleteVesselReservationMutation>;
export type DeleteVesselReservationMutationResult = Apollo.MutationResult<Types.DeleteVesselReservationMutation>;
export type DeleteVesselReservationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVesselReservationMutation, Types.DeleteVesselReservationMutationVariables>;
export const CarbonPriceDocument = gql`
    mutation carbonPrice {
  carbonPrice {
    price
    updatedAt
    isOverride
  }
}
    `;
export type CarbonPriceMutationFn = Apollo.MutationFunction<Types.CarbonPriceMutation, Types.CarbonPriceMutationVariables>;

/**
 * __useCarbonPriceMutation__
 *
 * To run a mutation, you first call `useCarbonPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarbonPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carbonPriceMutation, { data, loading, error }] = useCarbonPriceMutation({
 *   variables: {
 *   },
 * });
 */
export function useCarbonPriceMutation(baseOptions?: Apollo.MutationHookOptions<Types.CarbonPriceMutation, Types.CarbonPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CarbonPriceMutation, Types.CarbonPriceMutationVariables>(CarbonPriceDocument, options);
      }
export type CarbonPriceMutationHookResult = ReturnType<typeof useCarbonPriceMutation>;
export type CarbonPriceMutationResult = Apollo.MutationResult<Types.CarbonPriceMutation>;
export type CarbonPriceMutationOptions = Apollo.BaseMutationOptions<Types.CarbonPriceMutation, Types.CarbonPriceMutationVariables>;
export const AllCarbonPriceOverrideDocument = gql`
    query AllCarbonPriceOverride {
  allCarbonPriceOverrides {
    nodes {
      id
      ...CarbonPriceOverride_Admin
    }
  }
}
    ${CarbonPriceOverride_AdminFragmentDoc}`;

/**
 * __useAllCarbonPriceOverrideQuery__
 *
 * To run a query within a React component, call `useAllCarbonPriceOverrideQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarbonPriceOverrideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarbonPriceOverrideQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCarbonPriceOverrideQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllCarbonPriceOverrideQuery, Types.AllCarbonPriceOverrideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllCarbonPriceOverrideQuery, Types.AllCarbonPriceOverrideQueryVariables>(AllCarbonPriceOverrideDocument, options);
      }
export function useAllCarbonPriceOverrideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllCarbonPriceOverrideQuery, Types.AllCarbonPriceOverrideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllCarbonPriceOverrideQuery, Types.AllCarbonPriceOverrideQueryVariables>(AllCarbonPriceOverrideDocument, options);
        }
export function useAllCarbonPriceOverrideSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllCarbonPriceOverrideQuery, Types.AllCarbonPriceOverrideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllCarbonPriceOverrideQuery, Types.AllCarbonPriceOverrideQueryVariables>(AllCarbonPriceOverrideDocument, options);
        }
export type AllCarbonPriceOverrideQueryHookResult = ReturnType<typeof useAllCarbonPriceOverrideQuery>;
export type AllCarbonPriceOverrideLazyQueryHookResult = ReturnType<typeof useAllCarbonPriceOverrideLazyQuery>;
export type AllCarbonPriceOverrideSuspenseQueryHookResult = ReturnType<typeof useAllCarbonPriceOverrideSuspenseQuery>;
export type AllCarbonPriceOverrideQueryResult = Apollo.QueryResult<Types.AllCarbonPriceOverrideQuery, Types.AllCarbonPriceOverrideQueryVariables>;
export const CreateCarbonPriceOverrideDocument = gql`
    mutation CreateCarbonPriceOverride($input: CreateCarbonPriceOverrideInput!) {
  createCarbonPriceOverride(input: $input) {
    carbonPriceOverride {
      id
      ...CarbonPriceOverride_Admin
    }
  }
}
    ${CarbonPriceOverride_AdminFragmentDoc}`;
export type CreateCarbonPriceOverrideMutationFn = Apollo.MutationFunction<Types.CreateCarbonPriceOverrideMutation, Types.CreateCarbonPriceOverrideMutationVariables>;

/**
 * __useCreateCarbonPriceOverrideMutation__
 *
 * To run a mutation, you first call `useCreateCarbonPriceOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarbonPriceOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarbonPriceOverrideMutation, { data, loading, error }] = useCreateCarbonPriceOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarbonPriceOverrideMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCarbonPriceOverrideMutation, Types.CreateCarbonPriceOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCarbonPriceOverrideMutation, Types.CreateCarbonPriceOverrideMutationVariables>(CreateCarbonPriceOverrideDocument, options);
      }
export type CreateCarbonPriceOverrideMutationHookResult = ReturnType<typeof useCreateCarbonPriceOverrideMutation>;
export type CreateCarbonPriceOverrideMutationResult = Apollo.MutationResult<Types.CreateCarbonPriceOverrideMutation>;
export type CreateCarbonPriceOverrideMutationOptions = Apollo.BaseMutationOptions<Types.CreateCarbonPriceOverrideMutation, Types.CreateCarbonPriceOverrideMutationVariables>;
export const UpdateCarbonPriceOverrideByIdDocument = gql`
    mutation UpdateCarbonPriceOverrideById($input: UpdateCarbonPriceOverrideByIdInput!) {
  updateCarbonPriceOverrideById(input: $input) {
    carbonPriceOverride {
      id
      ...CarbonPriceOverride_Admin
    }
  }
}
    ${CarbonPriceOverride_AdminFragmentDoc}`;
export type UpdateCarbonPriceOverrideByIdMutationFn = Apollo.MutationFunction<Types.UpdateCarbonPriceOverrideByIdMutation, Types.UpdateCarbonPriceOverrideByIdMutationVariables>;

/**
 * __useUpdateCarbonPriceOverrideByIdMutation__
 *
 * To run a mutation, you first call `useUpdateCarbonPriceOverrideByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarbonPriceOverrideByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarbonPriceOverrideByIdMutation, { data, loading, error }] = useUpdateCarbonPriceOverrideByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarbonPriceOverrideByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCarbonPriceOverrideByIdMutation, Types.UpdateCarbonPriceOverrideByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCarbonPriceOverrideByIdMutation, Types.UpdateCarbonPriceOverrideByIdMutationVariables>(UpdateCarbonPriceOverrideByIdDocument, options);
      }
export type UpdateCarbonPriceOverrideByIdMutationHookResult = ReturnType<typeof useUpdateCarbonPriceOverrideByIdMutation>;
export type UpdateCarbonPriceOverrideByIdMutationResult = Apollo.MutationResult<Types.UpdateCarbonPriceOverrideByIdMutation>;
export type UpdateCarbonPriceOverrideByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCarbonPriceOverrideByIdMutation, Types.UpdateCarbonPriceOverrideByIdMutationVariables>;
export const DeleteCarbonPriceOverrideByIdDocument = gql`
    mutation DeleteCarbonPriceOverrideById($input: DeleteCarbonPriceOverrideByIdInput!) {
  deleteCarbonPriceOverrideById(input: $input) {
    carbonPriceOverride {
      id
      ...CarbonPriceOverride_Admin
    }
  }
}
    ${CarbonPriceOverride_AdminFragmentDoc}`;
export type DeleteCarbonPriceOverrideByIdMutationFn = Apollo.MutationFunction<Types.DeleteCarbonPriceOverrideByIdMutation, Types.DeleteCarbonPriceOverrideByIdMutationVariables>;

/**
 * __useDeleteCarbonPriceOverrideByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCarbonPriceOverrideByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarbonPriceOverrideByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarbonPriceOverrideByIdMutation, { data, loading, error }] = useDeleteCarbonPriceOverrideByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCarbonPriceOverrideByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCarbonPriceOverrideByIdMutation, Types.DeleteCarbonPriceOverrideByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCarbonPriceOverrideByIdMutation, Types.DeleteCarbonPriceOverrideByIdMutationVariables>(DeleteCarbonPriceOverrideByIdDocument, options);
      }
export type DeleteCarbonPriceOverrideByIdMutationHookResult = ReturnType<typeof useDeleteCarbonPriceOverrideByIdMutation>;
export type DeleteCarbonPriceOverrideByIdMutationResult = Apollo.MutationResult<Types.DeleteCarbonPriceOverrideByIdMutation>;
export type DeleteCarbonPriceOverrideByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCarbonPriceOverrideByIdMutation, Types.DeleteCarbonPriceOverrideByIdMutationVariables>;
export const CreateChannelCostEstimateClientDocument = gql`
    mutation CreateChannelCostEstimateClient($input: CreateChannelCostEstimateInput!) {
  createChannelCostEstimate(input: $input) {
    channelCostEstimate {
      id
      ...ChannelCostEstimate_fields
    }
    query {
      allChannelCostEstimates {
        nodes {
          id
          ...ChannelCostEstimate_fields
        }
      }
    }
  }
}
    ${ChannelCostEstimate_FieldsFragmentDoc}`;
export type CreateChannelCostEstimateClientMutationFn = Apollo.MutationFunction<Types.CreateChannelCostEstimateClientMutation, Types.CreateChannelCostEstimateClientMutationVariables>;

/**
 * __useCreateChannelCostEstimateClientMutation__
 *
 * To run a mutation, you first call `useCreateChannelCostEstimateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelCostEstimateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelCostEstimateClientMutation, { data, loading, error }] = useCreateChannelCostEstimateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChannelCostEstimateClientMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateChannelCostEstimateClientMutation, Types.CreateChannelCostEstimateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateChannelCostEstimateClientMutation, Types.CreateChannelCostEstimateClientMutationVariables>(CreateChannelCostEstimateClientDocument, options);
      }
export type CreateChannelCostEstimateClientMutationHookResult = ReturnType<typeof useCreateChannelCostEstimateClientMutation>;
export type CreateChannelCostEstimateClientMutationResult = Apollo.MutationResult<Types.CreateChannelCostEstimateClientMutation>;
export type CreateChannelCostEstimateClientMutationOptions = Apollo.BaseMutationOptions<Types.CreateChannelCostEstimateClientMutation, Types.CreateChannelCostEstimateClientMutationVariables>;
export const UpdateChannelCostEstimateClientDocument = gql`
    mutation UpdateChannelCostEstimateClient($input: UpdateChannelCostEstimateByIdInput!) {
  updateChannelCostEstimateById(input: $input) {
    channelCostEstimate {
      id
      ...ChannelCostEstimate_fields
    }
  }
}
    ${ChannelCostEstimate_FieldsFragmentDoc}`;
export type UpdateChannelCostEstimateClientMutationFn = Apollo.MutationFunction<Types.UpdateChannelCostEstimateClientMutation, Types.UpdateChannelCostEstimateClientMutationVariables>;

/**
 * __useUpdateChannelCostEstimateClientMutation__
 *
 * To run a mutation, you first call `useUpdateChannelCostEstimateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelCostEstimateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelCostEstimateClientMutation, { data, loading, error }] = useUpdateChannelCostEstimateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelCostEstimateClientMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChannelCostEstimateClientMutation, Types.UpdateChannelCostEstimateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChannelCostEstimateClientMutation, Types.UpdateChannelCostEstimateClientMutationVariables>(UpdateChannelCostEstimateClientDocument, options);
      }
export type UpdateChannelCostEstimateClientMutationHookResult = ReturnType<typeof useUpdateChannelCostEstimateClientMutation>;
export type UpdateChannelCostEstimateClientMutationResult = Apollo.MutationResult<Types.UpdateChannelCostEstimateClientMutation>;
export type UpdateChannelCostEstimateClientMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChannelCostEstimateClientMutation, Types.UpdateChannelCostEstimateClientMutationVariables>;
export const DeleteBillOfLadingDatumByIdDocument = gql`
    mutation DeleteBillOfLadingDatumById($bolDatumId: Int!) {
  deleteBillOfLadingDatumById(input: {id: $bolDatumId}) {
    deletedBillOfLadingDatumId
  }
}
    `;
export type DeleteBillOfLadingDatumByIdMutationFn = Apollo.MutationFunction<Types.DeleteBillOfLadingDatumByIdMutation, Types.DeleteBillOfLadingDatumByIdMutationVariables>;

/**
 * __useDeleteBillOfLadingDatumByIdMutation__
 *
 * To run a mutation, you first call `useDeleteBillOfLadingDatumByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillOfLadingDatumByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillOfLadingDatumByIdMutation, { data, loading, error }] = useDeleteBillOfLadingDatumByIdMutation({
 *   variables: {
 *      bolDatumId: // value for 'bolDatumId'
 *   },
 * });
 */
export function useDeleteBillOfLadingDatumByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteBillOfLadingDatumByIdMutation, Types.DeleteBillOfLadingDatumByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteBillOfLadingDatumByIdMutation, Types.DeleteBillOfLadingDatumByIdMutationVariables>(DeleteBillOfLadingDatumByIdDocument, options);
      }
export type DeleteBillOfLadingDatumByIdMutationHookResult = ReturnType<typeof useDeleteBillOfLadingDatumByIdMutation>;
export type DeleteBillOfLadingDatumByIdMutationResult = Apollo.MutationResult<Types.DeleteBillOfLadingDatumByIdMutation>;
export type DeleteBillOfLadingDatumByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteBillOfLadingDatumByIdMutation, Types.DeleteBillOfLadingDatumByIdMutationVariables>;
export const DeleteCargoMeasurementByIdDocument = gql`
    mutation DeleteCargoMeasurementById($cargoMeasurementId: Int!) {
  deleteCargoMeasurementById(input: {id: $cargoMeasurementId}) {
    deletedCargoMeasurementId
  }
}
    `;
export type DeleteCargoMeasurementByIdMutationFn = Apollo.MutationFunction<Types.DeleteCargoMeasurementByIdMutation, Types.DeleteCargoMeasurementByIdMutationVariables>;

/**
 * __useDeleteCargoMeasurementByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCargoMeasurementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCargoMeasurementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCargoMeasurementByIdMutation, { data, loading, error }] = useDeleteCargoMeasurementByIdMutation({
 *   variables: {
 *      cargoMeasurementId: // value for 'cargoMeasurementId'
 *   },
 * });
 */
export function useDeleteCargoMeasurementByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCargoMeasurementByIdMutation, Types.DeleteCargoMeasurementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCargoMeasurementByIdMutation, Types.DeleteCargoMeasurementByIdMutationVariables>(DeleteCargoMeasurementByIdDocument, options);
      }
export type DeleteCargoMeasurementByIdMutationHookResult = ReturnType<typeof useDeleteCargoMeasurementByIdMutation>;
export type DeleteCargoMeasurementByIdMutationResult = Apollo.MutationResult<Types.DeleteCargoMeasurementByIdMutation>;
export type DeleteCargoMeasurementByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCargoMeasurementByIdMutation, Types.DeleteCargoMeasurementByIdMutationVariables>;
export const DeleteNotificationReceiverByIdDocument = gql`
    mutation DeleteNotificationReceiverById($notificationReceiverId: Int!) {
  deleteNotificationReceiverById(input: {id: $notificationReceiverId}) {
    deletedNotificationReceiverId
  }
}
    `;
export type DeleteNotificationReceiverByIdMutationFn = Apollo.MutationFunction<Types.DeleteNotificationReceiverByIdMutation, Types.DeleteNotificationReceiverByIdMutationVariables>;

/**
 * __useDeleteNotificationReceiverByIdMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationReceiverByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationReceiverByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationReceiverByIdMutation, { data, loading, error }] = useDeleteNotificationReceiverByIdMutation({
 *   variables: {
 *      notificationReceiverId: // value for 'notificationReceiverId'
 *   },
 * });
 */
export function useDeleteNotificationReceiverByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteNotificationReceiverByIdMutation, Types.DeleteNotificationReceiverByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteNotificationReceiverByIdMutation, Types.DeleteNotificationReceiverByIdMutationVariables>(DeleteNotificationReceiverByIdDocument, options);
      }
export type DeleteNotificationReceiverByIdMutationHookResult = ReturnType<typeof useDeleteNotificationReceiverByIdMutation>;
export type DeleteNotificationReceiverByIdMutationResult = Apollo.MutationResult<Types.DeleteNotificationReceiverByIdMutation>;
export type DeleteNotificationReceiverByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteNotificationReceiverByIdMutation, Types.DeleteNotificationReceiverByIdMutationVariables>;
export const DeleteCargoCompartmentAllocationByIdDocument = gql`
    mutation DeleteCargoCompartmentAllocationById($cargoCompartmentAllocationId: Int!) {
  deleteCargoCompartmentAllocationById(input: {id: $cargoCompartmentAllocationId}) {
    deletedCargoCompartmentAllocationId
  }
}
    `;
export type DeleteCargoCompartmentAllocationByIdMutationFn = Apollo.MutationFunction<Types.DeleteCargoCompartmentAllocationByIdMutation, Types.DeleteCargoCompartmentAllocationByIdMutationVariables>;

/**
 * __useDeleteCargoCompartmentAllocationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCargoCompartmentAllocationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCargoCompartmentAllocationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCargoCompartmentAllocationByIdMutation, { data, loading, error }] = useDeleteCargoCompartmentAllocationByIdMutation({
 *   variables: {
 *      cargoCompartmentAllocationId: // value for 'cargoCompartmentAllocationId'
 *   },
 * });
 */
export function useDeleteCargoCompartmentAllocationByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCargoCompartmentAllocationByIdMutation, Types.DeleteCargoCompartmentAllocationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCargoCompartmentAllocationByIdMutation, Types.DeleteCargoCompartmentAllocationByIdMutationVariables>(DeleteCargoCompartmentAllocationByIdDocument, options);
      }
export type DeleteCargoCompartmentAllocationByIdMutationHookResult = ReturnType<typeof useDeleteCargoCompartmentAllocationByIdMutation>;
export type DeleteCargoCompartmentAllocationByIdMutationResult = Apollo.MutationResult<Types.DeleteCargoCompartmentAllocationByIdMutation>;
export type DeleteCargoCompartmentAllocationByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCargoCompartmentAllocationByIdMutation, Types.DeleteCargoCompartmentAllocationByIdMutationVariables>;
export const SoftDeleteOrdersDocument = gql`
    mutation SoftDeleteOrders($ids: [Int!]!) {
  softDeleteOrders(ids: $ids) {
    bols
    ccas
    ces
    cms
    nrs
    opcrs
    orders {
      id
      ...ScenarioTimeline_Order
    }
    ovcrs
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}`;
export type SoftDeleteOrdersMutationFn = Apollo.MutationFunction<Types.SoftDeleteOrdersMutation, Types.SoftDeleteOrdersMutationVariables>;

/**
 * __useSoftDeleteOrdersMutation__
 *
 * To run a mutation, you first call `useSoftDeleteOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteOrdersMutation, { data, loading, error }] = useSoftDeleteOrdersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSoftDeleteOrdersMutation(baseOptions?: Apollo.MutationHookOptions<Types.SoftDeleteOrdersMutation, Types.SoftDeleteOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SoftDeleteOrdersMutation, Types.SoftDeleteOrdersMutationVariables>(SoftDeleteOrdersDocument, options);
      }
export type SoftDeleteOrdersMutationHookResult = ReturnType<typeof useSoftDeleteOrdersMutation>;
export type SoftDeleteOrdersMutationResult = Apollo.MutationResult<Types.SoftDeleteOrdersMutation>;
export type SoftDeleteOrdersMutationOptions = Apollo.BaseMutationOptions<Types.SoftDeleteOrdersMutation, Types.SoftDeleteOrdersMutationVariables>;
export const CreateCoaDocument = gql`
    mutation CreateCoa($input: CreateCoaContractInput!) {
  createCoaContract(input: $input) {
    coaContract {
      id
      ...CoaForm_BaseContract
    }
  }
}
    ${CoaForm_BaseContractFragmentDoc}`;
export type CreateCoaMutationFn = Apollo.MutationFunction<Types.CreateCoaMutation, Types.CreateCoaMutationVariables>;

/**
 * __useCreateCoaMutation__
 *
 * To run a mutation, you first call `useCreateCoaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaMutation, { data, loading, error }] = useCreateCoaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaMutation, Types.CreateCoaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaMutation, Types.CreateCoaMutationVariables>(CreateCoaDocument, options);
      }
export type CreateCoaMutationHookResult = ReturnType<typeof useCreateCoaMutation>;
export type CreateCoaMutationResult = Apollo.MutationResult<Types.CreateCoaMutation>;
export type CreateCoaMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaMutation, Types.CreateCoaMutationVariables>;
export const UpdateCoaDocument = gql`
    mutation UpdateCoa($input: UpdateCoaContractByIdInput!) {
  updateCoaContractById(input: $input) {
    coaContract {
      id
      ...CoaForm_BaseContract
    }
  }
}
    ${CoaForm_BaseContractFragmentDoc}`;
export type UpdateCoaMutationFn = Apollo.MutationFunction<Types.UpdateCoaMutation, Types.UpdateCoaMutationVariables>;

/**
 * __useUpdateCoaMutation__
 *
 * To run a mutation, you first call `useUpdateCoaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaMutation, { data, loading, error }] = useUpdateCoaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaMutation, Types.UpdateCoaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaMutation, Types.UpdateCoaMutationVariables>(UpdateCoaDocument, options);
      }
export type UpdateCoaMutationHookResult = ReturnType<typeof useUpdateCoaMutation>;
export type UpdateCoaMutationResult = Apollo.MutationResult<Types.UpdateCoaMutation>;
export type UpdateCoaMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaMutation, Types.UpdateCoaMutationVariables>;
export const DeleteCoaDocument = gql`
    mutation DeleteCoa($input: DeleteCoaContractByIdInput!) {
  deleteCoaContractById(input: $input) {
    deletedCoaContractId
  }
}
    `;
export type DeleteCoaMutationFn = Apollo.MutationFunction<Types.DeleteCoaMutation, Types.DeleteCoaMutationVariables>;

/**
 * __useDeleteCoaMutation__
 *
 * To run a mutation, you first call `useDeleteCoaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaMutation, { data, loading, error }] = useDeleteCoaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaMutation, Types.DeleteCoaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaMutation, Types.DeleteCoaMutationVariables>(DeleteCoaDocument, options);
      }
export type DeleteCoaMutationHookResult = ReturnType<typeof useDeleteCoaMutation>;
export type DeleteCoaMutationResult = Apollo.MutationResult<Types.DeleteCoaMutation>;
export type DeleteCoaMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaMutation, Types.DeleteCoaMutationVariables>;
export const CreateCoaBunkerDocument = gql`
    mutation CreateCoaBunker($input: CreateCoaContractBunkerInput!) {
  createCoaContractBunker(input: $input) {
    coaContractBunker {
      id
      ...CoaForm_CoaBunker
    }
  }
}
    ${CoaForm_CoaBunkerFragmentDoc}`;
export type CreateCoaBunkerMutationFn = Apollo.MutationFunction<Types.CreateCoaBunkerMutation, Types.CreateCoaBunkerMutationVariables>;

/**
 * __useCreateCoaBunkerMutation__
 *
 * To run a mutation, you first call `useCreateCoaBunkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaBunkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaBunkerMutation, { data, loading, error }] = useCreateCoaBunkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaBunkerMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaBunkerMutation, Types.CreateCoaBunkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaBunkerMutation, Types.CreateCoaBunkerMutationVariables>(CreateCoaBunkerDocument, options);
      }
export type CreateCoaBunkerMutationHookResult = ReturnType<typeof useCreateCoaBunkerMutation>;
export type CreateCoaBunkerMutationResult = Apollo.MutationResult<Types.CreateCoaBunkerMutation>;
export type CreateCoaBunkerMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaBunkerMutation, Types.CreateCoaBunkerMutationVariables>;
export const UpdateCoaBunkerDocument = gql`
    mutation UpdateCoaBunker($input: UpdateCoaContractBunkerByIdInput!) {
  updateCoaContractBunkerById(input: $input) {
    coaContractBunker {
      id
      ...CoaForm_CoaBunker
    }
  }
}
    ${CoaForm_CoaBunkerFragmentDoc}`;
export type UpdateCoaBunkerMutationFn = Apollo.MutationFunction<Types.UpdateCoaBunkerMutation, Types.UpdateCoaBunkerMutationVariables>;

/**
 * __useUpdateCoaBunkerMutation__
 *
 * To run a mutation, you first call `useUpdateCoaBunkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaBunkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaBunkerMutation, { data, loading, error }] = useUpdateCoaBunkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaBunkerMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaBunkerMutation, Types.UpdateCoaBunkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaBunkerMutation, Types.UpdateCoaBunkerMutationVariables>(UpdateCoaBunkerDocument, options);
      }
export type UpdateCoaBunkerMutationHookResult = ReturnType<typeof useUpdateCoaBunkerMutation>;
export type UpdateCoaBunkerMutationResult = Apollo.MutationResult<Types.UpdateCoaBunkerMutation>;
export type UpdateCoaBunkerMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaBunkerMutation, Types.UpdateCoaBunkerMutationVariables>;
export const DeleteCoaBunkerDocument = gql`
    mutation DeleteCoaBunker($input: DeleteCoaContractBunkerByIdInput!) {
  deleteCoaContractBunkerById(input: $input) {
    deletedCoaContractBunkerId
  }
}
    `;
export type DeleteCoaBunkerMutationFn = Apollo.MutationFunction<Types.DeleteCoaBunkerMutation, Types.DeleteCoaBunkerMutationVariables>;

/**
 * __useDeleteCoaBunkerMutation__
 *
 * To run a mutation, you first call `useDeleteCoaBunkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaBunkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaBunkerMutation, { data, loading, error }] = useDeleteCoaBunkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaBunkerMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaBunkerMutation, Types.DeleteCoaBunkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaBunkerMutation, Types.DeleteCoaBunkerMutationVariables>(DeleteCoaBunkerDocument, options);
      }
export type DeleteCoaBunkerMutationHookResult = ReturnType<typeof useDeleteCoaBunkerMutation>;
export type DeleteCoaBunkerMutationResult = Apollo.MutationResult<Types.DeleteCoaBunkerMutation>;
export type DeleteCoaBunkerMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaBunkerMutation, Types.DeleteCoaBunkerMutationVariables>;
export const CreateCoaPortPairDocument = gql`
    mutation CreateCoaPortPair($input: CreateCoaContractPortInput!) {
  createCoaContractPort(input: $input) {
    coaContractPort {
      id
      ...CoaForm_PortPair
    }
  }
}
    ${CoaForm_PortPairFragmentDoc}`;
export type CreateCoaPortPairMutationFn = Apollo.MutationFunction<Types.CreateCoaPortPairMutation, Types.CreateCoaPortPairMutationVariables>;

/**
 * __useCreateCoaPortPairMutation__
 *
 * To run a mutation, you first call `useCreateCoaPortPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaPortPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaPortPairMutation, { data, loading, error }] = useCreateCoaPortPairMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaPortPairMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaPortPairMutation, Types.CreateCoaPortPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaPortPairMutation, Types.CreateCoaPortPairMutationVariables>(CreateCoaPortPairDocument, options);
      }
export type CreateCoaPortPairMutationHookResult = ReturnType<typeof useCreateCoaPortPairMutation>;
export type CreateCoaPortPairMutationResult = Apollo.MutationResult<Types.CreateCoaPortPairMutation>;
export type CreateCoaPortPairMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaPortPairMutation, Types.CreateCoaPortPairMutationVariables>;
export const UpdateCoaPortPairDocument = gql`
    mutation UpdateCoaPortPair($input: UpdateCoaContractPortByIdInput!) {
  updateCoaContractPortById(input: $input) {
    coaContractPort {
      id
      ...CoaForm_PortPair
    }
  }
}
    ${CoaForm_PortPairFragmentDoc}`;
export type UpdateCoaPortPairMutationFn = Apollo.MutationFunction<Types.UpdateCoaPortPairMutation, Types.UpdateCoaPortPairMutationVariables>;

/**
 * __useUpdateCoaPortPairMutation__
 *
 * To run a mutation, you first call `useUpdateCoaPortPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaPortPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaPortPairMutation, { data, loading, error }] = useUpdateCoaPortPairMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaPortPairMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaPortPairMutation, Types.UpdateCoaPortPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaPortPairMutation, Types.UpdateCoaPortPairMutationVariables>(UpdateCoaPortPairDocument, options);
      }
export type UpdateCoaPortPairMutationHookResult = ReturnType<typeof useUpdateCoaPortPairMutation>;
export type UpdateCoaPortPairMutationResult = Apollo.MutationResult<Types.UpdateCoaPortPairMutation>;
export type UpdateCoaPortPairMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaPortPairMutation, Types.UpdateCoaPortPairMutationVariables>;
export const DeleteCoaPortPairDocument = gql`
    mutation DeleteCoaPortPair($input: DeleteCoaContractPortByIdInput!) {
  deleteCoaContractPortById(input: $input) {
    deletedCoaContractPortId
  }
}
    `;
export type DeleteCoaPortPairMutationFn = Apollo.MutationFunction<Types.DeleteCoaPortPairMutation, Types.DeleteCoaPortPairMutationVariables>;

/**
 * __useDeleteCoaPortPairMutation__
 *
 * To run a mutation, you first call `useDeleteCoaPortPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaPortPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaPortPairMutation, { data, loading, error }] = useDeleteCoaPortPairMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaPortPairMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaPortPairMutation, Types.DeleteCoaPortPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaPortPairMutation, Types.DeleteCoaPortPairMutationVariables>(DeleteCoaPortPairDocument, options);
      }
export type DeleteCoaPortPairMutationHookResult = ReturnType<typeof useDeleteCoaPortPairMutation>;
export type DeleteCoaPortPairMutationResult = Apollo.MutationResult<Types.DeleteCoaPortPairMutation>;
export type DeleteCoaPortPairMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaPortPairMutation, Types.DeleteCoaPortPairMutationVariables>;
export const CreateCoaPortDataDocument = gql`
    mutation CreateCoaPortData($input: CreateCoaContractPortDatumInput!) {
  createCoaContractPortDatum(input: $input) {
    coaContractPortDatum {
      id
      ...CoaForm_PortData
    }
  }
}
    ${CoaForm_PortDataFragmentDoc}`;
export type CreateCoaPortDataMutationFn = Apollo.MutationFunction<Types.CreateCoaPortDataMutation, Types.CreateCoaPortDataMutationVariables>;

/**
 * __useCreateCoaPortDataMutation__
 *
 * To run a mutation, you first call `useCreateCoaPortDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaPortDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaPortDataMutation, { data, loading, error }] = useCreateCoaPortDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaPortDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaPortDataMutation, Types.CreateCoaPortDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaPortDataMutation, Types.CreateCoaPortDataMutationVariables>(CreateCoaPortDataDocument, options);
      }
export type CreateCoaPortDataMutationHookResult = ReturnType<typeof useCreateCoaPortDataMutation>;
export type CreateCoaPortDataMutationResult = Apollo.MutationResult<Types.CreateCoaPortDataMutation>;
export type CreateCoaPortDataMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaPortDataMutation, Types.CreateCoaPortDataMutationVariables>;
export const CreateCoaAssortmentDocument = gql`
    mutation CreateCoaAssortment($input: CreateCoaContractAssortmentInput!) {
  createCoaContractAssortment(input: $input) {
    coaContractAssortment {
      id
      ...CoaForm_CoaAssortment
    }
  }
}
    ${CoaForm_CoaAssortmentFragmentDoc}`;
export type CreateCoaAssortmentMutationFn = Apollo.MutationFunction<Types.CreateCoaAssortmentMutation, Types.CreateCoaAssortmentMutationVariables>;

/**
 * __useCreateCoaAssortmentMutation__
 *
 * To run a mutation, you first call `useCreateCoaAssortmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaAssortmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaAssortmentMutation, { data, loading, error }] = useCreateCoaAssortmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaAssortmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaAssortmentMutation, Types.CreateCoaAssortmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaAssortmentMutation, Types.CreateCoaAssortmentMutationVariables>(CreateCoaAssortmentDocument, options);
      }
export type CreateCoaAssortmentMutationHookResult = ReturnType<typeof useCreateCoaAssortmentMutation>;
export type CreateCoaAssortmentMutationResult = Apollo.MutationResult<Types.CreateCoaAssortmentMutation>;
export type CreateCoaAssortmentMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaAssortmentMutation, Types.CreateCoaAssortmentMutationVariables>;
export const UpdateCoaAssortmentDocument = gql`
    mutation UpdateCoaAssortment($input: UpdateCoaContractAssortmentByIdInput!) {
  updateCoaContractAssortmentById(input: $input) {
    coaContractAssortment {
      id
      ...CoaForm_CoaAssortment
    }
  }
}
    ${CoaForm_CoaAssortmentFragmentDoc}`;
export type UpdateCoaAssortmentMutationFn = Apollo.MutationFunction<Types.UpdateCoaAssortmentMutation, Types.UpdateCoaAssortmentMutationVariables>;

/**
 * __useUpdateCoaAssortmentMutation__
 *
 * To run a mutation, you first call `useUpdateCoaAssortmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaAssortmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaAssortmentMutation, { data, loading, error }] = useUpdateCoaAssortmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaAssortmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaAssortmentMutation, Types.UpdateCoaAssortmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaAssortmentMutation, Types.UpdateCoaAssortmentMutationVariables>(UpdateCoaAssortmentDocument, options);
      }
export type UpdateCoaAssortmentMutationHookResult = ReturnType<typeof useUpdateCoaAssortmentMutation>;
export type UpdateCoaAssortmentMutationResult = Apollo.MutationResult<Types.UpdateCoaAssortmentMutation>;
export type UpdateCoaAssortmentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaAssortmentMutation, Types.UpdateCoaAssortmentMutationVariables>;
export const DeleteCoaAssortmentDocument = gql`
    mutation DeleteCoaAssortment($input: DeleteCoaContractAssortmentByIdInput!) {
  deleteCoaContractAssortmentById(input: $input) {
    deletedCoaContractAssortmentId
  }
}
    `;
export type DeleteCoaAssortmentMutationFn = Apollo.MutationFunction<Types.DeleteCoaAssortmentMutation, Types.DeleteCoaAssortmentMutationVariables>;

/**
 * __useDeleteCoaAssortmentMutation__
 *
 * To run a mutation, you first call `useDeleteCoaAssortmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaAssortmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaAssortmentMutation, { data, loading, error }] = useDeleteCoaAssortmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaAssortmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaAssortmentMutation, Types.DeleteCoaAssortmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaAssortmentMutation, Types.DeleteCoaAssortmentMutationVariables>(DeleteCoaAssortmentDocument, options);
      }
export type DeleteCoaAssortmentMutationHookResult = ReturnType<typeof useDeleteCoaAssortmentMutation>;
export type DeleteCoaAssortmentMutationResult = Apollo.MutationResult<Types.DeleteCoaAssortmentMutation>;
export type DeleteCoaAssortmentMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaAssortmentMutation, Types.DeleteCoaAssortmentMutationVariables>;
export const CreateCoaPriceDocument = gql`
    mutation CreateCoaPrice($input: CreateCoaContractPriceInput!) {
  createCoaContractPrice(input: $input) {
    coaContractPrice {
      id
      ...CoaForm_CoaPrice
    }
  }
}
    ${CoaForm_CoaPriceFragmentDoc}`;
export type CreateCoaPriceMutationFn = Apollo.MutationFunction<Types.CreateCoaPriceMutation, Types.CreateCoaPriceMutationVariables>;

/**
 * __useCreateCoaPriceMutation__
 *
 * To run a mutation, you first call `useCreateCoaPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaPriceMutation, { data, loading, error }] = useCreateCoaPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaPriceMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaPriceMutation, Types.CreateCoaPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaPriceMutation, Types.CreateCoaPriceMutationVariables>(CreateCoaPriceDocument, options);
      }
export type CreateCoaPriceMutationHookResult = ReturnType<typeof useCreateCoaPriceMutation>;
export type CreateCoaPriceMutationResult = Apollo.MutationResult<Types.CreateCoaPriceMutation>;
export type CreateCoaPriceMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaPriceMutation, Types.CreateCoaPriceMutationVariables>;
export const UpdateCoaPriceDocument = gql`
    mutation UpdateCoaPrice($input: UpdateCoaContractPriceByIdInput!) {
  updateCoaContractPriceById(input: $input) {
    coaContractPrice {
      id
      ...CoaForm_CoaPrice
    }
  }
}
    ${CoaForm_CoaPriceFragmentDoc}`;
export type UpdateCoaPriceMutationFn = Apollo.MutationFunction<Types.UpdateCoaPriceMutation, Types.UpdateCoaPriceMutationVariables>;

/**
 * __useUpdateCoaPriceMutation__
 *
 * To run a mutation, you first call `useUpdateCoaPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaPriceMutation, { data, loading, error }] = useUpdateCoaPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaPriceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaPriceMutation, Types.UpdateCoaPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaPriceMutation, Types.UpdateCoaPriceMutationVariables>(UpdateCoaPriceDocument, options);
      }
export type UpdateCoaPriceMutationHookResult = ReturnType<typeof useUpdateCoaPriceMutation>;
export type UpdateCoaPriceMutationResult = Apollo.MutationResult<Types.UpdateCoaPriceMutation>;
export type UpdateCoaPriceMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaPriceMutation, Types.UpdateCoaPriceMutationVariables>;
export const DeleteCoaPriceDocument = gql`
    mutation DeleteCoaPrice($input: DeleteCoaContractPriceByIdInput!) {
  deleteCoaContractPriceById(input: $input) {
    deletedCoaContractPriceId
  }
}
    `;
export type DeleteCoaPriceMutationFn = Apollo.MutationFunction<Types.DeleteCoaPriceMutation, Types.DeleteCoaPriceMutationVariables>;

/**
 * __useDeleteCoaPriceMutation__
 *
 * To run a mutation, you first call `useDeleteCoaPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaPriceMutation, { data, loading, error }] = useDeleteCoaPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaPriceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaPriceMutation, Types.DeleteCoaPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaPriceMutation, Types.DeleteCoaPriceMutationVariables>(DeleteCoaPriceDocument, options);
      }
export type DeleteCoaPriceMutationHookResult = ReturnType<typeof useDeleteCoaPriceMutation>;
export type DeleteCoaPriceMutationResult = Apollo.MutationResult<Types.DeleteCoaPriceMutation>;
export type DeleteCoaPriceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaPriceMutation, Types.DeleteCoaPriceMutationVariables>;
export const CreateCoaVesselDocument = gql`
    mutation CreateCoaVessel($input: CreateCoaContractShipInput!) {
  createCoaContractShip(input: $input) {
    coaContractShip {
      id
      ...CoaForm_CoaVessel
    }
  }
}
    ${CoaForm_CoaVesselFragmentDoc}`;
export type CreateCoaVesselMutationFn = Apollo.MutationFunction<Types.CreateCoaVesselMutation, Types.CreateCoaVesselMutationVariables>;

/**
 * __useCreateCoaVesselMutation__
 *
 * To run a mutation, you first call `useCreateCoaVesselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaVesselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaVesselMutation, { data, loading, error }] = useCreateCoaVesselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaVesselMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaVesselMutation, Types.CreateCoaVesselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaVesselMutation, Types.CreateCoaVesselMutationVariables>(CreateCoaVesselDocument, options);
      }
export type CreateCoaVesselMutationHookResult = ReturnType<typeof useCreateCoaVesselMutation>;
export type CreateCoaVesselMutationResult = Apollo.MutationResult<Types.CreateCoaVesselMutation>;
export type CreateCoaVesselMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaVesselMutation, Types.CreateCoaVesselMutationVariables>;
export const UpdateCoaVesselDocument = gql`
    mutation UpdateCoaVessel($input: UpdateCoaContractShipByIdInput!) {
  updateCoaContractShipById(input: $input) {
    coaContractShip {
      id
      ...CoaForm_CoaVessel
    }
  }
}
    ${CoaForm_CoaVesselFragmentDoc}`;
export type UpdateCoaVesselMutationFn = Apollo.MutationFunction<Types.UpdateCoaVesselMutation, Types.UpdateCoaVesselMutationVariables>;

/**
 * __useUpdateCoaVesselMutation__
 *
 * To run a mutation, you first call `useUpdateCoaVesselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaVesselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaVesselMutation, { data, loading, error }] = useUpdateCoaVesselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaVesselMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaVesselMutation, Types.UpdateCoaVesselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaVesselMutation, Types.UpdateCoaVesselMutationVariables>(UpdateCoaVesselDocument, options);
      }
export type UpdateCoaVesselMutationHookResult = ReturnType<typeof useUpdateCoaVesselMutation>;
export type UpdateCoaVesselMutationResult = Apollo.MutationResult<Types.UpdateCoaVesselMutation>;
export type UpdateCoaVesselMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaVesselMutation, Types.UpdateCoaVesselMutationVariables>;
export const DeleteCoaVesselDocument = gql`
    mutation DeleteCoaVessel($input: DeleteCoaContractShipByIdInput!) {
  deleteCoaContractShipById(input: $input) {
    deletedCoaContractShipId
  }
}
    `;
export type DeleteCoaVesselMutationFn = Apollo.MutationFunction<Types.DeleteCoaVesselMutation, Types.DeleteCoaVesselMutationVariables>;

/**
 * __useDeleteCoaVesselMutation__
 *
 * To run a mutation, you first call `useDeleteCoaVesselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaVesselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaVesselMutation, { data, loading, error }] = useDeleteCoaVesselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaVesselMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaVesselMutation, Types.DeleteCoaVesselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaVesselMutation, Types.DeleteCoaVesselMutationVariables>(DeleteCoaVesselDocument, options);
      }
export type DeleteCoaVesselMutationHookResult = ReturnType<typeof useDeleteCoaVesselMutation>;
export type DeleteCoaVesselMutationResult = Apollo.MutationResult<Types.DeleteCoaVesselMutation>;
export type DeleteCoaVesselMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaVesselMutation, Types.DeleteCoaVesselMutationVariables>;
export const UpdateCoaInactivityDocument = gql`
    mutation UpdateCoaInactivity($coaId: Int!, $inactive: Boolean!) {
  updateCoaContractById(
    input: {id: $coaId, coaContractPatch: {inactive: $inactive}}
  ) {
    coaContract {
      id
      inactive
    }
  }
}
    `;
export type UpdateCoaInactivityMutationFn = Apollo.MutationFunction<Types.UpdateCoaInactivityMutation, Types.UpdateCoaInactivityMutationVariables>;

/**
 * __useUpdateCoaInactivityMutation__
 *
 * To run a mutation, you first call `useUpdateCoaInactivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaInactivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaInactivityMutation, { data, loading, error }] = useUpdateCoaInactivityMutation({
 *   variables: {
 *      coaId: // value for 'coaId'
 *      inactive: // value for 'inactive'
 *   },
 * });
 */
export function useUpdateCoaInactivityMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaInactivityMutation, Types.UpdateCoaInactivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaInactivityMutation, Types.UpdateCoaInactivityMutationVariables>(UpdateCoaInactivityDocument, options);
      }
export type UpdateCoaInactivityMutationHookResult = ReturnType<typeof useUpdateCoaInactivityMutation>;
export type UpdateCoaInactivityMutationResult = Apollo.MutationResult<Types.UpdateCoaInactivityMutation>;
export type UpdateCoaInactivityMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaInactivityMutation, Types.UpdateCoaInactivityMutationVariables>;
export const CreateCoaCommissionDocument = gql`
    mutation CreateCoaCommission($input: CreateCoaContractCommissionInput!) {
  createCoaContractCommission(input: $input) {
    coaContractCommission {
      id
      ...CoaForm_Commission
    }
  }
}
    ${CoaForm_CommissionFragmentDoc}`;
export type CreateCoaCommissionMutationFn = Apollo.MutationFunction<Types.CreateCoaCommissionMutation, Types.CreateCoaCommissionMutationVariables>;

/**
 * __useCreateCoaCommissionMutation__
 *
 * To run a mutation, you first call `useCreateCoaCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaCommissionMutation, { data, loading, error }] = useCreateCoaCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaCommissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaCommissionMutation, Types.CreateCoaCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaCommissionMutation, Types.CreateCoaCommissionMutationVariables>(CreateCoaCommissionDocument, options);
      }
export type CreateCoaCommissionMutationHookResult = ReturnType<typeof useCreateCoaCommissionMutation>;
export type CreateCoaCommissionMutationResult = Apollo.MutationResult<Types.CreateCoaCommissionMutation>;
export type CreateCoaCommissionMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaCommissionMutation, Types.CreateCoaCommissionMutationVariables>;
export const UpdateCoaCommissionDocument = gql`
    mutation UpdateCoaCommission($input: UpdateCoaContractCommissionByIdInput!) {
  updateCoaContractCommissionById(input: $input) {
    coaContractCommission {
      id
      ...CoaForm_Commission
    }
  }
}
    ${CoaForm_CommissionFragmentDoc}`;
export type UpdateCoaCommissionMutationFn = Apollo.MutationFunction<Types.UpdateCoaCommissionMutation, Types.UpdateCoaCommissionMutationVariables>;

/**
 * __useUpdateCoaCommissionMutation__
 *
 * To run a mutation, you first call `useUpdateCoaCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaCommissionMutation, { data, loading, error }] = useUpdateCoaCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaCommissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaCommissionMutation, Types.UpdateCoaCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaCommissionMutation, Types.UpdateCoaCommissionMutationVariables>(UpdateCoaCommissionDocument, options);
      }
export type UpdateCoaCommissionMutationHookResult = ReturnType<typeof useUpdateCoaCommissionMutation>;
export type UpdateCoaCommissionMutationResult = Apollo.MutationResult<Types.UpdateCoaCommissionMutation>;
export type UpdateCoaCommissionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaCommissionMutation, Types.UpdateCoaCommissionMutationVariables>;
export const DeleteCoaCommissionDocument = gql`
    mutation DeleteCoaCommission($input: DeleteCoaContractCommissionByIdInput!) {
  deleteCoaContractCommissionById(input: $input) {
    coaContractCommission {
      id
      ...CoaForm_Commission
    }
  }
}
    ${CoaForm_CommissionFragmentDoc}`;
export type DeleteCoaCommissionMutationFn = Apollo.MutationFunction<Types.DeleteCoaCommissionMutation, Types.DeleteCoaCommissionMutationVariables>;

/**
 * __useDeleteCoaCommissionMutation__
 *
 * To run a mutation, you first call `useDeleteCoaCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaCommissionMutation, { data, loading, error }] = useDeleteCoaCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaCommissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaCommissionMutation, Types.DeleteCoaCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaCommissionMutation, Types.DeleteCoaCommissionMutationVariables>(DeleteCoaCommissionDocument, options);
      }
export type DeleteCoaCommissionMutationHookResult = ReturnType<typeof useDeleteCoaCommissionMutation>;
export type DeleteCoaCommissionMutationResult = Apollo.MutationResult<Types.DeleteCoaCommissionMutation>;
export type DeleteCoaCommissionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaCommissionMutation, Types.DeleteCoaCommissionMutationVariables>;
export const CreateCoaPortCostDocument = gql`
    mutation CreateCoaPortCost($input: CreateCoaContractPortCostInput!) {
  createCoaContractPortCost(input: $input) {
    coaContractPortCost {
      id
      ...CoaForm_PortCost
    }
  }
}
    ${CoaForm_PortCostFragmentDoc}`;
export type CreateCoaPortCostMutationFn = Apollo.MutationFunction<Types.CreateCoaPortCostMutation, Types.CreateCoaPortCostMutationVariables>;

/**
 * __useCreateCoaPortCostMutation__
 *
 * To run a mutation, you first call `useCreateCoaPortCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoaPortCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoaPortCostMutation, { data, loading, error }] = useCreateCoaPortCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoaPortCostMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoaPortCostMutation, Types.CreateCoaPortCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoaPortCostMutation, Types.CreateCoaPortCostMutationVariables>(CreateCoaPortCostDocument, options);
      }
export type CreateCoaPortCostMutationHookResult = ReturnType<typeof useCreateCoaPortCostMutation>;
export type CreateCoaPortCostMutationResult = Apollo.MutationResult<Types.CreateCoaPortCostMutation>;
export type CreateCoaPortCostMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoaPortCostMutation, Types.CreateCoaPortCostMutationVariables>;
export const UpdateCoaPortCostDocument = gql`
    mutation UpdateCoaPortCost($input: UpdateCoaContractPortCostByIdInput!) {
  updateCoaContractPortCostById(input: $input) {
    coaContractPortCost {
      id
      ...CoaForm_PortCost
    }
  }
}
    ${CoaForm_PortCostFragmentDoc}`;
export type UpdateCoaPortCostMutationFn = Apollo.MutationFunction<Types.UpdateCoaPortCostMutation, Types.UpdateCoaPortCostMutationVariables>;

/**
 * __useUpdateCoaPortCostMutation__
 *
 * To run a mutation, you first call `useUpdateCoaPortCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoaPortCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoaPortCostMutation, { data, loading, error }] = useUpdateCoaPortCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoaPortCostMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCoaPortCostMutation, Types.UpdateCoaPortCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCoaPortCostMutation, Types.UpdateCoaPortCostMutationVariables>(UpdateCoaPortCostDocument, options);
      }
export type UpdateCoaPortCostMutationHookResult = ReturnType<typeof useUpdateCoaPortCostMutation>;
export type UpdateCoaPortCostMutationResult = Apollo.MutationResult<Types.UpdateCoaPortCostMutation>;
export type UpdateCoaPortCostMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCoaPortCostMutation, Types.UpdateCoaPortCostMutationVariables>;
export const DeleteCoaPortCostDocument = gql`
    mutation DeleteCoaPortCost($input: DeleteCoaContractPortCostByIdInput!) {
  deleteCoaContractPortCostById(input: $input) {
    coaContractPortCost {
      id
      ...CoaForm_PortCost
    }
  }
}
    ${CoaForm_PortCostFragmentDoc}`;
export type DeleteCoaPortCostMutationFn = Apollo.MutationFunction<Types.DeleteCoaPortCostMutation, Types.DeleteCoaPortCostMutationVariables>;

/**
 * __useDeleteCoaPortCostMutation__
 *
 * To run a mutation, you first call `useDeleteCoaPortCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoaPortCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoaPortCostMutation, { data, loading, error }] = useDeleteCoaPortCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoaPortCostMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCoaPortCostMutation, Types.DeleteCoaPortCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCoaPortCostMutation, Types.DeleteCoaPortCostMutationVariables>(DeleteCoaPortCostDocument, options);
      }
export type DeleteCoaPortCostMutationHookResult = ReturnType<typeof useDeleteCoaPortCostMutation>;
export type DeleteCoaPortCostMutationResult = Apollo.MutationResult<Types.DeleteCoaPortCostMutation>;
export type DeleteCoaPortCostMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCoaPortCostMutation, Types.DeleteCoaPortCostMutationVariables>;
export const CommitDocument = gql`
    mutation Commit($data: CommitInput!) {
  commit(input: $data) {
    success
    committedAt
    createdShipments {
      id
    }
    createdVoyageCharters {
      id
    }
  }
}
    `;
export type CommitMutationFn = Apollo.MutationFunction<Types.CommitMutation, Types.CommitMutationVariables>;

/**
 * __useCommitMutation__
 *
 * To run a mutation, you first call `useCommitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitMutation, { data, loading, error }] = useCommitMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCommitMutation(baseOptions?: Apollo.MutationHookOptions<Types.CommitMutation, Types.CommitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CommitMutation, Types.CommitMutationVariables>(CommitDocument, options);
      }
export type CommitMutationHookResult = ReturnType<typeof useCommitMutation>;
export type CommitMutationResult = Apollo.MutationResult<Types.CommitMutation>;
export type CommitMutationOptions = Apollo.BaseMutationOptions<Types.CommitMutation, Types.CommitMutationVariables>;
export const CreateCommitLogScenarioDocument = gql`
    mutation CreateCommitLogScenario($input: CreateCommitLogScenarioInput!) {
  createCommitLogScenario(input: $input) {
    commitLogScenario {
      id
    }
  }
}
    `;
export type CreateCommitLogScenarioMutationFn = Apollo.MutationFunction<Types.CreateCommitLogScenarioMutation, Types.CreateCommitLogScenarioMutationVariables>;

/**
 * __useCreateCommitLogScenarioMutation__
 *
 * To run a mutation, you first call `useCreateCommitLogScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommitLogScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommitLogScenarioMutation, { data, loading, error }] = useCreateCommitLogScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommitLogScenarioMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCommitLogScenarioMutation, Types.CreateCommitLogScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCommitLogScenarioMutation, Types.CreateCommitLogScenarioMutationVariables>(CreateCommitLogScenarioDocument, options);
      }
export type CreateCommitLogScenarioMutationHookResult = ReturnType<typeof useCreateCommitLogScenarioMutation>;
export type CreateCommitLogScenarioMutationResult = Apollo.MutationResult<Types.CreateCommitLogScenarioMutation>;
export type CreateCommitLogScenarioMutationOptions = Apollo.BaseMutationOptions<Types.CreateCommitLogScenarioMutation, Types.CreateCommitLogScenarioMutationVariables>;
export const CreateFileDocument = gql`
    mutation CreateFile($input: CreateFileInput!) {
  createFile(input: $input) {
    file {
      id
      uri
      orderId
      vesselId
      voyageId
      locationId
      shipmentId
      uploaded
      userId
      type
      note
    }
  }
}
    `;
export type CreateFileMutationFn = Apollo.MutationFunction<Types.CreateFileMutation, Types.CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFileMutation, Types.CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFileMutation, Types.CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<Types.CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<Types.CreateFileMutation, Types.CreateFileMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($input: DeleteFileByIdInput!) {
  deleteFileById(input: $input) {
    file {
      id
    }
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<Types.DeleteFileMutation, Types.DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFileMutation, Types.DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFileMutation, Types.DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<Types.DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFileMutation, Types.DeleteFileMutationVariables>;
export const CreateHandledBySpotDocument = gql`
    mutation CreateHandledBySpot($input: CreateHandledBySpotInput!) {
  createHandledBySpot(input: $input) {
    handledBySpot {
      id
      ...ScenarioTimeline_HandledBySpot
    }
  }
}
    ${ScenarioTimeline_HandledBySpotFragmentDoc}`;
export type CreateHandledBySpotMutationFn = Apollo.MutationFunction<Types.CreateHandledBySpotMutation, Types.CreateHandledBySpotMutationVariables>;

/**
 * __useCreateHandledBySpotMutation__
 *
 * To run a mutation, you first call `useCreateHandledBySpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHandledBySpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHandledBySpotMutation, { data, loading, error }] = useCreateHandledBySpotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHandledBySpotMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateHandledBySpotMutation, Types.CreateHandledBySpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateHandledBySpotMutation, Types.CreateHandledBySpotMutationVariables>(CreateHandledBySpotDocument, options);
      }
export type CreateHandledBySpotMutationHookResult = ReturnType<typeof useCreateHandledBySpotMutation>;
export type CreateHandledBySpotMutationResult = Apollo.MutationResult<Types.CreateHandledBySpotMutation>;
export type CreateHandledBySpotMutationOptions = Apollo.BaseMutationOptions<Types.CreateHandledBySpotMutation, Types.CreateHandledBySpotMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    order {
      id
      ...ScenarioTimeline_Order
    }
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}`;
export type CreateOrderMutationFn = Apollo.MutationFunction<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<Types.CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>;
export const CreateOrderDetailDocument = gql`
    mutation CreateOrderDetail($input: CreateOrderDetailInput!) {
  createOrderDetail(input: $input) {
    orderDetail {
      id
      ...ScenarioTimeline_Order_Details
    }
  }
}
    ${ScenarioTimeline_Order_DetailsFragmentDoc}`;
export type CreateOrderDetailMutationFn = Apollo.MutationFunction<Types.CreateOrderDetailMutation, Types.CreateOrderDetailMutationVariables>;

/**
 * __useCreateOrderDetailMutation__
 *
 * To run a mutation, you first call `useCreateOrderDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderDetailMutation, { data, loading, error }] = useCreateOrderDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderDetailMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderDetailMutation, Types.CreateOrderDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderDetailMutation, Types.CreateOrderDetailMutationVariables>(CreateOrderDetailDocument, options);
      }
export type CreateOrderDetailMutationHookResult = ReturnType<typeof useCreateOrderDetailMutation>;
export type CreateOrderDetailMutationResult = Apollo.MutationResult<Types.CreateOrderDetailMutation>;
export type CreateOrderDetailMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderDetailMutation, Types.CreateOrderDetailMutationVariables>;
export const CreateCargoExclusionDocument = gql`
    mutation CreateCargoExclusion($input: CreateCargoExclusionInput!) {
  createCargoExclusion(input: $input) {
    cargoExclusion {
      id
    }
  }
}
    `;
export type CreateCargoExclusionMutationFn = Apollo.MutationFunction<Types.CreateCargoExclusionMutation, Types.CreateCargoExclusionMutationVariables>;

/**
 * __useCreateCargoExclusionMutation__
 *
 * To run a mutation, you first call `useCreateCargoExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCargoExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCargoExclusionMutation, { data, loading, error }] = useCreateCargoExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCargoExclusionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCargoExclusionMutation, Types.CreateCargoExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCargoExclusionMutation, Types.CreateCargoExclusionMutationVariables>(CreateCargoExclusionDocument, options);
      }
export type CreateCargoExclusionMutationHookResult = ReturnType<typeof useCreateCargoExclusionMutation>;
export type CreateCargoExclusionMutationResult = Apollo.MutationResult<Types.CreateCargoExclusionMutation>;
export type CreateCargoExclusionMutationOptions = Apollo.BaseMutationOptions<Types.CreateCargoExclusionMutation, Types.CreateCargoExclusionMutationVariables>;
export const CreateOrderRequirementAssociationDocument = gql`
    mutation CreateOrderRequirementAssociation($input: CreateOrderRequirementAssociationInput!) {
  createOrderRequirementAssociation(input: $input) {
    orderRequirementAssociation {
      id
      ...ScenarioTimeline_Order_OrderRequirementAssociation
    }
  }
}
    ${ScenarioTimeline_Order_OrderRequirementAssociationFragmentDoc}`;
export type CreateOrderRequirementAssociationMutationFn = Apollo.MutationFunction<Types.CreateOrderRequirementAssociationMutation, Types.CreateOrderRequirementAssociationMutationVariables>;

/**
 * __useCreateOrderRequirementAssociationMutation__
 *
 * To run a mutation, you first call `useCreateOrderRequirementAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderRequirementAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderRequirementAssociationMutation, { data, loading, error }] = useCreateOrderRequirementAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderRequirementAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderRequirementAssociationMutation, Types.CreateOrderRequirementAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderRequirementAssociationMutation, Types.CreateOrderRequirementAssociationMutationVariables>(CreateOrderRequirementAssociationDocument, options);
      }
export type CreateOrderRequirementAssociationMutationHookResult = ReturnType<typeof useCreateOrderRequirementAssociationMutation>;
export type CreateOrderRequirementAssociationMutationResult = Apollo.MutationResult<Types.CreateOrderRequirementAssociationMutation>;
export type CreateOrderRequirementAssociationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderRequirementAssociationMutation, Types.CreateOrderRequirementAssociationMutationVariables>;
export const CreateOrderAttributeAssociationDocument = gql`
    mutation CreateOrderAttributeAssociation($input: CreateOrderAttributeAssociationInput!) {
  createOrderAttributeAssociation(input: $input) {
    orderAttributeAssociation {
      id
      ...OrderForm_OrderAttributeAssociation
      ...ScenarioTimeline_Order_OrderAttributeAssociation
    }
  }
}
    ${OrderForm_OrderAttributeAssociationFragmentDoc}
${ScenarioTimeline_Order_OrderAttributeAssociationFragmentDoc}`;
export type CreateOrderAttributeAssociationMutationFn = Apollo.MutationFunction<Types.CreateOrderAttributeAssociationMutation, Types.CreateOrderAttributeAssociationMutationVariables>;

/**
 * __useCreateOrderAttributeAssociationMutation__
 *
 * To run a mutation, you first call `useCreateOrderAttributeAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderAttributeAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderAttributeAssociationMutation, { data, loading, error }] = useCreateOrderAttributeAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderAttributeAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderAttributeAssociationMutation, Types.CreateOrderAttributeAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderAttributeAssociationMutation, Types.CreateOrderAttributeAssociationMutationVariables>(CreateOrderAttributeAssociationDocument, options);
      }
export type CreateOrderAttributeAssociationMutationHookResult = ReturnType<typeof useCreateOrderAttributeAssociationMutation>;
export type CreateOrderAttributeAssociationMutationResult = Apollo.MutationResult<Types.CreateOrderAttributeAssociationMutation>;
export type CreateOrderAttributeAssociationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderAttributeAssociationMutation, Types.CreateOrderAttributeAssociationMutationVariables>;
export const CreatePortCallFileDocument = gql`
    mutation CreatePortCallFile($input: CreatePortCallFileInput!) {
  createPortCallFile(input: $input) {
    portCallFile {
      id
      fileId
      portCallId
    }
  }
}
    `;
export type CreatePortCallFileMutationFn = Apollo.MutationFunction<Types.CreatePortCallFileMutation, Types.CreatePortCallFileMutationVariables>;

/**
 * __useCreatePortCallFileMutation__
 *
 * To run a mutation, you first call `useCreatePortCallFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortCallFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortCallFileMutation, { data, loading, error }] = useCreatePortCallFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortCallFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortCallFileMutation, Types.CreatePortCallFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortCallFileMutation, Types.CreatePortCallFileMutationVariables>(CreatePortCallFileDocument, options);
      }
export type CreatePortCallFileMutationHookResult = ReturnType<typeof useCreatePortCallFileMutation>;
export type CreatePortCallFileMutationResult = Apollo.MutationResult<Types.CreatePortCallFileMutation>;
export type CreatePortCallFileMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortCallFileMutation, Types.CreatePortCallFileMutationVariables>;
export const CreateScheduledOrderDocument = gql`
    mutation CreateScheduledOrder($input: CreateScheduledOrderInput!) {
  createScheduledOrder(input: $input) {
    scheduledOrder {
      id
      ...ScheduledOrder
    }
  }
}
    ${ScheduledOrderFragmentDoc}`;
export type CreateScheduledOrderMutationFn = Apollo.MutationFunction<Types.CreateScheduledOrderMutation, Types.CreateScheduledOrderMutationVariables>;

/**
 * __useCreateScheduledOrderMutation__
 *
 * To run a mutation, you first call `useCreateScheduledOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledOrderMutation, { data, loading, error }] = useCreateScheduledOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduledOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateScheduledOrderMutation, Types.CreateScheduledOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateScheduledOrderMutation, Types.CreateScheduledOrderMutationVariables>(CreateScheduledOrderDocument, options);
      }
export type CreateScheduledOrderMutationHookResult = ReturnType<typeof useCreateScheduledOrderMutation>;
export type CreateScheduledOrderMutationResult = Apollo.MutationResult<Types.CreateScheduledOrderMutation>;
export type CreateScheduledOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateScheduledOrderMutation, Types.CreateScheduledOrderMutationVariables>;
export const CreateShipmentDocument = gql`
    mutation CreateShipment($input: CreateShipmentInput!) {
  createShipment(input: $input) {
    shipment {
      name
      id
    }
  }
}
    `;
export type CreateShipmentMutationFn = Apollo.MutationFunction<Types.CreateShipmentMutation, Types.CreateShipmentMutationVariables>;

/**
 * __useCreateShipmentMutation__
 *
 * To run a mutation, you first call `useCreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateShipmentMutation, Types.CreateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateShipmentMutation, Types.CreateShipmentMutationVariables>(CreateShipmentDocument, options);
      }
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>;
export type CreateShipmentMutationResult = Apollo.MutationResult<Types.CreateShipmentMutation>;
export type CreateShipmentMutationOptions = Apollo.BaseMutationOptions<Types.CreateShipmentMutation, Types.CreateShipmentMutationVariables>;
export const CreateSingleEventDocument = gql`
    mutation CreateSingleEvent($input: CreateSingleEventInput!) {
  createSingleEvent(input: $input) {
    singleEvent {
      id
      ...ScenarioTimeline_SingleEvent
    }
  }
}
    ${ScenarioTimeline_SingleEventFragmentDoc}`;
export type CreateSingleEventMutationFn = Apollo.MutationFunction<Types.CreateSingleEventMutation, Types.CreateSingleEventMutationVariables>;

/**
 * __useCreateSingleEventMutation__
 *
 * To run a mutation, you first call `useCreateSingleEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleEventMutation, { data, loading, error }] = useCreateSingleEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSingleEventMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSingleEventMutation, Types.CreateSingleEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSingleEventMutation, Types.CreateSingleEventMutationVariables>(CreateSingleEventDocument, options);
      }
export type CreateSingleEventMutationHookResult = ReturnType<typeof useCreateSingleEventMutation>;
export type CreateSingleEventMutationResult = Apollo.MutationResult<Types.CreateSingleEventMutation>;
export type CreateSingleEventMutationOptions = Apollo.BaseMutationOptions<Types.CreateSingleEventMutation, Types.CreateSingleEventMutationVariables>;
export const CurrencyApiDocument = gql`
    mutation currencyApi($baseCurrency: Currency) {
  currencyApi(baseCurrency: $baseCurrency) {
    baseCurrency
    rates {
      code
      value
    }
    message
  }
}
    `;
export type CurrencyApiMutationFn = Apollo.MutationFunction<Types.CurrencyApiMutation, Types.CurrencyApiMutationVariables>;

/**
 * __useCurrencyApiMutation__
 *
 * To run a mutation, you first call `useCurrencyApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrencyApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currencyApiMutation, { data, loading, error }] = useCurrencyApiMutation({
 *   variables: {
 *      baseCurrency: // value for 'baseCurrency'
 *   },
 * });
 */
export function useCurrencyApiMutation(baseOptions?: Apollo.MutationHookOptions<Types.CurrencyApiMutation, Types.CurrencyApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CurrencyApiMutation, Types.CurrencyApiMutationVariables>(CurrencyApiDocument, options);
      }
export type CurrencyApiMutationHookResult = ReturnType<typeof useCurrencyApiMutation>;
export type CurrencyApiMutationResult = Apollo.MutationResult<Types.CurrencyApiMutation>;
export type CurrencyApiMutationOptions = Apollo.BaseMutationOptions<Types.CurrencyApiMutation, Types.CurrencyApiMutationVariables>;
export const DeleteHandledBySpotDocument = gql`
    mutation DeleteHandledBySpot($handledBySpotById: Int!) {
  deleteHandledBySpotById(input: {id: $handledBySpotById}) {
    deletedHandledBySpotId
  }
}
    `;
export type DeleteHandledBySpotMutationFn = Apollo.MutationFunction<Types.DeleteHandledBySpotMutation, Types.DeleteHandledBySpotMutationVariables>;

/**
 * __useDeleteHandledBySpotMutation__
 *
 * To run a mutation, you first call `useDeleteHandledBySpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHandledBySpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHandledBySpotMutation, { data, loading, error }] = useDeleteHandledBySpotMutation({
 *   variables: {
 *      handledBySpotById: // value for 'handledBySpotById'
 *   },
 * });
 */
export function useDeleteHandledBySpotMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteHandledBySpotMutation, Types.DeleteHandledBySpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteHandledBySpotMutation, Types.DeleteHandledBySpotMutationVariables>(DeleteHandledBySpotDocument, options);
      }
export type DeleteHandledBySpotMutationHookResult = ReturnType<typeof useDeleteHandledBySpotMutation>;
export type DeleteHandledBySpotMutationResult = Apollo.MutationResult<Types.DeleteHandledBySpotMutation>;
export type DeleteHandledBySpotMutationOptions = Apollo.BaseMutationOptions<Types.DeleteHandledBySpotMutation, Types.DeleteHandledBySpotMutationVariables>;
export const DeleteScheduledOrderDocument = gql`
    mutation DeleteScheduledOrder($scheduledOrderId: Int!) {
  deleteScheduledOrderById(input: {id: $scheduledOrderId}) {
    deletedScheduledOrderId
  }
}
    `;
export type DeleteScheduledOrderMutationFn = Apollo.MutationFunction<Types.DeleteScheduledOrderMutation, Types.DeleteScheduledOrderMutationVariables>;

/**
 * __useDeleteScheduledOrderMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledOrderMutation, { data, loading, error }] = useDeleteScheduledOrderMutation({
 *   variables: {
 *      scheduledOrderId: // value for 'scheduledOrderId'
 *   },
 * });
 */
export function useDeleteScheduledOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteScheduledOrderMutation, Types.DeleteScheduledOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteScheduledOrderMutation, Types.DeleteScheduledOrderMutationVariables>(DeleteScheduledOrderDocument, options);
      }
export type DeleteScheduledOrderMutationHookResult = ReturnType<typeof useDeleteScheduledOrderMutation>;
export type DeleteScheduledOrderMutationResult = Apollo.MutationResult<Types.DeleteScheduledOrderMutation>;
export type DeleteScheduledOrderMutationOptions = Apollo.BaseMutationOptions<Types.DeleteScheduledOrderMutation, Types.DeleteScheduledOrderMutationVariables>;
export const DeleteSingleEventDocument = gql`
    mutation DeleteSingleEvent($singleEventId: Int!) {
  deleteSingleEventById(input: {id: $singleEventId}) {
    deletedSingleEventId
  }
}
    `;
export type DeleteSingleEventMutationFn = Apollo.MutationFunction<Types.DeleteSingleEventMutation, Types.DeleteSingleEventMutationVariables>;

/**
 * __useDeleteSingleEventMutation__
 *
 * To run a mutation, you first call `useDeleteSingleEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSingleEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSingleEventMutation, { data, loading, error }] = useDeleteSingleEventMutation({
 *   variables: {
 *      singleEventId: // value for 'singleEventId'
 *   },
 * });
 */
export function useDeleteSingleEventMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSingleEventMutation, Types.DeleteSingleEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSingleEventMutation, Types.DeleteSingleEventMutationVariables>(DeleteSingleEventDocument, options);
      }
export type DeleteSingleEventMutationHookResult = ReturnType<typeof useDeleteSingleEventMutation>;
export type DeleteSingleEventMutationResult = Apollo.MutationResult<Types.DeleteSingleEventMutation>;
export type DeleteSingleEventMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSingleEventMutation, Types.DeleteSingleEventMutationVariables>;
export const UpdatePortCallExternalTimestampsDocument = gql`
    mutation UpdatePortCallExternalTimestamps($query: [UpdatePortCallExternalTimestampsInput!]!) {
  updatePortCallExternalTimestamps(input: $query) {
    portCallClientId
    isOk
    errorText
  }
}
    `;
export type UpdatePortCallExternalTimestampsMutationFn = Apollo.MutationFunction<Types.UpdatePortCallExternalTimestampsMutation, Types.UpdatePortCallExternalTimestampsMutationVariables>;

/**
 * __useUpdatePortCallExternalTimestampsMutation__
 *
 * To run a mutation, you first call `useUpdatePortCallExternalTimestampsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortCallExternalTimestampsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortCallExternalTimestampsMutation, { data, loading, error }] = useUpdatePortCallExternalTimestampsMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUpdatePortCallExternalTimestampsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortCallExternalTimestampsMutation, Types.UpdatePortCallExternalTimestampsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortCallExternalTimestampsMutation, Types.UpdatePortCallExternalTimestampsMutationVariables>(UpdatePortCallExternalTimestampsDocument, options);
      }
export type UpdatePortCallExternalTimestampsMutationHookResult = ReturnType<typeof useUpdatePortCallExternalTimestampsMutation>;
export type UpdatePortCallExternalTimestampsMutationResult = Apollo.MutationResult<Types.UpdatePortCallExternalTimestampsMutation>;
export type UpdatePortCallExternalTimestampsMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortCallExternalTimestampsMutation, Types.UpdatePortCallExternalTimestampsMutationVariables>;
export const InactivateVesselsDocument = gql`
    mutation InactivateVessels($vesselIds: [Int!]!) {
  inactivateShips(input: {shipIds: $vesselIds}) {
    ships {
      id
      inactive
    }
  }
}
    `;
export type InactivateVesselsMutationFn = Apollo.MutationFunction<Types.InactivateVesselsMutation, Types.InactivateVesselsMutationVariables>;

/**
 * __useInactivateVesselsMutation__
 *
 * To run a mutation, you first call `useInactivateVesselsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateVesselsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateVesselsMutation, { data, loading, error }] = useInactivateVesselsMutation({
 *   variables: {
 *      vesselIds: // value for 'vesselIds'
 *   },
 * });
 */
export function useInactivateVesselsMutation(baseOptions?: Apollo.MutationHookOptions<Types.InactivateVesselsMutation, Types.InactivateVesselsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InactivateVesselsMutation, Types.InactivateVesselsMutationVariables>(InactivateVesselsDocument, options);
      }
export type InactivateVesselsMutationHookResult = ReturnType<typeof useInactivateVesselsMutation>;
export type InactivateVesselsMutationResult = Apollo.MutationResult<Types.InactivateVesselsMutation>;
export type InactivateVesselsMutationOptions = Apollo.BaseMutationOptions<Types.InactivateVesselsMutation, Types.InactivateVesselsMutationVariables>;
export const UpdateVesonScenarioDocument = gql`
    mutation UpdateVesonScenario {
  updateVesonScenario {
    scenarioCid
    warnings
    generatedTCLength
  }
}
    `;
export type UpdateVesonScenarioMutationFn = Apollo.MutationFunction<Types.UpdateVesonScenarioMutation, Types.UpdateVesonScenarioMutationVariables>;

/**
 * __useUpdateVesonScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateVesonScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVesonScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVesonScenarioMutation, { data, loading, error }] = useUpdateVesonScenarioMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateVesonScenarioMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVesonScenarioMutation, Types.UpdateVesonScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVesonScenarioMutation, Types.UpdateVesonScenarioMutationVariables>(UpdateVesonScenarioDocument, options);
      }
export type UpdateVesonScenarioMutationHookResult = ReturnType<typeof useUpdateVesonScenarioMutation>;
export type UpdateVesonScenarioMutationResult = Apollo.MutationResult<Types.UpdateVesonScenarioMutation>;
export type UpdateVesonScenarioMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVesonScenarioMutation, Types.UpdateVesonScenarioMutationVariables>;
export const VesonOrdersSyncDocument = gql`
    mutation VesonOrdersSync {
  vesonOrdersSync {
    status
    errorMessage
  }
}
    `;
export type VesonOrdersSyncMutationFn = Apollo.MutationFunction<Types.VesonOrdersSyncMutation, Types.VesonOrdersSyncMutationVariables>;

/**
 * __useVesonOrdersSyncMutation__
 *
 * To run a mutation, you first call `useVesonOrdersSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVesonOrdersSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vesonOrdersSyncMutation, { data, loading, error }] = useVesonOrdersSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useVesonOrdersSyncMutation(baseOptions?: Apollo.MutationHookOptions<Types.VesonOrdersSyncMutation, Types.VesonOrdersSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VesonOrdersSyncMutation, Types.VesonOrdersSyncMutationVariables>(VesonOrdersSyncDocument, options);
      }
export type VesonOrdersSyncMutationHookResult = ReturnType<typeof useVesonOrdersSyncMutation>;
export type VesonOrdersSyncMutationResult = Apollo.MutationResult<Types.VesonOrdersSyncMutation>;
export type VesonOrdersSyncMutationOptions = Apollo.BaseMutationOptions<Types.VesonOrdersSyncMutation, Types.VesonOrdersSyncMutationVariables>;
export const VesonUpdateDataDocument = gql`
    mutation VesonUpdateData {
  vesonUpdateData {
    syncOrder {
      status
      errorMessage
    }
    syncVessel {
      status
      errorMessage
    }
    updateScenario {
      scenarioCid
      warnings
      generatedTCLength
      status
    }
  }
}
    `;
export type VesonUpdateDataMutationFn = Apollo.MutationFunction<Types.VesonUpdateDataMutation, Types.VesonUpdateDataMutationVariables>;

/**
 * __useVesonUpdateDataMutation__
 *
 * To run a mutation, you first call `useVesonUpdateDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVesonUpdateDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vesonUpdateDataMutation, { data, loading, error }] = useVesonUpdateDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useVesonUpdateDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.VesonUpdateDataMutation, Types.VesonUpdateDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VesonUpdateDataMutation, Types.VesonUpdateDataMutationVariables>(VesonUpdateDataDocument, options);
      }
export type VesonUpdateDataMutationHookResult = ReturnType<typeof useVesonUpdateDataMutation>;
export type VesonUpdateDataMutationResult = Apollo.MutationResult<Types.VesonUpdateDataMutation>;
export type VesonUpdateDataMutationOptions = Apollo.BaseMutationOptions<Types.VesonUpdateDataMutation, Types.VesonUpdateDataMutationVariables>;
export const VesonPortsSyncDocument = gql`
    mutation VesonPortsSync {
  vesonPortsSync {
    status
    errorMessage
  }
}
    `;
export type VesonPortsSyncMutationFn = Apollo.MutationFunction<Types.VesonPortsSyncMutation, Types.VesonPortsSyncMutationVariables>;

/**
 * __useVesonPortsSyncMutation__
 *
 * To run a mutation, you first call `useVesonPortsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVesonPortsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vesonPortsSyncMutation, { data, loading, error }] = useVesonPortsSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useVesonPortsSyncMutation(baseOptions?: Apollo.MutationHookOptions<Types.VesonPortsSyncMutation, Types.VesonPortsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VesonPortsSyncMutation, Types.VesonPortsSyncMutationVariables>(VesonPortsSyncDocument, options);
      }
export type VesonPortsSyncMutationHookResult = ReturnType<typeof useVesonPortsSyncMutation>;
export type VesonPortsSyncMutationResult = Apollo.MutationResult<Types.VesonPortsSyncMutation>;
export type VesonPortsSyncMutationOptions = Apollo.BaseMutationOptions<Types.VesonPortsSyncMutation, Types.VesonPortsSyncMutationVariables>;
export const VesonVesselsSyncDocument = gql`
    mutation VesonVesselsSync {
  vesonVesselsSync {
    status
    errorMessage
  }
}
    `;
export type VesonVesselsSyncMutationFn = Apollo.MutationFunction<Types.VesonVesselsSyncMutation, Types.VesonVesselsSyncMutationVariables>;

/**
 * __useVesonVesselsSyncMutation__
 *
 * To run a mutation, you first call `useVesonVesselsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVesonVesselsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vesonVesselsSyncMutation, { data, loading, error }] = useVesonVesselsSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useVesonVesselsSyncMutation(baseOptions?: Apollo.MutationHookOptions<Types.VesonVesselsSyncMutation, Types.VesonVesselsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VesonVesselsSyncMutation, Types.VesonVesselsSyncMutationVariables>(VesonVesselsSyncDocument, options);
      }
export type VesonVesselsSyncMutationHookResult = ReturnType<typeof useVesonVesselsSyncMutation>;
export type VesonVesselsSyncMutationResult = Apollo.MutationResult<Types.VesonVesselsSyncMutation>;
export type VesonVesselsSyncMutationOptions = Apollo.BaseMutationOptions<Types.VesonVesselsSyncMutation, Types.VesonVesselsSyncMutationVariables>;
export const InvoicesByIdDocument = gql`
    query InvoicesById($voyageCharterId: Int!) {
  voyageCharterById(id: $voyageCharterId) {
    __typename
    id
    invoicesByVoyageCharterId {
      nodes {
        id
        ...InvoiceForm
      }
    }
    ...InvoiceOrders
  }
  allOrganizations {
    nodes {
      __typename
      id
      name
    }
  }
}
    ${InvoiceFormFragmentDoc}
${InvoiceOrdersFragmentDoc}`;

/**
 * __useInvoicesByIdQuery__
 *
 * To run a query within a React component, call `useInvoicesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesByIdQuery({
 *   variables: {
 *      voyageCharterId: // value for 'voyageCharterId'
 *   },
 * });
 */
export function useInvoicesByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.InvoicesByIdQuery, Types.InvoicesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InvoicesByIdQuery, Types.InvoicesByIdQueryVariables>(InvoicesByIdDocument, options);
      }
export function useInvoicesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InvoicesByIdQuery, Types.InvoicesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InvoicesByIdQuery, Types.InvoicesByIdQueryVariables>(InvoicesByIdDocument, options);
        }
export function useInvoicesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InvoicesByIdQuery, Types.InvoicesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InvoicesByIdQuery, Types.InvoicesByIdQueryVariables>(InvoicesByIdDocument, options);
        }
export type InvoicesByIdQueryHookResult = ReturnType<typeof useInvoicesByIdQuery>;
export type InvoicesByIdLazyQueryHookResult = ReturnType<typeof useInvoicesByIdLazyQuery>;
export type InvoicesByIdSuspenseQueryHookResult = ReturnType<typeof useInvoicesByIdSuspenseQuery>;
export type InvoicesByIdQueryResult = Apollo.QueryResult<Types.InvoicesByIdQuery, Types.InvoicesByIdQueryVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($input: CreateInvoiceInput!) {
  createInvoice(input: $input) {
    invoice {
      id
      ...InvoiceForm
    }
  }
}
    ${InvoiceFormFragmentDoc}`;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<Types.CreateInvoiceMutation, Types.CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInvoiceMutation, Types.CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInvoiceMutation, Types.CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<Types.CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<Types.CreateInvoiceMutation, Types.CreateInvoiceMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($input: UpdateInvoiceByIdInput!) {
  updateInvoiceById(input: $input) {
    invoice {
      id
      ...InvoiceForm
    }
  }
}
    ${InvoiceFormFragmentDoc}`;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<Types.UpdateInvoiceMutation, Types.UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInvoiceMutation, Types.UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInvoiceMutation, Types.UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<Types.UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInvoiceMutation, Types.UpdateInvoiceMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($input: DeleteInvoiceByIdInput!) {
  deleteInvoiceById(input: $input) {
    invoice {
      id
    }
  }
}
    `;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<Types.DeleteInvoiceMutation, Types.DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInvoiceMutation, Types.DeleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInvoiceMutation, Types.DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<Types.DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInvoiceMutation, Types.DeleteInvoiceMutationVariables>;
export const CreateInvoiceItemDocument = gql`
    mutation CreateInvoiceItem($input: CreateInvoiceItemInput!) {
  createInvoiceItem(input: $input) {
    invoiceItem {
      id
      ...InvoiceFormItem
    }
  }
}
    ${InvoiceFormItemFragmentDoc}`;
export type CreateInvoiceItemMutationFn = Apollo.MutationFunction<Types.CreateInvoiceItemMutation, Types.CreateInvoiceItemMutationVariables>;

/**
 * __useCreateInvoiceItemMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceItemMutation, { data, loading, error }] = useCreateInvoiceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInvoiceItemMutation, Types.CreateInvoiceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInvoiceItemMutation, Types.CreateInvoiceItemMutationVariables>(CreateInvoiceItemDocument, options);
      }
export type CreateInvoiceItemMutationHookResult = ReturnType<typeof useCreateInvoiceItemMutation>;
export type CreateInvoiceItemMutationResult = Apollo.MutationResult<Types.CreateInvoiceItemMutation>;
export type CreateInvoiceItemMutationOptions = Apollo.BaseMutationOptions<Types.CreateInvoiceItemMutation, Types.CreateInvoiceItemMutationVariables>;
export const UpdateInvoiceItemDocument = gql`
    mutation UpdateInvoiceItem($input: UpdateInvoiceItemByIdInput!) {
  updateInvoiceItemById(input: $input) {
    invoiceItem {
      id
      ...InvoiceFormItem
    }
  }
}
    ${InvoiceFormItemFragmentDoc}`;
export type UpdateInvoiceItemMutationFn = Apollo.MutationFunction<Types.UpdateInvoiceItemMutation, Types.UpdateInvoiceItemMutationVariables>;

/**
 * __useUpdateInvoiceItemMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceItemMutation, { data, loading, error }] = useUpdateInvoiceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInvoiceItemMutation, Types.UpdateInvoiceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInvoiceItemMutation, Types.UpdateInvoiceItemMutationVariables>(UpdateInvoiceItemDocument, options);
      }
export type UpdateInvoiceItemMutationHookResult = ReturnType<typeof useUpdateInvoiceItemMutation>;
export type UpdateInvoiceItemMutationResult = Apollo.MutationResult<Types.UpdateInvoiceItemMutation>;
export type UpdateInvoiceItemMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInvoiceItemMutation, Types.UpdateInvoiceItemMutationVariables>;
export const DeleteInvoiceItemDocument = gql`
    mutation DeleteInvoiceItem($input: DeleteInvoiceItemByIdInput!) {
  deleteInvoiceItemById(input: $input) {
    invoiceItem {
      id
    }
  }
}
    `;
export type DeleteInvoiceItemMutationFn = Apollo.MutationFunction<Types.DeleteInvoiceItemMutation, Types.DeleteInvoiceItemMutationVariables>;

/**
 * __useDeleteInvoiceItemMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceItemMutation, { data, loading, error }] = useDeleteInvoiceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvoiceItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInvoiceItemMutation, Types.DeleteInvoiceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInvoiceItemMutation, Types.DeleteInvoiceItemMutationVariables>(DeleteInvoiceItemDocument, options);
      }
export type DeleteInvoiceItemMutationHookResult = ReturnType<typeof useDeleteInvoiceItemMutation>;
export type DeleteInvoiceItemMutationResult = Apollo.MutationResult<Types.DeleteInvoiceItemMutation>;
export type DeleteInvoiceItemMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInvoiceItemMutation, Types.DeleteInvoiceItemMutationVariables>;
export const CreateInvoiceItemOrderDocument = gql`
    mutation CreateInvoiceItemOrder($input: CreateInvoiceItemOrderInput!) {
  createInvoiceItemOrder(input: $input) {
    invoiceItemOrder {
      id
      ...InvoiceFormItemOrder
    }
  }
}
    ${InvoiceFormItemOrderFragmentDoc}`;
export type CreateInvoiceItemOrderMutationFn = Apollo.MutationFunction<Types.CreateInvoiceItemOrderMutation, Types.CreateInvoiceItemOrderMutationVariables>;

/**
 * __useCreateInvoiceItemOrderMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceItemOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceItemOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceItemOrderMutation, { data, loading, error }] = useCreateInvoiceItemOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceItemOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInvoiceItemOrderMutation, Types.CreateInvoiceItemOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInvoiceItemOrderMutation, Types.CreateInvoiceItemOrderMutationVariables>(CreateInvoiceItemOrderDocument, options);
      }
export type CreateInvoiceItemOrderMutationHookResult = ReturnType<typeof useCreateInvoiceItemOrderMutation>;
export type CreateInvoiceItemOrderMutationResult = Apollo.MutationResult<Types.CreateInvoiceItemOrderMutation>;
export type CreateInvoiceItemOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateInvoiceItemOrderMutation, Types.CreateInvoiceItemOrderMutationVariables>;
export const DeleteInvoiceItemOrderByIdDocument = gql`
    mutation DeleteInvoiceItemOrderById($input: DeleteInvoiceItemOrderByIdInput!) {
  deleteInvoiceItemOrderById(input: $input) {
    invoiceItemOrder {
      id
    }
  }
}
    `;
export type DeleteInvoiceItemOrderByIdMutationFn = Apollo.MutationFunction<Types.DeleteInvoiceItemOrderByIdMutation, Types.DeleteInvoiceItemOrderByIdMutationVariables>;

/**
 * __useDeleteInvoiceItemOrderByIdMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceItemOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceItemOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceItemOrderByIdMutation, { data, loading, error }] = useDeleteInvoiceItemOrderByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvoiceItemOrderByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInvoiceItemOrderByIdMutation, Types.DeleteInvoiceItemOrderByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInvoiceItemOrderByIdMutation, Types.DeleteInvoiceItemOrderByIdMutationVariables>(DeleteInvoiceItemOrderByIdDocument, options);
      }
export type DeleteInvoiceItemOrderByIdMutationHookResult = ReturnType<typeof useDeleteInvoiceItemOrderByIdMutation>;
export type DeleteInvoiceItemOrderByIdMutationResult = Apollo.MutationResult<Types.DeleteInvoiceItemOrderByIdMutation>;
export type DeleteInvoiceItemOrderByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInvoiceItemOrderByIdMutation, Types.DeleteInvoiceItemOrderByIdMutationVariables>;
export const LogOutDocument = gql`
    mutation LogOut {
  logout(input: {clientMutationId: "logout"}) {
    clientMutationId
  }
}
    `;
export type LogOutMutationFn = Apollo.MutationFunction<Types.LogOutMutation, Types.LogOutMutationVariables>;

/**
 * __useLogOutMutation__
 *
 * To run a mutation, you first call `useLogOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOutMutation, { data, loading, error }] = useLogOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogOutMutation(baseOptions?: Apollo.MutationHookOptions<Types.LogOutMutation, Types.LogOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LogOutMutation, Types.LogOutMutationVariables>(LogOutDocument, options);
      }
export type LogOutMutationHookResult = ReturnType<typeof useLogOutMutation>;
export type LogOutMutationResult = Apollo.MutationResult<Types.LogOutMutation>;
export type LogOutMutationOptions = Apollo.BaseMutationOptions<Types.LogOutMutation, Types.LogOutMutationVariables>;
export const CreateCargoMeasurementDocument = gql`
    mutation CreateCargoMeasurement($input: CreateCargoMeasurementInput!) {
  createCargoMeasurement(input: $input) {
    cargoMeasurement {
      id
      ...MRForm_CargoMeasurement
    }
  }
}
    ${MrForm_CargoMeasurementFragmentDoc}`;
export type CreateCargoMeasurementMutationFn = Apollo.MutationFunction<Types.CreateCargoMeasurementMutation, Types.CreateCargoMeasurementMutationVariables>;

/**
 * __useCreateCargoMeasurementMutation__
 *
 * To run a mutation, you first call `useCreateCargoMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCargoMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCargoMeasurementMutation, { data, loading, error }] = useCreateCargoMeasurementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCargoMeasurementMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCargoMeasurementMutation, Types.CreateCargoMeasurementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCargoMeasurementMutation, Types.CreateCargoMeasurementMutationVariables>(CreateCargoMeasurementDocument, options);
      }
export type CreateCargoMeasurementMutationHookResult = ReturnType<typeof useCreateCargoMeasurementMutation>;
export type CreateCargoMeasurementMutationResult = Apollo.MutationResult<Types.CreateCargoMeasurementMutation>;
export type CreateCargoMeasurementMutationOptions = Apollo.BaseMutationOptions<Types.CreateCargoMeasurementMutation, Types.CreateCargoMeasurementMutationVariables>;
export const UpdateCargoMeasurementDocument = gql`
    mutation UpdateCargoMeasurement($input: UpdateCargoMeasurementByIdInput!) {
  updateCargoMeasurementById(input: $input) {
    cargoMeasurement {
      id
      ...MRForm_CargoMeasurement
    }
  }
}
    ${MrForm_CargoMeasurementFragmentDoc}`;
export type UpdateCargoMeasurementMutationFn = Apollo.MutationFunction<Types.UpdateCargoMeasurementMutation, Types.UpdateCargoMeasurementMutationVariables>;

/**
 * __useUpdateCargoMeasurementMutation__
 *
 * To run a mutation, you first call `useUpdateCargoMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCargoMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCargoMeasurementMutation, { data, loading, error }] = useUpdateCargoMeasurementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCargoMeasurementMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCargoMeasurementMutation, Types.UpdateCargoMeasurementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCargoMeasurementMutation, Types.UpdateCargoMeasurementMutationVariables>(UpdateCargoMeasurementDocument, options);
      }
export type UpdateCargoMeasurementMutationHookResult = ReturnType<typeof useUpdateCargoMeasurementMutation>;
export type UpdateCargoMeasurementMutationResult = Apollo.MutationResult<Types.UpdateCargoMeasurementMutation>;
export type UpdateCargoMeasurementMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCargoMeasurementMutation, Types.UpdateCargoMeasurementMutationVariables>;
export const MarcuraCommodityGroupMappingDocument = gql`
    mutation MarcuraCommodityGroupMapping {
  commodityGroupMapping {
    status
  }
}
    `;
export type MarcuraCommodityGroupMappingMutationFn = Apollo.MutationFunction<Types.MarcuraCommodityGroupMappingMutation, Types.MarcuraCommodityGroupMappingMutationVariables>;

/**
 * __useMarcuraCommodityGroupMappingMutation__
 *
 * To run a mutation, you first call `useMarcuraCommodityGroupMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarcuraCommodityGroupMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marcuraCommodityGroupMappingMutation, { data, loading, error }] = useMarcuraCommodityGroupMappingMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarcuraCommodityGroupMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.MarcuraCommodityGroupMappingMutation, Types.MarcuraCommodityGroupMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MarcuraCommodityGroupMappingMutation, Types.MarcuraCommodityGroupMappingMutationVariables>(MarcuraCommodityGroupMappingDocument, options);
      }
export type MarcuraCommodityGroupMappingMutationHookResult = ReturnType<typeof useMarcuraCommodityGroupMappingMutation>;
export type MarcuraCommodityGroupMappingMutationResult = Apollo.MutationResult<Types.MarcuraCommodityGroupMappingMutation>;
export type MarcuraCommodityGroupMappingMutationOptions = Apollo.BaseMutationOptions<Types.MarcuraCommodityGroupMappingMutation, Types.MarcuraCommodityGroupMappingMutationVariables>;
export const UpsertMarcuraLocationDocument = gql`
    mutation UpsertMarcuraLocation {
  upsertMarcuraLocation(allowOverride: true) {
    status
  }
}
    `;
export type UpsertMarcuraLocationMutationFn = Apollo.MutationFunction<Types.UpsertMarcuraLocationMutation, Types.UpsertMarcuraLocationMutationVariables>;

/**
 * __useUpsertMarcuraLocationMutation__
 *
 * To run a mutation, you first call `useUpsertMarcuraLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMarcuraLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMarcuraLocationMutation, { data, loading, error }] = useUpsertMarcuraLocationMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpsertMarcuraLocationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpsertMarcuraLocationMutation, Types.UpsertMarcuraLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpsertMarcuraLocationMutation, Types.UpsertMarcuraLocationMutationVariables>(UpsertMarcuraLocationDocument, options);
      }
export type UpsertMarcuraLocationMutationHookResult = ReturnType<typeof useUpsertMarcuraLocationMutation>;
export type UpsertMarcuraLocationMutationResult = Apollo.MutationResult<Types.UpsertMarcuraLocationMutation>;
export type UpsertMarcuraLocationMutationOptions = Apollo.BaseMutationOptions<Types.UpsertMarcuraLocationMutation, Types.UpsertMarcuraLocationMutationVariables>;
export const GetMarcuraPortCostsDocument = gql`
    mutation getMarcuraPortCosts($input: [GetMarcuraPortCostInput!]!) {
  getMarcuraPortCosts(input: $input) {
    id
    marcura_port_id
    marcura_group_id
    location_id
    assortment_id
    data {
      costs {
        dwtMax
        dwtMin
        costLoading
        segmentName
        costDischarging
        costLoadingWithTowage
        costDischargingWithTowage
      }
    }
  }
}
    `;
export type GetMarcuraPortCostsMutationFn = Apollo.MutationFunction<Types.GetMarcuraPortCostsMutation, Types.GetMarcuraPortCostsMutationVariables>;

/**
 * __useGetMarcuraPortCostsMutation__
 *
 * To run a mutation, you first call `useGetMarcuraPortCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMarcuraPortCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMarcuraPortCostsMutation, { data, loading, error }] = useGetMarcuraPortCostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMarcuraPortCostsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GetMarcuraPortCostsMutation, Types.GetMarcuraPortCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GetMarcuraPortCostsMutation, Types.GetMarcuraPortCostsMutationVariables>(GetMarcuraPortCostsDocument, options);
      }
export type GetMarcuraPortCostsMutationHookResult = ReturnType<typeof useGetMarcuraPortCostsMutation>;
export type GetMarcuraPortCostsMutationResult = Apollo.MutationResult<Types.GetMarcuraPortCostsMutation>;
export type GetMarcuraPortCostsMutationOptions = Apollo.BaseMutationOptions<Types.GetMarcuraPortCostsMutation, Types.GetMarcuraPortCostsMutationVariables>;
export const CreateNorDocument = gql`
    mutation CreateNOR($input: CreatePortNoticeInput!) {
  createPortNotice(input: $input) {
    portNotice {
      id
      ...NORForm__NoticeOfReadiness
    }
  }
}
    ${NorForm__NoticeOfReadinessFragmentDoc}`;
export type CreateNorMutationFn = Apollo.MutationFunction<Types.CreateNorMutation, Types.CreateNorMutationVariables>;

/**
 * __useCreateNorMutation__
 *
 * To run a mutation, you first call `useCreateNorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNorMutation, { data, loading, error }] = useCreateNorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNorMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateNorMutation, Types.CreateNorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateNorMutation, Types.CreateNorMutationVariables>(CreateNorDocument, options);
      }
export type CreateNorMutationHookResult = ReturnType<typeof useCreateNorMutation>;
export type CreateNorMutationResult = Apollo.MutationResult<Types.CreateNorMutation>;
export type CreateNorMutationOptions = Apollo.BaseMutationOptions<Types.CreateNorMutation, Types.CreateNorMutationVariables>;
export const UpdateNorDocument = gql`
    mutation UpdateNOR($input: UpdatePortNoticeByIdInput!) {
  updatePortNoticeById(input: $input) {
    portNotice {
      id
      ...NORForm__NoticeOfReadiness
    }
  }
}
    ${NorForm__NoticeOfReadinessFragmentDoc}`;
export type UpdateNorMutationFn = Apollo.MutationFunction<Types.UpdateNorMutation, Types.UpdateNorMutationVariables>;

/**
 * __useUpdateNorMutation__
 *
 * To run a mutation, you first call `useUpdateNorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNorMutation, { data, loading, error }] = useUpdateNorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNorMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateNorMutation, Types.UpdateNorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateNorMutation, Types.UpdateNorMutationVariables>(UpdateNorDocument, options);
      }
export type UpdateNorMutationHookResult = ReturnType<typeof useUpdateNorMutation>;
export type UpdateNorMutationResult = Apollo.MutationResult<Types.UpdateNorMutation>;
export type UpdateNorMutationOptions = Apollo.BaseMutationOptions<Types.UpdateNorMutation, Types.UpdateNorMutationVariables>;
export const CreatePortCallDocument = gql`
    mutation CreatePortCall($input: CreatePortCallInput!) {
  createPortCall(input: $input) {
    portCall {
      id
      vesselId
      locationId
      updatedAt
    }
  }
}
    `;
export type CreatePortCallMutationFn = Apollo.MutationFunction<Types.CreatePortCallMutation, Types.CreatePortCallMutationVariables>;

/**
 * __useCreatePortCallMutation__
 *
 * To run a mutation, you first call `useCreatePortCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortCallMutation, { data, loading, error }] = useCreatePortCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortCallMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortCallMutation, Types.CreatePortCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortCallMutation, Types.CreatePortCallMutationVariables>(CreatePortCallDocument, options);
      }
export type CreatePortCallMutationHookResult = ReturnType<typeof useCreatePortCallMutation>;
export type CreatePortCallMutationResult = Apollo.MutationResult<Types.CreatePortCallMutation>;
export type CreatePortCallMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortCallMutation, Types.CreatePortCallMutationVariables>;
export const UpdatePortCallDocument = gql`
    mutation UpdatePortCall($portCallId: Int!, $patch: PortCallPatch!) {
  updatePortCallById(input: {id: $portCallId, portCallPatch: $patch}) {
    portCall {
      id
      updatedAt
    }
  }
}
    `;
export type UpdatePortCallMutationFn = Apollo.MutationFunction<Types.UpdatePortCallMutation, Types.UpdatePortCallMutationVariables>;

/**
 * __useUpdatePortCallMutation__
 *
 * To run a mutation, you first call `useUpdatePortCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortCallMutation, { data, loading, error }] = useUpdatePortCallMutation({
 *   variables: {
 *      portCallId: // value for 'portCallId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdatePortCallMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortCallMutation, Types.UpdatePortCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortCallMutation, Types.UpdatePortCallMutationVariables>(UpdatePortCallDocument, options);
      }
export type UpdatePortCallMutationHookResult = ReturnType<typeof useUpdatePortCallMutation>;
export type UpdatePortCallMutationResult = Apollo.MutationResult<Types.UpdatePortCallMutation>;
export type UpdatePortCallMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortCallMutation, Types.UpdatePortCallMutationVariables>;
export const CreateOrderPortCallRelationDocument = gql`
    mutation CreateOrderPortCallRelation($input: CreateOrderPortCallRelationInput!) {
  createOrderPortCallRelation(input: $input) {
    orderPortCallRelation {
      id
      portCallId
      isLoadPort
      orderId
    }
  }
}
    `;
export type CreateOrderPortCallRelationMutationFn = Apollo.MutationFunction<Types.CreateOrderPortCallRelationMutation, Types.CreateOrderPortCallRelationMutationVariables>;

/**
 * __useCreateOrderPortCallRelationMutation__
 *
 * To run a mutation, you first call `useCreateOrderPortCallRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderPortCallRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderPortCallRelationMutation, { data, loading, error }] = useCreateOrderPortCallRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderPortCallRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderPortCallRelationMutation, Types.CreateOrderPortCallRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderPortCallRelationMutation, Types.CreateOrderPortCallRelationMutationVariables>(CreateOrderPortCallRelationDocument, options);
      }
export type CreateOrderPortCallRelationMutationHookResult = ReturnType<typeof useCreateOrderPortCallRelationMutation>;
export type CreateOrderPortCallRelationMutationResult = Apollo.MutationResult<Types.CreateOrderPortCallRelationMutation>;
export type CreateOrderPortCallRelationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderPortCallRelationMutation, Types.CreateOrderPortCallRelationMutationVariables>;
export const CreateSingleEventPortCallRelationDocument = gql`
    mutation CreateSingleEventPortCallRelation($input: CreateSingleEventPortCallRelationInput!) {
  createSingleEventPortCallRelation(input: $input) {
    singleEventPortCallRelation {
      id
      portCallId
      singleEventId
    }
  }
}
    `;
export type CreateSingleEventPortCallRelationMutationFn = Apollo.MutationFunction<Types.CreateSingleEventPortCallRelationMutation, Types.CreateSingleEventPortCallRelationMutationVariables>;

/**
 * __useCreateSingleEventPortCallRelationMutation__
 *
 * To run a mutation, you first call `useCreateSingleEventPortCallRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleEventPortCallRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleEventPortCallRelationMutation, { data, loading, error }] = useCreateSingleEventPortCallRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSingleEventPortCallRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSingleEventPortCallRelationMutation, Types.CreateSingleEventPortCallRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSingleEventPortCallRelationMutation, Types.CreateSingleEventPortCallRelationMutationVariables>(CreateSingleEventPortCallRelationDocument, options);
      }
export type CreateSingleEventPortCallRelationMutationHookResult = ReturnType<typeof useCreateSingleEventPortCallRelationMutation>;
export type CreateSingleEventPortCallRelationMutationResult = Apollo.MutationResult<Types.CreateSingleEventPortCallRelationMutation>;
export type CreateSingleEventPortCallRelationMutationOptions = Apollo.BaseMutationOptions<Types.CreateSingleEventPortCallRelationMutation, Types.CreateSingleEventPortCallRelationMutationVariables>;
export const DeleteOrderPortCallRelationDocument = gql`
    mutation DeleteOrderPortCallRelation($input: DeleteOrderPortCallRelationByIdInput!) {
  deleteOrderPortCallRelationById(input: $input) {
    deletedOrderPortCallRelationId
  }
}
    `;
export type DeleteOrderPortCallRelationMutationFn = Apollo.MutationFunction<Types.DeleteOrderPortCallRelationMutation, Types.DeleteOrderPortCallRelationMutationVariables>;

/**
 * __useDeleteOrderPortCallRelationMutation__
 *
 * To run a mutation, you first call `useDeleteOrderPortCallRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderPortCallRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderPortCallRelationMutation, { data, loading, error }] = useDeleteOrderPortCallRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderPortCallRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderPortCallRelationMutation, Types.DeleteOrderPortCallRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderPortCallRelationMutation, Types.DeleteOrderPortCallRelationMutationVariables>(DeleteOrderPortCallRelationDocument, options);
      }
export type DeleteOrderPortCallRelationMutationHookResult = ReturnType<typeof useDeleteOrderPortCallRelationMutation>;
export type DeleteOrderPortCallRelationMutationResult = Apollo.MutationResult<Types.DeleteOrderPortCallRelationMutation>;
export type DeleteOrderPortCallRelationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderPortCallRelationMutation, Types.DeleteOrderPortCallRelationMutationVariables>;
export const DeleteSingleEventPortCallRelationDocument = gql`
    mutation DeleteSingleEventPortCallRelation($input: DeleteSingleEventPortCallRelationByIdInput!) {
  deleteSingleEventPortCallRelationById(input: $input) {
    deletedSingleEventPortCallRelationId
  }
}
    `;
export type DeleteSingleEventPortCallRelationMutationFn = Apollo.MutationFunction<Types.DeleteSingleEventPortCallRelationMutation, Types.DeleteSingleEventPortCallRelationMutationVariables>;

/**
 * __useDeleteSingleEventPortCallRelationMutation__
 *
 * To run a mutation, you first call `useDeleteSingleEventPortCallRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSingleEventPortCallRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSingleEventPortCallRelationMutation, { data, loading, error }] = useDeleteSingleEventPortCallRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSingleEventPortCallRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSingleEventPortCallRelationMutation, Types.DeleteSingleEventPortCallRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSingleEventPortCallRelationMutation, Types.DeleteSingleEventPortCallRelationMutationVariables>(DeleteSingleEventPortCallRelationDocument, options);
      }
export type DeleteSingleEventPortCallRelationMutationHookResult = ReturnType<typeof useDeleteSingleEventPortCallRelationMutation>;
export type DeleteSingleEventPortCallRelationMutationResult = Apollo.MutationResult<Types.DeleteSingleEventPortCallRelationMutation>;
export type DeleteSingleEventPortCallRelationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSingleEventPortCallRelationMutation, Types.DeleteSingleEventPortCallRelationMutationVariables>;
export const UpdatePortNoticeDocument = gql`
    mutation UpdatePortNotice($input: UpdatePortNoticeByIdInput!) {
  updatePortNoticeById(input: $input) {
    portNotice {
      id
      ...ScenarioTimeline_PortNotice
    }
  }
}
    ${ScenarioTimeline_PortNoticeFragmentDoc}`;
export type UpdatePortNoticeMutationFn = Apollo.MutationFunction<Types.UpdatePortNoticeMutation, Types.UpdatePortNoticeMutationVariables>;

/**
 * __useUpdatePortNoticeMutation__
 *
 * To run a mutation, you first call `useUpdatePortNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortNoticeMutation, { data, loading, error }] = useUpdatePortNoticeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortNoticeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortNoticeMutation, Types.UpdatePortNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortNoticeMutation, Types.UpdatePortNoticeMutationVariables>(UpdatePortNoticeDocument, options);
      }
export type UpdatePortNoticeMutationHookResult = ReturnType<typeof useUpdatePortNoticeMutation>;
export type UpdatePortNoticeMutationResult = Apollo.MutationResult<Types.UpdatePortNoticeMutation>;
export type UpdatePortNoticeMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortNoticeMutation, Types.UpdatePortNoticeMutationVariables>;
export const CreatePortDataDocument = gql`
    mutation CreatePortData($input: CreatePortDatumInput!) {
  createPortDatum(input: $input) {
    portDatum {
      id
      ...ContractPortDatum
    }
  }
}
    ${ContractPortDatumFragmentDoc}`;
export type CreatePortDataMutationFn = Apollo.MutationFunction<Types.CreatePortDataMutation, Types.CreatePortDataMutationVariables>;

/**
 * __useCreatePortDataMutation__
 *
 * To run a mutation, you first call `useCreatePortDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortDataMutation, { data, loading, error }] = useCreatePortDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortDataMutation, Types.CreatePortDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortDataMutation, Types.CreatePortDataMutationVariables>(CreatePortDataDocument, options);
      }
export type CreatePortDataMutationHookResult = ReturnType<typeof useCreatePortDataMutation>;
export type CreatePortDataMutationResult = Apollo.MutationResult<Types.CreatePortDataMutation>;
export type CreatePortDataMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortDataMutation, Types.CreatePortDataMutationVariables>;
export const UpdatePortDataDocument = gql`
    mutation UpdatePortData($input: UpdatePortDatumByIdInput!) {
  updatePortDatumById(input: $input) {
    portDatum {
      id
      ...ContractPortDatum
    }
  }
}
    ${ContractPortDatumFragmentDoc}`;
export type UpdatePortDataMutationFn = Apollo.MutationFunction<Types.UpdatePortDataMutation, Types.UpdatePortDataMutationVariables>;

/**
 * __useUpdatePortDataMutation__
 *
 * To run a mutation, you first call `useUpdatePortDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortDataMutation, { data, loading, error }] = useUpdatePortDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortDataMutation, Types.UpdatePortDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortDataMutation, Types.UpdatePortDataMutationVariables>(UpdatePortDataDocument, options);
      }
export type UpdatePortDataMutationHookResult = ReturnType<typeof useUpdatePortDataMutation>;
export type UpdatePortDataMutationResult = Apollo.MutationResult<Types.UpdatePortDataMutation>;
export type UpdatePortDataMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortDataMutation, Types.UpdatePortDataMutationVariables>;
export const DeletePortDataDocument = gql`
    mutation DeletePortData($input: DeletePortDatumByIdInput!) {
  deletePortDatumById(input: $input) {
    deletedPortDatumId
  }
}
    `;
export type DeletePortDataMutationFn = Apollo.MutationFunction<Types.DeletePortDataMutation, Types.DeletePortDataMutationVariables>;

/**
 * __useDeletePortDataMutation__
 *
 * To run a mutation, you first call `useDeletePortDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortDataMutation, { data, loading, error }] = useDeletePortDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePortDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePortDataMutation, Types.DeletePortDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePortDataMutation, Types.DeletePortDataMutationVariables>(DeletePortDataDocument, options);
      }
export type DeletePortDataMutationHookResult = ReturnType<typeof useDeletePortDataMutation>;
export type DeletePortDataMutationResult = Apollo.MutationResult<Types.DeletePortDataMutation>;
export type DeletePortDataMutationOptions = Apollo.BaseMutationOptions<Types.DeletePortDataMutation, Types.DeletePortDataMutationVariables>;
export const SyncPreemOrdersDocument = gql`
    mutation syncPreemOrders {
  syncPreemOrders {
    status
    errorLogs
  }
}
    `;
export type SyncPreemOrdersMutationFn = Apollo.MutationFunction<Types.SyncPreemOrdersMutation, Types.SyncPreemOrdersMutationVariables>;

/**
 * __useSyncPreemOrdersMutation__
 *
 * To run a mutation, you first call `useSyncPreemOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPreemOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPreemOrdersMutation, { data, loading, error }] = useSyncPreemOrdersMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncPreemOrdersMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncPreemOrdersMutation, Types.SyncPreemOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncPreemOrdersMutation, Types.SyncPreemOrdersMutationVariables>(SyncPreemOrdersDocument, options);
      }
export type SyncPreemOrdersMutationHookResult = ReturnType<typeof useSyncPreemOrdersMutation>;
export type SyncPreemOrdersMutationResult = Apollo.MutationResult<Types.SyncPreemOrdersMutation>;
export type SyncPreemOrdersMutationOptions = Apollo.BaseMutationOptions<Types.SyncPreemOrdersMutation, Types.SyncPreemOrdersMutationVariables>;
export const PublishOrdersDocument = gql`
    mutation PublishOrders($ids: [Int!]!, $shared: Boolean!) {
  publishOrders(ids: $ids, shared: $shared) {
    orders {
      id
      ...ScenarioTimeline_Order
    }
    sos
    hbss
    hbcs
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}`;
export type PublishOrdersMutationFn = Apollo.MutationFunction<Types.PublishOrdersMutation, Types.PublishOrdersMutationVariables>;

/**
 * __usePublishOrdersMutation__
 *
 * To run a mutation, you first call `usePublishOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOrdersMutation, { data, loading, error }] = usePublishOrdersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      shared: // value for 'shared'
 *   },
 * });
 */
export function usePublishOrdersMutation(baseOptions?: Apollo.MutationHookOptions<Types.PublishOrdersMutation, Types.PublishOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PublishOrdersMutation, Types.PublishOrdersMutationVariables>(PublishOrdersDocument, options);
      }
export type PublishOrdersMutationHookResult = ReturnType<typeof usePublishOrdersMutation>;
export type PublishOrdersMutationResult = Apollo.MutationResult<Types.PublishOrdersMutation>;
export type PublishOrdersMutationOptions = Apollo.BaseMutationOptions<Types.PublishOrdersMutation, Types.PublishOrdersMutationVariables>;
export const Q88OrderSyncDocument = gql`
    mutation Q88OrderSync {
  q88OrderSync {
    status
  }
}
    `;
export type Q88OrderSyncMutationFn = Apollo.MutationFunction<Types.Q88OrderSyncMutation, Types.Q88OrderSyncMutationVariables>;

/**
 * __useQ88OrderSyncMutation__
 *
 * To run a mutation, you first call `useQ88OrderSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQ88OrderSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [q88OrderSyncMutation, { data, loading, error }] = useQ88OrderSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useQ88OrderSyncMutation(baseOptions?: Apollo.MutationHookOptions<Types.Q88OrderSyncMutation, Types.Q88OrderSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.Q88OrderSyncMutation, Types.Q88OrderSyncMutationVariables>(Q88OrderSyncDocument, options);
      }
export type Q88OrderSyncMutationHookResult = ReturnType<typeof useQ88OrderSyncMutation>;
export type Q88OrderSyncMutationResult = Apollo.MutationResult<Types.Q88OrderSyncMutation>;
export type Q88OrderSyncMutationOptions = Apollo.BaseMutationOptions<Types.Q88OrderSyncMutation, Types.Q88OrderSyncMutationVariables>;
export const UpdateQ88ScenarioDocument = gql`
    mutation UpdateQ88Scenario {
  updateQ88Scenario {
    scenarioCid
    warnings
    generatedTCLength
  }
}
    `;
export type UpdateQ88ScenarioMutationFn = Apollo.MutationFunction<Types.UpdateQ88ScenarioMutation, Types.UpdateQ88ScenarioMutationVariables>;

/**
 * __useUpdateQ88ScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateQ88ScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQ88ScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQ88ScenarioMutation, { data, loading, error }] = useUpdateQ88ScenarioMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateQ88ScenarioMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateQ88ScenarioMutation, Types.UpdateQ88ScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateQ88ScenarioMutation, Types.UpdateQ88ScenarioMutationVariables>(UpdateQ88ScenarioDocument, options);
      }
export type UpdateQ88ScenarioMutationHookResult = ReturnType<typeof useUpdateQ88ScenarioMutation>;
export type UpdateQ88ScenarioMutationResult = Apollo.MutationResult<Types.UpdateQ88ScenarioMutation>;
export type UpdateQ88ScenarioMutationOptions = Apollo.BaseMutationOptions<Types.UpdateQ88ScenarioMutation, Types.UpdateQ88ScenarioMutationVariables>;
export const Q88UpdateDataDocument = gql`
    mutation Q88UpdateData {
  q88UpdateData {
    syncOrder {
      status
      errorMessage
    }
    updateScenario {
      status
      itemsLength
      generatedTCLength
      warnings
      scenarioCid
    }
  }
}
    `;
export type Q88UpdateDataMutationFn = Apollo.MutationFunction<Types.Q88UpdateDataMutation, Types.Q88UpdateDataMutationVariables>;

/**
 * __useQ88UpdateDataMutation__
 *
 * To run a mutation, you first call `useQ88UpdateDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQ88UpdateDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [q88UpdateDataMutation, { data, loading, error }] = useQ88UpdateDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useQ88UpdateDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.Q88UpdateDataMutation, Types.Q88UpdateDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.Q88UpdateDataMutation, Types.Q88UpdateDataMutationVariables>(Q88UpdateDataDocument, options);
      }
export type Q88UpdateDataMutationHookResult = ReturnType<typeof useQ88UpdateDataMutation>;
export type Q88UpdateDataMutationResult = Apollo.MutationResult<Types.Q88UpdateDataMutation>;
export type Q88UpdateDataMutationOptions = Apollo.BaseMutationOptions<Types.Q88UpdateDataMutation, Types.Q88UpdateDataMutationVariables>;
export const UpdateSapDocument = gql`
    mutation updateSAP($input: UpdateSAPInput!) {
  updateSAP(input: $input) {
    results
  }
}
    `;
export type UpdateSapMutationFn = Apollo.MutationFunction<Types.UpdateSapMutation, Types.UpdateSapMutationVariables>;

/**
 * __useUpdateSapMutation__
 *
 * To run a mutation, you first call `useUpdateSapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSapMutation, { data, loading, error }] = useUpdateSapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSapMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSapMutation, Types.UpdateSapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSapMutation, Types.UpdateSapMutationVariables>(UpdateSapDocument, options);
      }
export type UpdateSapMutationHookResult = ReturnType<typeof useUpdateSapMutation>;
export type UpdateSapMutationResult = Apollo.MutationResult<Types.UpdateSapMutation>;
export type UpdateSapMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSapMutation, Types.UpdateSapMutationVariables>;
export const UpdateManySapDocument = gql`
    mutation updateManySAP($input: [UpdateSAPInput!]!) {
  updateManySAP(input: $input) {
    results
  }
}
    `;
export type UpdateManySapMutationFn = Apollo.MutationFunction<Types.UpdateManySapMutation, Types.UpdateManySapMutationVariables>;

/**
 * __useUpdateManySapMutation__
 *
 * To run a mutation, you first call `useUpdateManySapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManySapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManySapMutation, { data, loading, error }] = useUpdateManySapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManySapMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateManySapMutation, Types.UpdateManySapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateManySapMutation, Types.UpdateManySapMutationVariables>(UpdateManySapDocument, options);
      }
export type UpdateManySapMutationHookResult = ReturnType<typeof useUpdateManySapMutation>;
export type UpdateManySapMutationResult = Apollo.MutationResult<Types.UpdateManySapMutation>;
export type UpdateManySapMutationOptions = Apollo.BaseMutationOptions<Types.UpdateManySapMutation, Types.UpdateManySapMutationVariables>;
export const GetLatestSapDocument = gql`
    query getLatestSAP {
  getLatestSAP
}
    `;

/**
 * __useGetLatestSapQuery__
 *
 * To run a query within a React component, call `useGetLatestSapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestSapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestSapQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestSapQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetLatestSapQuery, Types.GetLatestSapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLatestSapQuery, Types.GetLatestSapQueryVariables>(GetLatestSapDocument, options);
      }
export function useGetLatestSapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLatestSapQuery, Types.GetLatestSapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLatestSapQuery, Types.GetLatestSapQueryVariables>(GetLatestSapDocument, options);
        }
export function useGetLatestSapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetLatestSapQuery, Types.GetLatestSapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetLatestSapQuery, Types.GetLatestSapQueryVariables>(GetLatestSapDocument, options);
        }
export type GetLatestSapQueryHookResult = ReturnType<typeof useGetLatestSapQuery>;
export type GetLatestSapLazyQueryHookResult = ReturnType<typeof useGetLatestSapLazyQuery>;
export type GetLatestSapSuspenseQueryHookResult = ReturnType<typeof useGetLatestSapSuspenseQuery>;
export type GetLatestSapQueryResult = Apollo.QueryResult<Types.GetLatestSapQuery, Types.GetLatestSapQueryVariables>;
export const CreateSofDocument = gql`
    mutation CreateSOF($input: CreateStatementOfFactInput!) {
  createStatementOfFact(input: $input) {
    statementOfFact {
      id
      ...SOFForm__StatementOfFacts
    }
  }
}
    ${SofForm__StatementOfFactsFragmentDoc}`;
export type CreateSofMutationFn = Apollo.MutationFunction<Types.CreateSofMutation, Types.CreateSofMutationVariables>;

/**
 * __useCreateSofMutation__
 *
 * To run a mutation, you first call `useCreateSofMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSofMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSofMutation, { data, loading, error }] = useCreateSofMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSofMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSofMutation, Types.CreateSofMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSofMutation, Types.CreateSofMutationVariables>(CreateSofDocument, options);
      }
export type CreateSofMutationHookResult = ReturnType<typeof useCreateSofMutation>;
export type CreateSofMutationResult = Apollo.MutationResult<Types.CreateSofMutation>;
export type CreateSofMutationOptions = Apollo.BaseMutationOptions<Types.CreateSofMutation, Types.CreateSofMutationVariables>;
export const UpdateSofDocument = gql`
    mutation UpdateSOF($input: UpdateStatementOfFactByIdInput!) {
  updateStatementOfFactById(input: $input) {
    statementOfFact {
      id
      ...SOFForm__StatementOfFacts
    }
  }
}
    ${SofForm__StatementOfFactsFragmentDoc}`;
export type UpdateSofMutationFn = Apollo.MutationFunction<Types.UpdateSofMutation, Types.UpdateSofMutationVariables>;

/**
 * __useUpdateSofMutation__
 *
 * To run a mutation, you first call `useUpdateSofMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSofMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSofMutation, { data, loading, error }] = useUpdateSofMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSofMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSofMutation, Types.UpdateSofMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSofMutation, Types.UpdateSofMutationVariables>(UpdateSofDocument, options);
      }
export type UpdateSofMutationHookResult = ReturnType<typeof useUpdateSofMutation>;
export type UpdateSofMutationResult = Apollo.MutationResult<Types.UpdateSofMutation>;
export type UpdateSofMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSofMutation, Types.UpdateSofMutationVariables>;
export const CreatePortActivityDocument = gql`
    mutation CreatePortActivity($input: CreatePortActivityInput!) {
  createPortActivity(input: $input) {
    portActivity {
      id
      ...SOFForm__PortActivity
    }
  }
}
    ${SofForm__PortActivityFragmentDoc}`;
export type CreatePortActivityMutationFn = Apollo.MutationFunction<Types.CreatePortActivityMutation, Types.CreatePortActivityMutationVariables>;

/**
 * __useCreatePortActivityMutation__
 *
 * To run a mutation, you first call `useCreatePortActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortActivityMutation, { data, loading, error }] = useCreatePortActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortActivityMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePortActivityMutation, Types.CreatePortActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePortActivityMutation, Types.CreatePortActivityMutationVariables>(CreatePortActivityDocument, options);
      }
export type CreatePortActivityMutationHookResult = ReturnType<typeof useCreatePortActivityMutation>;
export type CreatePortActivityMutationResult = Apollo.MutationResult<Types.CreatePortActivityMutation>;
export type CreatePortActivityMutationOptions = Apollo.BaseMutationOptions<Types.CreatePortActivityMutation, Types.CreatePortActivityMutationVariables>;
export const UpdatePortActivityDocument = gql`
    mutation UpdatePortActivity($input: UpdatePortActivityByIdInput!) {
  updatePortActivityById(input: $input) {
    portActivity {
      id
      ...SOFForm__PortActivity
    }
  }
}
    ${SofForm__PortActivityFragmentDoc}`;
export type UpdatePortActivityMutationFn = Apollo.MutationFunction<Types.UpdatePortActivityMutation, Types.UpdatePortActivityMutationVariables>;

/**
 * __useUpdatePortActivityMutation__
 *
 * To run a mutation, you first call `useUpdatePortActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortActivityMutation, { data, loading, error }] = useUpdatePortActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortActivityMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePortActivityMutation, Types.UpdatePortActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePortActivityMutation, Types.UpdatePortActivityMutationVariables>(UpdatePortActivityDocument, options);
      }
export type UpdatePortActivityMutationHookResult = ReturnType<typeof useUpdatePortActivityMutation>;
export type UpdatePortActivityMutationResult = Apollo.MutationResult<Types.UpdatePortActivityMutation>;
export type UpdatePortActivityMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePortActivityMutation, Types.UpdatePortActivityMutationVariables>;
export const DeletePortActivityDocument = gql`
    mutation DeletePortActivity($input: DeletePortActivityByIdInput!) {
  deletePortActivityById(input: $input) {
    deletedPortActivityId
  }
}
    `;
export type DeletePortActivityMutationFn = Apollo.MutationFunction<Types.DeletePortActivityMutation, Types.DeletePortActivityMutationVariables>;

/**
 * __useDeletePortActivityMutation__
 *
 * To run a mutation, you first call `useDeletePortActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortActivityMutation, { data, loading, error }] = useDeletePortActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePortActivityMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePortActivityMutation, Types.DeletePortActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePortActivityMutation, Types.DeletePortActivityMutationVariables>(DeletePortActivityDocument, options);
      }
export type DeletePortActivityMutationHookResult = ReturnType<typeof useDeletePortActivityMutation>;
export type DeletePortActivityMutationResult = Apollo.MutationResult<Types.DeletePortActivityMutation>;
export type DeletePortActivityMutationOptions = Apollo.BaseMutationOptions<Types.DeletePortActivityMutation, Types.DeletePortActivityMutationVariables>;
export const UpdateShipnetScenarioDocument = gql`
    mutation UpdateShipnetScenario {
  updateShipnetScenario {
    scenarioCid
    warnings
    generatedTCLength
    status
  }
}
    `;
export type UpdateShipnetScenarioMutationFn = Apollo.MutationFunction<Types.UpdateShipnetScenarioMutation, Types.UpdateShipnetScenarioMutationVariables>;

/**
 * __useUpdateShipnetScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateShipnetScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipnetScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipnetScenarioMutation, { data, loading, error }] = useUpdateShipnetScenarioMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateShipnetScenarioMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipnetScenarioMutation, Types.UpdateShipnetScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipnetScenarioMutation, Types.UpdateShipnetScenarioMutationVariables>(UpdateShipnetScenarioDocument, options);
      }
export type UpdateShipnetScenarioMutationHookResult = ReturnType<typeof useUpdateShipnetScenarioMutation>;
export type UpdateShipnetScenarioMutationResult = Apollo.MutationResult<Types.UpdateShipnetScenarioMutation>;
export type UpdateShipnetScenarioMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipnetScenarioMutation, Types.UpdateShipnetScenarioMutationVariables>;
export const SyncShipnetOrdersDocument = gql`
    mutation SyncShipnetOrders {
  syncShipnetOrders {
    status
  }
}
    `;
export type SyncShipnetOrdersMutationFn = Apollo.MutationFunction<Types.SyncShipnetOrdersMutation, Types.SyncShipnetOrdersMutationVariables>;

/**
 * __useSyncShipnetOrdersMutation__
 *
 * To run a mutation, you first call `useSyncShipnetOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncShipnetOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncShipnetOrdersMutation, { data, loading, error }] = useSyncShipnetOrdersMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncShipnetOrdersMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncShipnetOrdersMutation, Types.SyncShipnetOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncShipnetOrdersMutation, Types.SyncShipnetOrdersMutationVariables>(SyncShipnetOrdersDocument, options);
      }
export type SyncShipnetOrdersMutationHookResult = ReturnType<typeof useSyncShipnetOrdersMutation>;
export type SyncShipnetOrdersMutationResult = Apollo.MutationResult<Types.SyncShipnetOrdersMutation>;
export type SyncShipnetOrdersMutationOptions = Apollo.BaseMutationOptions<Types.SyncShipnetOrdersMutation, Types.SyncShipnetOrdersMutationVariables>;
export const RefreshShipnetOrdersDocument = gql`
    mutation RefreshShipnetOrders {
  refreshShipnetOrders {
    status
  }
}
    `;
export type RefreshShipnetOrdersMutationFn = Apollo.MutationFunction<Types.RefreshShipnetOrdersMutation, Types.RefreshShipnetOrdersMutationVariables>;

/**
 * __useRefreshShipnetOrdersMutation__
 *
 * To run a mutation, you first call `useRefreshShipnetOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshShipnetOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshShipnetOrdersMutation, { data, loading, error }] = useRefreshShipnetOrdersMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshShipnetOrdersMutation(baseOptions?: Apollo.MutationHookOptions<Types.RefreshShipnetOrdersMutation, Types.RefreshShipnetOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RefreshShipnetOrdersMutation, Types.RefreshShipnetOrdersMutationVariables>(RefreshShipnetOrdersDocument, options);
      }
export type RefreshShipnetOrdersMutationHookResult = ReturnType<typeof useRefreshShipnetOrdersMutation>;
export type RefreshShipnetOrdersMutationResult = Apollo.MutationResult<Types.RefreshShipnetOrdersMutation>;
export type RefreshShipnetOrdersMutationOptions = Apollo.BaseMutationOptions<Types.RefreshShipnetOrdersMutation, Types.RefreshShipnetOrdersMutationVariables>;
export const UpdateDateShipnetDocument = gql`
    mutation UpdateDateShipnet {
  updateDateShipnet {
    status
  }
}
    `;
export type UpdateDateShipnetMutationFn = Apollo.MutationFunction<Types.UpdateDateShipnetMutation, Types.UpdateDateShipnetMutationVariables>;

/**
 * __useUpdateDateShipnetMutation__
 *
 * To run a mutation, you first call `useUpdateDateShipnetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDateShipnetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDateShipnetMutation, { data, loading, error }] = useUpdateDateShipnetMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateDateShipnetMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDateShipnetMutation, Types.UpdateDateShipnetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDateShipnetMutation, Types.UpdateDateShipnetMutationVariables>(UpdateDateShipnetDocument, options);
      }
export type UpdateDateShipnetMutationHookResult = ReturnType<typeof useUpdateDateShipnetMutation>;
export type UpdateDateShipnetMutationResult = Apollo.MutationResult<Types.UpdateDateShipnetMutation>;
export type UpdateDateShipnetMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDateShipnetMutation, Types.UpdateDateShipnetMutationVariables>;
export const SetupShipnetCoaDocument = gql`
    mutation SetupShipnetCoa {
  setupShipnetCoa {
    status
  }
}
    `;
export type SetupShipnetCoaMutationFn = Apollo.MutationFunction<Types.SetupShipnetCoaMutation, Types.SetupShipnetCoaMutationVariables>;

/**
 * __useSetupShipnetCoaMutation__
 *
 * To run a mutation, you first call `useSetupShipnetCoaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupShipnetCoaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupShipnetCoaMutation, { data, loading, error }] = useSetupShipnetCoaMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupShipnetCoaMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetupShipnetCoaMutation, Types.SetupShipnetCoaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetupShipnetCoaMutation, Types.SetupShipnetCoaMutationVariables>(SetupShipnetCoaDocument, options);
      }
export type SetupShipnetCoaMutationHookResult = ReturnType<typeof useSetupShipnetCoaMutation>;
export type SetupShipnetCoaMutationResult = Apollo.MutationResult<Types.SetupShipnetCoaMutation>;
export type SetupShipnetCoaMutationOptions = Apollo.BaseMutationOptions<Types.SetupShipnetCoaMutation, Types.SetupShipnetCoaMutationVariables>;
export const SyncBookingListDocument = gql`
    mutation syncBookingList {
  syncBookingList {
    status
  }
}
    `;
export type SyncBookingListMutationFn = Apollo.MutationFunction<Types.SyncBookingListMutation, Types.SyncBookingListMutationVariables>;

/**
 * __useSyncBookingListMutation__
 *
 * To run a mutation, you first call `useSyncBookingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBookingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBookingListMutation, { data, loading, error }] = useSyncBookingListMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncBookingListMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncBookingListMutation, Types.SyncBookingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncBookingListMutation, Types.SyncBookingListMutationVariables>(SyncBookingListDocument, options);
      }
export type SyncBookingListMutationHookResult = ReturnType<typeof useSyncBookingListMutation>;
export type SyncBookingListMutationResult = Apollo.MutationResult<Types.SyncBookingListMutation>;
export type SyncBookingListMutationOptions = Apollo.BaseMutationOptions<Types.SyncBookingListMutation, Types.SyncBookingListMutationVariables>;
export const UpdateConfirmedVoyagesDocument = gql`
    mutation updateConfirmedVoyages($scenarioCid: String!) {
  updateConfirmedVoyages(scenarioCid: $scenarioCid) {
    status
    warnings
  }
}
    `;
export type UpdateConfirmedVoyagesMutationFn = Apollo.MutationFunction<Types.UpdateConfirmedVoyagesMutation, Types.UpdateConfirmedVoyagesMutationVariables>;

/**
 * __useUpdateConfirmedVoyagesMutation__
 *
 * To run a mutation, you first call `useUpdateConfirmedVoyagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfirmedVoyagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfirmedVoyagesMutation, { data, loading, error }] = useUpdateConfirmedVoyagesMutation({
 *   variables: {
 *      scenarioCid: // value for 'scenarioCid'
 *   },
 * });
 */
export function useUpdateConfirmedVoyagesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateConfirmedVoyagesMutation, Types.UpdateConfirmedVoyagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateConfirmedVoyagesMutation, Types.UpdateConfirmedVoyagesMutationVariables>(UpdateConfirmedVoyagesDocument, options);
      }
export type UpdateConfirmedVoyagesMutationHookResult = ReturnType<typeof useUpdateConfirmedVoyagesMutation>;
export type UpdateConfirmedVoyagesMutationResult = Apollo.MutationResult<Types.UpdateConfirmedVoyagesMutation>;
export type UpdateConfirmedVoyagesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateConfirmedVoyagesMutation, Types.UpdateConfirmedVoyagesMutationVariables>;
export const CreateSpotDocument = gql`
    mutation CreateSpot($input: CreateVoyageCharterInput!, $outgoing: Boolean = true) {
  createVoyageCharter(input: $input) {
    voyageCharter {
      id
      ...SpotForm_SpotContract
    }
  }
}
    ${SpotForm_SpotContractFragmentDoc}`;
export type CreateSpotMutationFn = Apollo.MutationFunction<Types.CreateSpotMutation, Types.CreateSpotMutationVariables>;

/**
 * __useCreateSpotMutation__
 *
 * To run a mutation, you first call `useCreateSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpotMutation, { data, loading, error }] = useCreateSpotMutation({
 *   variables: {
 *      input: // value for 'input'
 *      outgoing: // value for 'outgoing'
 *   },
 * });
 */
export function useCreateSpotMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSpotMutation, Types.CreateSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSpotMutation, Types.CreateSpotMutationVariables>(CreateSpotDocument, options);
      }
export type CreateSpotMutationHookResult = ReturnType<typeof useCreateSpotMutation>;
export type CreateSpotMutationResult = Apollo.MutationResult<Types.CreateSpotMutation>;
export type CreateSpotMutationOptions = Apollo.BaseMutationOptions<Types.CreateSpotMutation, Types.CreateSpotMutationVariables>;
export const UpdateSpotDocument = gql`
    mutation UpdateSpot($input: UpdateVoyageCharterByIdInput!, $outgoing: Boolean = true) {
  updateVoyageCharterById(input: $input) {
    voyageCharter {
      id
      ...SpotForm_SpotContract
    }
  }
}
    ${SpotForm_SpotContractFragmentDoc}`;
export type UpdateSpotMutationFn = Apollo.MutationFunction<Types.UpdateSpotMutation, Types.UpdateSpotMutationVariables>;

/**
 * __useUpdateSpotMutation__
 *
 * To run a mutation, you first call `useUpdateSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotMutation, { data, loading, error }] = useUpdateSpotMutation({
 *   variables: {
 *      input: // value for 'input'
 *      outgoing: // value for 'outgoing'
 *   },
 * });
 */
export function useUpdateSpotMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSpotMutation, Types.UpdateSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSpotMutation, Types.UpdateSpotMutationVariables>(UpdateSpotDocument, options);
      }
export type UpdateSpotMutationHookResult = ReturnType<typeof useUpdateSpotMutation>;
export type UpdateSpotMutationResult = Apollo.MutationResult<Types.UpdateSpotMutation>;
export type UpdateSpotMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSpotMutation, Types.UpdateSpotMutationVariables>;
export const DeleteSpotDocument = gql`
    mutation DeleteSpot($input: DeleteVoyageCharterByIdInput!) {
  deleteVoyageCharterById(input: $input) {
    deletedVoyageCharterId
  }
}
    `;
export type DeleteSpotMutationFn = Apollo.MutationFunction<Types.DeleteSpotMutation, Types.DeleteSpotMutationVariables>;

/**
 * __useDeleteSpotMutation__
 *
 * To run a mutation, you first call `useDeleteSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpotMutation, { data, loading, error }] = useDeleteSpotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSpotMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSpotMutation, Types.DeleteSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSpotMutation, Types.DeleteSpotMutationVariables>(DeleteSpotDocument, options);
      }
export type DeleteSpotMutationHookResult = ReturnType<typeof useDeleteSpotMutation>;
export type DeleteSpotMutationResult = Apollo.MutationResult<Types.DeleteSpotMutation>;
export type DeleteSpotMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSpotMutation, Types.DeleteSpotMutationVariables>;
export const CreateOrderSpotRelationDocument = gql`
    mutation CreateOrderSpotRelation($input: CreateOrderVoyageCharterRelationInput!) {
  createOrderVoyageCharterRelation(input: $input) {
    orderVoyageCharterRelation {
      id
      orderId
      voyageCharterId
      outgoing
      coaRouteId
    }
  }
}
    `;
export type CreateOrderSpotRelationMutationFn = Apollo.MutationFunction<Types.CreateOrderSpotRelationMutation, Types.CreateOrderSpotRelationMutationVariables>;

/**
 * __useCreateOrderSpotRelationMutation__
 *
 * To run a mutation, you first call `useCreateOrderSpotRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderSpotRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderSpotRelationMutation, { data, loading, error }] = useCreateOrderSpotRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderSpotRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderSpotRelationMutation, Types.CreateOrderSpotRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderSpotRelationMutation, Types.CreateOrderSpotRelationMutationVariables>(CreateOrderSpotRelationDocument, options);
      }
export type CreateOrderSpotRelationMutationHookResult = ReturnType<typeof useCreateOrderSpotRelationMutation>;
export type CreateOrderSpotRelationMutationResult = Apollo.MutationResult<Types.CreateOrderSpotRelationMutation>;
export type CreateOrderSpotRelationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderSpotRelationMutation, Types.CreateOrderSpotRelationMutationVariables>;
export const DeleteOrderSpotRelationDocument = gql`
    mutation DeleteOrderSpotRelation($input: DeleteOrderVoyageCharterRelationByIdInput!) {
  deleteOrderVoyageCharterRelationById(input: $input) {
    orderVoyageCharterRelation {
      id
      orderId
      voyageCharterId
      outgoing
      coaRouteId
    }
  }
}
    `;
export type DeleteOrderSpotRelationMutationFn = Apollo.MutationFunction<Types.DeleteOrderSpotRelationMutation, Types.DeleteOrderSpotRelationMutationVariables>;

/**
 * __useDeleteOrderSpotRelationMutation__
 *
 * To run a mutation, you first call `useDeleteOrderSpotRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderSpotRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderSpotRelationMutation, { data, loading, error }] = useDeleteOrderSpotRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderSpotRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderSpotRelationMutation, Types.DeleteOrderSpotRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderSpotRelationMutation, Types.DeleteOrderSpotRelationMutationVariables>(DeleteOrderSpotRelationDocument, options);
      }
export type DeleteOrderSpotRelationMutationHookResult = ReturnType<typeof useDeleteOrderSpotRelationMutation>;
export type DeleteOrderSpotRelationMutationResult = Apollo.MutationResult<Types.DeleteOrderSpotRelationMutation>;
export type DeleteOrderSpotRelationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderSpotRelationMutation, Types.DeleteOrderSpotRelationMutationVariables>;
export const CreateVoyageCharterOrderFreightDocument = gql`
    mutation CreateVoyageCharterOrderFreight($input: CreateVoyageCharterOrderFreightInput!) {
  createVoyageCharterOrderFreight(input: $input) {
    voyageCharterOrderFreight {
      id
      orderVoyageCharterRelationId
      freightAmount
      freightUnit
    }
  }
}
    `;
export type CreateVoyageCharterOrderFreightMutationFn = Apollo.MutationFunction<Types.CreateVoyageCharterOrderFreightMutation, Types.CreateVoyageCharterOrderFreightMutationVariables>;

/**
 * __useCreateVoyageCharterOrderFreightMutation__
 *
 * To run a mutation, you first call `useCreateVoyageCharterOrderFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoyageCharterOrderFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoyageCharterOrderFreightMutation, { data, loading, error }] = useCreateVoyageCharterOrderFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoyageCharterOrderFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVoyageCharterOrderFreightMutation, Types.CreateVoyageCharterOrderFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVoyageCharterOrderFreightMutation, Types.CreateVoyageCharterOrderFreightMutationVariables>(CreateVoyageCharterOrderFreightDocument, options);
      }
export type CreateVoyageCharterOrderFreightMutationHookResult = ReturnType<typeof useCreateVoyageCharterOrderFreightMutation>;
export type CreateVoyageCharterOrderFreightMutationResult = Apollo.MutationResult<Types.CreateVoyageCharterOrderFreightMutation>;
export type CreateVoyageCharterOrderFreightMutationOptions = Apollo.BaseMutationOptions<Types.CreateVoyageCharterOrderFreightMutation, Types.CreateVoyageCharterOrderFreightMutationVariables>;
export const UpdateVoyageCharterOrderFreightDocument = gql`
    mutation UpdateVoyageCharterOrderFreight($input: UpdateVoyageCharterOrderFreightByIdInput!) {
  updateVoyageCharterOrderFreightById(input: $input) {
    voyageCharterOrderFreight {
      id
      orderVoyageCharterRelationId
      freightAmount
      freightUnit
    }
  }
}
    `;
export type UpdateVoyageCharterOrderFreightMutationFn = Apollo.MutationFunction<Types.UpdateVoyageCharterOrderFreightMutation, Types.UpdateVoyageCharterOrderFreightMutationVariables>;

/**
 * __useUpdateVoyageCharterOrderFreightMutation__
 *
 * To run a mutation, you first call `useUpdateVoyageCharterOrderFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoyageCharterOrderFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoyageCharterOrderFreightMutation, { data, loading, error }] = useUpdateVoyageCharterOrderFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVoyageCharterOrderFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVoyageCharterOrderFreightMutation, Types.UpdateVoyageCharterOrderFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVoyageCharterOrderFreightMutation, Types.UpdateVoyageCharterOrderFreightMutationVariables>(UpdateVoyageCharterOrderFreightDocument, options);
      }
export type UpdateVoyageCharterOrderFreightMutationHookResult = ReturnType<typeof useUpdateVoyageCharterOrderFreightMutation>;
export type UpdateVoyageCharterOrderFreightMutationResult = Apollo.MutationResult<Types.UpdateVoyageCharterOrderFreightMutation>;
export type UpdateVoyageCharterOrderFreightMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVoyageCharterOrderFreightMutation, Types.UpdateVoyageCharterOrderFreightMutationVariables>;
export const CreateSpotPortDataDocument = gql`
    mutation CreateSpotPortData($input: CreateVoyageCharterPortDatumInput!) {
  createVoyageCharterPortDatum(input: $input) {
    voyageCharterPortDatum {
      id
      voyageCharterId
      portDataId
    }
  }
}
    `;
export type CreateSpotPortDataMutationFn = Apollo.MutationFunction<Types.CreateSpotPortDataMutation, Types.CreateSpotPortDataMutationVariables>;

/**
 * __useCreateSpotPortDataMutation__
 *
 * To run a mutation, you first call `useCreateSpotPortDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpotPortDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpotPortDataMutation, { data, loading, error }] = useCreateSpotPortDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpotPortDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSpotPortDataMutation, Types.CreateSpotPortDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSpotPortDataMutation, Types.CreateSpotPortDataMutationVariables>(CreateSpotPortDataDocument, options);
      }
export type CreateSpotPortDataMutationHookResult = ReturnType<typeof useCreateSpotPortDataMutation>;
export type CreateSpotPortDataMutationResult = Apollo.MutationResult<Types.CreateSpotPortDataMutation>;
export type CreateSpotPortDataMutationOptions = Apollo.BaseMutationOptions<Types.CreateSpotPortDataMutation, Types.CreateSpotPortDataMutationVariables>;
export const DeleteVoyageCharterPortDataDocument = gql`
    mutation DeleteVoyageCharterPortData($input: DeleteVoyageCharterPortDatumByIdInput!) {
  deleteVoyageCharterPortDatumById(input: $input) {
    voyageCharterPortDatum {
      id
      voyageCharterId
      portDataId
    }
  }
}
    `;
export type DeleteVoyageCharterPortDataMutationFn = Apollo.MutationFunction<Types.DeleteVoyageCharterPortDataMutation, Types.DeleteVoyageCharterPortDataMutationVariables>;

/**
 * __useDeleteVoyageCharterPortDataMutation__
 *
 * To run a mutation, you first call `useDeleteVoyageCharterPortDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoyageCharterPortDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoyageCharterPortDataMutation, { data, loading, error }] = useDeleteVoyageCharterPortDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVoyageCharterPortDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVoyageCharterPortDataMutation, Types.DeleteVoyageCharterPortDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVoyageCharterPortDataMutation, Types.DeleteVoyageCharterPortDataMutationVariables>(DeleteVoyageCharterPortDataDocument, options);
      }
export type DeleteVoyageCharterPortDataMutationHookResult = ReturnType<typeof useDeleteVoyageCharterPortDataMutation>;
export type DeleteVoyageCharterPortDataMutationResult = Apollo.MutationResult<Types.DeleteVoyageCharterPortDataMutation>;
export type DeleteVoyageCharterPortDataMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVoyageCharterPortDataMutation, Types.DeleteVoyageCharterPortDataMutationVariables>;
export const CreateVoyageCharterContractDocument = gql`
    mutation CreateVoyageCharterContract($input: CreateVoyageCharterToContractInput!) {
  createVoyageCharterToContract(input: $input) {
    voyageCharterToContract {
      id
      coaId
      voyageCharterId
    }
  }
}
    `;
export type CreateVoyageCharterContractMutationFn = Apollo.MutationFunction<Types.CreateVoyageCharterContractMutation, Types.CreateVoyageCharterContractMutationVariables>;

/**
 * __useCreateVoyageCharterContractMutation__
 *
 * To run a mutation, you first call `useCreateVoyageCharterContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoyageCharterContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoyageCharterContractMutation, { data, loading, error }] = useCreateVoyageCharterContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoyageCharterContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVoyageCharterContractMutation, Types.CreateVoyageCharterContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVoyageCharterContractMutation, Types.CreateVoyageCharterContractMutationVariables>(CreateVoyageCharterContractDocument, options);
      }
export type CreateVoyageCharterContractMutationHookResult = ReturnType<typeof useCreateVoyageCharterContractMutation>;
export type CreateVoyageCharterContractMutationResult = Apollo.MutationResult<Types.CreateVoyageCharterContractMutation>;
export type CreateVoyageCharterContractMutationOptions = Apollo.BaseMutationOptions<Types.CreateVoyageCharterContractMutation, Types.CreateVoyageCharterContractMutationVariables>;
export const UpdateVoyageCharterContractDocument = gql`
    mutation UpdateVoyageCharterContract($input: UpdateVoyageCharterToContractByIdInput!) {
  updateVoyageCharterToContractById(input: $input) {
    voyageCharterToContract {
      id
      coaId
      voyageCharterId
    }
  }
}
    `;
export type UpdateVoyageCharterContractMutationFn = Apollo.MutationFunction<Types.UpdateVoyageCharterContractMutation, Types.UpdateVoyageCharterContractMutationVariables>;

/**
 * __useUpdateVoyageCharterContractMutation__
 *
 * To run a mutation, you first call `useUpdateVoyageCharterContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoyageCharterContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoyageCharterContractMutation, { data, loading, error }] = useUpdateVoyageCharterContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVoyageCharterContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVoyageCharterContractMutation, Types.UpdateVoyageCharterContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVoyageCharterContractMutation, Types.UpdateVoyageCharterContractMutationVariables>(UpdateVoyageCharterContractDocument, options);
      }
export type UpdateVoyageCharterContractMutationHookResult = ReturnType<typeof useUpdateVoyageCharterContractMutation>;
export type UpdateVoyageCharterContractMutationResult = Apollo.MutationResult<Types.UpdateVoyageCharterContractMutation>;
export type UpdateVoyageCharterContractMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVoyageCharterContractMutation, Types.UpdateVoyageCharterContractMutationVariables>;
export const DeleteVoyageCharterContractDocument = gql`
    mutation DeleteVoyageCharterContract($input: DeleteVoyageCharterToContractByIdInput!) {
  deleteVoyageCharterToContractById(input: $input) {
    voyageCharterToContract {
      id
      coaId
      voyageCharterId
    }
  }
}
    `;
export type DeleteVoyageCharterContractMutationFn = Apollo.MutationFunction<Types.DeleteVoyageCharterContractMutation, Types.DeleteVoyageCharterContractMutationVariables>;

/**
 * __useDeleteVoyageCharterContractMutation__
 *
 * To run a mutation, you first call `useDeleteVoyageCharterContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoyageCharterContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoyageCharterContractMutation, { data, loading, error }] = useDeleteVoyageCharterContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVoyageCharterContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVoyageCharterContractMutation, Types.DeleteVoyageCharterContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVoyageCharterContractMutation, Types.DeleteVoyageCharterContractMutationVariables>(DeleteVoyageCharterContractDocument, options);
      }
export type DeleteVoyageCharterContractMutationHookResult = ReturnType<typeof useDeleteVoyageCharterContractMutation>;
export type DeleteVoyageCharterContractMutationResult = Apollo.MutationResult<Types.DeleteVoyageCharterContractMutation>;
export type DeleteVoyageCharterContractMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVoyageCharterContractMutation, Types.DeleteVoyageCharterContractMutationVariables>;
export const CreateChartererDocument = gql`
    mutation CreateCharterer($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    organization {
      id
      name
    }
  }
}
    `;
export type CreateChartererMutationFn = Apollo.MutationFunction<Types.CreateChartererMutation, Types.CreateChartererMutationVariables>;

/**
 * __useCreateChartererMutation__
 *
 * To run a mutation, you first call `useCreateChartererMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartererMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartererMutation, { data, loading, error }] = useCreateChartererMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChartererMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateChartererMutation, Types.CreateChartererMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateChartererMutation, Types.CreateChartererMutationVariables>(CreateChartererDocument, options);
      }
export type CreateChartererMutationHookResult = ReturnType<typeof useCreateChartererMutation>;
export type CreateChartererMutationResult = Apollo.MutationResult<Types.CreateChartererMutation>;
export type CreateChartererMutationOptions = Apollo.BaseMutationOptions<Types.CreateChartererMutation, Types.CreateChartererMutationVariables>;
export const CreateShipOwnerDocument = gql`
    mutation CreateShipOwner($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    organization {
      id
      name
    }
  }
}
    `;
export type CreateShipOwnerMutationFn = Apollo.MutationFunction<Types.CreateShipOwnerMutation, Types.CreateShipOwnerMutationVariables>;

/**
 * __useCreateShipOwnerMutation__
 *
 * To run a mutation, you first call `useCreateShipOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipOwnerMutation, { data, loading, error }] = useCreateShipOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipOwnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateShipOwnerMutation, Types.CreateShipOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateShipOwnerMutation, Types.CreateShipOwnerMutationVariables>(CreateShipOwnerDocument, options);
      }
export type CreateShipOwnerMutationHookResult = ReturnType<typeof useCreateShipOwnerMutation>;
export type CreateShipOwnerMutationResult = Apollo.MutationResult<Types.CreateShipOwnerMutation>;
export type CreateShipOwnerMutationOptions = Apollo.BaseMutationOptions<Types.CreateShipOwnerMutation, Types.CreateShipOwnerMutationVariables>;
export const CreateShipDocument = gql`
    mutation CreateShip($input: CreateShipInput!) {
  createShip(input: $input) {
    ship {
      id
      name
    }
  }
}
    `;
export type CreateShipMutationFn = Apollo.MutationFunction<Types.CreateShipMutation, Types.CreateShipMutationVariables>;

/**
 * __useCreateShipMutation__
 *
 * To run a mutation, you first call `useCreateShipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipMutation, { data, loading, error }] = useCreateShipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateShipMutation, Types.CreateShipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateShipMutation, Types.CreateShipMutationVariables>(CreateShipDocument, options);
      }
export type CreateShipMutationHookResult = ReturnType<typeof useCreateShipMutation>;
export type CreateShipMutationResult = Apollo.MutationResult<Types.CreateShipMutation>;
export type CreateShipMutationOptions = Apollo.BaseMutationOptions<Types.CreateShipMutation, Types.CreateShipMutationVariables>;
export const CreateExtraFreightDocument = gql`
    mutation CreateExtraFreight($input: CreateVoyageCharterExtraFreightInput!) {
  createVoyageCharterExtraFreight(input: $input) {
    voyageCharterExtraFreight {
      id
      ...SpotForm_ExtraFreight
    }
  }
}
    ${SpotForm_ExtraFreightFragmentDoc}`;
export type CreateExtraFreightMutationFn = Apollo.MutationFunction<Types.CreateExtraFreightMutation, Types.CreateExtraFreightMutationVariables>;

/**
 * __useCreateExtraFreightMutation__
 *
 * To run a mutation, you first call `useCreateExtraFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExtraFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExtraFreightMutation, { data, loading, error }] = useCreateExtraFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExtraFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateExtraFreightMutation, Types.CreateExtraFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateExtraFreightMutation, Types.CreateExtraFreightMutationVariables>(CreateExtraFreightDocument, options);
      }
export type CreateExtraFreightMutationHookResult = ReturnType<typeof useCreateExtraFreightMutation>;
export type CreateExtraFreightMutationResult = Apollo.MutationResult<Types.CreateExtraFreightMutation>;
export type CreateExtraFreightMutationOptions = Apollo.BaseMutationOptions<Types.CreateExtraFreightMutation, Types.CreateExtraFreightMutationVariables>;
export const DeleteExtraFreightDocument = gql`
    mutation DeleteExtraFreight($input: DeleteVoyageCharterExtraFreightByIdInput!) {
  deleteVoyageCharterExtraFreightById(input: $input) {
    voyageCharterExtraFreight {
      id
    }
  }
}
    `;
export type DeleteExtraFreightMutationFn = Apollo.MutationFunction<Types.DeleteExtraFreightMutation, Types.DeleteExtraFreightMutationVariables>;

/**
 * __useDeleteExtraFreightMutation__
 *
 * To run a mutation, you first call `useDeleteExtraFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExtraFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExtraFreightMutation, { data, loading, error }] = useDeleteExtraFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExtraFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteExtraFreightMutation, Types.DeleteExtraFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteExtraFreightMutation, Types.DeleteExtraFreightMutationVariables>(DeleteExtraFreightDocument, options);
      }
export type DeleteExtraFreightMutationHookResult = ReturnType<typeof useDeleteExtraFreightMutation>;
export type DeleteExtraFreightMutationResult = Apollo.MutationResult<Types.DeleteExtraFreightMutation>;
export type DeleteExtraFreightMutationOptions = Apollo.BaseMutationOptions<Types.DeleteExtraFreightMutation, Types.DeleteExtraFreightMutationVariables>;
export const UpdateExtraFreightDocument = gql`
    mutation UpdateExtraFreight($input: UpdateVoyageCharterExtraFreightByIdInput!) {
  updateVoyageCharterExtraFreightById(input: $input) {
    voyageCharterExtraFreight {
      id
      ...SpotForm_ExtraFreight
    }
  }
}
    ${SpotForm_ExtraFreightFragmentDoc}`;
export type UpdateExtraFreightMutationFn = Apollo.MutationFunction<Types.UpdateExtraFreightMutation, Types.UpdateExtraFreightMutationVariables>;

/**
 * __useUpdateExtraFreightMutation__
 *
 * To run a mutation, you first call `useUpdateExtraFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtraFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtraFreightMutation, { data, loading, error }] = useUpdateExtraFreightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExtraFreightMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateExtraFreightMutation, Types.UpdateExtraFreightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateExtraFreightMutation, Types.UpdateExtraFreightMutationVariables>(UpdateExtraFreightDocument, options);
      }
export type UpdateExtraFreightMutationHookResult = ReturnType<typeof useUpdateExtraFreightMutation>;
export type UpdateExtraFreightMutationResult = Apollo.MutationResult<Types.UpdateExtraFreightMutation>;
export type UpdateExtraFreightMutationOptions = Apollo.BaseMutationOptions<Types.UpdateExtraFreightMutation, Types.UpdateExtraFreightMutationVariables>;
export const CreateExtraCostDocument = gql`
    mutation CreateExtraCost($input: CreateVoyageCharterExtraCostInput!) {
  createVoyageCharterExtraCost(input: $input) {
    voyageCharterExtraCost {
      id
      ...SpotForm_ExtraCost
    }
  }
}
    ${SpotForm_ExtraCostFragmentDoc}`;
export type CreateExtraCostMutationFn = Apollo.MutationFunction<Types.CreateExtraCostMutation, Types.CreateExtraCostMutationVariables>;

/**
 * __useCreateExtraCostMutation__
 *
 * To run a mutation, you first call `useCreateExtraCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExtraCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExtraCostMutation, { data, loading, error }] = useCreateExtraCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExtraCostMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateExtraCostMutation, Types.CreateExtraCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateExtraCostMutation, Types.CreateExtraCostMutationVariables>(CreateExtraCostDocument, options);
      }
export type CreateExtraCostMutationHookResult = ReturnType<typeof useCreateExtraCostMutation>;
export type CreateExtraCostMutationResult = Apollo.MutationResult<Types.CreateExtraCostMutation>;
export type CreateExtraCostMutationOptions = Apollo.BaseMutationOptions<Types.CreateExtraCostMutation, Types.CreateExtraCostMutationVariables>;
export const DeleteExtraCostDocument = gql`
    mutation DeleteExtraCost($input: DeleteVoyageCharterExtraCostByIdInput!) {
  deleteVoyageCharterExtraCostById(input: $input) {
    voyageCharterExtraCost {
      id
    }
  }
}
    `;
export type DeleteExtraCostMutationFn = Apollo.MutationFunction<Types.DeleteExtraCostMutation, Types.DeleteExtraCostMutationVariables>;

/**
 * __useDeleteExtraCostMutation__
 *
 * To run a mutation, you first call `useDeleteExtraCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExtraCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExtraCostMutation, { data, loading, error }] = useDeleteExtraCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExtraCostMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteExtraCostMutation, Types.DeleteExtraCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteExtraCostMutation, Types.DeleteExtraCostMutationVariables>(DeleteExtraCostDocument, options);
      }
export type DeleteExtraCostMutationHookResult = ReturnType<typeof useDeleteExtraCostMutation>;
export type DeleteExtraCostMutationResult = Apollo.MutationResult<Types.DeleteExtraCostMutation>;
export type DeleteExtraCostMutationOptions = Apollo.BaseMutationOptions<Types.DeleteExtraCostMutation, Types.DeleteExtraCostMutationVariables>;
export const UpdateExtraCostDocument = gql`
    mutation UpdateExtraCost($input: UpdateVoyageCharterExtraCostByIdInput!) {
  updateVoyageCharterExtraCostById(input: $input) {
    voyageCharterExtraCost {
      id
      ...SpotForm_ExtraCost
    }
  }
}
    ${SpotForm_ExtraCostFragmentDoc}`;
export type UpdateExtraCostMutationFn = Apollo.MutationFunction<Types.UpdateExtraCostMutation, Types.UpdateExtraCostMutationVariables>;

/**
 * __useUpdateExtraCostMutation__
 *
 * To run a mutation, you first call `useUpdateExtraCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtraCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtraCostMutation, { data, loading, error }] = useUpdateExtraCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExtraCostMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateExtraCostMutation, Types.UpdateExtraCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateExtraCostMutation, Types.UpdateExtraCostMutationVariables>(UpdateExtraCostDocument, options);
      }
export type UpdateExtraCostMutationHookResult = ReturnType<typeof useUpdateExtraCostMutation>;
export type UpdateExtraCostMutationResult = Apollo.MutationResult<Types.UpdateExtraCostMutation>;
export type UpdateExtraCostMutationOptions = Apollo.BaseMutationOptions<Types.UpdateExtraCostMutation, Types.UpdateExtraCostMutationVariables>;
export const CreateCommissionDocument = gql`
    mutation CreateCommission($input: CreateCommissionInput!) {
  createCommission(input: $input) {
    commission {
      id
      ...SpotForm_Commission
    }
  }
}
    ${SpotForm_CommissionFragmentDoc}`;
export type CreateCommissionMutationFn = Apollo.MutationFunction<Types.CreateCommissionMutation, Types.CreateCommissionMutationVariables>;

/**
 * __useCreateCommissionMutation__
 *
 * To run a mutation, you first call `useCreateCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommissionMutation, { data, loading, error }] = useCreateCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCommissionMutation, Types.CreateCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCommissionMutation, Types.CreateCommissionMutationVariables>(CreateCommissionDocument, options);
      }
export type CreateCommissionMutationHookResult = ReturnType<typeof useCreateCommissionMutation>;
export type CreateCommissionMutationResult = Apollo.MutationResult<Types.CreateCommissionMutation>;
export type CreateCommissionMutationOptions = Apollo.BaseMutationOptions<Types.CreateCommissionMutation, Types.CreateCommissionMutationVariables>;
export const UpdateCommissionDocument = gql`
    mutation UpdateCommission($input: UpdateCommissionByIdInput!) {
  updateCommissionById(input: $input) {
    commission {
      id
      ...SpotForm_Commission
    }
  }
}
    ${SpotForm_CommissionFragmentDoc}`;
export type UpdateCommissionMutationFn = Apollo.MutationFunction<Types.UpdateCommissionMutation, Types.UpdateCommissionMutationVariables>;

/**
 * __useUpdateCommissionMutation__
 *
 * To run a mutation, you first call `useUpdateCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommissionMutation, { data, loading, error }] = useUpdateCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCommissionMutation, Types.UpdateCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCommissionMutation, Types.UpdateCommissionMutationVariables>(UpdateCommissionDocument, options);
      }
export type UpdateCommissionMutationHookResult = ReturnType<typeof useUpdateCommissionMutation>;
export type UpdateCommissionMutationResult = Apollo.MutationResult<Types.UpdateCommissionMutation>;
export type UpdateCommissionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCommissionMutation, Types.UpdateCommissionMutationVariables>;
export const DeleteCommissionDocument = gql`
    mutation DeleteCommission($input: DeleteCommissionByIdInput!) {
  deleteCommissionById(input: $input) {
    commission {
      id
    }
  }
}
    `;
export type DeleteCommissionMutationFn = Apollo.MutationFunction<Types.DeleteCommissionMutation, Types.DeleteCommissionMutationVariables>;

/**
 * __useDeleteCommissionMutation__
 *
 * To run a mutation, you first call `useDeleteCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommissionMutation, { data, loading, error }] = useDeleteCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCommissionMutation, Types.DeleteCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCommissionMutation, Types.DeleteCommissionMutationVariables>(DeleteCommissionDocument, options);
      }
export type DeleteCommissionMutationHookResult = ReturnType<typeof useDeleteCommissionMutation>;
export type DeleteCommissionMutationResult = Apollo.MutationResult<Types.DeleteCommissionMutation>;
export type DeleteCommissionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCommissionMutation, Types.DeleteCommissionMutationVariables>;
export const UpdateFileDocument = gql`
    mutation UpdateFile($fileId: Int!, $patch: FilePatch!) {
  updateFileById(input: {id: $fileId, filePatch: $patch}) {
    file {
      id
      type
      note
    }
  }
}
    `;
export type UpdateFileMutationFn = Apollo.MutationFunction<Types.UpdateFileMutation, Types.UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFileMutation, Types.UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFileMutation, Types.UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<Types.UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFileMutation, Types.UpdateFileMutationVariables>;
export const UpdateHandledBySpotDocument = gql`
    mutation UpdateHandledBySpot($handledBySpotId: Int!, $patch: HandledBySpotPatch!) {
  updateHandledBySpotById(
    input: {id: $handledBySpotId, handledBySpotPatch: $patch}
  ) {
    handledBySpot {
      id
      ...ScenarioTimeline_HandledBySpot
    }
  }
}
    ${ScenarioTimeline_HandledBySpotFragmentDoc}`;
export type UpdateHandledBySpotMutationFn = Apollo.MutationFunction<Types.UpdateHandledBySpotMutation, Types.UpdateHandledBySpotMutationVariables>;

/**
 * __useUpdateHandledBySpotMutation__
 *
 * To run a mutation, you first call `useUpdateHandledBySpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHandledBySpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHandledBySpotMutation, { data, loading, error }] = useUpdateHandledBySpotMutation({
 *   variables: {
 *      handledBySpotId: // value for 'handledBySpotId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateHandledBySpotMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateHandledBySpotMutation, Types.UpdateHandledBySpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateHandledBySpotMutation, Types.UpdateHandledBySpotMutationVariables>(UpdateHandledBySpotDocument, options);
      }
export type UpdateHandledBySpotMutationHookResult = ReturnType<typeof useUpdateHandledBySpotMutation>;
export type UpdateHandledBySpotMutationResult = Apollo.MutationResult<Types.UpdateHandledBySpotMutation>;
export type UpdateHandledBySpotMutationOptions = Apollo.BaseMutationOptions<Types.UpdateHandledBySpotMutation, Types.UpdateHandledBySpotMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderByIdInput!) {
  updateOrderById(input: $input) {
    order {
      id
      shipmentId
      cargoAmount
      cargoUnitByCargoUnitId {
        id
        name
      }
      marginAmount
      marginUnit
      assortmentByAssortmentId {
        id
        name
      }
      locationByLoadPortId {
        id
        name
      }
      locationByDischargePortId {
        id
        name
      }
      orderRequirementAssociationsByOrderId {
        nodes {
          id
          orderId
          specialRequirementId
        }
      }
      orderAttributeAssociationsByOrderId {
        nodes {
          id
          orderId
          orderAttributeId
        }
      }
    }
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<Types.UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>;
export const UpdateOrderDetailDocument = gql`
    mutation UpdateOrderDetail($input: UpdateOrderDetailByIdInput!) {
  updateOrderDetailById(input: $input) {
    orderDetail {
      id
      closingDate
      senderOrganisationId
      receiverOrganisationId
      consignee
      extraInfo
    }
  }
}
    `;
export type UpdateOrderDetailMutationFn = Apollo.MutationFunction<Types.UpdateOrderDetailMutation, Types.UpdateOrderDetailMutationVariables>;

/**
 * __useUpdateOrderDetailMutation__
 *
 * To run a mutation, you first call `useUpdateOrderDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderDetailMutation, { data, loading, error }] = useUpdateOrderDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderDetailMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderDetailMutation, Types.UpdateOrderDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderDetailMutation, Types.UpdateOrderDetailMutationVariables>(UpdateOrderDetailDocument, options);
      }
export type UpdateOrderDetailMutationHookResult = ReturnType<typeof useUpdateOrderDetailMutation>;
export type UpdateOrderDetailMutationResult = Apollo.MutationResult<Types.UpdateOrderDetailMutation>;
export type UpdateOrderDetailMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderDetailMutation, Types.UpdateOrderDetailMutationVariables>;
export const UpdateCargoExclusionDocument = gql`
    mutation UpdateCargoExclusion($input: UpdateCargoExclusionByIdInput!) {
  updateCargoExclusionById(input: $input) {
    cargoExclusion {
      id
    }
  }
}
    `;
export type UpdateCargoExclusionMutationFn = Apollo.MutationFunction<Types.UpdateCargoExclusionMutation, Types.UpdateCargoExclusionMutationVariables>;

/**
 * __useUpdateCargoExclusionMutation__
 *
 * To run a mutation, you first call `useUpdateCargoExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCargoExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCargoExclusionMutation, { data, loading, error }] = useUpdateCargoExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCargoExclusionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCargoExclusionMutation, Types.UpdateCargoExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCargoExclusionMutation, Types.UpdateCargoExclusionMutationVariables>(UpdateCargoExclusionDocument, options);
      }
export type UpdateCargoExclusionMutationHookResult = ReturnType<typeof useUpdateCargoExclusionMutation>;
export type UpdateCargoExclusionMutationResult = Apollo.MutationResult<Types.UpdateCargoExclusionMutation>;
export type UpdateCargoExclusionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCargoExclusionMutation, Types.UpdateCargoExclusionMutationVariables>;
export const DeleteCargoExclusionByIdDocument = gql`
    mutation DeleteCargoExclusionById($input: DeleteCargoExclusionByIdInput!) {
  deleteCargoExclusionById(input: $input) {
    cargoExclusion {
      id
    }
  }
}
    `;
export type DeleteCargoExclusionByIdMutationFn = Apollo.MutationFunction<Types.DeleteCargoExclusionByIdMutation, Types.DeleteCargoExclusionByIdMutationVariables>;

/**
 * __useDeleteCargoExclusionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCargoExclusionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCargoExclusionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCargoExclusionByIdMutation, { data, loading, error }] = useDeleteCargoExclusionByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCargoExclusionByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCargoExclusionByIdMutation, Types.DeleteCargoExclusionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCargoExclusionByIdMutation, Types.DeleteCargoExclusionByIdMutationVariables>(DeleteCargoExclusionByIdDocument, options);
      }
export type DeleteCargoExclusionByIdMutationHookResult = ReturnType<typeof useDeleteCargoExclusionByIdMutation>;
export type DeleteCargoExclusionByIdMutationResult = Apollo.MutationResult<Types.DeleteCargoExclusionByIdMutation>;
export type DeleteCargoExclusionByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCargoExclusionByIdMutation, Types.DeleteCargoExclusionByIdMutationVariables>;
export const DeleteOrderRequirementAssociationDocument = gql`
    mutation DeleteOrderRequirementAssociation($input: DeleteOrderRequirementAssociationByIdInput!) {
  deleteOrderRequirementAssociationById(input: $input) {
    orderRequirementAssociation {
      id
    }
  }
}
    `;
export type DeleteOrderRequirementAssociationMutationFn = Apollo.MutationFunction<Types.DeleteOrderRequirementAssociationMutation, Types.DeleteOrderRequirementAssociationMutationVariables>;

/**
 * __useDeleteOrderRequirementAssociationMutation__
 *
 * To run a mutation, you first call `useDeleteOrderRequirementAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderRequirementAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderRequirementAssociationMutation, { data, loading, error }] = useDeleteOrderRequirementAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderRequirementAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderRequirementAssociationMutation, Types.DeleteOrderRequirementAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderRequirementAssociationMutation, Types.DeleteOrderRequirementAssociationMutationVariables>(DeleteOrderRequirementAssociationDocument, options);
      }
export type DeleteOrderRequirementAssociationMutationHookResult = ReturnType<typeof useDeleteOrderRequirementAssociationMutation>;
export type DeleteOrderRequirementAssociationMutationResult = Apollo.MutationResult<Types.DeleteOrderRequirementAssociationMutation>;
export type DeleteOrderRequirementAssociationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderRequirementAssociationMutation, Types.DeleteOrderRequirementAssociationMutationVariables>;
export const DeleteOrderAttributeAssociationDocument = gql`
    mutation DeleteOrderAttributeAssociation($input: DeleteOrderAttributeAssociationByIdInput!) {
  deleteOrderAttributeAssociationById(input: $input) {
    orderAttributeAssociation {
      id
      ...OrderForm_OrderAttributeAssociation
    }
  }
}
    ${OrderForm_OrderAttributeAssociationFragmentDoc}`;
export type DeleteOrderAttributeAssociationMutationFn = Apollo.MutationFunction<Types.DeleteOrderAttributeAssociationMutation, Types.DeleteOrderAttributeAssociationMutationVariables>;

/**
 * __useDeleteOrderAttributeAssociationMutation__
 *
 * To run a mutation, you first call `useDeleteOrderAttributeAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderAttributeAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderAttributeAssociationMutation, { data, loading, error }] = useDeleteOrderAttributeAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderAttributeAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderAttributeAssociationMutation, Types.DeleteOrderAttributeAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderAttributeAssociationMutation, Types.DeleteOrderAttributeAssociationMutationVariables>(DeleteOrderAttributeAssociationDocument, options);
      }
export type DeleteOrderAttributeAssociationMutationHookResult = ReturnType<typeof useDeleteOrderAttributeAssociationMutation>;
export type DeleteOrderAttributeAssociationMutationResult = Apollo.MutationResult<Types.DeleteOrderAttributeAssociationMutation>;
export type DeleteOrderAttributeAssociationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderAttributeAssociationMutation, Types.DeleteOrderAttributeAssociationMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($input: DeleteOrderByIdInput!) {
  deleteOrderById(input: $input) {
    order {
      id
    }
  }
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<Types.DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>;
export const UpdateScheduledOrderDocument = gql`
    mutation UpdateScheduledOrder($scheduledOrderId: Int!, $patch: ScheduledOrderPatch!) {
  updateScheduledOrderById(
    input: {id: $scheduledOrderId, scheduledOrderPatch: $patch}
  ) {
    scheduledOrder {
      id
      ...ScheduledOrder
    }
  }
}
    ${ScheduledOrderFragmentDoc}`;
export type UpdateScheduledOrderMutationFn = Apollo.MutationFunction<Types.UpdateScheduledOrderMutation, Types.UpdateScheduledOrderMutationVariables>;

/**
 * __useUpdateScheduledOrderMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledOrderMutation, { data, loading, error }] = useUpdateScheduledOrderMutation({
 *   variables: {
 *      scheduledOrderId: // value for 'scheduledOrderId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateScheduledOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateScheduledOrderMutation, Types.UpdateScheduledOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateScheduledOrderMutation, Types.UpdateScheduledOrderMutationVariables>(UpdateScheduledOrderDocument, options);
      }
export type UpdateScheduledOrderMutationHookResult = ReturnType<typeof useUpdateScheduledOrderMutation>;
export type UpdateScheduledOrderMutationResult = Apollo.MutationResult<Types.UpdateScheduledOrderMutation>;
export type UpdateScheduledOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateScheduledOrderMutation, Types.UpdateScheduledOrderMutationVariables>;
export const UpdateShipmentDocument = gql`
    mutation UpdateShipment($shipmentId: Int!, $patch: ShipmentPatch!) {
  updateShipmentById(input: {id: $shipmentId, shipmentPatch: $patch}) {
    shipment {
      id
      ...ScenarioTimeline_Shipment
    }
  }
}
    ${ScenarioTimeline_ShipmentFragmentDoc}`;
export type UpdateShipmentMutationFn = Apollo.MutationFunction<Types.UpdateShipmentMutation, Types.UpdateShipmentMutationVariables>;

/**
 * __useUpdateShipmentMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentMutation, { data, loading, error }] = useUpdateShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipmentMutation, Types.UpdateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipmentMutation, Types.UpdateShipmentMutationVariables>(UpdateShipmentDocument, options);
      }
export type UpdateShipmentMutationHookResult = ReturnType<typeof useUpdateShipmentMutation>;
export type UpdateShipmentMutationResult = Apollo.MutationResult<Types.UpdateShipmentMutation>;
export type UpdateShipmentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipmentMutation, Types.UpdateShipmentMutationVariables>;
export const ApiShipmentStatusDocument = gql`
    mutation ApiShipmentStatus($input: CreateApiShipmentStatusInput!) {
  createApiShipmentStatus(input: $input) {
    apiShipmentStatus {
      shipmentId
      externalShipmentId
      sourceId
      status
      isAccepted
      shipmentStatusId
    }
  }
}
    `;
export type ApiShipmentStatusMutationFn = Apollo.MutationFunction<Types.ApiShipmentStatusMutation, Types.ApiShipmentStatusMutationVariables>;

/**
 * __useApiShipmentStatusMutation__
 *
 * To run a mutation, you first call `useApiShipmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiShipmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiShipmentStatusMutation, { data, loading, error }] = useApiShipmentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiShipmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.ApiShipmentStatusMutation, Types.ApiShipmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ApiShipmentStatusMutation, Types.ApiShipmentStatusMutationVariables>(ApiShipmentStatusDocument, options);
      }
export type ApiShipmentStatusMutationHookResult = ReturnType<typeof useApiShipmentStatusMutation>;
export type ApiShipmentStatusMutationResult = Apollo.MutationResult<Types.ApiShipmentStatusMutation>;
export type ApiShipmentStatusMutationOptions = Apollo.BaseMutationOptions<Types.ApiShipmentStatusMutation, Types.ApiShipmentStatusMutationVariables>;
export const UpdateSingleEventDocument = gql`
    mutation UpdateSingleEvent($singleEventId: Int!, $patch: SingleEventPatch!) {
  updateSingleEventById(input: {id: $singleEventId, singleEventPatch: $patch}) {
    singleEvent {
      id
      duration
      end
      locationId
      locationByLocationId {
        id
        name
        locode
      }
      locked
      meta
      shared
      start
      vesselId
      type
      startOverride
      ...ScenarioTimeline_SingleEvent
    }
  }
}
    ${ScenarioTimeline_SingleEventFragmentDoc}`;
export type UpdateSingleEventMutationFn = Apollo.MutationFunction<Types.UpdateSingleEventMutation, Types.UpdateSingleEventMutationVariables>;

/**
 * __useUpdateSingleEventMutation__
 *
 * To run a mutation, you first call `useUpdateSingleEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleEventMutation, { data, loading, error }] = useUpdateSingleEventMutation({
 *   variables: {
 *      singleEventId: // value for 'singleEventId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateSingleEventMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSingleEventMutation, Types.UpdateSingleEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSingleEventMutation, Types.UpdateSingleEventMutationVariables>(UpdateSingleEventDocument, options);
      }
export type UpdateSingleEventMutationHookResult = ReturnType<typeof useUpdateSingleEventMutation>;
export type UpdateSingleEventMutationResult = Apollo.MutationResult<Types.UpdateSingleEventMutation>;
export type UpdateSingleEventMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSingleEventMutation, Types.UpdateSingleEventMutationVariables>;
export const UpdatePlanningPageVesselInfoDocument = gql`
    mutation UpdatePlanningPageVesselInfo($id: Int!, $vessel: ShipPatch!) {
  updateShipById(input: {id: $id, shipPatch: $vessel}) {
    ship {
      id
      ...ScenarioTimeline_Ship
    }
  }
}
    ${ScenarioTimeline_ShipFragmentDoc}`;
export type UpdatePlanningPageVesselInfoMutationFn = Apollo.MutationFunction<Types.UpdatePlanningPageVesselInfoMutation, Types.UpdatePlanningPageVesselInfoMutationVariables>;

/**
 * __useUpdatePlanningPageVesselInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePlanningPageVesselInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanningPageVesselInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanningPageVesselInfoMutation, { data, loading, error }] = useUpdatePlanningPageVesselInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vessel: // value for 'vessel'
 *   },
 * });
 */
export function useUpdatePlanningPageVesselInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePlanningPageVesselInfoMutation, Types.UpdatePlanningPageVesselInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePlanningPageVesselInfoMutation, Types.UpdatePlanningPageVesselInfoMutationVariables>(UpdatePlanningPageVesselInfoDocument, options);
      }
export type UpdatePlanningPageVesselInfoMutationHookResult = ReturnType<typeof useUpdatePlanningPageVesselInfoMutation>;
export type UpdatePlanningPageVesselInfoMutationResult = Apollo.MutationResult<Types.UpdatePlanningPageVesselInfoMutation>;
export type UpdatePlanningPageVesselInfoMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePlanningPageVesselInfoMutation, Types.UpdatePlanningPageVesselInfoMutationVariables>;
export const CreateVaAssociationDocument = gql`
    mutation CreateVAAssociation($input: CreateVesselAttributesAssociationInput!) {
  createVesselAttributesAssociation(input: $input) {
    shipByShipId {
      id
      ...ScenarioTimeline_Ship
    }
  }
}
    ${ScenarioTimeline_ShipFragmentDoc}`;
export type CreateVaAssociationMutationFn = Apollo.MutationFunction<Types.CreateVaAssociationMutation, Types.CreateVaAssociationMutationVariables>;

/**
 * __useCreateVaAssociationMutation__
 *
 * To run a mutation, you first call `useCreateVaAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVaAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVaAssociationMutation, { data, loading, error }] = useCreateVaAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVaAssociationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVaAssociationMutation, Types.CreateVaAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVaAssociationMutation, Types.CreateVaAssociationMutationVariables>(CreateVaAssociationDocument, options);
      }
export type CreateVaAssociationMutationHookResult = ReturnType<typeof useCreateVaAssociationMutation>;
export type CreateVaAssociationMutationResult = Apollo.MutationResult<Types.CreateVaAssociationMutation>;
export type CreateVaAssociationMutationOptions = Apollo.BaseMutationOptions<Types.CreateVaAssociationMutation, Types.CreateVaAssociationMutationVariables>;
export const DeleteVaaByIdDocument = gql`
    mutation DeleteVAAById($associationId: Int!) {
  deleteVesselAttributesAssociationById(input: {id: $associationId}) {
    shipByShipId {
      id
      ...ScenarioTimeline_Ship
    }
  }
}
    ${ScenarioTimeline_ShipFragmentDoc}`;
export type DeleteVaaByIdMutationFn = Apollo.MutationFunction<Types.DeleteVaaByIdMutation, Types.DeleteVaaByIdMutationVariables>;

/**
 * __useDeleteVaaByIdMutation__
 *
 * To run a mutation, you first call `useDeleteVaaByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVaaByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVaaByIdMutation, { data, loading, error }] = useDeleteVaaByIdMutation({
 *   variables: {
 *      associationId: // value for 'associationId'
 *   },
 * });
 */
export function useDeleteVaaByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVaaByIdMutation, Types.DeleteVaaByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVaaByIdMutation, Types.DeleteVaaByIdMutationVariables>(DeleteVaaByIdDocument, options);
      }
export type DeleteVaaByIdMutationHookResult = ReturnType<typeof useDeleteVaaByIdMutation>;
export type DeleteVaaByIdMutationResult = Apollo.MutationResult<Types.DeleteVaaByIdMutation>;
export type DeleteVaaByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVaaByIdMutation, Types.DeleteVaaByIdMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($input: UpdateUserSettingByIdInput!) {
  updateUserSettingById(input: $input) {
    userSetting {
      id
      userId
      ...NotificationSettings
    }
  }
}
    ${NotificationSettingsFragmentDoc}`;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<Types.UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>;
export const VcAndOrdersDocument = gql`
    mutation vcAndOrders($deleteCargoExclusions: [Int!], $deleteOrderRequirementAssociations: [Int!], $deleteOrderAttributeAssociations: [Int!], $deleteCommissions: [Int!], $deleteVoyageCharterExtraFreights: [Int!], $deleteVoyageCharterExtraCosts: [Int!], $deleteOrderVoyageCharterRelations: [Int!], $deleteVoyageCharterOrderFreights: [Int!], $deleteVoyageCharterToContracts: [Int!], $deleteVoyageCharterPortData: [Int!], $deleteVoyageCharters: [Int!], $deletePortData: [Int!], $createOrders: [OrderInput!], $createOrderDetails: [CommitOrderDetailInput!], $createCargoExclusions: [CommitCargoExclusionInput!], $createOrderRequirementAssociations: [CommitOrderRequirementAssociationInput!], $createOrderAttributeAssociations: [CommitOrderAttributeAssociationInput!], $createPortData: [PortDatumInput!], $createVoyageCharters: [VoyageCharterInput!], $createVoyageCharterPortData: [CommitVcVoyageCharterPortDatumInput!], $createVoyageCharterToContracts: [CommitVoyageCharterToContractInput!], $createOrderVoyageCharterRelations: [CommitVcOrderVoyageCharterRelationInput!], $createVoyageCharterOrderFreights: [CommitVoyageCharterOrderFreightInput!], $createVoyageCharterExtraFreights: [CommitVoyageCharterExtraFreightInput!], $createVoyageCharterExtraCosts: [CommitVoyageCharterExtraCostInput!], $createCommissions: [CommitCommissionInput!], $mapLocations: [IdRemappingInput!], $mapAssortments: [IdRemappingInput!], $updateOrders: [UpdateOrderByIdInput!], $updateOrderDetails: [UpdateOrderDetailByIdInput!], $updatePortData: [UpdatePortDatumByIdInput!], $updateVoyageCharters: [UpdateVoyageCharterByIdInput!], $updateVoyageCharterPortData: [UpdateVoyageCharterPortDatumByIdInput!], $updateVoyageCharterToContracts: [UpdateVoyageCharterToContractByIdInput!], $updateOrderVoyageCharterRelations: [UpdateOrderVoyageCharterRelationByIdInput!], $updateVoyageCharterOrderFreights: [UpdateVoyageCharterOrderFreightByIdInput!], $updateVoyageCharterExtraFreights: [UpdateVoyageCharterExtraFreightByIdInput!], $updateVoyageCharterExtraCosts: [UpdateVoyageCharterExtraCostByIdInput!], $updateCommissions: [UpdateCommissionByIdInput!]) {
  vcAndOrders(
    input: {deleteCargoExclusions: $deleteCargoExclusions, deleteOrderRequirementAssociations: $deleteOrderRequirementAssociations, deleteOrderAttributeAssociations: $deleteOrderAttributeAssociations, deleteCommissions: $deleteCommissions, deleteVoyageCharterExtraFreights: $deleteVoyageCharterExtraFreights, deleteVoyageCharterExtraCosts: $deleteVoyageCharterExtraCosts, deleteOrderVoyageCharterRelations: $deleteOrderVoyageCharterRelations, deleteVoyageCharterOrderFreights: $deleteVoyageCharterOrderFreights, deleteVoyageCharterToContracts: $deleteVoyageCharterToContracts, deleteVoyageCharterPortData: $deleteVoyageCharterPortData, deleteVoyageCharters: $deleteVoyageCharters, deletePortData: $deletePortData, createOrders: $createOrders, createOrderDetails: $createOrderDetails, createCargoExclusions: $createCargoExclusions, createOrderRequirementAssociations: $createOrderRequirementAssociations, createOrderAttributeAssociations: $createOrderAttributeAssociations, createPortData: $createPortData, createVoyageCharters: $createVoyageCharters, createVoyageCharterPortData: $createVoyageCharterPortData, createVoyageCharterToContracts: $createVoyageCharterToContracts, createOrderVoyageCharterRelations: $createOrderVoyageCharterRelations, createVoyageCharterOrderFreights: $createVoyageCharterOrderFreights, createVoyageCharterExtraFreights: $createVoyageCharterExtraFreights, createVoyageCharterExtraCosts: $createVoyageCharterExtraCosts, createCommissions: $createCommissions, mapLocations: $mapLocations, mapAssortments: $mapAssortments, updateOrders: $updateOrders, updateOrderDetails: $updateOrderDetails, updatePortData: $updatePortData, updateVoyageCharters: $updateVoyageCharters, updateVoyageCharterPortData: $updateVoyageCharterPortData, updateVoyageCharterToContracts: $updateVoyageCharterToContracts, updateOrderVoyageCharterRelations: $updateOrderVoyageCharterRelations, updateVoyageCharterOrderFreights: $updateVoyageCharterOrderFreights, updateVoyageCharterExtraFreights: $updateVoyageCharterExtraFreights, updateVoyageCharterExtraCosts: $updateVoyageCharterExtraCosts, updateCommissions: $updateCommissions}
  ) {
    createdOrders {
      id
      ...ScenarioTimeline_Order
    }
    createdVoyageCharters {
      id
    }
    updatedOrders {
      id
      ...ScenarioTimeline_Order
    }
    updatedOrderDetails {
      id
      ...ScenarioTimeline_Order_Details
    }
    updatedPortData {
      id
      ...ScenarioTimeline_PortDatum
    }
    updatedVoyageCharters {
      id
      ...ScenarioTimeline_VoyageCharter
      ...VoyageIncome_VoyageCharter
    }
    updatedVoyageCharterPortData {
      id
    }
    updatedVoyageCharterToContracts {
      id
      ...ScenarioTimeline_VoyageCharterToContract
      ...VoyageIncome_VoyageCharterToContract
    }
    updatedOrderVoyageCharterRelations {
      id
      ...ScenarioTimeline_OrderVoyageCharterRelation
      ...VoyageIncome_OrderVoyageCharterRelation
    }
    updatedVoyageCharterOrderFreights {
      id
      ...VoyageIncome_VoyageCharterOrderFreight
    }
    updatedVoyageCharterExtraFreights {
      id
      ...VoyageIncome_VoyageCharterExtraFreight
    }
    updatedVoyageCharterExtraCosts {
      id
    }
    updatedCommissions {
      id
    }
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}
${ScenarioTimeline_Order_DetailsFragmentDoc}
${ScenarioTimeline_PortDatumFragmentDoc}
${ScenarioTimeline_VoyageCharterFragmentDoc}
${VoyageIncome_VoyageCharterFragmentDoc}
${ScenarioTimeline_VoyageCharterToContractFragmentDoc}
${VoyageIncome_VoyageCharterToContractFragmentDoc}
${ScenarioTimeline_OrderVoyageCharterRelationFragmentDoc}
${VoyageIncome_OrderVoyageCharterRelationFragmentDoc}
${VoyageIncome_VoyageCharterOrderFreightFragmentDoc}
${VoyageIncome_VoyageCharterExtraFreightFragmentDoc}`;
export type VcAndOrdersMutationFn = Apollo.MutationFunction<Types.VcAndOrdersMutation, Types.VcAndOrdersMutationVariables>;

/**
 * __useVcAndOrdersMutation__
 *
 * To run a mutation, you first call `useVcAndOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVcAndOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vcAndOrdersMutation, { data, loading, error }] = useVcAndOrdersMutation({
 *   variables: {
 *      deleteCargoExclusions: // value for 'deleteCargoExclusions'
 *      deleteOrderRequirementAssociations: // value for 'deleteOrderRequirementAssociations'
 *      deleteOrderAttributeAssociations: // value for 'deleteOrderAttributeAssociations'
 *      deleteCommissions: // value for 'deleteCommissions'
 *      deleteVoyageCharterExtraFreights: // value for 'deleteVoyageCharterExtraFreights'
 *      deleteVoyageCharterExtraCosts: // value for 'deleteVoyageCharterExtraCosts'
 *      deleteOrderVoyageCharterRelations: // value for 'deleteOrderVoyageCharterRelations'
 *      deleteVoyageCharterOrderFreights: // value for 'deleteVoyageCharterOrderFreights'
 *      deleteVoyageCharterToContracts: // value for 'deleteVoyageCharterToContracts'
 *      deleteVoyageCharterPortData: // value for 'deleteVoyageCharterPortData'
 *      deleteVoyageCharters: // value for 'deleteVoyageCharters'
 *      deletePortData: // value for 'deletePortData'
 *      createOrders: // value for 'createOrders'
 *      createOrderDetails: // value for 'createOrderDetails'
 *      createCargoExclusions: // value for 'createCargoExclusions'
 *      createOrderRequirementAssociations: // value for 'createOrderRequirementAssociations'
 *      createOrderAttributeAssociations: // value for 'createOrderAttributeAssociations'
 *      createPortData: // value for 'createPortData'
 *      createVoyageCharters: // value for 'createVoyageCharters'
 *      createVoyageCharterPortData: // value for 'createVoyageCharterPortData'
 *      createVoyageCharterToContracts: // value for 'createVoyageCharterToContracts'
 *      createOrderVoyageCharterRelations: // value for 'createOrderVoyageCharterRelations'
 *      createVoyageCharterOrderFreights: // value for 'createVoyageCharterOrderFreights'
 *      createVoyageCharterExtraFreights: // value for 'createVoyageCharterExtraFreights'
 *      createVoyageCharterExtraCosts: // value for 'createVoyageCharterExtraCosts'
 *      createCommissions: // value for 'createCommissions'
 *      mapLocations: // value for 'mapLocations'
 *      mapAssortments: // value for 'mapAssortments'
 *      updateOrders: // value for 'updateOrders'
 *      updateOrderDetails: // value for 'updateOrderDetails'
 *      updatePortData: // value for 'updatePortData'
 *      updateVoyageCharters: // value for 'updateVoyageCharters'
 *      updateVoyageCharterPortData: // value for 'updateVoyageCharterPortData'
 *      updateVoyageCharterToContracts: // value for 'updateVoyageCharterToContracts'
 *      updateOrderVoyageCharterRelations: // value for 'updateOrderVoyageCharterRelations'
 *      updateVoyageCharterOrderFreights: // value for 'updateVoyageCharterOrderFreights'
 *      updateVoyageCharterExtraFreights: // value for 'updateVoyageCharterExtraFreights'
 *      updateVoyageCharterExtraCosts: // value for 'updateVoyageCharterExtraCosts'
 *      updateCommissions: // value for 'updateCommissions'
 *   },
 * });
 */
export function useVcAndOrdersMutation(baseOptions?: Apollo.MutationHookOptions<Types.VcAndOrdersMutation, Types.VcAndOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VcAndOrdersMutation, Types.VcAndOrdersMutationVariables>(VcAndOrdersDocument, options);
      }
export type VcAndOrdersMutationHookResult = ReturnType<typeof useVcAndOrdersMutation>;
export type VcAndOrdersMutationResult = Apollo.MutationResult<Types.VcAndOrdersMutation>;
export type VcAndOrdersMutationOptions = Apollo.BaseMutationOptions<Types.VcAndOrdersMutation, Types.VcAndOrdersMutationVariables>;
export const CreateVoyageCharterDocument = gql`
    mutation CreateVoyageCharter($input: CreateVoyageCharterInput!) {
  createVoyageCharter(input: $input) {
    voyageCharter {
      id
    }
  }
}
    `;
export type CreateVoyageCharterMutationFn = Apollo.MutationFunction<Types.CreateVoyageCharterMutation, Types.CreateVoyageCharterMutationVariables>;

/**
 * __useCreateVoyageCharterMutation__
 *
 * To run a mutation, you first call `useCreateVoyageCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoyageCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoyageCharterMutation, { data, loading, error }] = useCreateVoyageCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoyageCharterMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVoyageCharterMutation, Types.CreateVoyageCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVoyageCharterMutation, Types.CreateVoyageCharterMutationVariables>(CreateVoyageCharterDocument, options);
      }
export type CreateVoyageCharterMutationHookResult = ReturnType<typeof useCreateVoyageCharterMutation>;
export type CreateVoyageCharterMutationResult = Apollo.MutationResult<Types.CreateVoyageCharterMutation>;
export type CreateVoyageCharterMutationOptions = Apollo.BaseMutationOptions<Types.CreateVoyageCharterMutation, Types.CreateVoyageCharterMutationVariables>;
export const DeleteVoyageCharterDocument = gql`
    mutation DeleteVoyageCharter($input: DeleteVoyageCharterByIdInput!) {
  deleteVoyageCharterById(input: $input) {
    voyageCharter {
      id
    }
  }
}
    `;
export type DeleteVoyageCharterMutationFn = Apollo.MutationFunction<Types.DeleteVoyageCharterMutation, Types.DeleteVoyageCharterMutationVariables>;

/**
 * __useDeleteVoyageCharterMutation__
 *
 * To run a mutation, you first call `useDeleteVoyageCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoyageCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoyageCharterMutation, { data, loading, error }] = useDeleteVoyageCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVoyageCharterMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVoyageCharterMutation, Types.DeleteVoyageCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVoyageCharterMutation, Types.DeleteVoyageCharterMutationVariables>(DeleteVoyageCharterDocument, options);
      }
export type DeleteVoyageCharterMutationHookResult = ReturnType<typeof useDeleteVoyageCharterMutation>;
export type DeleteVoyageCharterMutationResult = Apollo.MutationResult<Types.DeleteVoyageCharterMutation>;
export type DeleteVoyageCharterMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVoyageCharterMutation, Types.DeleteVoyageCharterMutationVariables>;
export const CreateOrderVoyageCharterRelationDocument = gql`
    mutation CreateOrderVoyageCharterRelation($input: CreateOrderVoyageCharterRelationInput!) {
  createOrderVoyageCharterRelation(input: $input) {
    orderVoyageCharterRelation {
      id
      orderId
      voyageCharterId
      outgoing
      coaRouteId
    }
  }
}
    `;
export type CreateOrderVoyageCharterRelationMutationFn = Apollo.MutationFunction<Types.CreateOrderVoyageCharterRelationMutation, Types.CreateOrderVoyageCharterRelationMutationVariables>;

/**
 * __useCreateOrderVoyageCharterRelationMutation__
 *
 * To run a mutation, you first call `useCreateOrderVoyageCharterRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderVoyageCharterRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderVoyageCharterRelationMutation, { data, loading, error }] = useCreateOrderVoyageCharterRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderVoyageCharterRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderVoyageCharterRelationMutation, Types.CreateOrderVoyageCharterRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderVoyageCharterRelationMutation, Types.CreateOrderVoyageCharterRelationMutationVariables>(CreateOrderVoyageCharterRelationDocument, options);
      }
export type CreateOrderVoyageCharterRelationMutationHookResult = ReturnType<typeof useCreateOrderVoyageCharterRelationMutation>;
export type CreateOrderVoyageCharterRelationMutationResult = Apollo.MutationResult<Types.CreateOrderVoyageCharterRelationMutation>;
export type CreateOrderVoyageCharterRelationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderVoyageCharterRelationMutation, Types.CreateOrderVoyageCharterRelationMutationVariables>;
export const UpdateOrderVoyageCharterRelationDocument = gql`
    mutation UpdateOrderVoyageCharterRelation($input: UpdateOrderVoyageCharterRelationByIdInput!) {
  updateOrderVoyageCharterRelationById(input: $input) {
    orderVoyageCharterRelation {
      id
      orderId
      voyageCharterId
      outgoing
      coaRouteId
    }
  }
}
    `;
export type UpdateOrderVoyageCharterRelationMutationFn = Apollo.MutationFunction<Types.UpdateOrderVoyageCharterRelationMutation, Types.UpdateOrderVoyageCharterRelationMutationVariables>;

/**
 * __useUpdateOrderVoyageCharterRelationMutation__
 *
 * To run a mutation, you first call `useUpdateOrderVoyageCharterRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderVoyageCharterRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderVoyageCharterRelationMutation, { data, loading, error }] = useUpdateOrderVoyageCharterRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderVoyageCharterRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderVoyageCharterRelationMutation, Types.UpdateOrderVoyageCharterRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderVoyageCharterRelationMutation, Types.UpdateOrderVoyageCharterRelationMutationVariables>(UpdateOrderVoyageCharterRelationDocument, options);
      }
export type UpdateOrderVoyageCharterRelationMutationHookResult = ReturnType<typeof useUpdateOrderVoyageCharterRelationMutation>;
export type UpdateOrderVoyageCharterRelationMutationResult = Apollo.MutationResult<Types.UpdateOrderVoyageCharterRelationMutation>;
export type UpdateOrderVoyageCharterRelationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderVoyageCharterRelationMutation, Types.UpdateOrderVoyageCharterRelationMutationVariables>;
export const DeleteOrderVoyageCharterRelationDocument = gql`
    mutation DeleteOrderVoyageCharterRelation($input: DeleteOrderVoyageCharterRelationByIdInput!) {
  deleteOrderVoyageCharterRelationById(input: $input) {
    orderVoyageCharterRelation {
      id
      orderId
      voyageCharterId
      outgoing
      coaRouteId
    }
  }
}
    `;
export type DeleteOrderVoyageCharterRelationMutationFn = Apollo.MutationFunction<Types.DeleteOrderVoyageCharterRelationMutation, Types.DeleteOrderVoyageCharterRelationMutationVariables>;

/**
 * __useDeleteOrderVoyageCharterRelationMutation__
 *
 * To run a mutation, you first call `useDeleteOrderVoyageCharterRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderVoyageCharterRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderVoyageCharterRelationMutation, { data, loading, error }] = useDeleteOrderVoyageCharterRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderVoyageCharterRelationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderVoyageCharterRelationMutation, Types.DeleteOrderVoyageCharterRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderVoyageCharterRelationMutation, Types.DeleteOrderVoyageCharterRelationMutationVariables>(DeleteOrderVoyageCharterRelationDocument, options);
      }
export type DeleteOrderVoyageCharterRelationMutationHookResult = ReturnType<typeof useDeleteOrderVoyageCharterRelationMutation>;
export type DeleteOrderVoyageCharterRelationMutationResult = Apollo.MutationResult<Types.DeleteOrderVoyageCharterRelationMutation>;
export type DeleteOrderVoyageCharterRelationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderVoyageCharterRelationMutation, Types.DeleteOrderVoyageCharterRelationMutationVariables>;
export const UpdateVoyageCharterOnSubsDocument = gql`
    mutation UpdateVoyageCharterOnSubs($voyageCharterId: Int!, $onSubsUntil: Datetime) {
  updateVoyageCharterById(
    input: {id: $voyageCharterId, voyageCharterPatch: {onSubsUntil: $onSubsUntil}}
  ) {
    voyageCharter {
      id
      onSubsUntil
    }
  }
}
    `;
export type UpdateVoyageCharterOnSubsMutationFn = Apollo.MutationFunction<Types.UpdateVoyageCharterOnSubsMutation, Types.UpdateVoyageCharterOnSubsMutationVariables>;

/**
 * __useUpdateVoyageCharterOnSubsMutation__
 *
 * To run a mutation, you first call `useUpdateVoyageCharterOnSubsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoyageCharterOnSubsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoyageCharterOnSubsMutation, { data, loading, error }] = useUpdateVoyageCharterOnSubsMutation({
 *   variables: {
 *      voyageCharterId: // value for 'voyageCharterId'
 *      onSubsUntil: // value for 'onSubsUntil'
 *   },
 * });
 */
export function useUpdateVoyageCharterOnSubsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVoyageCharterOnSubsMutation, Types.UpdateVoyageCharterOnSubsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVoyageCharterOnSubsMutation, Types.UpdateVoyageCharterOnSubsMutationVariables>(UpdateVoyageCharterOnSubsDocument, options);
      }
export type UpdateVoyageCharterOnSubsMutationHookResult = ReturnType<typeof useUpdateVoyageCharterOnSubsMutation>;
export type UpdateVoyageCharterOnSubsMutationResult = Apollo.MutationResult<Types.UpdateVoyageCharterOnSubsMutation>;
export type UpdateVoyageCharterOnSubsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVoyageCharterOnSubsMutation, Types.UpdateVoyageCharterOnSubsMutationVariables>;
export const UpdateVoyageCharterIsInquiryDocument = gql`
    mutation UpdateVoyageCharterIsInquiry($voyageCharterId: Int!, $isInquiry: Boolean!) {
  updateVoyageCharterById(
    input: {id: $voyageCharterId, voyageCharterPatch: {isInquiry: $isInquiry}}
  ) {
    voyageCharter {
      id
      isInquiry
    }
  }
}
    `;
export type UpdateVoyageCharterIsInquiryMutationFn = Apollo.MutationFunction<Types.UpdateVoyageCharterIsInquiryMutation, Types.UpdateVoyageCharterIsInquiryMutationVariables>;

/**
 * __useUpdateVoyageCharterIsInquiryMutation__
 *
 * To run a mutation, you first call `useUpdateVoyageCharterIsInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoyageCharterIsInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoyageCharterIsInquiryMutation, { data, loading, error }] = useUpdateVoyageCharterIsInquiryMutation({
 *   variables: {
 *      voyageCharterId: // value for 'voyageCharterId'
 *      isInquiry: // value for 'isInquiry'
 *   },
 * });
 */
export function useUpdateVoyageCharterIsInquiryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVoyageCharterIsInquiryMutation, Types.UpdateVoyageCharterIsInquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVoyageCharterIsInquiryMutation, Types.UpdateVoyageCharterIsInquiryMutationVariables>(UpdateVoyageCharterIsInquiryDocument, options);
      }
export type UpdateVoyageCharterIsInquiryMutationHookResult = ReturnType<typeof useUpdateVoyageCharterIsInquiryMutation>;
export type UpdateVoyageCharterIsInquiryMutationResult = Apollo.MutationResult<Types.UpdateVoyageCharterIsInquiryMutation>;
export type UpdateVoyageCharterIsInquiryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVoyageCharterIsInquiryMutation, Types.UpdateVoyageCharterIsInquiryMutationVariables>;
export const CreateLostContractDocument = gql`
    mutation CreateLostContract($input: CreateLostContractInput!) {
  createLostContract(input: $input) {
    lostContract {
      id
    }
  }
}
    `;
export type CreateLostContractMutationFn = Apollo.MutationFunction<Types.CreateLostContractMutation, Types.CreateLostContractMutationVariables>;

/**
 * __useCreateLostContractMutation__
 *
 * To run a mutation, you first call `useCreateLostContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLostContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLostContractMutation, { data, loading, error }] = useCreateLostContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLostContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLostContractMutation, Types.CreateLostContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLostContractMutation, Types.CreateLostContractMutationVariables>(CreateLostContractDocument, options);
      }
export type CreateLostContractMutationHookResult = ReturnType<typeof useCreateLostContractMutation>;
export type CreateLostContractMutationResult = Apollo.MutationResult<Types.CreateLostContractMutation>;
export type CreateLostContractMutationOptions = Apollo.BaseMutationOptions<Types.CreateLostContractMutation, Types.CreateLostContractMutationVariables>;
export const UpdateLostContractDocument = gql`
    mutation UpdateLostContract($input: UpdateLostContractByIdInput!) {
  updateLostContractById(input: $input) {
    lostContract {
      id
    }
  }
}
    `;
export type UpdateLostContractMutationFn = Apollo.MutationFunction<Types.UpdateLostContractMutation, Types.UpdateLostContractMutationVariables>;

/**
 * __useUpdateLostContractMutation__
 *
 * To run a mutation, you first call `useUpdateLostContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLostContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLostContractMutation, { data, loading, error }] = useUpdateLostContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLostContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLostContractMutation, Types.UpdateLostContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLostContractMutation, Types.UpdateLostContractMutationVariables>(UpdateLostContractDocument, options);
      }
export type UpdateLostContractMutationHookResult = ReturnType<typeof useUpdateLostContractMutation>;
export type UpdateLostContractMutationResult = Apollo.MutationResult<Types.UpdateLostContractMutation>;
export type UpdateLostContractMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLostContractMutation, Types.UpdateLostContractMutationVariables>;
export const CreateVoyageCharterUpdateDocument = gql`
    mutation CreateVoyageCharterUpdate($input: CreateVoyageCharterUpdateInput!) {
  createVoyageCharterUpdate(input: $input) {
    voyageCharterUpdate {
      id
      ...VoyageCharterUpdates_Update
    }
  }
}
    ${VoyageCharterUpdates_UpdateFragmentDoc}`;
export type CreateVoyageCharterUpdateMutationFn = Apollo.MutationFunction<Types.CreateVoyageCharterUpdateMutation, Types.CreateVoyageCharterUpdateMutationVariables>;

/**
 * __useCreateVoyageCharterUpdateMutation__
 *
 * To run a mutation, you first call `useCreateVoyageCharterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoyageCharterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoyageCharterUpdateMutation, { data, loading, error }] = useCreateVoyageCharterUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoyageCharterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVoyageCharterUpdateMutation, Types.CreateVoyageCharterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVoyageCharterUpdateMutation, Types.CreateVoyageCharterUpdateMutationVariables>(CreateVoyageCharterUpdateDocument, options);
      }
export type CreateVoyageCharterUpdateMutationHookResult = ReturnType<typeof useCreateVoyageCharterUpdateMutation>;
export type CreateVoyageCharterUpdateMutationResult = Apollo.MutationResult<Types.CreateVoyageCharterUpdateMutation>;
export type CreateVoyageCharterUpdateMutationOptions = Apollo.BaseMutationOptions<Types.CreateVoyageCharterUpdateMutation, Types.CreateVoyageCharterUpdateMutationVariables>;
export const DeleteVoyageCharterUpdateDocument = gql`
    mutation DeleteVoyageCharterUpdate($input: DeleteVoyageCharterUpdateByIdInput!) {
  deleteVoyageCharterUpdateById(input: $input) {
    deletedVoyageCharterUpdateId
  }
}
    `;
export type DeleteVoyageCharterUpdateMutationFn = Apollo.MutationFunction<Types.DeleteVoyageCharterUpdateMutation, Types.DeleteVoyageCharterUpdateMutationVariables>;

/**
 * __useDeleteVoyageCharterUpdateMutation__
 *
 * To run a mutation, you first call `useDeleteVoyageCharterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoyageCharterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoyageCharterUpdateMutation, { data, loading, error }] = useDeleteVoyageCharterUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVoyageCharterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVoyageCharterUpdateMutation, Types.DeleteVoyageCharterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVoyageCharterUpdateMutation, Types.DeleteVoyageCharterUpdateMutationVariables>(DeleteVoyageCharterUpdateDocument, options);
      }
export type DeleteVoyageCharterUpdateMutationHookResult = ReturnType<typeof useDeleteVoyageCharterUpdateMutation>;
export type DeleteVoyageCharterUpdateMutationResult = Apollo.MutationResult<Types.DeleteVoyageCharterUpdateMutation>;
export type DeleteVoyageCharterUpdateMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVoyageCharterUpdateMutation, Types.DeleteVoyageCharterUpdateMutationVariables>;
export const AcceptVoyageCharterUpdateDocument = gql`
    mutation AcceptVoyageCharterUpdate($input: AcceptVoyageCharterUpdateInput!) {
  acceptVoyageCharterUpdate(input: $input) {
    voyageCharter {
      id
      vesselId
      layday
      cancelling
      shipByVesselId {
        id
        name
      }
    }
  }
}
    `;
export type AcceptVoyageCharterUpdateMutationFn = Apollo.MutationFunction<Types.AcceptVoyageCharterUpdateMutation, Types.AcceptVoyageCharterUpdateMutationVariables>;

/**
 * __useAcceptVoyageCharterUpdateMutation__
 *
 * To run a mutation, you first call `useAcceptVoyageCharterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptVoyageCharterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptVoyageCharterUpdateMutation, { data, loading, error }] = useAcceptVoyageCharterUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptVoyageCharterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.AcceptVoyageCharterUpdateMutation, Types.AcceptVoyageCharterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AcceptVoyageCharterUpdateMutation, Types.AcceptVoyageCharterUpdateMutationVariables>(AcceptVoyageCharterUpdateDocument, options);
      }
export type AcceptVoyageCharterUpdateMutationHookResult = ReturnType<typeof useAcceptVoyageCharterUpdateMutation>;
export type AcceptVoyageCharterUpdateMutationResult = Apollo.MutationResult<Types.AcceptVoyageCharterUpdateMutation>;
export type AcceptVoyageCharterUpdateMutationOptions = Apollo.BaseMutationOptions<Types.AcceptVoyageCharterUpdateMutation, Types.AcceptVoyageCharterUpdateMutationVariables>;
export const VoyagePrefixGetNextIdsDocument = gql`
    mutation VoyagePrefixGetNextIds($input: VoyagePrefixGetNextIdsInput!) {
  voyagePrefixGetNextIds(input: $input) {
    strings
  }
}
    `;
export type VoyagePrefixGetNextIdsMutationFn = Apollo.MutationFunction<Types.VoyagePrefixGetNextIdsMutation, Types.VoyagePrefixGetNextIdsMutationVariables>;

/**
 * __useVoyagePrefixGetNextIdsMutation__
 *
 * To run a mutation, you first call `useVoyagePrefixGetNextIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoyagePrefixGetNextIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voyagePrefixGetNextIdsMutation, { data, loading, error }] = useVoyagePrefixGetNextIdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoyagePrefixGetNextIdsMutation(baseOptions?: Apollo.MutationHookOptions<Types.VoyagePrefixGetNextIdsMutation, Types.VoyagePrefixGetNextIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VoyagePrefixGetNextIdsMutation, Types.VoyagePrefixGetNextIdsMutationVariables>(VoyagePrefixGetNextIdsDocument, options);
      }
export type VoyagePrefixGetNextIdsMutationHookResult = ReturnType<typeof useVoyagePrefixGetNextIdsMutation>;
export type VoyagePrefixGetNextIdsMutationResult = Apollo.MutationResult<Types.VoyagePrefixGetNextIdsMutation>;
export type VoyagePrefixGetNextIdsMutationOptions = Apollo.BaseMutationOptions<Types.VoyagePrefixGetNextIdsMutation, Types.VoyagePrefixGetNextIdsMutationVariables>;
export const AllLocationsDocument = gql`
    query AllLocations {
  allLocations {
    nodes {
      id
      ...ScenarioTimeline_OrderLocation
    }
  }
}
    ${ScenarioTimeline_OrderLocationFragmentDoc}`;

/**
 * __useAllLocationsQuery__
 *
 * To run a query within a React component, call `useAllLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllLocationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllLocationsQuery, Types.AllLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllLocationsQuery, Types.AllLocationsQueryVariables>(AllLocationsDocument, options);
      }
export function useAllLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllLocationsQuery, Types.AllLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllLocationsQuery, Types.AllLocationsQueryVariables>(AllLocationsDocument, options);
        }
export function useAllLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllLocationsQuery, Types.AllLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllLocationsQuery, Types.AllLocationsQueryVariables>(AllLocationsDocument, options);
        }
export type AllLocationsQueryHookResult = ReturnType<typeof useAllLocationsQuery>;
export type AllLocationsLazyQueryHookResult = ReturnType<typeof useAllLocationsLazyQuery>;
export type AllLocationsSuspenseQueryHookResult = ReturnType<typeof useAllLocationsSuspenseQuery>;
export type AllLocationsQueryResult = Apollo.QueryResult<Types.AllLocationsQuery, Types.AllLocationsQueryVariables>;
export const AllZonesDocument = gql`
    query AllZones {
  allZones {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAllZonesQuery__
 *
 * To run a query within a React component, call `useAllZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllZonesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllZonesQuery, Types.AllZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllZonesQuery, Types.AllZonesQueryVariables>(AllZonesDocument, options);
      }
export function useAllZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllZonesQuery, Types.AllZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllZonesQuery, Types.AllZonesQueryVariables>(AllZonesDocument, options);
        }
export function useAllZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllZonesQuery, Types.AllZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllZonesQuery, Types.AllZonesQueryVariables>(AllZonesDocument, options);
        }
export type AllZonesQueryHookResult = ReturnType<typeof useAllZonesQuery>;
export type AllZonesLazyQueryHookResult = ReturnType<typeof useAllZonesLazyQuery>;
export type AllZonesSuspenseQueryHookResult = ReturnType<typeof useAllZonesSuspenseQuery>;
export type AllZonesQueryResult = Apollo.QueryResult<Types.AllZonesQuery, Types.AllZonesQueryVariables>;
export const ArchivePageDocument = gql`
    query ArchivePage {
  ...ArchivePage_Query
}
    ${ArchivePage_QueryFragmentDoc}`;

/**
 * __useArchivePageQuery__
 *
 * To run a query within a React component, call `useArchivePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useArchivePageQuery(baseOptions?: Apollo.QueryHookOptions<Types.ArchivePageQuery, Types.ArchivePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ArchivePageQuery, Types.ArchivePageQueryVariables>(ArchivePageDocument, options);
      }
export function useArchivePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ArchivePageQuery, Types.ArchivePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ArchivePageQuery, Types.ArchivePageQueryVariables>(ArchivePageDocument, options);
        }
export function useArchivePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ArchivePageQuery, Types.ArchivePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ArchivePageQuery, Types.ArchivePageQueryVariables>(ArchivePageDocument, options);
        }
export type ArchivePageQueryHookResult = ReturnType<typeof useArchivePageQuery>;
export type ArchivePageLazyQueryHookResult = ReturnType<typeof useArchivePageLazyQuery>;
export type ArchivePageSuspenseQueryHookResult = ReturnType<typeof useArchivePageSuspenseQuery>;
export type ArchivePageQueryResult = Apollo.QueryResult<Types.ArchivePageQuery, Types.ArchivePageQueryVariables>;
export const ArchivedAndLostPageDocument = gql`
    query ArchivedAndLostPage {
  orders: allOrders(condition: {softDelete: false, archived: true}) {
    nodes {
      id
      ...ArchivedAndLostTable_Order
    }
  }
}
    ${ArchivedAndLostTable_OrderFragmentDoc}`;

/**
 * __useArchivedAndLostPageQuery__
 *
 * To run a query within a React component, call `useArchivedAndLostPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedAndLostPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedAndLostPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useArchivedAndLostPageQuery(baseOptions?: Apollo.QueryHookOptions<Types.ArchivedAndLostPageQuery, Types.ArchivedAndLostPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ArchivedAndLostPageQuery, Types.ArchivedAndLostPageQueryVariables>(ArchivedAndLostPageDocument, options);
      }
export function useArchivedAndLostPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ArchivedAndLostPageQuery, Types.ArchivedAndLostPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ArchivedAndLostPageQuery, Types.ArchivedAndLostPageQueryVariables>(ArchivedAndLostPageDocument, options);
        }
export function useArchivedAndLostPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ArchivedAndLostPageQuery, Types.ArchivedAndLostPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ArchivedAndLostPageQuery, Types.ArchivedAndLostPageQueryVariables>(ArchivedAndLostPageDocument, options);
        }
export type ArchivedAndLostPageQueryHookResult = ReturnType<typeof useArchivedAndLostPageQuery>;
export type ArchivedAndLostPageLazyQueryHookResult = ReturnType<typeof useArchivedAndLostPageLazyQuery>;
export type ArchivedAndLostPageSuspenseQueryHookResult = ReturnType<typeof useArchivedAndLostPageSuspenseQuery>;
export type ArchivedAndLostPageQueryResult = Apollo.QueryResult<Types.ArchivedAndLostPageQuery, Types.ArchivedAndLostPageQueryVariables>;
export const ArchivedDataDocument = gql`
    query ArchivedData {
  allOrders(condition: {archived: true}) {
    nodes {
      id
    }
  }
  allSingleEvents(condition: {archived: true}) {
    nodes {
      id
      clientId
    }
  }
  allOffHires(condition: {archived: true}) {
    nodes {
      id
      clientId
    }
  }
  allPortCalls(condition: {archived: true}) {
    nodes {
      id
      clientId
    }
  }
}
    `;

/**
 * __useArchivedDataQuery__
 *
 * To run a query within a React component, call `useArchivedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useArchivedDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.ArchivedDataQuery, Types.ArchivedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ArchivedDataQuery, Types.ArchivedDataQueryVariables>(ArchivedDataDocument, options);
      }
export function useArchivedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ArchivedDataQuery, Types.ArchivedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ArchivedDataQuery, Types.ArchivedDataQueryVariables>(ArchivedDataDocument, options);
        }
export function useArchivedDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ArchivedDataQuery, Types.ArchivedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ArchivedDataQuery, Types.ArchivedDataQueryVariables>(ArchivedDataDocument, options);
        }
export type ArchivedDataQueryHookResult = ReturnType<typeof useArchivedDataQuery>;
export type ArchivedDataLazyQueryHookResult = ReturnType<typeof useArchivedDataLazyQuery>;
export type ArchivedDataSuspenseQueryHookResult = ReturnType<typeof useArchivedDataSuspenseQuery>;
export type ArchivedDataQueryResult = Apollo.QueryResult<Types.ArchivedDataQuery, Types.ArchivedDataQueryVariables>;
export const BatchDataDocument = gql`
    query BatchData($updatedIds: [Int!]!, $insertedIds: [Int!]!, $includeOrgs: Boolean!, $includeShips: Boolean!, $includeUpdated: Boolean!, $includeInserted: Boolean!) {
  updated: allOrders(
    condition: {softDelete: false, archived: false}
    filter: {id: {in: $updatedIds}}
  ) @include(if: $includeUpdated) {
    nodes {
      id
      ...ScenarioTimeline_Order
    }
  }
  inserted: allOrders(
    condition: {softDelete: false, archived: false}
    filter: {id: {in: $insertedIds}}
  ) @include(if: $includeInserted) {
    nodes {
      id
      ...ScenarioTimeline_Order
    }
  }
  allOrganizations @include(if: $includeOrgs) {
    nodes {
      id
      ...ScenarioTimeline_Organization
    }
  }
  allShips @include(if: $includeShips) {
    nodes {
      id
      ...ScenarioTimeline_Ship
    }
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}
${ScenarioTimeline_OrganizationFragmentDoc}
${ScenarioTimeline_ShipFragmentDoc}`;

/**
 * __useBatchDataQuery__
 *
 * To run a query within a React component, call `useBatchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchDataQuery({
 *   variables: {
 *      updatedIds: // value for 'updatedIds'
 *      insertedIds: // value for 'insertedIds'
 *      includeOrgs: // value for 'includeOrgs'
 *      includeShips: // value for 'includeShips'
 *      includeUpdated: // value for 'includeUpdated'
 *      includeInserted: // value for 'includeInserted'
 *   },
 * });
 */
export function useBatchDataQuery(baseOptions: Apollo.QueryHookOptions<Types.BatchDataQuery, Types.BatchDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BatchDataQuery, Types.BatchDataQueryVariables>(BatchDataDocument, options);
      }
export function useBatchDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BatchDataQuery, Types.BatchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BatchDataQuery, Types.BatchDataQueryVariables>(BatchDataDocument, options);
        }
export function useBatchDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.BatchDataQuery, Types.BatchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.BatchDataQuery, Types.BatchDataQueryVariables>(BatchDataDocument, options);
        }
export type BatchDataQueryHookResult = ReturnType<typeof useBatchDataQuery>;
export type BatchDataLazyQueryHookResult = ReturnType<typeof useBatchDataLazyQuery>;
export type BatchDataSuspenseQueryHookResult = ReturnType<typeof useBatchDataSuspenseQuery>;
export type BatchDataQueryResult = Apollo.QueryResult<Types.BatchDataQuery, Types.BatchDataQueryVariables>;
export const AllOrdersDocument = gql`
    query AllOrders {
  allOrders(condition: {softDelete: false, archived: false}) {
    nodes {
      id
      ...ScenarioTimeline_Order
    }
  }
}
    ${ScenarioTimeline_OrderFragmentDoc}`;

/**
 * __useAllOrdersQuery__
 *
 * To run a query within a React component, call `useAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllOrdersQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllOrdersQuery, Types.AllOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllOrdersQuery, Types.AllOrdersQueryVariables>(AllOrdersDocument, options);
      }
export function useAllOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllOrdersQuery, Types.AllOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllOrdersQuery, Types.AllOrdersQueryVariables>(AllOrdersDocument, options);
        }
export function useAllOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllOrdersQuery, Types.AllOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllOrdersQuery, Types.AllOrdersQueryVariables>(AllOrdersDocument, options);
        }
export type AllOrdersQueryHookResult = ReturnType<typeof useAllOrdersQuery>;
export type AllOrdersLazyQueryHookResult = ReturnType<typeof useAllOrdersLazyQuery>;
export type AllOrdersSuspenseQueryHookResult = ReturnType<typeof useAllOrdersSuspenseQuery>;
export type AllOrdersQueryResult = Apollo.QueryResult<Types.AllOrdersQuery, Types.AllOrdersQueryVariables>;
export const BerthPredictionsDocument = gql`
    query BerthPredictions($inputs: [BerthPredictionInput!]!) {
  GetBerthPredictions(query: $inputs) {
    predictions {
      InputUsedByTheModel {
        VesselName
        PortName
        TerminalName
        Operation
        Scheduled_Quantity
        Cargo
        dwt
        vesselType
        CargoOPL
      }
      PredictedBerthTime
    }
  }
}
    `;

/**
 * __useBerthPredictionsQuery__
 *
 * To run a query within a React component, call `useBerthPredictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBerthPredictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBerthPredictionsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useBerthPredictionsQuery(baseOptions: Apollo.QueryHookOptions<Types.BerthPredictionsQuery, Types.BerthPredictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BerthPredictionsQuery, Types.BerthPredictionsQueryVariables>(BerthPredictionsDocument, options);
      }
export function useBerthPredictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BerthPredictionsQuery, Types.BerthPredictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BerthPredictionsQuery, Types.BerthPredictionsQueryVariables>(BerthPredictionsDocument, options);
        }
export function useBerthPredictionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.BerthPredictionsQuery, Types.BerthPredictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.BerthPredictionsQuery, Types.BerthPredictionsQueryVariables>(BerthPredictionsDocument, options);
        }
export type BerthPredictionsQueryHookResult = ReturnType<typeof useBerthPredictionsQuery>;
export type BerthPredictionsLazyQueryHookResult = ReturnType<typeof useBerthPredictionsLazyQuery>;
export type BerthPredictionsSuspenseQueryHookResult = ReturnType<typeof useBerthPredictionsSuspenseQuery>;
export type BerthPredictionsQueryResult = Apollo.QueryResult<Types.BerthPredictionsQuery, Types.BerthPredictionsQueryVariables>;
export const BunkerGradesDocument = gql`
    query BunkerGrades {
  allBunkerGradeOverrides {
    nodes {
      id
      carbonFactor
      ch4Factor
      lcv
      n2OFactor
      wttFactor
    }
  }
}
    `;

/**
 * __useBunkerGradesQuery__
 *
 * To run a query within a React component, call `useBunkerGradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBunkerGradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBunkerGradesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBunkerGradesQuery(baseOptions?: Apollo.QueryHookOptions<Types.BunkerGradesQuery, Types.BunkerGradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BunkerGradesQuery, Types.BunkerGradesQueryVariables>(BunkerGradesDocument, options);
      }
export function useBunkerGradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BunkerGradesQuery, Types.BunkerGradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BunkerGradesQuery, Types.BunkerGradesQueryVariables>(BunkerGradesDocument, options);
        }
export function useBunkerGradesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.BunkerGradesQuery, Types.BunkerGradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.BunkerGradesQuery, Types.BunkerGradesQueryVariables>(BunkerGradesDocument, options);
        }
export type BunkerGradesQueryHookResult = ReturnType<typeof useBunkerGradesQuery>;
export type BunkerGradesLazyQueryHookResult = ReturnType<typeof useBunkerGradesLazyQuery>;
export type BunkerGradesSuspenseQueryHookResult = ReturnType<typeof useBunkerGradesSuspenseQuery>;
export type BunkerGradesQueryResult = Apollo.QueryResult<Types.BunkerGradesQuery, Types.BunkerGradesQueryVariables>;
export const CalculateVoyagesDocument = gql`
    query CalculateVoyages($inputs: [CalculateVoyageInputs!]!) {
  calculateVoyages(inputs: $inputs) {
    fuelConsumptionBreakdown {
      isSuccess
      value {
        HFO {
          consumption
          cost
        }
        LSFO {
          consumption
          cost
        }
        MGO {
          consumption
          cost
        }
        LNG {
          consumption
          cost
        }
      }
      errors
    }
  }
}
    `;

/**
 * __useCalculateVoyagesQuery__
 *
 * To run a query within a React component, call `useCalculateVoyagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateVoyagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateVoyagesQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCalculateVoyagesQuery(baseOptions: Apollo.QueryHookOptions<Types.CalculateVoyagesQuery, Types.CalculateVoyagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CalculateVoyagesQuery, Types.CalculateVoyagesQueryVariables>(CalculateVoyagesDocument, options);
      }
export function useCalculateVoyagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CalculateVoyagesQuery, Types.CalculateVoyagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CalculateVoyagesQuery, Types.CalculateVoyagesQueryVariables>(CalculateVoyagesDocument, options);
        }
export function useCalculateVoyagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CalculateVoyagesQuery, Types.CalculateVoyagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CalculateVoyagesQuery, Types.CalculateVoyagesQueryVariables>(CalculateVoyagesDocument, options);
        }
export type CalculateVoyagesQueryHookResult = ReturnType<typeof useCalculateVoyagesQuery>;
export type CalculateVoyagesLazyQueryHookResult = ReturnType<typeof useCalculateVoyagesLazyQuery>;
export type CalculateVoyagesSuspenseQueryHookResult = ReturnType<typeof useCalculateVoyagesSuspenseQuery>;
export type CalculateVoyagesQueryResult = Apollo.QueryResult<Types.CalculateVoyagesQuery, Types.CalculateVoyagesQueryVariables>;
export const ChangelogDocument = gql`
    query Changelog($portCallIds: [Int!], $portCallClientIds: [UUID!], $voyageCharterIds: [Int!]) {
  allPortCalls(filter: {clientId: {in: $portCallClientIds}}) {
    nodes {
      id
      ...Changelog_PortCall
    }
  }
  allPortNotices(filter: {portCallId: {in: $portCallIds}}) {
    nodes {
      id
      ...Changelog_PortNotice
    }
  }
  allStatementOfFacts(filter: {portCallId: {in: $portCallIds}}) {
    nodes {
      id
      ...Changelog_StatementOfFacts
    }
  }
  allVoyageCharters(filter: {id: {in: $voyageCharterIds}}) {
    nodes {
      id
      ...Changelog_VoyageCharters
    }
  }
}
    ${Changelog_PortCallFragmentDoc}
${Changelog_PortNoticeFragmentDoc}
${Changelog_StatementOfFactsFragmentDoc}
${Changelog_VoyageChartersFragmentDoc}`;

/**
 * __useChangelogQuery__
 *
 * To run a query within a React component, call `useChangelogQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangelogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangelogQuery({
 *   variables: {
 *      portCallIds: // value for 'portCallIds'
 *      portCallClientIds: // value for 'portCallClientIds'
 *      voyageCharterIds: // value for 'voyageCharterIds'
 *   },
 * });
 */
export function useChangelogQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChangelogQuery, Types.ChangelogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChangelogQuery, Types.ChangelogQueryVariables>(ChangelogDocument, options);
      }
export function useChangelogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChangelogQuery, Types.ChangelogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChangelogQuery, Types.ChangelogQueryVariables>(ChangelogDocument, options);
        }
export function useChangelogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ChangelogQuery, Types.ChangelogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ChangelogQuery, Types.ChangelogQueryVariables>(ChangelogDocument, options);
        }
export type ChangelogQueryHookResult = ReturnType<typeof useChangelogQuery>;
export type ChangelogLazyQueryHookResult = ReturnType<typeof useChangelogLazyQuery>;
export type ChangelogSuspenseQueryHookResult = ReturnType<typeof useChangelogSuspenseQuery>;
export type ChangelogQueryResult = Apollo.QueryResult<Types.ChangelogQuery, Types.ChangelogQueryVariables>;
export const GetDataToCleanupForOrderDocument = gql`
    query GetDataToCleanupForOrder($orderId: Int!) {
  orderById(id: $orderId) {
    id
    billOfLadingDataByOrderId {
      nodes {
        id
      }
    }
    orderPortCallRelationsByOrderId {
      nodes {
        id
      }
    }
    orderVoyageCharterRelationsByOrderId(condition: {outgoing: true}) {
      nodes {
        id
        voyageCharterId
      }
    }
    cargoMeasurementsByOrderId {
      nodes {
        id
      }
    }
    cargoExclusionsByOrderId {
      nodes {
        id
      }
    }
    notificationReceiversByOrderId {
      nodes {
        id
      }
    }
    cargoCompartmentAllocationsByOrderId {
      nodes {
        id
      }
    }
    scheduledOrdersByOrderId {
      nodes {
        id
      }
    }
    handledByCoaByOrderId {
      id
    }
    handledBySpotByOrderId {
      id
    }
  }
}
    `;

/**
 * __useGetDataToCleanupForOrderQuery__
 *
 * To run a query within a React component, call `useGetDataToCleanupForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataToCleanupForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataToCleanupForOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetDataToCleanupForOrderQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDataToCleanupForOrderQuery, Types.GetDataToCleanupForOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDataToCleanupForOrderQuery, Types.GetDataToCleanupForOrderQueryVariables>(GetDataToCleanupForOrderDocument, options);
      }
export function useGetDataToCleanupForOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDataToCleanupForOrderQuery, Types.GetDataToCleanupForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDataToCleanupForOrderQuery, Types.GetDataToCleanupForOrderQueryVariables>(GetDataToCleanupForOrderDocument, options);
        }
export function useGetDataToCleanupForOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDataToCleanupForOrderQuery, Types.GetDataToCleanupForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDataToCleanupForOrderQuery, Types.GetDataToCleanupForOrderQueryVariables>(GetDataToCleanupForOrderDocument, options);
        }
export type GetDataToCleanupForOrderQueryHookResult = ReturnType<typeof useGetDataToCleanupForOrderQuery>;
export type GetDataToCleanupForOrderLazyQueryHookResult = ReturnType<typeof useGetDataToCleanupForOrderLazyQuery>;
export type GetDataToCleanupForOrderSuspenseQueryHookResult = ReturnType<typeof useGetDataToCleanupForOrderSuspenseQuery>;
export type GetDataToCleanupForOrderQueryResult = Apollo.QueryResult<Types.GetDataToCleanupForOrderQuery, Types.GetDataToCleanupForOrderQueryVariables>;
export const GetOrderAssignmentsDocument = gql`
    query GetOrderAssignments($ids: [Int!]) {
  allOrders(condition: {archived: false}, filter: {id: {in: $ids}}) {
    nodes {
      id
      scheduledOrdersByOrderId {
        nodes {
          id
        }
      }
      handledByCoaByOrderId {
        id
      }
      handledBySpotByOrderId {
        id
      }
    }
  }
}
    `;

/**
 * __useGetOrderAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetOrderAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderAssignmentsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetOrderAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOrderAssignmentsQuery, Types.GetOrderAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrderAssignmentsQuery, Types.GetOrderAssignmentsQueryVariables>(GetOrderAssignmentsDocument, options);
      }
export function useGetOrderAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrderAssignmentsQuery, Types.GetOrderAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrderAssignmentsQuery, Types.GetOrderAssignmentsQueryVariables>(GetOrderAssignmentsDocument, options);
        }
export function useGetOrderAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrderAssignmentsQuery, Types.GetOrderAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrderAssignmentsQuery, Types.GetOrderAssignmentsQueryVariables>(GetOrderAssignmentsDocument, options);
        }
export type GetOrderAssignmentsQueryHookResult = ReturnType<typeof useGetOrderAssignmentsQuery>;
export type GetOrderAssignmentsLazyQueryHookResult = ReturnType<typeof useGetOrderAssignmentsLazyQuery>;
export type GetOrderAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetOrderAssignmentsSuspenseQuery>;
export type GetOrderAssignmentsQueryResult = Apollo.QueryResult<Types.GetOrderAssignmentsQuery, Types.GetOrderAssignmentsQueryVariables>;
export const GetDataToCleanupForAllOrdersDocument = gql`
    query GetDataToCleanupForAllOrders($ids: [Int!]) {
  allOrders(condition: {archived: false}, filter: {id: {in: $ids}}) {
    nodes {
      id
      billOfLadingDataByOrderId {
        nodes {
          id
        }
      }
      orderPortCallRelationsByOrderId {
        nodes {
          id
        }
      }
      orderVoyageCharterRelationsByOrderId(condition: {outgoing: true}) {
        nodes {
          id
          voyageCharterId
        }
      }
      cargoMeasurementsByOrderId {
        nodes {
          id
        }
      }
      cargoExclusionsByOrderId {
        nodes {
          id
        }
      }
      notificationReceiversByOrderId {
        nodes {
          id
        }
      }
      cargoCompartmentAllocationsByOrderId {
        nodes {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetDataToCleanupForAllOrdersQuery__
 *
 * To run a query within a React component, call `useGetDataToCleanupForAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataToCleanupForAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataToCleanupForAllOrdersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetDataToCleanupForAllOrdersQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetDataToCleanupForAllOrdersQuery, Types.GetDataToCleanupForAllOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDataToCleanupForAllOrdersQuery, Types.GetDataToCleanupForAllOrdersQueryVariables>(GetDataToCleanupForAllOrdersDocument, options);
      }
export function useGetDataToCleanupForAllOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDataToCleanupForAllOrdersQuery, Types.GetDataToCleanupForAllOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDataToCleanupForAllOrdersQuery, Types.GetDataToCleanupForAllOrdersQueryVariables>(GetDataToCleanupForAllOrdersDocument, options);
        }
export function useGetDataToCleanupForAllOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDataToCleanupForAllOrdersQuery, Types.GetDataToCleanupForAllOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDataToCleanupForAllOrdersQuery, Types.GetDataToCleanupForAllOrdersQueryVariables>(GetDataToCleanupForAllOrdersDocument, options);
        }
export type GetDataToCleanupForAllOrdersQueryHookResult = ReturnType<typeof useGetDataToCleanupForAllOrdersQuery>;
export type GetDataToCleanupForAllOrdersLazyQueryHookResult = ReturnType<typeof useGetDataToCleanupForAllOrdersLazyQuery>;
export type GetDataToCleanupForAllOrdersSuspenseQueryHookResult = ReturnType<typeof useGetDataToCleanupForAllOrdersSuspenseQuery>;
export type GetDataToCleanupForAllOrdersQueryResult = Apollo.QueryResult<Types.GetDataToCleanupForAllOrdersQuery, Types.GetDataToCleanupForAllOrdersQueryVariables>;
export const CoaFormDocument = gql`
    query CoaForm {
  ...CoaForm
}
    ${CoaFormFragmentDoc}`;

/**
 * __useCoaFormQuery__
 *
 * To run a query within a React component, call `useCoaFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoaFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoaFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoaFormQuery(baseOptions?: Apollo.QueryHookOptions<Types.CoaFormQuery, Types.CoaFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CoaFormQuery, Types.CoaFormQueryVariables>(CoaFormDocument, options);
      }
export function useCoaFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CoaFormQuery, Types.CoaFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CoaFormQuery, Types.CoaFormQueryVariables>(CoaFormDocument, options);
        }
export function useCoaFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CoaFormQuery, Types.CoaFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CoaFormQuery, Types.CoaFormQueryVariables>(CoaFormDocument, options);
        }
export type CoaFormQueryHookResult = ReturnType<typeof useCoaFormQuery>;
export type CoaFormLazyQueryHookResult = ReturnType<typeof useCoaFormLazyQuery>;
export type CoaFormSuspenseQueryHookResult = ReturnType<typeof useCoaFormSuspenseQuery>;
export type CoaFormQueryResult = Apollo.QueryResult<Types.CoaFormQuery, Types.CoaFormQueryVariables>;
export const CommitLogScenarioByClientIdDocument = gql`
    query CommitLogScenarioByClientId($commitLogScenarioClientId: UUID!) {
  allCommitLogScenarios(condition: {clientId: $commitLogScenarioClientId}) {
    nodes {
      id
      dataSchemaVersion
      scenarioData
      organizationId
    }
  }
}
    `;

/**
 * __useCommitLogScenarioByClientIdQuery__
 *
 * To run a query within a React component, call `useCommitLogScenarioByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommitLogScenarioByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitLogScenarioByClientIdQuery({
 *   variables: {
 *      commitLogScenarioClientId: // value for 'commitLogScenarioClientId'
 *   },
 * });
 */
export function useCommitLogScenarioByClientIdQuery(baseOptions: Apollo.QueryHookOptions<Types.CommitLogScenarioByClientIdQuery, Types.CommitLogScenarioByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CommitLogScenarioByClientIdQuery, Types.CommitLogScenarioByClientIdQueryVariables>(CommitLogScenarioByClientIdDocument, options);
      }
export function useCommitLogScenarioByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CommitLogScenarioByClientIdQuery, Types.CommitLogScenarioByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CommitLogScenarioByClientIdQuery, Types.CommitLogScenarioByClientIdQueryVariables>(CommitLogScenarioByClientIdDocument, options);
        }
export function useCommitLogScenarioByClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CommitLogScenarioByClientIdQuery, Types.CommitLogScenarioByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CommitLogScenarioByClientIdQuery, Types.CommitLogScenarioByClientIdQueryVariables>(CommitLogScenarioByClientIdDocument, options);
        }
export type CommitLogScenarioByClientIdQueryHookResult = ReturnType<typeof useCommitLogScenarioByClientIdQuery>;
export type CommitLogScenarioByClientIdLazyQueryHookResult = ReturnType<typeof useCommitLogScenarioByClientIdLazyQuery>;
export type CommitLogScenarioByClientIdSuspenseQueryHookResult = ReturnType<typeof useCommitLogScenarioByClientIdSuspenseQuery>;
export type CommitLogScenarioByClientIdQueryResult = Apollo.QueryResult<Types.CommitLogScenarioByClientIdQuery, Types.CommitLogScenarioByClientIdQueryVariables>;
export const LastCommitDocument = gql`
    query LastCommit {
  lastCommit: allCommitLogs(
    condition: {success: true}
    orderBy: COMMITTED_AT_DESC
    first: 1
  ) {
    nodes {
      id
      ...LastCommit
    }
  }
}
    ${LastCommitFragmentDoc}`;

/**
 * __useLastCommitQuery__
 *
 * To run a query within a React component, call `useLastCommitQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastCommitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastCommitQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastCommitQuery(baseOptions?: Apollo.QueryHookOptions<Types.LastCommitQuery, Types.LastCommitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LastCommitQuery, Types.LastCommitQueryVariables>(LastCommitDocument, options);
      }
export function useLastCommitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LastCommitQuery, Types.LastCommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LastCommitQuery, Types.LastCommitQueryVariables>(LastCommitDocument, options);
        }
export function useLastCommitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LastCommitQuery, Types.LastCommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LastCommitQuery, Types.LastCommitQueryVariables>(LastCommitDocument, options);
        }
export type LastCommitQueryHookResult = ReturnType<typeof useLastCommitQuery>;
export type LastCommitLazyQueryHookResult = ReturnType<typeof useLastCommitLazyQuery>;
export type LastCommitSuspenseQueryHookResult = ReturnType<typeof useLastCommitSuspenseQuery>;
export type LastCommitQueryResult = Apollo.QueryResult<Types.LastCommitQuery, Types.LastCommitQueryVariables>;
export const LastCommitsDocument = gql`
    query LastCommits($first: Int!) {
  lastCommits: allCommitLogs(
    condition: {success: true}
    orderBy: COMMITTED_AT_DESC
    first: $first
  ) {
    nodes {
      id
      ...LastCommit
    }
  }
}
    ${LastCommitFragmentDoc}`;

/**
 * __useLastCommitsQuery__
 *
 * To run a query within a React component, call `useLastCommitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastCommitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastCommitsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useLastCommitsQuery(baseOptions: Apollo.QueryHookOptions<Types.LastCommitsQuery, Types.LastCommitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LastCommitsQuery, Types.LastCommitsQueryVariables>(LastCommitsDocument, options);
      }
export function useLastCommitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LastCommitsQuery, Types.LastCommitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LastCommitsQuery, Types.LastCommitsQueryVariables>(LastCommitsDocument, options);
        }
export function useLastCommitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LastCommitsQuery, Types.LastCommitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LastCommitsQuery, Types.LastCommitsQueryVariables>(LastCommitsDocument, options);
        }
export type LastCommitsQueryHookResult = ReturnType<typeof useLastCommitsQuery>;
export type LastCommitsLazyQueryHookResult = ReturnType<typeof useLastCommitsLazyQuery>;
export type LastCommitsSuspenseQueryHookResult = ReturnType<typeof useLastCommitsSuspenseQuery>;
export type LastCommitsQueryResult = Apollo.QueryResult<Types.LastCommitsQuery, Types.LastCommitsQueryVariables>;
export const CommitsSinceDisconnectDocument = gql`
    query CommitsSinceDisconnect($committedAt: Datetime!) {
  allCommitLogs(
    filter: {and: [{success: {equalTo: true}}, {committedAt: {greaterThan: $committedAt}}]}
    orderBy: COMMITTED_AT_ASC
  ) {
    nodes {
      id
      input
      payload
      success
      committedAt
      committedBy
    }
  }
}
    `;

/**
 * __useCommitsSinceDisconnectQuery__
 *
 * To run a query within a React component, call `useCommitsSinceDisconnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommitsSinceDisconnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitsSinceDisconnectQuery({
 *   variables: {
 *      committedAt: // value for 'committedAt'
 *   },
 * });
 */
export function useCommitsSinceDisconnectQuery(baseOptions: Apollo.QueryHookOptions<Types.CommitsSinceDisconnectQuery, Types.CommitsSinceDisconnectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CommitsSinceDisconnectQuery, Types.CommitsSinceDisconnectQueryVariables>(CommitsSinceDisconnectDocument, options);
      }
export function useCommitsSinceDisconnectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CommitsSinceDisconnectQuery, Types.CommitsSinceDisconnectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CommitsSinceDisconnectQuery, Types.CommitsSinceDisconnectQueryVariables>(CommitsSinceDisconnectDocument, options);
        }
export function useCommitsSinceDisconnectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CommitsSinceDisconnectQuery, Types.CommitsSinceDisconnectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CommitsSinceDisconnectQuery, Types.CommitsSinceDisconnectQueryVariables>(CommitsSinceDisconnectDocument, options);
        }
export type CommitsSinceDisconnectQueryHookResult = ReturnType<typeof useCommitsSinceDisconnectQuery>;
export type CommitsSinceDisconnectLazyQueryHookResult = ReturnType<typeof useCommitsSinceDisconnectLazyQuery>;
export type CommitsSinceDisconnectSuspenseQueryHookResult = ReturnType<typeof useCommitsSinceDisconnectSuspenseQuery>;
export type CommitsSinceDisconnectQueryResult = Apollo.QueryResult<Types.CommitsSinceDisconnectQuery, Types.CommitsSinceDisconnectQueryVariables>;
export const ContractsPageDocument = gql`
    query ContractsPage {
  ...ContractsPageQuery
  ...VoyageChartersForSpotContracts
}
    ${ContractsPageQueryFragmentDoc}
${VoyageChartersForSpotContractsFragmentDoc}`;

/**
 * __useContractsPageQuery__
 *
 * To run a query within a React component, call `useContractsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractsPageQuery(baseOptions?: Apollo.QueryHookOptions<Types.ContractsPageQuery, Types.ContractsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContractsPageQuery, Types.ContractsPageQueryVariables>(ContractsPageDocument, options);
      }
export function useContractsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContractsPageQuery, Types.ContractsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContractsPageQuery, Types.ContractsPageQueryVariables>(ContractsPageDocument, options);
        }
export function useContractsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ContractsPageQuery, Types.ContractsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ContractsPageQuery, Types.ContractsPageQueryVariables>(ContractsPageDocument, options);
        }
export type ContractsPageQueryHookResult = ReturnType<typeof useContractsPageQuery>;
export type ContractsPageLazyQueryHookResult = ReturnType<typeof useContractsPageLazyQuery>;
export type ContractsPageSuspenseQueryHookResult = ReturnType<typeof useContractsPageSuspenseQuery>;
export type ContractsPageQueryResult = Apollo.QueryResult<Types.ContractsPageQuery, Types.ContractsPageQueryVariables>;
export const SyncImosCoasDocument = gql`
    mutation SyncImosCoas {
  syncImosCoas {
    runUuid
  }
}
    `;
export type SyncImosCoasMutationFn = Apollo.MutationFunction<Types.SyncImosCoasMutation, Types.SyncImosCoasMutationVariables>;

/**
 * __useSyncImosCoasMutation__
 *
 * To run a mutation, you first call `useSyncImosCoasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncImosCoasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncImosCoasMutation, { data, loading, error }] = useSyncImosCoasMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncImosCoasMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncImosCoasMutation, Types.SyncImosCoasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncImosCoasMutation, Types.SyncImosCoasMutationVariables>(SyncImosCoasDocument, options);
      }
export type SyncImosCoasMutationHookResult = ReturnType<typeof useSyncImosCoasMutation>;
export type SyncImosCoasMutationResult = Apollo.MutationResult<Types.SyncImosCoasMutation>;
export type SyncImosCoasMutationOptions = Apollo.BaseMutationOptions<Types.SyncImosCoasMutation, Types.SyncImosCoasMutationVariables>;
export const FreightCostsDocument = gql`
    query FreightCosts($orderIds: [Int!]) {
  allOrders(filter: {id: {in: $orderIds}}) {
    nodes {
      id
      cargoMeasurementsByOrderId {
        nodes {
          id
          ...Costs_Measurement
        }
      }
      assortmentId
      assortmentByAssortmentId {
        id
        assortmentGroup
        name
      }
      loadPortId
      dischargePortId
      orderVoyageCharterRelationsByOrderId(condition: {outgoing: true}) {
        nodes {
          id
          voyageCharterOrderFreightsByOrderVoyageCharterRelationId {
            nodes {
              id
              ...Costs_Freight
            }
          }
          voyageCharterByVoyageCharterId {
            id
            currency
            lumpsum
            externalId
            name
            vesselId
            voyageCharterToContractsByVoyageCharterId {
              nodes {
                id
                coaContractByCoaId {
                  id
                }
              }
            }
            voyageCharterExtraFreightsByVoyageCharterId {
              nodes {
                id
                amount
                description
                name
                type
                ignoreInPnl
              }
            }
          }
          coaRouteId
        }
      }
      orderDetailsByOrderId {
        nodes {
          id
          orderName
        }
      }
    }
  }
  allCoaContracts {
    nodes {
      id
      ...Baf_Coa
    }
  }
}
    ${Costs_MeasurementFragmentDoc}
${Costs_FreightFragmentDoc}
${Baf_CoaFragmentDoc}`;

/**
 * __useFreightCostsQuery__
 *
 * To run a query within a React component, call `useFreightCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreightCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFreightCostsQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useFreightCostsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FreightCostsQuery, Types.FreightCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FreightCostsQuery, Types.FreightCostsQueryVariables>(FreightCostsDocument, options);
      }
export function useFreightCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FreightCostsQuery, Types.FreightCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FreightCostsQuery, Types.FreightCostsQueryVariables>(FreightCostsDocument, options);
        }
export function useFreightCostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FreightCostsQuery, Types.FreightCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FreightCostsQuery, Types.FreightCostsQueryVariables>(FreightCostsDocument, options);
        }
export type FreightCostsQueryHookResult = ReturnType<typeof useFreightCostsQuery>;
export type FreightCostsLazyQueryHookResult = ReturnType<typeof useFreightCostsLazyQuery>;
export type FreightCostsSuspenseQueryHookResult = ReturnType<typeof useFreightCostsSuspenseQuery>;
export type FreightCostsQueryResult = Apollo.QueryResult<Types.FreightCostsQuery, Types.FreightCostsQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    name
    nickname
    email
    userType
    initials
    organizationId
    organization: organizationByOrganizationId {
      id
      name
      charterer
      configEnableDefaultLaycan
      configCargoAllocationCombineAssortment
      configDisablePcUpdates
      configUseMasterPorts
      configIgnoreIntegrationCargoMargins
      configEnableWorldscaleFreights
      portAgent
      shipOwner
      defaultCurrency
      parentOrganizationId
      organizationFeaturesByOrganizationId(condition: {isEnabled: true}) {
        nodes {
          id
          organizationId
          featureName
          isEnabled
        }
      }
      organizationAreaBunkerGradeMappingsByOrganizationId {
        nodes {
          organizationId
          bunkerGradeId
          vesselArea
        }
      }
      portCommodityLdRatesByOrganizationId {
        nodes {
          id
          organizationId
          portId
          zoneId
          loadingRate
          loadingUnit
          dischargeRate
          dischargeUnit
          assortmentId
          assortmentGroupId
        }
      }
    }
    rootOrganization {
      id
      defaultCurrency
      configAutoAcceptUpdates
      configAutoSyncUserScenarios
      configAutoAcceptOnlyConfirmed
      configIncludeFuelEuInCosts
      configUseCalculatedLimit
      configReducedUnits
      euEtsCosts
      draft
      portCostPriority
    }
    userRights: userRightsByUserId {
      nodes {
        accessFinancialData
        createAndEditContracts
        createAndEditOrders
        createAndEditVoyages
        createAndEditPortCalls
        createAndEditCargoMeasurement
        accessCargoMeasurement
        createAndEditBillOfLading
        accessBillOfLading
        orgAdmin
        id
        userId
        organizationId
        organizationByOrganizationId {
          id
          descendants
        }
      }
    }
    userSettingsByUserId {
      nodes {
        id
        formSettings
      }
    }
    isVerified
    isActivated
    isAdmin
    monitoringOnly
  }
  myMail
  currentUserIsSystemAdmin
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>;
export const EditCoaModalDocument = gql`
    query EditCoaModal($coaId: Int!) {
  coaContractById(id: $coaId) {
    id
    ...CoaForm_Coa
  }
}
    ${CoaForm_CoaFragmentDoc}`;

/**
 * __useEditCoaModalQuery__
 *
 * To run a query within a React component, call `useEditCoaModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditCoaModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditCoaModalQuery({
 *   variables: {
 *      coaId: // value for 'coaId'
 *   },
 * });
 */
export function useEditCoaModalQuery(baseOptions: Apollo.QueryHookOptions<Types.EditCoaModalQuery, Types.EditCoaModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EditCoaModalQuery, Types.EditCoaModalQueryVariables>(EditCoaModalDocument, options);
      }
export function useEditCoaModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EditCoaModalQuery, Types.EditCoaModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EditCoaModalQuery, Types.EditCoaModalQueryVariables>(EditCoaModalDocument, options);
        }
export function useEditCoaModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EditCoaModalQuery, Types.EditCoaModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EditCoaModalQuery, Types.EditCoaModalQueryVariables>(EditCoaModalDocument, options);
        }
export type EditCoaModalQueryHookResult = ReturnType<typeof useEditCoaModalQuery>;
export type EditCoaModalLazyQueryHookResult = ReturnType<typeof useEditCoaModalLazyQuery>;
export type EditCoaModalSuspenseQueryHookResult = ReturnType<typeof useEditCoaModalSuspenseQuery>;
export type EditCoaModalQueryResult = Apollo.QueryResult<Types.EditCoaModalQuery, Types.EditCoaModalQueryVariables>;
export const EditOrderModalDocument = gql`
    query EditOrderModal($orderId: Int!) {
  ...EditOrderModal_Query
}
    ${EditOrderModal_QueryFragmentDoc}`;

/**
 * __useEditOrderModalQuery__
 *
 * To run a query within a React component, call `useEditOrderModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOrderModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOrderModalQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useEditOrderModalQuery(baseOptions: Apollo.QueryHookOptions<Types.EditOrderModalQuery, Types.EditOrderModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EditOrderModalQuery, Types.EditOrderModalQueryVariables>(EditOrderModalDocument, options);
      }
export function useEditOrderModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EditOrderModalQuery, Types.EditOrderModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EditOrderModalQuery, Types.EditOrderModalQueryVariables>(EditOrderModalDocument, options);
        }
export function useEditOrderModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EditOrderModalQuery, Types.EditOrderModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EditOrderModalQuery, Types.EditOrderModalQueryVariables>(EditOrderModalDocument, options);
        }
export type EditOrderModalQueryHookResult = ReturnType<typeof useEditOrderModalQuery>;
export type EditOrderModalLazyQueryHookResult = ReturnType<typeof useEditOrderModalLazyQuery>;
export type EditOrderModalSuspenseQueryHookResult = ReturnType<typeof useEditOrderModalSuspenseQuery>;
export type EditOrderModalQueryResult = Apollo.QueryResult<Types.EditOrderModalQuery, Types.EditOrderModalQueryVariables>;
export const DuplicateOrdersModalDocument = gql`
    query DuplicateOrdersModal($orderIds: [Int!]!) {
  allOrders(filter: {id: {in: $orderIds}}) {
    nodes {
      id
      ...OrderForm_Order
    }
  }
}
    ${OrderForm_OrderFragmentDoc}`;

/**
 * __useDuplicateOrdersModalQuery__
 *
 * To run a query within a React component, call `useDuplicateOrdersModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrdersModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateOrdersModalQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useDuplicateOrdersModalQuery(baseOptions: Apollo.QueryHookOptions<Types.DuplicateOrdersModalQuery, Types.DuplicateOrdersModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DuplicateOrdersModalQuery, Types.DuplicateOrdersModalQueryVariables>(DuplicateOrdersModalDocument, options);
      }
export function useDuplicateOrdersModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DuplicateOrdersModalQuery, Types.DuplicateOrdersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DuplicateOrdersModalQuery, Types.DuplicateOrdersModalQueryVariables>(DuplicateOrdersModalDocument, options);
        }
export function useDuplicateOrdersModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DuplicateOrdersModalQuery, Types.DuplicateOrdersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DuplicateOrdersModalQuery, Types.DuplicateOrdersModalQueryVariables>(DuplicateOrdersModalDocument, options);
        }
export type DuplicateOrdersModalQueryHookResult = ReturnType<typeof useDuplicateOrdersModalQuery>;
export type DuplicateOrdersModalLazyQueryHookResult = ReturnType<typeof useDuplicateOrdersModalLazyQuery>;
export type DuplicateOrdersModalSuspenseQueryHookResult = ReturnType<typeof useDuplicateOrdersModalSuspenseQuery>;
export type DuplicateOrdersModalQueryResult = Apollo.QueryResult<Types.DuplicateOrdersModalQuery, Types.DuplicateOrdersModalQueryVariables>;
export const EditSpotModalDocument = gql`
    query EditSpotModal($spotId: Int!, $outgoing: Boolean = true) {
  voyageCharterById(id: $spotId) {
    id
    ...SpotForm_SpotContract
  }
}
    ${SpotForm_SpotContractFragmentDoc}`;

/**
 * __useEditSpotModalQuery__
 *
 * To run a query within a React component, call `useEditSpotModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSpotModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSpotModalQuery({
 *   variables: {
 *      spotId: // value for 'spotId'
 *      outgoing: // value for 'outgoing'
 *   },
 * });
 */
export function useEditSpotModalQuery(baseOptions: Apollo.QueryHookOptions<Types.EditSpotModalQuery, Types.EditSpotModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EditSpotModalQuery, Types.EditSpotModalQueryVariables>(EditSpotModalDocument, options);
      }
export function useEditSpotModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EditSpotModalQuery, Types.EditSpotModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EditSpotModalQuery, Types.EditSpotModalQueryVariables>(EditSpotModalDocument, options);
        }
export function useEditSpotModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EditSpotModalQuery, Types.EditSpotModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EditSpotModalQuery, Types.EditSpotModalQueryVariables>(EditSpotModalDocument, options);
        }
export type EditSpotModalQueryHookResult = ReturnType<typeof useEditSpotModalQuery>;
export type EditSpotModalLazyQueryHookResult = ReturnType<typeof useEditSpotModalLazyQuery>;
export type EditSpotModalSuspenseQueryHookResult = ReturnType<typeof useEditSpotModalSuspenseQuery>;
export type EditSpotModalQueryResult = Apollo.QueryResult<Types.EditSpotModalQuery, Types.EditSpotModalQueryVariables>;
export const OrderToEmailDocument = gql`
    query OrderToEmail($input: String!) {
  allEmailToOrderLogs(filter: {orderExternalIds: {anyEqualTo: $input}}) {
    nodes {
      id
      createdAt
      mailSubject
      mailText
      mailHtml
      parsed
      error
    }
  }
}
    `;

/**
 * __useOrderToEmailQuery__
 *
 * To run a query within a React component, call `useOrderToEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderToEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderToEmailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderToEmailQuery(baseOptions: Apollo.QueryHookOptions<Types.OrderToEmailQuery, Types.OrderToEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrderToEmailQuery, Types.OrderToEmailQueryVariables>(OrderToEmailDocument, options);
      }
export function useOrderToEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrderToEmailQuery, Types.OrderToEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrderToEmailQuery, Types.OrderToEmailQueryVariables>(OrderToEmailDocument, options);
        }
export function useOrderToEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OrderToEmailQuery, Types.OrderToEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OrderToEmailQuery, Types.OrderToEmailQueryVariables>(OrderToEmailDocument, options);
        }
export type OrderToEmailQueryHookResult = ReturnType<typeof useOrderToEmailQuery>;
export type OrderToEmailLazyQueryHookResult = ReturnType<typeof useOrderToEmailLazyQuery>;
export type OrderToEmailSuspenseQueryHookResult = ReturnType<typeof useOrderToEmailSuspenseQuery>;
export type OrderToEmailQueryResult = Apollo.QueryResult<Types.OrderToEmailQuery, Types.OrderToEmailQueryVariables>;
export const FetchOrderAssignmentByClientIdDocument = gql`
    query FetchOrderAssignmentByClientId($clientId: UUID!) {
  allScheduledOrders(condition: {clientId: $clientId}) {
    nodes {
      id
    }
  }
  allHandledByCoas(condition: {clientId: $clientId}) {
    nodes {
      id
    }
  }
  allHandledBySpots(condition: {clientId: $clientId}) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useFetchOrderAssignmentByClientIdQuery__
 *
 * To run a query within a React component, call `useFetchOrderAssignmentByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderAssignmentByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderAssignmentByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useFetchOrderAssignmentByClientIdQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchOrderAssignmentByClientIdQuery, Types.FetchOrderAssignmentByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchOrderAssignmentByClientIdQuery, Types.FetchOrderAssignmentByClientIdQueryVariables>(FetchOrderAssignmentByClientIdDocument, options);
      }
export function useFetchOrderAssignmentByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchOrderAssignmentByClientIdQuery, Types.FetchOrderAssignmentByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchOrderAssignmentByClientIdQuery, Types.FetchOrderAssignmentByClientIdQueryVariables>(FetchOrderAssignmentByClientIdDocument, options);
        }
export function useFetchOrderAssignmentByClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchOrderAssignmentByClientIdQuery, Types.FetchOrderAssignmentByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchOrderAssignmentByClientIdQuery, Types.FetchOrderAssignmentByClientIdQueryVariables>(FetchOrderAssignmentByClientIdDocument, options);
        }
export type FetchOrderAssignmentByClientIdQueryHookResult = ReturnType<typeof useFetchOrderAssignmentByClientIdQuery>;
export type FetchOrderAssignmentByClientIdLazyQueryHookResult = ReturnType<typeof useFetchOrderAssignmentByClientIdLazyQuery>;
export type FetchOrderAssignmentByClientIdSuspenseQueryHookResult = ReturnType<typeof useFetchOrderAssignmentByClientIdSuspenseQuery>;
export type FetchOrderAssignmentByClientIdQueryResult = Apollo.QueryResult<Types.FetchOrderAssignmentByClientIdQuery, Types.FetchOrderAssignmentByClientIdQueryVariables>;
export const FormSettingsDocument = gql`
    query FormSettings {
  currentUser {
    id
    userSettingsByUserId {
      nodes {
        id
        formSettings
      }
    }
  }
}
    `;

/**
 * __useFormSettingsQuery__
 *
 * To run a query within a React component, call `useFormSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFormSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FormSettingsQuery, Types.FormSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FormSettingsQuery, Types.FormSettingsQueryVariables>(FormSettingsDocument, options);
      }
export function useFormSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FormSettingsQuery, Types.FormSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FormSettingsQuery, Types.FormSettingsQueryVariables>(FormSettingsDocument, options);
        }
export function useFormSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FormSettingsQuery, Types.FormSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FormSettingsQuery, Types.FormSettingsQueryVariables>(FormSettingsDocument, options);
        }
export type FormSettingsQueryHookResult = ReturnType<typeof useFormSettingsQuery>;
export type FormSettingsLazyQueryHookResult = ReturnType<typeof useFormSettingsLazyQuery>;
export type FormSettingsSuspenseQueryHookResult = ReturnType<typeof useFormSettingsSuspenseQuery>;
export type FormSettingsQueryResult = Apollo.QueryResult<Types.FormSettingsQuery, Types.FormSettingsQueryVariables>;
export const UpdateFormSettingsDocument = gql`
    mutation UpdateFormSettings($id: Int!, $formSettings: JSON) {
  updateUserSettingById(
    input: {userSettingPatch: {formSettings: $formSettings}, id: $id}
  ) {
    userSetting {
      id
      formSettings
    }
  }
}
    `;
export type UpdateFormSettingsMutationFn = Apollo.MutationFunction<Types.UpdateFormSettingsMutation, Types.UpdateFormSettingsMutationVariables>;

/**
 * __useUpdateFormSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFormSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormSettingsMutation, { data, loading, error }] = useUpdateFormSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      formSettings: // value for 'formSettings'
 *   },
 * });
 */
export function useUpdateFormSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFormSettingsMutation, Types.UpdateFormSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFormSettingsMutation, Types.UpdateFormSettingsMutationVariables>(UpdateFormSettingsDocument, options);
      }
export type UpdateFormSettingsMutationHookResult = ReturnType<typeof useUpdateFormSettingsMutation>;
export type UpdateFormSettingsMutationResult = Apollo.MutationResult<Types.UpdateFormSettingsMutation>;
export type UpdateFormSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFormSettingsMutation, Types.UpdateFormSettingsMutationVariables>;
export const GetRouteDocument = gql`
    query GetRoute($from: Int!, $to: Int!, $draft: BigFloat, $avoidsChannels: Boolean!, $noGoZones: [Int]) {
  routeByPortPair(
    from: $from
    to: $to
    draft: $draft
    avoidsChannels: $avoidsChannels
    noGoZones: $noGoZones
  )
}
    `;

/**
 * __useGetRouteQuery__
 *
 * To run a query within a React component, call `useGetRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      draft: // value for 'draft'
 *      avoidsChannels: // value for 'avoidsChannels'
 *      noGoZones: // value for 'noGoZones'
 *   },
 * });
 */
export function useGetRouteQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRouteQuery, Types.GetRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRouteQuery, Types.GetRouteQueryVariables>(GetRouteDocument, options);
      }
export function useGetRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRouteQuery, Types.GetRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRouteQuery, Types.GetRouteQueryVariables>(GetRouteDocument, options);
        }
export function useGetRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRouteQuery, Types.GetRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRouteQuery, Types.GetRouteQueryVariables>(GetRouteDocument, options);
        }
export type GetRouteQueryHookResult = ReturnType<typeof useGetRouteQuery>;
export type GetRouteLazyQueryHookResult = ReturnType<typeof useGetRouteLazyQuery>;
export type GetRouteSuspenseQueryHookResult = ReturnType<typeof useGetRouteSuspenseQuery>;
export type GetRouteQueryResult = Apollo.QueryResult<Types.GetRouteQuery, Types.GetRouteQueryVariables>;
export const GetCachedExactRoutesDocument = gql`
    query GetCachedExactRoutes($inputs: [CachedRoutesByPortPairsInputs!]!) {
  cachedExactRoutesByPortPairs(inputs: $inputs) {
    from
    to
    draft
    avoidsChannels
    exact
  }
}
    `;

/**
 * __useGetCachedExactRoutesQuery__
 *
 * To run a query within a React component, call `useGetCachedExactRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCachedExactRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCachedExactRoutesQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGetCachedExactRoutesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCachedExactRoutesQuery, Types.GetCachedExactRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCachedExactRoutesQuery, Types.GetCachedExactRoutesQueryVariables>(GetCachedExactRoutesDocument, options);
      }
export function useGetCachedExactRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCachedExactRoutesQuery, Types.GetCachedExactRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCachedExactRoutesQuery, Types.GetCachedExactRoutesQueryVariables>(GetCachedExactRoutesDocument, options);
        }
export function useGetCachedExactRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCachedExactRoutesQuery, Types.GetCachedExactRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCachedExactRoutesQuery, Types.GetCachedExactRoutesQueryVariables>(GetCachedExactRoutesDocument, options);
        }
export type GetCachedExactRoutesQueryHookResult = ReturnType<typeof useGetCachedExactRoutesQuery>;
export type GetCachedExactRoutesLazyQueryHookResult = ReturnType<typeof useGetCachedExactRoutesLazyQuery>;
export type GetCachedExactRoutesSuspenseQueryHookResult = ReturnType<typeof useGetCachedExactRoutesSuspenseQuery>;
export type GetCachedExactRoutesQueryResult = Apollo.QueryResult<Types.GetCachedExactRoutesQuery, Types.GetCachedExactRoutesQueryVariables>;
export const GetCachedRoutesDocument = gql`
    query GetCachedRoutes($inputs: [CachedRoutesByPortPairsInputs!]!) {
  cachedRoutesByPortPairs(inputs: $inputs) {
    from
    to
    draft
    avoidsChannels
    exact
  }
}
    `;

/**
 * __useGetCachedRoutesQuery__
 *
 * To run a query within a React component, call `useGetCachedRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCachedRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCachedRoutesQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGetCachedRoutesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCachedRoutesQuery, Types.GetCachedRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCachedRoutesQuery, Types.GetCachedRoutesQueryVariables>(GetCachedRoutesDocument, options);
      }
export function useGetCachedRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCachedRoutesQuery, Types.GetCachedRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCachedRoutesQuery, Types.GetCachedRoutesQueryVariables>(GetCachedRoutesDocument, options);
        }
export function useGetCachedRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCachedRoutesQuery, Types.GetCachedRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCachedRoutesQuery, Types.GetCachedRoutesQueryVariables>(GetCachedRoutesDocument, options);
        }
export type GetCachedRoutesQueryHookResult = ReturnType<typeof useGetCachedRoutesQuery>;
export type GetCachedRoutesLazyQueryHookResult = ReturnType<typeof useGetCachedRoutesLazyQuery>;
export type GetCachedRoutesSuspenseQueryHookResult = ReturnType<typeof useGetCachedRoutesSuspenseQuery>;
export type GetCachedRoutesQueryResult = Apollo.QueryResult<Types.GetCachedRoutesQuery, Types.GetCachedRoutesQueryVariables>;
export const GetRoutesDocument = gql`
    query GetRoutes($inputs: [CachedRoutesByPortPairsInputs!]!) {
  routesByPortPairs(inputs: $inputs) {
    from
    to
    draft
    avoidsChannels
    exact
  }
}
    `;

/**
 * __useGetRoutesQuery__
 *
 * To run a query within a React component, call `useGetRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoutesQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGetRoutesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRoutesQuery, Types.GetRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRoutesQuery, Types.GetRoutesQueryVariables>(GetRoutesDocument, options);
      }
export function useGetRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRoutesQuery, Types.GetRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRoutesQuery, Types.GetRoutesQueryVariables>(GetRoutesDocument, options);
        }
export function useGetRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRoutesQuery, Types.GetRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRoutesQuery, Types.GetRoutesQueryVariables>(GetRoutesDocument, options);
        }
export type GetRoutesQueryHookResult = ReturnType<typeof useGetRoutesQuery>;
export type GetRoutesLazyQueryHookResult = ReturnType<typeof useGetRoutesLazyQuery>;
export type GetRoutesSuspenseQueryHookResult = ReturnType<typeof useGetRoutesSuspenseQuery>;
export type GetRoutesQueryResult = Apollo.QueryResult<Types.GetRoutesQuery, Types.GetRoutesQueryVariables>;
export const GetRouteOverridesDocument = gql`
    query GetRouteOverrides {
  allRouteOverrides {
    nodes {
      id
      organisationId
      fromId
      toId
      distance
      time
      vesselId
      userId
      avoidsChannels
    }
  }
}
    `;

/**
 * __useGetRouteOverridesQuery__
 *
 * To run a query within a React component, call `useGetRouteOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteOverridesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRouteOverridesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetRouteOverridesQuery, Types.GetRouteOverridesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRouteOverridesQuery, Types.GetRouteOverridesQueryVariables>(GetRouteOverridesDocument, options);
      }
export function useGetRouteOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRouteOverridesQuery, Types.GetRouteOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRouteOverridesQuery, Types.GetRouteOverridesQueryVariables>(GetRouteOverridesDocument, options);
        }
export function useGetRouteOverridesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRouteOverridesQuery, Types.GetRouteOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRouteOverridesQuery, Types.GetRouteOverridesQueryVariables>(GetRouteOverridesDocument, options);
        }
export type GetRouteOverridesQueryHookResult = ReturnType<typeof useGetRouteOverridesQuery>;
export type GetRouteOverridesLazyQueryHookResult = ReturnType<typeof useGetRouteOverridesLazyQuery>;
export type GetRouteOverridesSuspenseQueryHookResult = ReturnType<typeof useGetRouteOverridesSuspenseQuery>;
export type GetRouteOverridesQueryResult = Apollo.QueryResult<Types.GetRouteOverridesQuery, Types.GetRouteOverridesQueryVariables>;
export const VoyageIncomeDocument = gql`
    query VoyageIncome {
  allVoyageCharters {
    nodes {
      id
      ...VoyageIncomeQuery_VoyageCharter
    }
  }
}
    ${VoyageIncomeQuery_VoyageCharterFragmentDoc}`;

/**
 * __useVoyageIncomeQuery__
 *
 * To run a query within a React component, call `useVoyageIncomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageIncomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageIncomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useVoyageIncomeQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyageIncomeQuery, Types.VoyageIncomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageIncomeQuery, Types.VoyageIncomeQueryVariables>(VoyageIncomeDocument, options);
      }
export function useVoyageIncomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageIncomeQuery, Types.VoyageIncomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageIncomeQuery, Types.VoyageIncomeQueryVariables>(VoyageIncomeDocument, options);
        }
export function useVoyageIncomeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageIncomeQuery, Types.VoyageIncomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageIncomeQuery, Types.VoyageIncomeQueryVariables>(VoyageIncomeDocument, options);
        }
export type VoyageIncomeQueryHookResult = ReturnType<typeof useVoyageIncomeQuery>;
export type VoyageIncomeLazyQueryHookResult = ReturnType<typeof useVoyageIncomeLazyQuery>;
export type VoyageIncomeSuspenseQueryHookResult = ReturnType<typeof useVoyageIncomeSuspenseQuery>;
export type VoyageIncomeQueryResult = Apollo.QueryResult<Types.VoyageIncomeQuery, Types.VoyageIncomeQueryVariables>;
export const IncomingDocument = gql`
    query Incoming {
  allVwSapOrdersIntegrations {
    nodes {
      ...IncomingEntry
    }
  }
}
    ${IncomingEntryFragmentDoc}`;

/**
 * __useIncomingQuery__
 *
 * To run a query within a React component, call `useIncomingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingQuery({
 *   variables: {
 *   },
 * });
 */
export function useIncomingQuery(baseOptions?: Apollo.QueryHookOptions<Types.IncomingQuery, Types.IncomingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IncomingQuery, Types.IncomingQueryVariables>(IncomingDocument, options);
      }
export function useIncomingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IncomingQuery, Types.IncomingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IncomingQuery, Types.IncomingQueryVariables>(IncomingDocument, options);
        }
export function useIncomingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.IncomingQuery, Types.IncomingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.IncomingQuery, Types.IncomingQueryVariables>(IncomingDocument, options);
        }
export type IncomingQueryHookResult = ReturnType<typeof useIncomingQuery>;
export type IncomingLazyQueryHookResult = ReturnType<typeof useIncomingLazyQuery>;
export type IncomingSuspenseQueryHookResult = ReturnType<typeof useIncomingSuspenseQuery>;
export type IncomingQueryResult = Apollo.QueryResult<Types.IncomingQuery, Types.IncomingQueryVariables>;
export const LatestIntegrationLogDocument = gql`
    query LatestIntegrationLog {
  allIntegrationLogs(orderBy: ID_DESC, first: 1) {
    nodes {
      id
      ...IntegrationLogEntry
    }
  }
}
    ${IntegrationLogEntryFragmentDoc}`;

/**
 * __useLatestIntegrationLogQuery__
 *
 * To run a query within a React component, call `useLatestIntegrationLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestIntegrationLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestIntegrationLogQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestIntegrationLogQuery(baseOptions?: Apollo.QueryHookOptions<Types.LatestIntegrationLogQuery, Types.LatestIntegrationLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LatestIntegrationLogQuery, Types.LatestIntegrationLogQueryVariables>(LatestIntegrationLogDocument, options);
      }
export function useLatestIntegrationLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LatestIntegrationLogQuery, Types.LatestIntegrationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LatestIntegrationLogQuery, Types.LatestIntegrationLogQueryVariables>(LatestIntegrationLogDocument, options);
        }
export function useLatestIntegrationLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LatestIntegrationLogQuery, Types.LatestIntegrationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LatestIntegrationLogQuery, Types.LatestIntegrationLogQueryVariables>(LatestIntegrationLogDocument, options);
        }
export type LatestIntegrationLogQueryHookResult = ReturnType<typeof useLatestIntegrationLogQuery>;
export type LatestIntegrationLogLazyQueryHookResult = ReturnType<typeof useLatestIntegrationLogLazyQuery>;
export type LatestIntegrationLogSuspenseQueryHookResult = ReturnType<typeof useLatestIntegrationLogSuspenseQuery>;
export type LatestIntegrationLogQueryResult = Apollo.QueryResult<Types.LatestIntegrationLogQuery, Types.LatestIntegrationLogQueryVariables>;
export const AllIntegrationLogsDocument = gql`
    query AllIntegrationLogs($runtime_uuid: UUID) {
  allIntegrationLogs(
    orderBy: ID_ASC
    filter: {runtimeUuid: {equalTo: $runtime_uuid}}
  ) {
    nodes {
      id
      ...IntegrationLogEntry
    }
  }
}
    ${IntegrationLogEntryFragmentDoc}`;

/**
 * __useAllIntegrationLogsQuery__
 *
 * To run a query within a React component, call `useAllIntegrationLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllIntegrationLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllIntegrationLogsQuery({
 *   variables: {
 *      runtime_uuid: // value for 'runtime_uuid'
 *   },
 * });
 */
export function useAllIntegrationLogsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllIntegrationLogsQuery, Types.AllIntegrationLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllIntegrationLogsQuery, Types.AllIntegrationLogsQueryVariables>(AllIntegrationLogsDocument, options);
      }
export function useAllIntegrationLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllIntegrationLogsQuery, Types.AllIntegrationLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllIntegrationLogsQuery, Types.AllIntegrationLogsQueryVariables>(AllIntegrationLogsDocument, options);
        }
export function useAllIntegrationLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllIntegrationLogsQuery, Types.AllIntegrationLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllIntegrationLogsQuery, Types.AllIntegrationLogsQueryVariables>(AllIntegrationLogsDocument, options);
        }
export type AllIntegrationLogsQueryHookResult = ReturnType<typeof useAllIntegrationLogsQuery>;
export type AllIntegrationLogsLazyQueryHookResult = ReturnType<typeof useAllIntegrationLogsLazyQuery>;
export type AllIntegrationLogsSuspenseQueryHookResult = ReturnType<typeof useAllIntegrationLogsSuspenseQuery>;
export type AllIntegrationLogsQueryResult = Apollo.QueryResult<Types.AllIntegrationLogsQuery, Types.AllIntegrationLogsQueryVariables>;
export const RaptorDraftDocument = gql`
    query RaptorDraft($imo: Int!, $loadedMass: Float!) {
  getRaptorDraft(imo: $imo, loadedMass: $loadedMass) {
    fit
    lwr
    upr
  }
}
    `;

/**
 * __useRaptorDraftQuery__
 *
 * To run a query within a React component, call `useRaptorDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useRaptorDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaptorDraftQuery({
 *   variables: {
 *      imo: // value for 'imo'
 *      loadedMass: // value for 'loadedMass'
 *   },
 * });
 */
export function useRaptorDraftQuery(baseOptions: Apollo.QueryHookOptions<Types.RaptorDraftQuery, Types.RaptorDraftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RaptorDraftQuery, Types.RaptorDraftQueryVariables>(RaptorDraftDocument, options);
      }
export function useRaptorDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RaptorDraftQuery, Types.RaptorDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RaptorDraftQuery, Types.RaptorDraftQueryVariables>(RaptorDraftDocument, options);
        }
export function useRaptorDraftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RaptorDraftQuery, Types.RaptorDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RaptorDraftQuery, Types.RaptorDraftQueryVariables>(RaptorDraftDocument, options);
        }
export type RaptorDraftQueryHookResult = ReturnType<typeof useRaptorDraftQuery>;
export type RaptorDraftLazyQueryHookResult = ReturnType<typeof useRaptorDraftLazyQuery>;
export type RaptorDraftSuspenseQueryHookResult = ReturnType<typeof useRaptorDraftSuspenseQuery>;
export type RaptorDraftQueryResult = Apollo.QueryResult<Types.RaptorDraftQuery, Types.RaptorDraftQueryVariables>;
export const NotificationSettingsDocument = gql`
    query NotificationSettings($userId: Int!) {
  allUserSettings(filter: {userId: {equalTo: $userId}}) {
    nodes {
      id
      userId
      ...NotificationSettings
    }
  }
}
    ${NotificationSettingsFragmentDoc}`;

/**
 * __useNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.NotificationSettingsQuery, Types.NotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NotificationSettingsQuery, Types.NotificationSettingsQueryVariables>(NotificationSettingsDocument, options);
      }
export function useNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NotificationSettingsQuery, Types.NotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NotificationSettingsQuery, Types.NotificationSettingsQueryVariables>(NotificationSettingsDocument, options);
        }
export function useNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.NotificationSettingsQuery, Types.NotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.NotificationSettingsQuery, Types.NotificationSettingsQueryVariables>(NotificationSettingsDocument, options);
        }
export type NotificationSettingsQueryHookResult = ReturnType<typeof useNotificationSettingsQuery>;
export type NotificationSettingsLazyQueryHookResult = ReturnType<typeof useNotificationSettingsLazyQuery>;
export type NotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useNotificationSettingsSuspenseQuery>;
export type NotificationSettingsQueryResult = Apollo.QueryResult<Types.NotificationSettingsQuery, Types.NotificationSettingsQueryVariables>;
export const OpenPositionsDocument = gql`
    query OpenPositions {
  allOpenPositions {
    nodes {
      id
      ...OpenPositions
    }
  }
}
    ${OpenPositionsFragmentDoc}`;

/**
 * __useOpenPositionsQuery__
 *
 * To run a query within a React component, call `useOpenPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenPositionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OpenPositionsQuery, Types.OpenPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpenPositionsQuery, Types.OpenPositionsQueryVariables>(OpenPositionsDocument, options);
      }
export function useOpenPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpenPositionsQuery, Types.OpenPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpenPositionsQuery, Types.OpenPositionsQueryVariables>(OpenPositionsDocument, options);
        }
export function useOpenPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpenPositionsQuery, Types.OpenPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpenPositionsQuery, Types.OpenPositionsQueryVariables>(OpenPositionsDocument, options);
        }
export type OpenPositionsQueryHookResult = ReturnType<typeof useOpenPositionsQuery>;
export type OpenPositionsLazyQueryHookResult = ReturnType<typeof useOpenPositionsLazyQuery>;
export type OpenPositionsSuspenseQueryHookResult = ReturnType<typeof useOpenPositionsSuspenseQuery>;
export type OpenPositionsQueryResult = Apollo.QueryResult<Types.OpenPositionsQuery, Types.OpenPositionsQueryVariables>;
export const OrderFormDocument = gql`
    query OrderForm {
  ...OrderForm_Query
}
    ${OrderForm_QueryFragmentDoc}`;

/**
 * __useOrderFormQuery__
 *
 * To run a query within a React component, call `useOrderFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderFormQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrderFormQuery, Types.OrderFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrderFormQuery, Types.OrderFormQueryVariables>(OrderFormDocument, options);
      }
export function useOrderFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrderFormQuery, Types.OrderFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrderFormQuery, Types.OrderFormQueryVariables>(OrderFormDocument, options);
        }
export function useOrderFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OrderFormQuery, Types.OrderFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OrderFormQuery, Types.OrderFormQueryVariables>(OrderFormDocument, options);
        }
export type OrderFormQueryHookResult = ReturnType<typeof useOrderFormQuery>;
export type OrderFormLazyQueryHookResult = ReturnType<typeof useOrderFormLazyQuery>;
export type OrderFormSuspenseQueryHookResult = ReturnType<typeof useOrderFormSuspenseQuery>;
export type OrderFormQueryResult = Apollo.QueryResult<Types.OrderFormQuery, Types.OrderFormQueryVariables>;
export const OrderHistoriesByIdDocument = gql`
    query OrderHistoriesById($orderId: Int) {
  allOrdersHistories(condition: {id: $orderId}) {
    nodes {
      id
      ...OrdersHistory_Order
    }
  }
}
    ${OrdersHistory_OrderFragmentDoc}`;

/**
 * __useOrderHistoriesByIdQuery__
 *
 * To run a query within a React component, call `useOrderHistoriesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderHistoriesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderHistoriesByIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderHistoriesByIdQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrderHistoriesByIdQuery, Types.OrderHistoriesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrderHistoriesByIdQuery, Types.OrderHistoriesByIdQueryVariables>(OrderHistoriesByIdDocument, options);
      }
export function useOrderHistoriesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrderHistoriesByIdQuery, Types.OrderHistoriesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrderHistoriesByIdQuery, Types.OrderHistoriesByIdQueryVariables>(OrderHistoriesByIdDocument, options);
        }
export function useOrderHistoriesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OrderHistoriesByIdQuery, Types.OrderHistoriesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OrderHistoriesByIdQuery, Types.OrderHistoriesByIdQueryVariables>(OrderHistoriesByIdDocument, options);
        }
export type OrderHistoriesByIdQueryHookResult = ReturnType<typeof useOrderHistoriesByIdQuery>;
export type OrderHistoriesByIdLazyQueryHookResult = ReturnType<typeof useOrderHistoriesByIdLazyQuery>;
export type OrderHistoriesByIdSuspenseQueryHookResult = ReturnType<typeof useOrderHistoriesByIdSuspenseQuery>;
export type OrderHistoriesByIdQueryResult = Apollo.QueryResult<Types.OrderHistoriesByIdQuery, Types.OrderHistoriesByIdQueryVariables>;
export const OrderVoyageCharterDocument = gql`
    query OrderVoyageCharter($orderId: Int!, $outgoing: Boolean = false) {
  allOrderVoyageCharterRelations(
    filter: {orderId: {equalTo: $orderId}}
    condition: {outgoing: false}
  ) {
    nodes {
      id
      orderId
      voyageCharterId
      outgoing
      coaRouteId
      voyageCharterByVoyageCharterId {
        id
        ...SpotForm_SpotContract
        isInquiry
        onSubsUntil
        voyageCharterToContractsByVoyageCharterId {
          nodes {
            coaId
            id
          }
        }
      }
    }
  }
}
    ${SpotForm_SpotContractFragmentDoc}`;

/**
 * __useOrderVoyageCharterQuery__
 *
 * To run a query within a React component, call `useOrderVoyageCharterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderVoyageCharterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderVoyageCharterQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      outgoing: // value for 'outgoing'
 *   },
 * });
 */
export function useOrderVoyageCharterQuery(baseOptions: Apollo.QueryHookOptions<Types.OrderVoyageCharterQuery, Types.OrderVoyageCharterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrderVoyageCharterQuery, Types.OrderVoyageCharterQueryVariables>(OrderVoyageCharterDocument, options);
      }
export function useOrderVoyageCharterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrderVoyageCharterQuery, Types.OrderVoyageCharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrderVoyageCharterQuery, Types.OrderVoyageCharterQueryVariables>(OrderVoyageCharterDocument, options);
        }
export function useOrderVoyageCharterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OrderVoyageCharterQuery, Types.OrderVoyageCharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OrderVoyageCharterQuery, Types.OrderVoyageCharterQueryVariables>(OrderVoyageCharterDocument, options);
        }
export type OrderVoyageCharterQueryHookResult = ReturnType<typeof useOrderVoyageCharterQuery>;
export type OrderVoyageCharterLazyQueryHookResult = ReturnType<typeof useOrderVoyageCharterLazyQuery>;
export type OrderVoyageCharterSuspenseQueryHookResult = ReturnType<typeof useOrderVoyageCharterSuspenseQuery>;
export type OrderVoyageCharterQueryResult = Apollo.QueryResult<Types.OrderVoyageCharterQuery, Types.OrderVoyageCharterQueryVariables>;
export const OrdersPageDocument = gql`
    query OrdersPage($showArchived: Boolean) {
  ...ReportingTable
}
    ${ReportingTableFragmentDoc}`;

/**
 * __useOrdersPageQuery__
 *
 * To run a query within a React component, call `useOrdersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersPageQuery({
 *   variables: {
 *      showArchived: // value for 'showArchived'
 *   },
 * });
 */
export function useOrdersPageQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrdersPageQuery, Types.OrdersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrdersPageQuery, Types.OrdersPageQueryVariables>(OrdersPageDocument, options);
      }
export function useOrdersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrdersPageQuery, Types.OrdersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrdersPageQuery, Types.OrdersPageQueryVariables>(OrdersPageDocument, options);
        }
export function useOrdersPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OrdersPageQuery, Types.OrdersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OrdersPageQuery, Types.OrdersPageQueryVariables>(OrdersPageDocument, options);
        }
export type OrdersPageQueryHookResult = ReturnType<typeof useOrdersPageQuery>;
export type OrdersPageLazyQueryHookResult = ReturnType<typeof useOrdersPageLazyQuery>;
export type OrdersPageSuspenseQueryHookResult = ReturnType<typeof useOrdersPageSuspenseQuery>;
export type OrdersPageQueryResult = Apollo.QueryResult<Types.OrdersPageQuery, Types.OrdersPageQueryVariables>;
export const PlanningPageDocument = gql`
    query PlanningPage($showArchived: Boolean) {
  ...ScenarioTimeline_Query
  ...PortCostEstimatesQuery
  allZones {
    nodes {
      id
      name
      zoneLocationsByZoneId {
        nodes {
          id
          zoneId
          locationId
        }
      }
    }
  }
  allAssortments {
    nodes {
      id
      assortmentGroupByAssortmentGroup {
        id
      }
    }
  }
  lastCommit: allCommitLogs(
    condition: {success: true}
    orderBy: COMMITTED_AT_DESC
    first: 1
  ) {
    nodes {
      id
      ...LastCommit
    }
  }
}
    ${ScenarioTimeline_QueryFragmentDoc}
${PortCostEstimatesQueryFragmentDoc}
${LastCommitFragmentDoc}`;

/**
 * __usePlanningPageQuery__
 *
 * To run a query within a React component, call `usePlanningPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningPageQuery({
 *   variables: {
 *      showArchived: // value for 'showArchived'
 *   },
 * });
 */
export function usePlanningPageQuery(baseOptions?: Apollo.QueryHookOptions<Types.PlanningPageQuery, Types.PlanningPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PlanningPageQuery, Types.PlanningPageQueryVariables>(PlanningPageDocument, options);
      }
export function usePlanningPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PlanningPageQuery, Types.PlanningPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PlanningPageQuery, Types.PlanningPageQueryVariables>(PlanningPageDocument, options);
        }
export function usePlanningPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PlanningPageQuery, Types.PlanningPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PlanningPageQuery, Types.PlanningPageQueryVariables>(PlanningPageDocument, options);
        }
export type PlanningPageQueryHookResult = ReturnType<typeof usePlanningPageQuery>;
export type PlanningPageLazyQueryHookResult = ReturnType<typeof usePlanningPageLazyQuery>;
export type PlanningPageSuspenseQueryHookResult = ReturnType<typeof usePlanningPageSuspenseQuery>;
export type PlanningPageQueryResult = Apollo.QueryResult<Types.PlanningPageQuery, Types.PlanningPageQueryVariables>;
export const UsersDocument = gql`
    query Users {
  allUsers {
    nodes {
      id
      ...UserWithName
    }
  }
}
    ${UserWithNameFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.UsersQuery, Types.UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UsersQuery, Types.UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UsersQuery, Types.UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UsersQuery, Types.UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UsersQuery, Types.UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UsersQuery, Types.UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<Types.UsersQuery, Types.UsersQueryVariables>;
export const PortCallUpdatesDocument = gql`
    query PortCallUpdates($portCallClientIds: [UUID!]) {
  allPortCalls(filter: {clientId: {in: $portCallClientIds}}) {
    nodes {
      id
      clientId
      portNoticesByPortCallId {
        nodes {
          id
          ataBerth
          ataPbp
          eta
          berthingProspects
          etdBerth
          sysPeriod {
            start {
              value
            }
          }
        }
      }
      statementOfFactsByPortCallId {
        nodes {
          id
          arrivalTime
          berthed
          sailingTime
          sysPeriod {
            start {
              value
            }
          }
        }
      }
      portCallExternalTimestampsByPortCallId {
        nodes {
          id
          ...PortCallExternalTimestamp
        }
      }
    }
  }
}
    ${PortCallExternalTimestampFragmentDoc}`;

/**
 * __usePortCallUpdatesQuery__
 *
 * To run a query within a React component, call `usePortCallUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortCallUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortCallUpdatesQuery({
 *   variables: {
 *      portCallClientIds: // value for 'portCallClientIds'
 *   },
 * });
 */
export function usePortCallUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PortCallUpdatesQuery, Types.PortCallUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PortCallUpdatesQuery, Types.PortCallUpdatesQueryVariables>(PortCallUpdatesDocument, options);
      }
export function usePortCallUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PortCallUpdatesQuery, Types.PortCallUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PortCallUpdatesQuery, Types.PortCallUpdatesQueryVariables>(PortCallUpdatesDocument, options);
        }
export function usePortCallUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PortCallUpdatesQuery, Types.PortCallUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PortCallUpdatesQuery, Types.PortCallUpdatesQueryVariables>(PortCallUpdatesDocument, options);
        }
export type PortCallUpdatesQueryHookResult = ReturnType<typeof usePortCallUpdatesQuery>;
export type PortCallUpdatesLazyQueryHookResult = ReturnType<typeof usePortCallUpdatesLazyQuery>;
export type PortCallUpdatesSuspenseQueryHookResult = ReturnType<typeof usePortCallUpdatesSuspenseQuery>;
export type PortCallUpdatesQueryResult = Apollo.QueryResult<Types.PortCallUpdatesQuery, Types.PortCallUpdatesQueryVariables>;
export const PortCallsDocumentsDocument = gql`
    query PortCallsDocuments($portCallClientIds: [UUID!], $orderIds: [Int!]) {
  ...PortCallsDocumentsQuery
}
    ${PortCallsDocumentsQueryFragmentDoc}`;

/**
 * __usePortCallsDocumentsQuery__
 *
 * To run a query within a React component, call `usePortCallsDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortCallsDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortCallsDocumentsQuery({
 *   variables: {
 *      portCallClientIds: // value for 'portCallClientIds'
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function usePortCallsDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PortCallsDocumentsQuery, Types.PortCallsDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PortCallsDocumentsQuery, Types.PortCallsDocumentsQueryVariables>(PortCallsDocumentsDocument, options);
      }
export function usePortCallsDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PortCallsDocumentsQuery, Types.PortCallsDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PortCallsDocumentsQuery, Types.PortCallsDocumentsQueryVariables>(PortCallsDocumentsDocument, options);
        }
export function usePortCallsDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PortCallsDocumentsQuery, Types.PortCallsDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PortCallsDocumentsQuery, Types.PortCallsDocumentsQueryVariables>(PortCallsDocumentsDocument, options);
        }
export type PortCallsDocumentsQueryHookResult = ReturnType<typeof usePortCallsDocumentsQuery>;
export type PortCallsDocumentsLazyQueryHookResult = ReturnType<typeof usePortCallsDocumentsLazyQuery>;
export type PortCallsDocumentsSuspenseQueryHookResult = ReturnType<typeof usePortCallsDocumentsSuspenseQuery>;
export type PortCallsDocumentsQueryResult = Apollo.QueryResult<Types.PortCallsDocumentsQuery, Types.PortCallsDocumentsQueryVariables>;
export const VoyageCharterPortCostsDocument = gql`
    query VoyageCharterPortCosts {
  allVoyageCharterPortCosts {
    nodes {
      id
      voyageCharterId
      voyageCharterByVoyageCharterId {
        id
        externalId
        currency
      }
      portCostByPortCostId {
        id
        ...PortCost_fields
      }
    }
  }
}
    ${PortCost_FieldsFragmentDoc}`;

/**
 * __useVoyageCharterPortCostsQuery__
 *
 * To run a query within a React component, call `useVoyageCharterPortCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterPortCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterPortCostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVoyageCharterPortCostsQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyageCharterPortCostsQuery, Types.VoyageCharterPortCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterPortCostsQuery, Types.VoyageCharterPortCostsQueryVariables>(VoyageCharterPortCostsDocument, options);
      }
export function useVoyageCharterPortCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterPortCostsQuery, Types.VoyageCharterPortCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterPortCostsQuery, Types.VoyageCharterPortCostsQueryVariables>(VoyageCharterPortCostsDocument, options);
        }
export function useVoyageCharterPortCostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterPortCostsQuery, Types.VoyageCharterPortCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterPortCostsQuery, Types.VoyageCharterPortCostsQueryVariables>(VoyageCharterPortCostsDocument, options);
        }
export type VoyageCharterPortCostsQueryHookResult = ReturnType<typeof useVoyageCharterPortCostsQuery>;
export type VoyageCharterPortCostsLazyQueryHookResult = ReturnType<typeof useVoyageCharterPortCostsLazyQuery>;
export type VoyageCharterPortCostsSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterPortCostsSuspenseQuery>;
export type VoyageCharterPortCostsQueryResult = Apollo.QueryResult<Types.VoyageCharterPortCostsQuery, Types.VoyageCharterPortCostsQueryVariables>;
export const CoaPortCostsDocument = gql`
    query CoaPortCosts {
  allCoaContractPortCosts {
    nodes {
      id
      coaContractByCoaContractId {
        currency
      }
      ...CoaForm_PortCost
    }
  }
}
    ${CoaForm_PortCostFragmentDoc}`;

/**
 * __useCoaPortCostsQuery__
 *
 * To run a query within a React component, call `useCoaPortCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoaPortCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoaPortCostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoaPortCostsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CoaPortCostsQuery, Types.CoaPortCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CoaPortCostsQuery, Types.CoaPortCostsQueryVariables>(CoaPortCostsDocument, options);
      }
export function useCoaPortCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CoaPortCostsQuery, Types.CoaPortCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CoaPortCostsQuery, Types.CoaPortCostsQueryVariables>(CoaPortCostsDocument, options);
        }
export function useCoaPortCostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CoaPortCostsQuery, Types.CoaPortCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CoaPortCostsQuery, Types.CoaPortCostsQueryVariables>(CoaPortCostsDocument, options);
        }
export type CoaPortCostsQueryHookResult = ReturnType<typeof useCoaPortCostsQuery>;
export type CoaPortCostsLazyQueryHookResult = ReturnType<typeof useCoaPortCostsLazyQuery>;
export type CoaPortCostsSuspenseQueryHookResult = ReturnType<typeof useCoaPortCostsSuspenseQuery>;
export type CoaPortCostsQueryResult = Apollo.QueryResult<Types.CoaPortCostsQuery, Types.CoaPortCostsQueryVariables>;
export const PortCostEstimatesDocument = gql`
    query PortCostEstimates {
  ...PortCostEstimatesQuery
}
    ${PortCostEstimatesQueryFragmentDoc}`;

/**
 * __usePortCostEstimatesQuery__
 *
 * To run a query within a React component, call `usePortCostEstimatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortCostEstimatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortCostEstimatesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortCostEstimatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PortCostEstimatesQuery, Types.PortCostEstimatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PortCostEstimatesQuery, Types.PortCostEstimatesQueryVariables>(PortCostEstimatesDocument, options);
      }
export function usePortCostEstimatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PortCostEstimatesQuery, Types.PortCostEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PortCostEstimatesQuery, Types.PortCostEstimatesQueryVariables>(PortCostEstimatesDocument, options);
        }
export function usePortCostEstimatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PortCostEstimatesQuery, Types.PortCostEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PortCostEstimatesQuery, Types.PortCostEstimatesQueryVariables>(PortCostEstimatesDocument, options);
        }
export type PortCostEstimatesQueryHookResult = ReturnType<typeof usePortCostEstimatesQuery>;
export type PortCostEstimatesLazyQueryHookResult = ReturnType<typeof usePortCostEstimatesLazyQuery>;
export type PortCostEstimatesSuspenseQueryHookResult = ReturnType<typeof usePortCostEstimatesSuspenseQuery>;
export type PortCostEstimatesQueryResult = Apollo.QueryResult<Types.PortCostEstimatesQuery, Types.PortCostEstimatesQueryVariables>;
export const PortCostsByPortAndPrimaryAttributesDocument = gql`
    query PortCostsByPortAndPrimaryAttributes {
  allPortCostsByPortAndPrimaryAttributes {
    nodes {
      ...PortCostsByPortAndPrimaryAttributes_fields
    }
  }
}
    ${PortCostsByPortAndPrimaryAttributes_FieldsFragmentDoc}`;

/**
 * __usePortCostsByPortAndPrimaryAttributesQuery__
 *
 * To run a query within a React component, call `usePortCostsByPortAndPrimaryAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortCostsByPortAndPrimaryAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortCostsByPortAndPrimaryAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortCostsByPortAndPrimaryAttributesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PortCostsByPortAndPrimaryAttributesQuery, Types.PortCostsByPortAndPrimaryAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PortCostsByPortAndPrimaryAttributesQuery, Types.PortCostsByPortAndPrimaryAttributesQueryVariables>(PortCostsByPortAndPrimaryAttributesDocument, options);
      }
export function usePortCostsByPortAndPrimaryAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PortCostsByPortAndPrimaryAttributesQuery, Types.PortCostsByPortAndPrimaryAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PortCostsByPortAndPrimaryAttributesQuery, Types.PortCostsByPortAndPrimaryAttributesQueryVariables>(PortCostsByPortAndPrimaryAttributesDocument, options);
        }
export function usePortCostsByPortAndPrimaryAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PortCostsByPortAndPrimaryAttributesQuery, Types.PortCostsByPortAndPrimaryAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PortCostsByPortAndPrimaryAttributesQuery, Types.PortCostsByPortAndPrimaryAttributesQueryVariables>(PortCostsByPortAndPrimaryAttributesDocument, options);
        }
export type PortCostsByPortAndPrimaryAttributesQueryHookResult = ReturnType<typeof usePortCostsByPortAndPrimaryAttributesQuery>;
export type PortCostsByPortAndPrimaryAttributesLazyQueryHookResult = ReturnType<typeof usePortCostsByPortAndPrimaryAttributesLazyQuery>;
export type PortCostsByPortAndPrimaryAttributesSuspenseQueryHookResult = ReturnType<typeof usePortCostsByPortAndPrimaryAttributesSuspenseQuery>;
export type PortCostsByPortAndPrimaryAttributesQueryResult = Apollo.QueryResult<Types.PortCostsByPortAndPrimaryAttributesQuery, Types.PortCostsByPortAndPrimaryAttributesQueryVariables>;
export const PortCostEstimatesFromVcDocument = gql`
    query PortCostEstimatesFromVC($vcIds: [Int!]!) {
  allVoyageCharterPortData(filter: {voyageCharterId: {in: $vcIds}}) {
    nodes {
      id
      voyageCharterId
      portDatumByPortDataId {
        id
        portId
        portcallCostEstimation
        portcallCostEstimationCurrency
      }
    }
  }
}
    `;

/**
 * __usePortCostEstimatesFromVcQuery__
 *
 * To run a query within a React component, call `usePortCostEstimatesFromVcQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortCostEstimatesFromVcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortCostEstimatesFromVcQuery({
 *   variables: {
 *      vcIds: // value for 'vcIds'
 *   },
 * });
 */
export function usePortCostEstimatesFromVcQuery(baseOptions: Apollo.QueryHookOptions<Types.PortCostEstimatesFromVcQuery, Types.PortCostEstimatesFromVcQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PortCostEstimatesFromVcQuery, Types.PortCostEstimatesFromVcQueryVariables>(PortCostEstimatesFromVcDocument, options);
      }
export function usePortCostEstimatesFromVcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PortCostEstimatesFromVcQuery, Types.PortCostEstimatesFromVcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PortCostEstimatesFromVcQuery, Types.PortCostEstimatesFromVcQueryVariables>(PortCostEstimatesFromVcDocument, options);
        }
export function usePortCostEstimatesFromVcSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PortCostEstimatesFromVcQuery, Types.PortCostEstimatesFromVcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PortCostEstimatesFromVcQuery, Types.PortCostEstimatesFromVcQueryVariables>(PortCostEstimatesFromVcDocument, options);
        }
export type PortCostEstimatesFromVcQueryHookResult = ReturnType<typeof usePortCostEstimatesFromVcQuery>;
export type PortCostEstimatesFromVcLazyQueryHookResult = ReturnType<typeof usePortCostEstimatesFromVcLazyQuery>;
export type PortCostEstimatesFromVcSuspenseQueryHookResult = ReturnType<typeof usePortCostEstimatesFromVcSuspenseQuery>;
export type PortCostEstimatesFromVcQueryResult = Apollo.QueryResult<Types.PortCostEstimatesFromVcQuery, Types.PortCostEstimatesFromVcQueryVariables>;
export const ExternalPortCostPredictionsDocument = gql`
    query ExternalPortCostPredictions($input: [ExternalPortCostPredictionsInput!]!) {
  externalPortCostPredictions(input: $input) {
    predicted {
      fairway_dues
      harbor_dues
      mooring_dues
      pilotage_dues
      tonnage_dues
      total_dues
      towage_dues
    }
  }
}
    `;

/**
 * __useExternalPortCostPredictionsQuery__
 *
 * To run a query within a React component, call `useExternalPortCostPredictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalPortCostPredictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalPortCostPredictionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalPortCostPredictionsQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalPortCostPredictionsQuery, Types.ExternalPortCostPredictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalPortCostPredictionsQuery, Types.ExternalPortCostPredictionsQueryVariables>(ExternalPortCostPredictionsDocument, options);
      }
export function useExternalPortCostPredictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalPortCostPredictionsQuery, Types.ExternalPortCostPredictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalPortCostPredictionsQuery, Types.ExternalPortCostPredictionsQueryVariables>(ExternalPortCostPredictionsDocument, options);
        }
export function useExternalPortCostPredictionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ExternalPortCostPredictionsQuery, Types.ExternalPortCostPredictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ExternalPortCostPredictionsQuery, Types.ExternalPortCostPredictionsQueryVariables>(ExternalPortCostPredictionsDocument, options);
        }
export type ExternalPortCostPredictionsQueryHookResult = ReturnType<typeof useExternalPortCostPredictionsQuery>;
export type ExternalPortCostPredictionsLazyQueryHookResult = ReturnType<typeof useExternalPortCostPredictionsLazyQuery>;
export type ExternalPortCostPredictionsSuspenseQueryHookResult = ReturnType<typeof useExternalPortCostPredictionsSuspenseQuery>;
export type ExternalPortCostPredictionsQueryResult = Apollo.QueryResult<Types.ExternalPortCostPredictionsQuery, Types.ExternalPortCostPredictionsQueryVariables>;
export const ReconnectDocument = gql`
    query Reconnect {
  allShips {
    nodes {
      id
      ...ScenarioTimeline_Ship
    }
  }
  allOrders(condition: {softDelete: false, archived: false}) {
    nodes {
      id
      ...ScenarioTimeline_Order
    }
  }
  allCoaContracts {
    nodes {
      id
      ...ScenarioTimeline_Coa
    }
  }
  allOrganizations {
    nodes {
      id
      ...ScenarioTimeline_Organization
    }
  }
  allPortCalls(condition: {archived: false}) {
    nodes {
      id
      ...ScenarioTimeline_PortCall
      ...ScenarioTimeline_PortCall_Files
    }
  }
  allScenarios {
    nodes {
      id
      clientId
      updatedAt
    }
  }
}
    ${ScenarioTimeline_ShipFragmentDoc}
${ScenarioTimeline_OrderFragmentDoc}
${ScenarioTimeline_CoaFragmentDoc}
${ScenarioTimeline_OrganizationFragmentDoc}
${ScenarioTimeline_PortCallFragmentDoc}
${ScenarioTimeline_PortCall_FilesFragmentDoc}`;

/**
 * __useReconnectQuery__
 *
 * To run a query within a React component, call `useReconnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReconnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReconnectQuery({
 *   variables: {
 *   },
 * });
 */
export function useReconnectQuery(baseOptions?: Apollo.QueryHookOptions<Types.ReconnectQuery, Types.ReconnectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReconnectQuery, Types.ReconnectQueryVariables>(ReconnectDocument, options);
      }
export function useReconnectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReconnectQuery, Types.ReconnectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReconnectQuery, Types.ReconnectQueryVariables>(ReconnectDocument, options);
        }
export function useReconnectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReconnectQuery, Types.ReconnectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReconnectQuery, Types.ReconnectQueryVariables>(ReconnectDocument, options);
        }
export type ReconnectQueryHookResult = ReturnType<typeof useReconnectQuery>;
export type ReconnectLazyQueryHookResult = ReturnType<typeof useReconnectLazyQuery>;
export type ReconnectSuspenseQueryHookResult = ReturnType<typeof useReconnectSuspenseQuery>;
export type ReconnectQueryResult = Apollo.QueryResult<Types.ReconnectQuery, Types.ReconnectQueryVariables>;
export const RelatedOrgsDocument = gql`
    query RelatedOrgs {
  allOrders {
    nodes {
      id
      relatedOrgs
    }
  }
}
    `;

/**
 * __useRelatedOrgsQuery__
 *
 * To run a query within a React component, call `useRelatedOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRelatedOrgsQuery(baseOptions?: Apollo.QueryHookOptions<Types.RelatedOrgsQuery, Types.RelatedOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RelatedOrgsQuery, Types.RelatedOrgsQueryVariables>(RelatedOrgsDocument, options);
      }
export function useRelatedOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RelatedOrgsQuery, Types.RelatedOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RelatedOrgsQuery, Types.RelatedOrgsQueryVariables>(RelatedOrgsDocument, options);
        }
export function useRelatedOrgsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RelatedOrgsQuery, Types.RelatedOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RelatedOrgsQuery, Types.RelatedOrgsQueryVariables>(RelatedOrgsDocument, options);
        }
export type RelatedOrgsQueryHookResult = ReturnType<typeof useRelatedOrgsQuery>;
export type RelatedOrgsLazyQueryHookResult = ReturnType<typeof useRelatedOrgsLazyQuery>;
export type RelatedOrgsSuspenseQueryHookResult = ReturnType<typeof useRelatedOrgsSuspenseQuery>;
export type RelatedOrgsQueryResult = Apollo.QueryResult<Types.RelatedOrgsQuery, Types.RelatedOrgsQueryVariables>;
export const AllRequestLogsDocument = gql`
    query AllRequestLogs {
  allRequestLogs(orderBy: ID_DESC, first: 5000) {
    nodes {
      id
      ...RequestLogEntry
    }
  }
}
    ${RequestLogEntryFragmentDoc}`;

/**
 * __useAllRequestLogsQuery__
 *
 * To run a query within a React component, call `useAllRequestLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRequestLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRequestLogsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRequestLogsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllRequestLogsQuery, Types.AllRequestLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllRequestLogsQuery, Types.AllRequestLogsQueryVariables>(AllRequestLogsDocument, options);
      }
export function useAllRequestLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllRequestLogsQuery, Types.AllRequestLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllRequestLogsQuery, Types.AllRequestLogsQueryVariables>(AllRequestLogsDocument, options);
        }
export function useAllRequestLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllRequestLogsQuery, Types.AllRequestLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllRequestLogsQuery, Types.AllRequestLogsQueryVariables>(AllRequestLogsDocument, options);
        }
export type AllRequestLogsQueryHookResult = ReturnType<typeof useAllRequestLogsQuery>;
export type AllRequestLogsLazyQueryHookResult = ReturnType<typeof useAllRequestLogsLazyQuery>;
export type AllRequestLogsSuspenseQueryHookResult = ReturnType<typeof useAllRequestLogsSuspenseQuery>;
export type AllRequestLogsQueryResult = Apollo.QueryResult<Types.AllRequestLogsQuery, Types.AllRequestLogsQueryVariables>;
export const ScenariosDocument = gql`
    query Scenarios($scenarioDataSchemaVersion: Int!) {
  allScenarios(condition: {dataSchemaVersion: $scenarioDataSchemaVersion}) {
    nodes {
      id
      ...Scenarios_Scenario
    }
  }
}
    ${Scenarios_ScenarioFragmentDoc}`;

/**
 * __useScenariosQuery__
 *
 * To run a query within a React component, call `useScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenariosQuery({
 *   variables: {
 *      scenarioDataSchemaVersion: // value for 'scenarioDataSchemaVersion'
 *   },
 * });
 */
export function useScenariosQuery(baseOptions: Apollo.QueryHookOptions<Types.ScenariosQuery, Types.ScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ScenariosQuery, Types.ScenariosQueryVariables>(ScenariosDocument, options);
      }
export function useScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ScenariosQuery, Types.ScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ScenariosQuery, Types.ScenariosQueryVariables>(ScenariosDocument, options);
        }
export function useScenariosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ScenariosQuery, Types.ScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ScenariosQuery, Types.ScenariosQueryVariables>(ScenariosDocument, options);
        }
export type ScenariosQueryHookResult = ReturnType<typeof useScenariosQuery>;
export type ScenariosLazyQueryHookResult = ReturnType<typeof useScenariosLazyQuery>;
export type ScenariosSuspenseQueryHookResult = ReturnType<typeof useScenariosSuspenseQuery>;
export type ScenariosQueryResult = Apollo.QueryResult<Types.ScenariosQuery, Types.ScenariosQueryVariables>;
export const ScenariosByIdsDocument = gql`
    query ScenariosByIds($scenarioDataSchemaVersion: Int!, $cids: [UUID!]!) {
  allScenarios(
    filter: {dataSchemaVersion: {equalTo: $scenarioDataSchemaVersion}, clientId: {in: $cids}}
  ) {
    nodes {
      id
      ...Scenarios_Scenario
    }
  }
}
    ${Scenarios_ScenarioFragmentDoc}`;

/**
 * __useScenariosByIdsQuery__
 *
 * To run a query within a React component, call `useScenariosByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenariosByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenariosByIdsQuery({
 *   variables: {
 *      scenarioDataSchemaVersion: // value for 'scenarioDataSchemaVersion'
 *      cids: // value for 'cids'
 *   },
 * });
 */
export function useScenariosByIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.ScenariosByIdsQuery, Types.ScenariosByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ScenariosByIdsQuery, Types.ScenariosByIdsQueryVariables>(ScenariosByIdsDocument, options);
      }
export function useScenariosByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ScenariosByIdsQuery, Types.ScenariosByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ScenariosByIdsQuery, Types.ScenariosByIdsQueryVariables>(ScenariosByIdsDocument, options);
        }
export function useScenariosByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ScenariosByIdsQuery, Types.ScenariosByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ScenariosByIdsQuery, Types.ScenariosByIdsQueryVariables>(ScenariosByIdsDocument, options);
        }
export type ScenariosByIdsQueryHookResult = ReturnType<typeof useScenariosByIdsQuery>;
export type ScenariosByIdsLazyQueryHookResult = ReturnType<typeof useScenariosByIdsLazyQuery>;
export type ScenariosByIdsSuspenseQueryHookResult = ReturnType<typeof useScenariosByIdsSuspenseQuery>;
export type ScenariosByIdsQueryResult = Apollo.QueryResult<Types.ScenariosByIdsQuery, Types.ScenariosByIdsQueryVariables>;
export const ScenarioByClientIdDocument = gql`
    query ScenarioByClientId($clientId: UUID!) {
  scenario: allScenarios(condition: {clientId: $clientId}) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useScenarioByClientIdQuery__
 *
 * To run a query within a React component, call `useScenarioByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useScenarioByClientIdQuery(baseOptions: Apollo.QueryHookOptions<Types.ScenarioByClientIdQuery, Types.ScenarioByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ScenarioByClientIdQuery, Types.ScenarioByClientIdQueryVariables>(ScenarioByClientIdDocument, options);
      }
export function useScenarioByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ScenarioByClientIdQuery, Types.ScenarioByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ScenarioByClientIdQuery, Types.ScenarioByClientIdQueryVariables>(ScenarioByClientIdDocument, options);
        }
export function useScenarioByClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ScenarioByClientIdQuery, Types.ScenarioByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ScenarioByClientIdQuery, Types.ScenarioByClientIdQueryVariables>(ScenarioByClientIdDocument, options);
        }
export type ScenarioByClientIdQueryHookResult = ReturnType<typeof useScenarioByClientIdQuery>;
export type ScenarioByClientIdLazyQueryHookResult = ReturnType<typeof useScenarioByClientIdLazyQuery>;
export type ScenarioByClientIdSuspenseQueryHookResult = ReturnType<typeof useScenarioByClientIdSuspenseQuery>;
export type ScenarioByClientIdQueryResult = Apollo.QueryResult<Types.ScenarioByClientIdQuery, Types.ScenarioByClientIdQueryVariables>;
export const LocationSearchDocument = gql`
    query LocationSearch($name: String!) {
  searchLocations(query: $name) {
    nodes {
      id
      ...ScenarioTimeline_OrderLocation
    }
  }
}
    ${ScenarioTimeline_OrderLocationFragmentDoc}`;

/**
 * __useLocationSearchQuery__
 *
 * To run a query within a React component, call `useLocationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useLocationSearchQuery(baseOptions: Apollo.QueryHookOptions<Types.LocationSearchQuery, Types.LocationSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LocationSearchQuery, Types.LocationSearchQueryVariables>(LocationSearchDocument, options);
      }
export function useLocationSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LocationSearchQuery, Types.LocationSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LocationSearchQuery, Types.LocationSearchQueryVariables>(LocationSearchDocument, options);
        }
export function useLocationSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LocationSearchQuery, Types.LocationSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LocationSearchQuery, Types.LocationSearchQueryVariables>(LocationSearchDocument, options);
        }
export type LocationSearchQueryHookResult = ReturnType<typeof useLocationSearchQuery>;
export type LocationSearchLazyQueryHookResult = ReturnType<typeof useLocationSearchLazyQuery>;
export type LocationSearchSuspenseQueryHookResult = ReturnType<typeof useLocationSearchSuspenseQuery>;
export type LocationSearchQueryResult = Apollo.QueryResult<Types.LocationSearchQuery, Types.LocationSearchQueryVariables>;
export const ShipmentsByExternalIdDocument = gql`
    query ShipmentsByExternalId($externalIds: [String!]!) {
  allShipments(filter: {externalShipmentId: {in: $externalIds}}) {
    nodes {
      id
      externalShipmentId
      ordersByShipmentId {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useShipmentsByExternalIdQuery__
 *
 * To run a query within a React component, call `useShipmentsByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentsByExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentsByExternalIdQuery({
 *   variables: {
 *      externalIds: // value for 'externalIds'
 *   },
 * });
 */
export function useShipmentsByExternalIdQuery(baseOptions: Apollo.QueryHookOptions<Types.ShipmentsByExternalIdQuery, Types.ShipmentsByExternalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ShipmentsByExternalIdQuery, Types.ShipmentsByExternalIdQueryVariables>(ShipmentsByExternalIdDocument, options);
      }
export function useShipmentsByExternalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ShipmentsByExternalIdQuery, Types.ShipmentsByExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ShipmentsByExternalIdQuery, Types.ShipmentsByExternalIdQueryVariables>(ShipmentsByExternalIdDocument, options);
        }
export function useShipmentsByExternalIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ShipmentsByExternalIdQuery, Types.ShipmentsByExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ShipmentsByExternalIdQuery, Types.ShipmentsByExternalIdQueryVariables>(ShipmentsByExternalIdDocument, options);
        }
export type ShipmentsByExternalIdQueryHookResult = ReturnType<typeof useShipmentsByExternalIdQuery>;
export type ShipmentsByExternalIdLazyQueryHookResult = ReturnType<typeof useShipmentsByExternalIdLazyQuery>;
export type ShipmentsByExternalIdSuspenseQueryHookResult = ReturnType<typeof useShipmentsByExternalIdSuspenseQuery>;
export type ShipmentsByExternalIdQueryResult = Apollo.QueryResult<Types.ShipmentsByExternalIdQuery, Types.ShipmentsByExternalIdQueryVariables>;
export const SpotContractDocument = gql`
    query SpotContract($voyageCharterId: Int!, $outgoing: Boolean = true) {
  voyageCharterById(id: $voyageCharterId) {
    id
    ...SpotForm_SpotContract
  }
}
    ${SpotForm_SpotContractFragmentDoc}`;

/**
 * __useSpotContractQuery__
 *
 * To run a query within a React component, call `useSpotContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotContractQuery({
 *   variables: {
 *      voyageCharterId: // value for 'voyageCharterId'
 *      outgoing: // value for 'outgoing'
 *   },
 * });
 */
export function useSpotContractQuery(baseOptions: Apollo.QueryHookOptions<Types.SpotContractQuery, Types.SpotContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SpotContractQuery, Types.SpotContractQueryVariables>(SpotContractDocument, options);
      }
export function useSpotContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SpotContractQuery, Types.SpotContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SpotContractQuery, Types.SpotContractQueryVariables>(SpotContractDocument, options);
        }
export function useSpotContractSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SpotContractQuery, Types.SpotContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SpotContractQuery, Types.SpotContractQueryVariables>(SpotContractDocument, options);
        }
export type SpotContractQueryHookResult = ReturnType<typeof useSpotContractQuery>;
export type SpotContractLazyQueryHookResult = ReturnType<typeof useSpotContractLazyQuery>;
export type SpotContractSuspenseQueryHookResult = ReturnType<typeof useSpotContractSuspenseQuery>;
export type SpotContractQueryResult = Apollo.QueryResult<Types.SpotContractQuery, Types.SpotContractQueryVariables>;
export const SpotFormDocument = gql`
    query SpotForm($unsavedOrderIds: [Int!], $outgoing: Boolean!) {
  ...SpotForm
}
    ${SpotFormFragmentDoc}`;

/**
 * __useSpotFormQuery__
 *
 * To run a query within a React component, call `useSpotFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotFormQuery({
 *   variables: {
 *      unsavedOrderIds: // value for 'unsavedOrderIds'
 *      outgoing: // value for 'outgoing'
 *   },
 * });
 */
export function useSpotFormQuery(baseOptions: Apollo.QueryHookOptions<Types.SpotFormQuery, Types.SpotFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SpotFormQuery, Types.SpotFormQueryVariables>(SpotFormDocument, options);
      }
export function useSpotFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SpotFormQuery, Types.SpotFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SpotFormQuery, Types.SpotFormQueryVariables>(SpotFormDocument, options);
        }
export function useSpotFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SpotFormQuery, Types.SpotFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SpotFormQuery, Types.SpotFormQueryVariables>(SpotFormDocument, options);
        }
export type SpotFormQueryHookResult = ReturnType<typeof useSpotFormQuery>;
export type SpotFormLazyQueryHookResult = ReturnType<typeof useSpotFormLazyQuery>;
export type SpotFormSuspenseQueryHookResult = ReturnType<typeof useSpotFormSuspenseQuery>;
export type SpotFormQueryResult = Apollo.QueryResult<Types.SpotFormQuery, Types.SpotFormQueryVariables>;
export const GetUserDataByIdDocument = gql`
    query GetUserDataById($userId: Int!) {
  userById(id: $userId) {
    id
    name
    nickname
    userId
    email
    familyName
    givenName
    picture
    locale
    userType
    organizationId
    monitoringOnly
    showAdmin
    initials
    preferredWordForVessel
  }
}
    `;

/**
 * __useGetUserDataByIdQuery__
 *
 * To run a query within a React component, call `useGetUserDataByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDataByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserDataByIdQuery, Types.GetUserDataByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserDataByIdQuery, Types.GetUserDataByIdQueryVariables>(GetUserDataByIdDocument, options);
      }
export function useGetUserDataByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserDataByIdQuery, Types.GetUserDataByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserDataByIdQuery, Types.GetUserDataByIdQueryVariables>(GetUserDataByIdDocument, options);
        }
export function useGetUserDataByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserDataByIdQuery, Types.GetUserDataByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserDataByIdQuery, Types.GetUserDataByIdQueryVariables>(GetUserDataByIdDocument, options);
        }
export type GetUserDataByIdQueryHookResult = ReturnType<typeof useGetUserDataByIdQuery>;
export type GetUserDataByIdLazyQueryHookResult = ReturnType<typeof useGetUserDataByIdLazyQuery>;
export type GetUserDataByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserDataByIdSuspenseQuery>;
export type GetUserDataByIdQueryResult = Apollo.QueryResult<Types.GetUserDataByIdQuery, Types.GetUserDataByIdQueryVariables>;
export const VesonPnlDocument = gql`
    query VesonPnl {
  getVesonPnl {
    voyagePnl {
      VesselName
      VoyageNo
      VoyagePnlSummary {
        ActualAmountBase
        EstimatedAmountBase
        Description
        PostedAmountBase
        RootCategory
      }
    }
  }
}
    `;

/**
 * __useVesonPnlQuery__
 *
 * To run a query within a React component, call `useVesonPnlQuery` and pass it any options that fit your needs.
 * When your component renders, `useVesonPnlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVesonPnlQuery({
 *   variables: {
 *   },
 * });
 */
export function useVesonPnlQuery(baseOptions?: Apollo.QueryHookOptions<Types.VesonPnlQuery, Types.VesonPnlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VesonPnlQuery, Types.VesonPnlQueryVariables>(VesonPnlDocument, options);
      }
export function useVesonPnlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VesonPnlQuery, Types.VesonPnlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VesonPnlQuery, Types.VesonPnlQueryVariables>(VesonPnlDocument, options);
        }
export function useVesonPnlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VesonPnlQuery, Types.VesonPnlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VesonPnlQuery, Types.VesonPnlQueryVariables>(VesonPnlDocument, options);
        }
export type VesonPnlQueryHookResult = ReturnType<typeof useVesonPnlQuery>;
export type VesonPnlLazyQueryHookResult = ReturnType<typeof useVesonPnlLazyQuery>;
export type VesonPnlSuspenseQueryHookResult = ReturnType<typeof useVesonPnlSuspenseQuery>;
export type VesonPnlQueryResult = Apollo.QueryResult<Types.VesonPnlQuery, Types.VesonPnlQueryVariables>;
export const VesonBunkerDocument = gql`
    query VesonBunker {
  getVesonBunker {
    remainingBunkerOfVoyages {
      id
      voyage
      bunkerOpen {
        price
        amount
        name
      }
      bunkerClose {
        price
        amount
        name
      }
    }
    defaultBunkerOfVessels {
      id
      vessel_code
      bunker {
        price
        name
      }
    }
    errorMessage
  }
}
    `;

/**
 * __useVesonBunkerQuery__
 *
 * To run a query within a React component, call `useVesonBunkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useVesonBunkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVesonBunkerQuery({
 *   variables: {
 *   },
 * });
 */
export function useVesonBunkerQuery(baseOptions?: Apollo.QueryHookOptions<Types.VesonBunkerQuery, Types.VesonBunkerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VesonBunkerQuery, Types.VesonBunkerQueryVariables>(VesonBunkerDocument, options);
      }
export function useVesonBunkerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VesonBunkerQuery, Types.VesonBunkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VesonBunkerQuery, Types.VesonBunkerQueryVariables>(VesonBunkerDocument, options);
        }
export function useVesonBunkerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VesonBunkerQuery, Types.VesonBunkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VesonBunkerQuery, Types.VesonBunkerQueryVariables>(VesonBunkerDocument, options);
        }
export type VesonBunkerQueryHookResult = ReturnType<typeof useVesonBunkerQuery>;
export type VesonBunkerLazyQueryHookResult = ReturnType<typeof useVesonBunkerLazyQuery>;
export type VesonBunkerSuspenseQueryHookResult = ReturnType<typeof useVesonBunkerSuspenseQuery>;
export type VesonBunkerQueryResult = Apollo.QueryResult<Types.VesonBunkerQuery, Types.VesonBunkerQueryVariables>;
export const VesselChangeFormDocument = gql`
    query VesselChangeForm($shipownerOrgId: Int!, $includeCoaVessels: Boolean!, $coaId: Int, $includeVoyageCharter: Boolean!, $voyageCharterId: Int!) {
  allShips(filter: {organizationId: {equalTo: $shipownerOrgId}}) {
    nodes {
      id
      ...VesselChangeForm_Vessel
    }
  }
  allCoaContractShips(filter: {coaContractId: {equalTo: $coaId}}) @include(if: $includeCoaVessels) {
    nodes {
      id
      shipId
    }
  }
  voyageCharterById(id: $voyageCharterId) @include(if: $includeVoyageCharter) {
    id
    layday
    cancelling
    shipByVesselId {
      id
      name
    }
  }
}
    ${VesselChangeForm_VesselFragmentDoc}`;

/**
 * __useVesselChangeFormQuery__
 *
 * To run a query within a React component, call `useVesselChangeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useVesselChangeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVesselChangeFormQuery({
 *   variables: {
 *      shipownerOrgId: // value for 'shipownerOrgId'
 *      includeCoaVessels: // value for 'includeCoaVessels'
 *      coaId: // value for 'coaId'
 *      includeVoyageCharter: // value for 'includeVoyageCharter'
 *      voyageCharterId: // value for 'voyageCharterId'
 *   },
 * });
 */
export function useVesselChangeFormQuery(baseOptions: Apollo.QueryHookOptions<Types.VesselChangeFormQuery, Types.VesselChangeFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VesselChangeFormQuery, Types.VesselChangeFormQueryVariables>(VesselChangeFormDocument, options);
      }
export function useVesselChangeFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VesselChangeFormQuery, Types.VesselChangeFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VesselChangeFormQuery, Types.VesselChangeFormQueryVariables>(VesselChangeFormDocument, options);
        }
export function useVesselChangeFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VesselChangeFormQuery, Types.VesselChangeFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VesselChangeFormQuery, Types.VesselChangeFormQueryVariables>(VesselChangeFormDocument, options);
        }
export type VesselChangeFormQueryHookResult = ReturnType<typeof useVesselChangeFormQuery>;
export type VesselChangeFormLazyQueryHookResult = ReturnType<typeof useVesselChangeFormLazyQuery>;
export type VesselChangeFormSuspenseQueryHookResult = ReturnType<typeof useVesselChangeFormSuspenseQuery>;
export type VesselChangeFormQueryResult = Apollo.QueryResult<Types.VesselChangeFormQuery, Types.VesselChangeFormQueryVariables>;
export const AllVesselReservationsDocument = gql`
    query AllVesselReservations {
  allVesselReservations {
    nodes {
      id
      ...VesselReservation
    }
  }
}
    ${VesselReservationFragmentDoc}`;

/**
 * __useAllVesselReservationsQuery__
 *
 * To run a query within a React component, call `useAllVesselReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVesselReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVesselReservationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVesselReservationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVesselReservationsQuery, Types.AllVesselReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVesselReservationsQuery, Types.AllVesselReservationsQueryVariables>(AllVesselReservationsDocument, options);
      }
export function useAllVesselReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVesselReservationsQuery, Types.AllVesselReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVesselReservationsQuery, Types.AllVesselReservationsQueryVariables>(AllVesselReservationsDocument, options);
        }
export function useAllVesselReservationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVesselReservationsQuery, Types.AllVesselReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVesselReservationsQuery, Types.AllVesselReservationsQueryVariables>(AllVesselReservationsDocument, options);
        }
export type AllVesselReservationsQueryHookResult = ReturnType<typeof useAllVesselReservationsQuery>;
export type AllVesselReservationsLazyQueryHookResult = ReturnType<typeof useAllVesselReservationsLazyQuery>;
export type AllVesselReservationsSuspenseQueryHookResult = ReturnType<typeof useAllVesselReservationsSuspenseQuery>;
export type AllVesselReservationsQueryResult = Apollo.QueryResult<Types.AllVesselReservationsQuery, Types.AllVesselReservationsQueryVariables>;
export const VoyageCharterDataForCommitDocument = gql`
    query VoyageCharterDataForCommit($coaIds: [Int!], $voyageCharterIds: [Int!]) {
  allCoaContracts(filter: {id: {in: $coaIds}}) {
    nodes {
      id
      currency
      paymentDays
      paymentTrigger
      paymentType
      shipownerOrgId
      coaContractShipsByCoaContractId {
        nodes {
          id
          demurrage
          shipId
        }
      }
      coaContractPricesByCoaContractId {
        nodes {
          id
          coaAssortmentId
          price
          routeId
          coaContractPortByRouteId {
            id
            destinationId
            originId
          }
        }
      }
      coaContractAssortmentsByCoaContractId {
        nodes {
          id
          assortmentId
          assortmentGroupId
          paymentUnit
        }
      }
      coaContractPortDataByCoaContractId {
        nodes {
          id
          portDataId
          portDatumByPortDataId {
            id
            portId
          }
        }
      }
    }
  }
  allVoyageCharters(filter: {id: {in: $voyageCharterIds}}) {
    nodes {
      id
      currency
      demurrage
      organisationId
      paymentTime
      paymentTrigger
      paymentType
      shipownerOrgId
      chartererOrgId
      vesselId
      voyageCharterPortDataByVoyageCharterId {
        nodes {
          id
          portDataId
        }
      }
      orderVoyageCharterRelationsByVoyageCharterId(condition: {outgoing: true}) {
        nodes {
          id
          orderId
          voyageCharterId
          outgoing
          voyageCharterOrderFreightsByOrderVoyageCharterRelationId {
            nodes {
              id
              orderVoyageCharterRelationId
            }
          }
        }
      }
      voyageCharterToContractsByVoyageCharterId {
        nodes {
          id
          coaId
          voyageCharterId
        }
      }
    }
  }
}
    `;

/**
 * __useVoyageCharterDataForCommitQuery__
 *
 * To run a query within a React component, call `useVoyageCharterDataForCommitQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterDataForCommitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterDataForCommitQuery({
 *   variables: {
 *      coaIds: // value for 'coaIds'
 *      voyageCharterIds: // value for 'voyageCharterIds'
 *   },
 * });
 */
export function useVoyageCharterDataForCommitQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyageCharterDataForCommitQuery, Types.VoyageCharterDataForCommitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterDataForCommitQuery, Types.VoyageCharterDataForCommitQueryVariables>(VoyageCharterDataForCommitDocument, options);
      }
export function useVoyageCharterDataForCommitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterDataForCommitQuery, Types.VoyageCharterDataForCommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterDataForCommitQuery, Types.VoyageCharterDataForCommitQueryVariables>(VoyageCharterDataForCommitDocument, options);
        }
export function useVoyageCharterDataForCommitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterDataForCommitQuery, Types.VoyageCharterDataForCommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterDataForCommitQuery, Types.VoyageCharterDataForCommitQueryVariables>(VoyageCharterDataForCommitDocument, options);
        }
export type VoyageCharterDataForCommitQueryHookResult = ReturnType<typeof useVoyageCharterDataForCommitQuery>;
export type VoyageCharterDataForCommitLazyQueryHookResult = ReturnType<typeof useVoyageCharterDataForCommitLazyQuery>;
export type VoyageCharterDataForCommitSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterDataForCommitSuspenseQuery>;
export type VoyageCharterDataForCommitQueryResult = Apollo.QueryResult<Types.VoyageCharterDataForCommitQuery, Types.VoyageCharterDataForCommitQueryVariables>;
export const SpotForVoyageCharterDocument = gql`
    query SpotForVoyageCharter($spotId: Int!) {
  voyageCharterById(id: $spotId) {
    id
    shipownerOrgId
    vesselId
    cancelling
    layday
    demurrage
    organisationId
    paymentTime
    paymentTrigger
    paymentType
    currency
    shipByVesselId {
      id
      name
    }
    organizationByShipownerOrgId {
      id
      name
    }
  }
}
    `;

/**
 * __useSpotForVoyageCharterQuery__
 *
 * To run a query within a React component, call `useSpotForVoyageCharterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotForVoyageCharterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotForVoyageCharterQuery({
 *   variables: {
 *      spotId: // value for 'spotId'
 *   },
 * });
 */
export function useSpotForVoyageCharterQuery(baseOptions: Apollo.QueryHookOptions<Types.SpotForVoyageCharterQuery, Types.SpotForVoyageCharterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SpotForVoyageCharterQuery, Types.SpotForVoyageCharterQueryVariables>(SpotForVoyageCharterDocument, options);
      }
export function useSpotForVoyageCharterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SpotForVoyageCharterQuery, Types.SpotForVoyageCharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SpotForVoyageCharterQuery, Types.SpotForVoyageCharterQueryVariables>(SpotForVoyageCharterDocument, options);
        }
export function useSpotForVoyageCharterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SpotForVoyageCharterQuery, Types.SpotForVoyageCharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SpotForVoyageCharterQuery, Types.SpotForVoyageCharterQueryVariables>(SpotForVoyageCharterDocument, options);
        }
export type SpotForVoyageCharterQueryHookResult = ReturnType<typeof useSpotForVoyageCharterQuery>;
export type SpotForVoyageCharterLazyQueryHookResult = ReturnType<typeof useSpotForVoyageCharterLazyQuery>;
export type SpotForVoyageCharterSuspenseQueryHookResult = ReturnType<typeof useSpotForVoyageCharterSuspenseQuery>;
export type SpotForVoyageCharterQueryResult = Apollo.QueryResult<Types.SpotForVoyageCharterQuery, Types.SpotForVoyageCharterQueryVariables>;
export const VoyageCharterFormDocument = gql`
    query VoyageCharterForm {
  ...BaseContractForm
  allCargoUnits {
    nodes {
      id
      ...VoyageCharterForm_CargoUnit
    }
  }
}
    ${BaseContractFormFragmentDoc}
${VoyageCharterForm_CargoUnitFragmentDoc}`;

/**
 * __useVoyageCharterFormQuery__
 *
 * To run a query within a React component, call `useVoyageCharterFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useVoyageCharterFormQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyageCharterFormQuery, Types.VoyageCharterFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterFormQuery, Types.VoyageCharterFormQueryVariables>(VoyageCharterFormDocument, options);
      }
export function useVoyageCharterFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterFormQuery, Types.VoyageCharterFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterFormQuery, Types.VoyageCharterFormQueryVariables>(VoyageCharterFormDocument, options);
        }
export function useVoyageCharterFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterFormQuery, Types.VoyageCharterFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterFormQuery, Types.VoyageCharterFormQueryVariables>(VoyageCharterFormDocument, options);
        }
export type VoyageCharterFormQueryHookResult = ReturnType<typeof useVoyageCharterFormQuery>;
export type VoyageCharterFormLazyQueryHookResult = ReturnType<typeof useVoyageCharterFormLazyQuery>;
export type VoyageCharterFormSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterFormSuspenseQuery>;
export type VoyageCharterFormQueryResult = Apollo.QueryResult<Types.VoyageCharterFormQuery, Types.VoyageCharterFormQueryVariables>;
export const VoyageCharterDocument = gql`
    query VoyageCharter($id: Int!) {
  voyageCharterById(id: $id) {
    id
    ...VoyageCharter_VoyageCharter
  }
}
    ${VoyageCharter_VoyageCharterFragmentDoc}`;

/**
 * __useVoyageCharterQuery__
 *
 * To run a query within a React component, call `useVoyageCharterQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVoyageCharterQuery(baseOptions: Apollo.QueryHookOptions<Types.VoyageCharterQuery, Types.VoyageCharterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterQuery, Types.VoyageCharterQueryVariables>(VoyageCharterDocument, options);
      }
export function useVoyageCharterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterQuery, Types.VoyageCharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterQuery, Types.VoyageCharterQueryVariables>(VoyageCharterDocument, options);
        }
export function useVoyageCharterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterQuery, Types.VoyageCharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterQuery, Types.VoyageCharterQueryVariables>(VoyageCharterDocument, options);
        }
export type VoyageCharterQueryHookResult = ReturnType<typeof useVoyageCharterQuery>;
export type VoyageCharterLazyQueryHookResult = ReturnType<typeof useVoyageCharterLazyQuery>;
export type VoyageCharterSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterSuspenseQuery>;
export type VoyageCharterQueryResult = Apollo.QueryResult<Types.VoyageCharterQuery, Types.VoyageCharterQueryVariables>;
export const VoyageChartersDocument = gql`
    query VoyageCharters($ids: [Int!]) {
  allVoyageCharters(filter: {id: {in: $ids}}) {
    nodes {
      id
      ...VoyageCharter_VoyageCharter
    }
  }
}
    ${VoyageCharter_VoyageCharterFragmentDoc}`;

/**
 * __useVoyageChartersQuery__
 *
 * To run a query within a React component, call `useVoyageChartersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageChartersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageChartersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVoyageChartersQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyageChartersQuery, Types.VoyageChartersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageChartersQuery, Types.VoyageChartersQueryVariables>(VoyageChartersDocument, options);
      }
export function useVoyageChartersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageChartersQuery, Types.VoyageChartersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageChartersQuery, Types.VoyageChartersQueryVariables>(VoyageChartersDocument, options);
        }
export function useVoyageChartersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageChartersQuery, Types.VoyageChartersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageChartersQuery, Types.VoyageChartersQueryVariables>(VoyageChartersDocument, options);
        }
export type VoyageChartersQueryHookResult = ReturnType<typeof useVoyageChartersQuery>;
export type VoyageChartersLazyQueryHookResult = ReturnType<typeof useVoyageChartersLazyQuery>;
export type VoyageChartersSuspenseQueryHookResult = ReturnType<typeof useVoyageChartersSuspenseQuery>;
export type VoyageChartersQueryResult = Apollo.QueryResult<Types.VoyageChartersQuery, Types.VoyageChartersQueryVariables>;
export const AllVoyageCharterUpdatesDocument = gql`
    query AllVoyageCharterUpdates {
  allVoyageCharterUpdates(filter: {accepted: {isNull: true}}) {
    nodes {
      id
      ...VoyageCharterUpdates_Update
    }
  }
}
    ${VoyageCharterUpdates_UpdateFragmentDoc}`;

/**
 * __useAllVoyageCharterUpdatesQuery__
 *
 * To run a query within a React component, call `useAllVoyageCharterUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVoyageCharterUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVoyageCharterUpdatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVoyageCharterUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllVoyageCharterUpdatesQuery, Types.AllVoyageCharterUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllVoyageCharterUpdatesQuery, Types.AllVoyageCharterUpdatesQueryVariables>(AllVoyageCharterUpdatesDocument, options);
      }
export function useAllVoyageCharterUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllVoyageCharterUpdatesQuery, Types.AllVoyageCharterUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllVoyageCharterUpdatesQuery, Types.AllVoyageCharterUpdatesQueryVariables>(AllVoyageCharterUpdatesDocument, options);
        }
export function useAllVoyageCharterUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllVoyageCharterUpdatesQuery, Types.AllVoyageCharterUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllVoyageCharterUpdatesQuery, Types.AllVoyageCharterUpdatesQueryVariables>(AllVoyageCharterUpdatesDocument, options);
        }
export type AllVoyageCharterUpdatesQueryHookResult = ReturnType<typeof useAllVoyageCharterUpdatesQuery>;
export type AllVoyageCharterUpdatesLazyQueryHookResult = ReturnType<typeof useAllVoyageCharterUpdatesLazyQuery>;
export type AllVoyageCharterUpdatesSuspenseQueryHookResult = ReturnType<typeof useAllVoyageCharterUpdatesSuspenseQuery>;
export type AllVoyageCharterUpdatesQueryResult = Apollo.QueryResult<Types.AllVoyageCharterUpdatesQuery, Types.AllVoyageCharterUpdatesQueryVariables>;
export const VoyageCharterUpdatesDocument = gql`
    query VoyageCharterUpdates($voyageCharterId: Int!) {
  allVoyageCharterUpdates(
    filter: {voyageCharterId: {equalTo: $voyageCharterId}, and: {accepted: {isNull: true}}}
  ) {
    nodes {
      id
      ...VoyageCharterUpdates_Update
    }
  }
}
    ${VoyageCharterUpdates_UpdateFragmentDoc}`;

/**
 * __useVoyageCharterUpdatesQuery__
 *
 * To run a query within a React component, call `useVoyageCharterUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterUpdatesQuery({
 *   variables: {
 *      voyageCharterId: // value for 'voyageCharterId'
 *   },
 * });
 */
export function useVoyageCharterUpdatesQuery(baseOptions: Apollo.QueryHookOptions<Types.VoyageCharterUpdatesQuery, Types.VoyageCharterUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterUpdatesQuery, Types.VoyageCharterUpdatesQueryVariables>(VoyageCharterUpdatesDocument, options);
      }
export function useVoyageCharterUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterUpdatesQuery, Types.VoyageCharterUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterUpdatesQuery, Types.VoyageCharterUpdatesQueryVariables>(VoyageCharterUpdatesDocument, options);
        }
export function useVoyageCharterUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterUpdatesQuery, Types.VoyageCharterUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterUpdatesQuery, Types.VoyageCharterUpdatesQueryVariables>(VoyageCharterUpdatesDocument, options);
        }
export type VoyageCharterUpdatesQueryHookResult = ReturnType<typeof useVoyageCharterUpdatesQuery>;
export type VoyageCharterUpdatesLazyQueryHookResult = ReturnType<typeof useVoyageCharterUpdatesLazyQuery>;
export type VoyageCharterUpdatesSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterUpdatesSuspenseQuery>;
export type VoyageCharterUpdatesQueryResult = Apollo.QueryResult<Types.VoyageCharterUpdatesQuery, Types.VoyageCharterUpdatesQueryVariables>;
export const VoyageCharterContractsDocument = gql`
    query VoyageCharterContracts($voyageCharterId: Int!) {
  allVoyageCharterToContracts(
    filter: {voyageCharterId: {equalTo: $voyageCharterId}}
  ) {
    nodes {
      id
      coaId
    }
  }
}
    `;

/**
 * __useVoyageCharterContractsQuery__
 *
 * To run a query within a React component, call `useVoyageCharterContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterContractsQuery({
 *   variables: {
 *      voyageCharterId: // value for 'voyageCharterId'
 *   },
 * });
 */
export function useVoyageCharterContractsQuery(baseOptions: Apollo.QueryHookOptions<Types.VoyageCharterContractsQuery, Types.VoyageCharterContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterContractsQuery, Types.VoyageCharterContractsQueryVariables>(VoyageCharterContractsDocument, options);
      }
export function useVoyageCharterContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterContractsQuery, Types.VoyageCharterContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterContractsQuery, Types.VoyageCharterContractsQueryVariables>(VoyageCharterContractsDocument, options);
        }
export function useVoyageCharterContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterContractsQuery, Types.VoyageCharterContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterContractsQuery, Types.VoyageCharterContractsQueryVariables>(VoyageCharterContractsDocument, options);
        }
export type VoyageCharterContractsQueryHookResult = ReturnType<typeof useVoyageCharterContractsQuery>;
export type VoyageCharterContractsLazyQueryHookResult = ReturnType<typeof useVoyageCharterContractsLazyQuery>;
export type VoyageCharterContractsSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterContractsSuspenseQuery>;
export type VoyageCharterContractsQueryResult = Apollo.QueryResult<Types.VoyageCharterContractsQuery, Types.VoyageCharterContractsQueryVariables>;
export const VoyageCharterUpdateFormDocument = gql`
    query VoyageCharterUpdateForm($shipownerOrgId: Int!, $includeCoaVessels: Boolean!, $coaId: Int) {
  allShips(filter: {organizationId: {equalTo: $shipownerOrgId}}) {
    nodes {
      id
      ...VesselChangeForm_Vessel
    }
  }
  allCoaContractShips(filter: {coaContractId: {equalTo: $coaId}}) @include(if: $includeCoaVessels) {
    nodes {
      id
      shipId
    }
  }
}
    ${VesselChangeForm_VesselFragmentDoc}`;

/**
 * __useVoyageCharterUpdateFormQuery__
 *
 * To run a query within a React component, call `useVoyageCharterUpdateFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterUpdateFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterUpdateFormQuery({
 *   variables: {
 *      shipownerOrgId: // value for 'shipownerOrgId'
 *      includeCoaVessels: // value for 'includeCoaVessels'
 *      coaId: // value for 'coaId'
 *   },
 * });
 */
export function useVoyageCharterUpdateFormQuery(baseOptions: Apollo.QueryHookOptions<Types.VoyageCharterUpdateFormQuery, Types.VoyageCharterUpdateFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterUpdateFormQuery, Types.VoyageCharterUpdateFormQueryVariables>(VoyageCharterUpdateFormDocument, options);
      }
export function useVoyageCharterUpdateFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterUpdateFormQuery, Types.VoyageCharterUpdateFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterUpdateFormQuery, Types.VoyageCharterUpdateFormQueryVariables>(VoyageCharterUpdateFormDocument, options);
        }
export function useVoyageCharterUpdateFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterUpdateFormQuery, Types.VoyageCharterUpdateFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterUpdateFormQuery, Types.VoyageCharterUpdateFormQueryVariables>(VoyageCharterUpdateFormDocument, options);
        }
export type VoyageCharterUpdateFormQueryHookResult = ReturnType<typeof useVoyageCharterUpdateFormQuery>;
export type VoyageCharterUpdateFormLazyQueryHookResult = ReturnType<typeof useVoyageCharterUpdateFormLazyQuery>;
export type VoyageCharterUpdateFormSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterUpdateFormSuspenseQuery>;
export type VoyageCharterUpdateFormQueryResult = Apollo.QueryResult<Types.VoyageCharterUpdateFormQuery, Types.VoyageCharterUpdateFormQueryVariables>;
export const VoyageCharterShipownerNonFinancialDocument = gql`
    query VoyageCharterShipownerNonFinancial($voyageCharterId: Int!) {
  allVwVoyageCharterShipownerNonfinancials(
    filter: {id: {equalTo: $voyageCharterId}}
  ) {
    nodes {
      id
      ...VoyageCharterUpdates_VoyageCharter
    }
  }
}
    ${VoyageCharterUpdates_VoyageCharterFragmentDoc}`;

/**
 * __useVoyageCharterShipownerNonFinancialQuery__
 *
 * To run a query within a React component, call `useVoyageCharterShipownerNonFinancialQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyageCharterShipownerNonFinancialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageCharterShipownerNonFinancialQuery({
 *   variables: {
 *      voyageCharterId: // value for 'voyageCharterId'
 *   },
 * });
 */
export function useVoyageCharterShipownerNonFinancialQuery(baseOptions: Apollo.QueryHookOptions<Types.VoyageCharterShipownerNonFinancialQuery, Types.VoyageCharterShipownerNonFinancialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyageCharterShipownerNonFinancialQuery, Types.VoyageCharterShipownerNonFinancialQueryVariables>(VoyageCharterShipownerNonFinancialDocument, options);
      }
export function useVoyageCharterShipownerNonFinancialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyageCharterShipownerNonFinancialQuery, Types.VoyageCharterShipownerNonFinancialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyageCharterShipownerNonFinancialQuery, Types.VoyageCharterShipownerNonFinancialQueryVariables>(VoyageCharterShipownerNonFinancialDocument, options);
        }
export function useVoyageCharterShipownerNonFinancialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyageCharterShipownerNonFinancialQuery, Types.VoyageCharterShipownerNonFinancialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyageCharterShipownerNonFinancialQuery, Types.VoyageCharterShipownerNonFinancialQueryVariables>(VoyageCharterShipownerNonFinancialDocument, options);
        }
export type VoyageCharterShipownerNonFinancialQueryHookResult = ReturnType<typeof useVoyageCharterShipownerNonFinancialQuery>;
export type VoyageCharterShipownerNonFinancialLazyQueryHookResult = ReturnType<typeof useVoyageCharterShipownerNonFinancialLazyQuery>;
export type VoyageCharterShipownerNonFinancialSuspenseQueryHookResult = ReturnType<typeof useVoyageCharterShipownerNonFinancialSuspenseQuery>;
export type VoyageCharterShipownerNonFinancialQueryResult = Apollo.QueryResult<Types.VoyageCharterShipownerNonFinancialQuery, Types.VoyageCharterShipownerNonFinancialQueryVariables>;
export const VoyagesTable_BillOfLadingsDocument = gql`
    query VoyagesTable_BillOfLadings($portCallIds: [Int!]) {
  allBillOfLadings(filter: {portCallId: {in: $portCallIds}}) {
    nodes {
      id
      ...BOLForm__BillOfLading
    }
  }
}
    ${BolForm__BillOfLadingFragmentDoc}`;

/**
 * __useVoyagesTable_BillOfLadingsQuery__
 *
 * To run a query within a React component, call `useVoyagesTable_BillOfLadingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyagesTable_BillOfLadingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyagesTable_BillOfLadingsQuery({
 *   variables: {
 *      portCallIds: // value for 'portCallIds'
 *   },
 * });
 */
export function useVoyagesTable_BillOfLadingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyagesTable_BillOfLadingsQuery, Types.VoyagesTable_BillOfLadingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyagesTable_BillOfLadingsQuery, Types.VoyagesTable_BillOfLadingsQueryVariables>(VoyagesTable_BillOfLadingsDocument, options);
      }
export function useVoyagesTable_BillOfLadingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyagesTable_BillOfLadingsQuery, Types.VoyagesTable_BillOfLadingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyagesTable_BillOfLadingsQuery, Types.VoyagesTable_BillOfLadingsQueryVariables>(VoyagesTable_BillOfLadingsDocument, options);
        }
export function useVoyagesTable_BillOfLadingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyagesTable_BillOfLadingsQuery, Types.VoyagesTable_BillOfLadingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyagesTable_BillOfLadingsQuery, Types.VoyagesTable_BillOfLadingsQueryVariables>(VoyagesTable_BillOfLadingsDocument, options);
        }
export type VoyagesTable_BillOfLadingsQueryHookResult = ReturnType<typeof useVoyagesTable_BillOfLadingsQuery>;
export type VoyagesTable_BillOfLadingsLazyQueryHookResult = ReturnType<typeof useVoyagesTable_BillOfLadingsLazyQuery>;
export type VoyagesTable_BillOfLadingsSuspenseQueryHookResult = ReturnType<typeof useVoyagesTable_BillOfLadingsSuspenseQuery>;
export type VoyagesTable_BillOfLadingsQueryResult = Apollo.QueryResult<Types.VoyagesTable_BillOfLadingsQuery, Types.VoyagesTable_BillOfLadingsQueryVariables>;
export const VoyagesTable_MeasurementReportsDocument = gql`
    query VoyagesTable_MeasurementReports($orderIds: [Int!]) {
  allCargoMeasurements(filter: {orderId: {in: $orderIds}}) {
    nodes {
      id
      ...MRForm_CargoMeasurement
    }
  }
}
    ${MrForm_CargoMeasurementFragmentDoc}`;

/**
 * __useVoyagesTable_MeasurementReportsQuery__
 *
 * To run a query within a React component, call `useVoyagesTable_MeasurementReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyagesTable_MeasurementReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyagesTable_MeasurementReportsQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useVoyagesTable_MeasurementReportsQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyagesTable_MeasurementReportsQuery, Types.VoyagesTable_MeasurementReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyagesTable_MeasurementReportsQuery, Types.VoyagesTable_MeasurementReportsQueryVariables>(VoyagesTable_MeasurementReportsDocument, options);
      }
export function useVoyagesTable_MeasurementReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyagesTable_MeasurementReportsQuery, Types.VoyagesTable_MeasurementReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyagesTable_MeasurementReportsQuery, Types.VoyagesTable_MeasurementReportsQueryVariables>(VoyagesTable_MeasurementReportsDocument, options);
        }
export function useVoyagesTable_MeasurementReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyagesTable_MeasurementReportsQuery, Types.VoyagesTable_MeasurementReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyagesTable_MeasurementReportsQuery, Types.VoyagesTable_MeasurementReportsQueryVariables>(VoyagesTable_MeasurementReportsDocument, options);
        }
export type VoyagesTable_MeasurementReportsQueryHookResult = ReturnType<typeof useVoyagesTable_MeasurementReportsQuery>;
export type VoyagesTable_MeasurementReportsLazyQueryHookResult = ReturnType<typeof useVoyagesTable_MeasurementReportsLazyQuery>;
export type VoyagesTable_MeasurementReportsSuspenseQueryHookResult = ReturnType<typeof useVoyagesTable_MeasurementReportsSuspenseQuery>;
export type VoyagesTable_MeasurementReportsQueryResult = Apollo.QueryResult<Types.VoyagesTable_MeasurementReportsQuery, Types.VoyagesTable_MeasurementReportsQueryVariables>;
export const VoyagesTable_DocumentsDocument = gql`
    query VoyagesTable_Documents($portCallIds: [Int!]) {
  allPortCallFiles(filter: {portCallId: {in: $portCallIds}}) {
    nodes {
      id
      portCallId
      fileByFileId {
        id
        type
        uri
      }
    }
  }
}
    `;

/**
 * __useVoyagesTable_DocumentsQuery__
 *
 * To run a query within a React component, call `useVoyagesTable_DocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoyagesTable_DocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyagesTable_DocumentsQuery({
 *   variables: {
 *      portCallIds: // value for 'portCallIds'
 *   },
 * });
 */
export function useVoyagesTable_DocumentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.VoyagesTable_DocumentsQuery, Types.VoyagesTable_DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VoyagesTable_DocumentsQuery, Types.VoyagesTable_DocumentsQueryVariables>(VoyagesTable_DocumentsDocument, options);
      }
export function useVoyagesTable_DocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VoyagesTable_DocumentsQuery, Types.VoyagesTable_DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VoyagesTable_DocumentsQuery, Types.VoyagesTable_DocumentsQueryVariables>(VoyagesTable_DocumentsDocument, options);
        }
export function useVoyagesTable_DocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VoyagesTable_DocumentsQuery, Types.VoyagesTable_DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VoyagesTable_DocumentsQuery, Types.VoyagesTable_DocumentsQueryVariables>(VoyagesTable_DocumentsDocument, options);
        }
export type VoyagesTable_DocumentsQueryHookResult = ReturnType<typeof useVoyagesTable_DocumentsQuery>;
export type VoyagesTable_DocumentsLazyQueryHookResult = ReturnType<typeof useVoyagesTable_DocumentsLazyQuery>;
export type VoyagesTable_DocumentsSuspenseQueryHookResult = ReturnType<typeof useVoyagesTable_DocumentsSuspenseQuery>;
export type VoyagesTable_DocumentsQueryResult = Apollo.QueryResult<Types.VoyagesTable_DocumentsQuery, Types.VoyagesTable_DocumentsQueryVariables>;
export const RouteByPortPairDocument = gql`
    query routeByPortPair($from: Int!, $to: Int!, $draft: BigFloat, $avoidsChannels: Boolean, $noGoZones: [Int]) {
  routeByPortPair(
    from: $from
    to: $to
    draft: $draft
    avoidsChannels: $avoidsChannels
    noGoZones: $noGoZones
  )
}
    `;

/**
 * __useRouteByPortPairQuery__
 *
 * To run a query within a React component, call `useRouteByPortPairQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteByPortPairQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteByPortPairQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      draft: // value for 'draft'
 *      avoidsChannels: // value for 'avoidsChannels'
 *      noGoZones: // value for 'noGoZones'
 *   },
 * });
 */
export function useRouteByPortPairQuery(baseOptions: Apollo.QueryHookOptions<Types.RouteByPortPairQuery, Types.RouteByPortPairQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RouteByPortPairQuery, Types.RouteByPortPairQueryVariables>(RouteByPortPairDocument, options);
      }
export function useRouteByPortPairLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RouteByPortPairQuery, Types.RouteByPortPairQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RouteByPortPairQuery, Types.RouteByPortPairQueryVariables>(RouteByPortPairDocument, options);
        }
export function useRouteByPortPairSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RouteByPortPairQuery, Types.RouteByPortPairQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RouteByPortPairQuery, Types.RouteByPortPairQueryVariables>(RouteByPortPairDocument, options);
        }
export type RouteByPortPairQueryHookResult = ReturnType<typeof useRouteByPortPairQuery>;
export type RouteByPortPairLazyQueryHookResult = ReturnType<typeof useRouteByPortPairLazyQuery>;
export type RouteByPortPairSuspenseQueryHookResult = ReturnType<typeof useRouteByPortPairSuspenseQuery>;
export type RouteByPortPairQueryResult = Apollo.QueryResult<Types.RouteByPortPairQuery, Types.RouteByPortPairQueryVariables>;
export const RouteByCoordinatesDocument = gql`
    query routeByCoordinates($fromLong: BigFloat!, $fromLat: BigFloat!, $toLong: BigFloat!, $toLat: BigFloat!, $draft: BigFloat!, $avoidsChannels: Boolean!, $usedNoGoZones: [Int]!) {
  routeByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZones(
    draft: $draft
    fromLong: $fromLong
    fromLat: $fromLat
    toLong: $toLong
    toLat: $toLat
    avoidsChannels: $avoidsChannels
    usedNoGoZones: $usedNoGoZones
  ) {
    id
    decomposed
  }
}
    `;

/**
 * __useRouteByCoordinatesQuery__
 *
 * To run a query within a React component, call `useRouteByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteByCoordinatesQuery({
 *   variables: {
 *      fromLong: // value for 'fromLong'
 *      fromLat: // value for 'fromLat'
 *      toLong: // value for 'toLong'
 *      toLat: // value for 'toLat'
 *      draft: // value for 'draft'
 *      avoidsChannels: // value for 'avoidsChannels'
 *      usedNoGoZones: // value for 'usedNoGoZones'
 *   },
 * });
 */
export function useRouteByCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<Types.RouteByCoordinatesQuery, Types.RouteByCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RouteByCoordinatesQuery, Types.RouteByCoordinatesQueryVariables>(RouteByCoordinatesDocument, options);
      }
export function useRouteByCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RouteByCoordinatesQuery, Types.RouteByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RouteByCoordinatesQuery, Types.RouteByCoordinatesQueryVariables>(RouteByCoordinatesDocument, options);
        }
export function useRouteByCoordinatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RouteByCoordinatesQuery, Types.RouteByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RouteByCoordinatesQuery, Types.RouteByCoordinatesQueryVariables>(RouteByCoordinatesDocument, options);
        }
export type RouteByCoordinatesQueryHookResult = ReturnType<typeof useRouteByCoordinatesQuery>;
export type RouteByCoordinatesLazyQueryHookResult = ReturnType<typeof useRouteByCoordinatesLazyQuery>;
export type RouteByCoordinatesSuspenseQueryHookResult = ReturnType<typeof useRouteByCoordinatesSuspenseQuery>;
export type RouteByCoordinatesQueryResult = Apollo.QueryResult<Types.RouteByCoordinatesQuery, Types.RouteByCoordinatesQueryVariables>;
export const RouteByDraftAndCoordinatesAndAvoidsChannelsDocument = gql`
    query routeByDraftAndCoordinatesAndAvoidsChannels($fromLong: BigFloat!, $fromLat: BigFloat!, $toLong: BigFloat!, $toLat: BigFloat!, $draft: BigFloat, $avoidsChannels: Boolean!, $noGoZones: [Int]) {
  routeByDraftAndCoordinatesAndAvoidsChannels(
    draft: $draft
    fromLong: $fromLong
    fromLat: $fromLat
    toLong: $toLong
    toLat: $toLat
    avoidsChannels: $avoidsChannels
    noGoZones: $noGoZones
  ) {
    id
    decomposed
  }
}
    `;

/**
 * __useRouteByDraftAndCoordinatesAndAvoidsChannelsQuery__
 *
 * To run a query within a React component, call `useRouteByDraftAndCoordinatesAndAvoidsChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteByDraftAndCoordinatesAndAvoidsChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteByDraftAndCoordinatesAndAvoidsChannelsQuery({
 *   variables: {
 *      fromLong: // value for 'fromLong'
 *      fromLat: // value for 'fromLat'
 *      toLong: // value for 'toLong'
 *      toLat: // value for 'toLat'
 *      draft: // value for 'draft'
 *      avoidsChannels: // value for 'avoidsChannels'
 *      noGoZones: // value for 'noGoZones'
 *   },
 * });
 */
export function useRouteByDraftAndCoordinatesAndAvoidsChannelsQuery(baseOptions: Apollo.QueryHookOptions<Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQuery, Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQuery, Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables>(RouteByDraftAndCoordinatesAndAvoidsChannelsDocument, options);
      }
export function useRouteByDraftAndCoordinatesAndAvoidsChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQuery, Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQuery, Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables>(RouteByDraftAndCoordinatesAndAvoidsChannelsDocument, options);
        }
export function useRouteByDraftAndCoordinatesAndAvoidsChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQuery, Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQuery, Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables>(RouteByDraftAndCoordinatesAndAvoidsChannelsDocument, options);
        }
export type RouteByDraftAndCoordinatesAndAvoidsChannelsQueryHookResult = ReturnType<typeof useRouteByDraftAndCoordinatesAndAvoidsChannelsQuery>;
export type RouteByDraftAndCoordinatesAndAvoidsChannelsLazyQueryHookResult = ReturnType<typeof useRouteByDraftAndCoordinatesAndAvoidsChannelsLazyQuery>;
export type RouteByDraftAndCoordinatesAndAvoidsChannelsSuspenseQueryHookResult = ReturnType<typeof useRouteByDraftAndCoordinatesAndAvoidsChannelsSuspenseQuery>;
export type RouteByDraftAndCoordinatesAndAvoidsChannelsQueryResult = Apollo.QueryResult<Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQuery, Types.RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables>;
export const BatchUpdateDocument = gql`
    subscription BatchUpdate($org: String!) {
  batchUpdate(topic: $org) {
    batchUpdate {
      id
      data
      __typename
    }
  }
}
    `;

/**
 * __useBatchUpdateSubscription__
 *
 * To run a query within a React component, call `useBatchUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchUpdateSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useBatchUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.BatchUpdateSubscription, Types.BatchUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.BatchUpdateSubscription, Types.BatchUpdateSubscriptionVariables>(BatchUpdateDocument, options);
      }
export type BatchUpdateSubscriptionHookResult = ReturnType<typeof useBatchUpdateSubscription>;
export type BatchUpdateSubscriptionResult = Apollo.SubscriptionResult<Types.BatchUpdateSubscription>;
export const CommitLogScenarioUpdatedDocument = gql`
    subscription CommitLogScenarioUpdated($org: String!) {
  commitLogScenarioUpdated(topic: $org) {
    event
  }
}
    `;

/**
 * __useCommitLogScenarioUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommitLogScenarioUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommitLogScenarioUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitLogScenarioUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useCommitLogScenarioUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.CommitLogScenarioUpdatedSubscription, Types.CommitLogScenarioUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.CommitLogScenarioUpdatedSubscription, Types.CommitLogScenarioUpdatedSubscriptionVariables>(CommitLogScenarioUpdatedDocument, options);
      }
export type CommitLogScenarioUpdatedSubscriptionHookResult = ReturnType<typeof useCommitLogScenarioUpdatedSubscription>;
export type CommitLogScenarioUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.CommitLogScenarioUpdatedSubscription>;
export const CommitLogUpdatedDocument = gql`
    subscription CommitLogUpdated($org: String!) {
  commitLogUpdated(topic: $org) {
    event
    commitLog {
      id
      input
      payload
      success
      committedAt
      committedBy
      ...LastCommit
    }
  }
}
    ${LastCommitFragmentDoc}`;

/**
 * __useCommitLogUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommitLogUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommitLogUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitLogUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useCommitLogUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.CommitLogUpdatedSubscription, Types.CommitLogUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.CommitLogUpdatedSubscription, Types.CommitLogUpdatedSubscriptionVariables>(CommitLogUpdatedDocument, options);
      }
export type CommitLogUpdatedSubscriptionHookResult = ReturnType<typeof useCommitLogUpdatedSubscription>;
export type CommitLogUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.CommitLogUpdatedSubscription>;
export const DbChangeDocument = gql`
    subscription DbChange($org: String!) {
  dbChange(topic: $org) {
    dbChange {
      id
      deletedBillOfLadingData
      deletedCargoCompartmentAllocation
      deletedCargoExclusion
      deletedCargoMeasurement
      deletedNotificationReceivers
      deletedOrderPortCallRelation
      deletedOrderVoyageCharterRelation
      softDeletedOrders
      __typename
    }
  }
}
    `;

/**
 * __useDbChangeSubscription__
 *
 * To run a query within a React component, call `useDbChangeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDbChangeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDbChangeSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useDbChangeSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.DbChangeSubscription, Types.DbChangeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.DbChangeSubscription, Types.DbChangeSubscriptionVariables>(DbChangeDocument, options);
      }
export type DbChangeSubscriptionHookResult = ReturnType<typeof useDbChangeSubscription>;
export type DbChangeSubscriptionResult = Apollo.SubscriptionResult<Types.DbChangeSubscription>;
export const OpenPositionUpdatedDocument = gql`
    subscription OpenPositionUpdated($org: String!) {
  openPositionUpdated(topic: $org) {
    event
    openPosition {
      id
      ...OpenPositions
    }
  }
}
    ${OpenPositionsFragmentDoc}`;

/**
 * __useOpenPositionUpdatedSubscription__
 *
 * To run a query within a React component, call `useOpenPositionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOpenPositionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenPositionUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useOpenPositionUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.OpenPositionUpdatedSubscription, Types.OpenPositionUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.OpenPositionUpdatedSubscription, Types.OpenPositionUpdatedSubscriptionVariables>(OpenPositionUpdatedDocument, options);
      }
export type OpenPositionUpdatedSubscriptionHookResult = ReturnType<typeof useOpenPositionUpdatedSubscription>;
export type OpenPositionUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.OpenPositionUpdatedSubscription>;
export const PlanningDataUpdatedDocument = gql`
    subscription PlanningDataUpdated($org: String!) {
  planningDataUpdated(topic: $org) {
    event
    order {
      id
      ...PlanningOrderUpdate
    }
  }
}
    ${PlanningOrderUpdateFragmentDoc}`;

/**
 * __usePlanningDataUpdatedSubscription__
 *
 * To run a query within a React component, call `usePlanningDataUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlanningDataUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningDataUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function usePlanningDataUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.PlanningDataUpdatedSubscription, Types.PlanningDataUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.PlanningDataUpdatedSubscription, Types.PlanningDataUpdatedSubscriptionVariables>(PlanningDataUpdatedDocument, options);
      }
export type PlanningDataUpdatedSubscriptionHookResult = ReturnType<typeof usePlanningDataUpdatedSubscription>;
export type PlanningDataUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.PlanningDataUpdatedSubscription>;
export const LocationUpdatedDocument = gql`
    subscription LocationUpdated($org: String!) {
  locationUpdated(topic: $org) {
    event
    location {
      id
      ...ScenarioTimeline_OrderLocation
    }
  }
}
    ${ScenarioTimeline_OrderLocationFragmentDoc}`;

/**
 * __useLocationUpdatedSubscription__
 *
 * To run a query within a React component, call `useLocationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLocationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useLocationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.LocationUpdatedSubscription, Types.LocationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.LocationUpdatedSubscription, Types.LocationUpdatedSubscriptionVariables>(LocationUpdatedDocument, options);
      }
export type LocationUpdatedSubscriptionHookResult = ReturnType<typeof useLocationUpdatedSubscription>;
export type LocationUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.LocationUpdatedSubscription>;
export const OrganizationUpdatedDocument = gql`
    subscription OrganizationUpdated($org: String!) {
  organizationUpdated(topic: $org) {
    event
    organization {
      id
      ...ScenarioTimeline_Organization
    }
  }
}
    ${ScenarioTimeline_OrganizationFragmentDoc}`;

/**
 * __useOrganizationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOrganizationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useOrganizationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.OrganizationUpdatedSubscription, Types.OrganizationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.OrganizationUpdatedSubscription, Types.OrganizationUpdatedSubscriptionVariables>(OrganizationUpdatedDocument, options);
      }
export type OrganizationUpdatedSubscriptionHookResult = ReturnType<typeof useOrganizationUpdatedSubscription>;
export type OrganizationUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.OrganizationUpdatedSubscription>;
export const AssortmentUpdatedDocument = gql`
    subscription AssortmentUpdated($org: String!) {
  assortmentUpdated(topic: $org) {
    event
    assortment {
      id
      ...ScenarioTimeline_Assortment
    }
  }
}
    ${ScenarioTimeline_AssortmentFragmentDoc}`;

/**
 * __useAssortmentUpdatedSubscription__
 *
 * To run a query within a React component, call `useAssortmentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssortmentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssortmentUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useAssortmentUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.AssortmentUpdatedSubscription, Types.AssortmentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.AssortmentUpdatedSubscription, Types.AssortmentUpdatedSubscriptionVariables>(AssortmentUpdatedDocument, options);
      }
export type AssortmentUpdatedSubscriptionHookResult = ReturnType<typeof useAssortmentUpdatedSubscription>;
export type AssortmentUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.AssortmentUpdatedSubscription>;
export const ShipsUpdatedDocument = gql`
    subscription ShipsUpdated($org: String!) {
  shipUpdated(topic: $org) {
    event
    ship {
      id
      ...ScenarioTimeline_Ship
    }
  }
}
    ${ScenarioTimeline_ShipFragmentDoc}`;

/**
 * __useShipsUpdatedSubscription__
 *
 * To run a query within a React component, call `useShipsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipsUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useShipsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ShipsUpdatedSubscription, Types.ShipsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ShipsUpdatedSubscription, Types.ShipsUpdatedSubscriptionVariables>(ShipsUpdatedDocument, options);
      }
export type ShipsUpdatedSubscriptionHookResult = ReturnType<typeof useShipsUpdatedSubscription>;
export type ShipsUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ShipsUpdatedSubscription>;
export const VoyageAttributeUpdatedDocument = gql`
    subscription VoyageAttributeUpdated($org: String!) {
  voyageAttributeUpdated(topic: $org) {
    event
    voyageAttribute {
      id
      ...VoyageAttribute_Admin
    }
  }
}
    ${VoyageAttribute_AdminFragmentDoc}`;

/**
 * __useVoyageAttributeUpdatedSubscription__
 *
 * To run a query within a React component, call `useVoyageAttributeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVoyageAttributeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoyageAttributeUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useVoyageAttributeUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.VoyageAttributeUpdatedSubscription, Types.VoyageAttributeUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.VoyageAttributeUpdatedSubscription, Types.VoyageAttributeUpdatedSubscriptionVariables>(VoyageAttributeUpdatedDocument, options);
      }
export type VoyageAttributeUpdatedSubscriptionHookResult = ReturnType<typeof useVoyageAttributeUpdatedSubscription>;
export type VoyageAttributeUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.VoyageAttributeUpdatedSubscription>;
export const ShipmentUpdatedDocument = gql`
    subscription ShipmentUpdated($org: String!) {
  shipmentUpdated(topic: $org) {
    event
    shipment {
      id
      ...ScenarioTimeline_Shipment
    }
  }
}
    ${ScenarioTimeline_ShipmentFragmentDoc}`;

/**
 * __useShipmentUpdatedSubscription__
 *
 * To run a query within a React component, call `useShipmentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useShipmentUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ShipmentUpdatedSubscription, Types.ShipmentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ShipmentUpdatedSubscription, Types.ShipmentUpdatedSubscriptionVariables>(ShipmentUpdatedDocument, options);
      }
export type ShipmentUpdatedSubscriptionHookResult = ReturnType<typeof useShipmentUpdatedSubscription>;
export type ShipmentUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ShipmentUpdatedSubscription>;
export const PortCostDefaultUpdatedDocument = gql`
    subscription PortCostDefaultUpdated($org: String!) {
  portCostDefaultUpdated(topic: $org) {
    event
    portCostDefault {
      id
      ...PortCostDefault_fields
    }
  }
}
    ${PortCostDefault_FieldsFragmentDoc}`;

/**
 * __usePortCostDefaultUpdatedSubscription__
 *
 * To run a query within a React component, call `usePortCostDefaultUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePortCostDefaultUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortCostDefaultUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function usePortCostDefaultUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.PortCostDefaultUpdatedSubscription, Types.PortCostDefaultUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.PortCostDefaultUpdatedSubscription, Types.PortCostDefaultUpdatedSubscriptionVariables>(PortCostDefaultUpdatedDocument, options);
      }
export type PortCostDefaultUpdatedSubscriptionHookResult = ReturnType<typeof usePortCostDefaultUpdatedSubscription>;
export type PortCostDefaultUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.PortCostDefaultUpdatedSubscription>;
export const RobTaskUpdateDocument = gql`
    subscription RobTaskUpdate($org: String!) {
  robTaskUpdated(topic: $org) {
    bunker {
      remainingBunkerOfVoyages {
        id
        voyage
        bunkerOpen {
          price
          amount
          name
        }
        bunkerClose {
          price
          amount
          name
        }
      }
      defaultBunkerOfVessels {
        id
        vessel_code
        bunker {
          price
          name
        }
      }
      errorMessage
    }
  }
}
    `;

/**
 * __useRobTaskUpdateSubscription__
 *
 * To run a query within a React component, call `useRobTaskUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRobTaskUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRobTaskUpdateSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useRobTaskUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.RobTaskUpdateSubscription, Types.RobTaskUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.RobTaskUpdateSubscription, Types.RobTaskUpdateSubscriptionVariables>(RobTaskUpdateDocument, options);
      }
export type RobTaskUpdateSubscriptionHookResult = ReturnType<typeof useRobTaskUpdateSubscription>;
export type RobTaskUpdateSubscriptionResult = Apollo.SubscriptionResult<Types.RobTaskUpdateSubscription>;
export const RouteOverrideUpdatedDocument = gql`
    subscription RouteOverrideUpdated($org: String!) {
  routeOverrideUpdated(topic: $org) {
    event
    routeOverride {
      id
      fromId
      toId
      distance
      avoidsChannels
    }
  }
}
    `;

/**
 * __useRouteOverrideUpdatedSubscription__
 *
 * To run a query within a React component, call `useRouteOverrideUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRouteOverrideUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteOverrideUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useRouteOverrideUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.RouteOverrideUpdatedSubscription, Types.RouteOverrideUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.RouteOverrideUpdatedSubscription, Types.RouteOverrideUpdatedSubscriptionVariables>(RouteOverrideUpdatedDocument, options);
      }
export type RouteOverrideUpdatedSubscriptionHookResult = ReturnType<typeof useRouteOverrideUpdatedSubscription>;
export type RouteOverrideUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.RouteOverrideUpdatedSubscription>;
export const ScenarioUpdatedDocument = gql`
    subscription ScenarioUpdated($org: String!) {
  scenarioUpdated(topic: $org) {
    event
    scenario {
      id
      ...Scenarios_Scenario
    }
  }
}
    ${Scenarios_ScenarioFragmentDoc}`;

/**
 * __useScenarioUpdatedSubscription__
 *
 * To run a query within a React component, call `useScenarioUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useScenarioUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useScenarioUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ScenarioUpdatedSubscription, Types.ScenarioUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ScenarioUpdatedSubscription, Types.ScenarioUpdatedSubscriptionVariables>(ScenarioUpdatedDocument, options);
      }
export type ScenarioUpdatedSubscriptionHookResult = ReturnType<typeof useScenarioUpdatedSubscription>;
export type ScenarioUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ScenarioUpdatedSubscription>;
export const ScenariosListDocument = gql`
    query ScenariosList {
  allScenarios {
    nodes {
      id
      clientId
      createdBy
    }
  }
}
    `;

/**
 * __useScenariosListQuery__
 *
 * To run a query within a React component, call `useScenariosListQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenariosListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenariosListQuery({
 *   variables: {
 *   },
 * });
 */
export function useScenariosListQuery(baseOptions?: Apollo.QueryHookOptions<Types.ScenariosListQuery, Types.ScenariosListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ScenariosListQuery, Types.ScenariosListQueryVariables>(ScenariosListDocument, options);
      }
export function useScenariosListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ScenariosListQuery, Types.ScenariosListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ScenariosListQuery, Types.ScenariosListQueryVariables>(ScenariosListDocument, options);
        }
export function useScenariosListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ScenariosListQuery, Types.ScenariosListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ScenariosListQuery, Types.ScenariosListQueryVariables>(ScenariosListDocument, options);
        }
export type ScenariosListQueryHookResult = ReturnType<typeof useScenariosListQuery>;
export type ScenariosListLazyQueryHookResult = ReturnType<typeof useScenariosListLazyQuery>;
export type ScenariosListSuspenseQueryHookResult = ReturnType<typeof useScenariosListSuspenseQuery>;
export type ScenariosListQueryResult = Apollo.QueryResult<Types.ScenariosListQuery, Types.ScenariosListQueryVariables>;
export const ShipUpdatedDocument = gql`
    subscription ShipUpdated($org: String!) {
  shipUpdated(topic: $org) {
    event
    ship {
      id
      ...Ship_Admin
    }
  }
}
    ${Ship_AdminFragmentDoc}`;

/**
 * __useShipUpdatedSubscription__
 *
 * To run a query within a React component, call `useShipUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useShipUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ShipUpdatedSubscription, Types.ShipUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ShipUpdatedSubscription, Types.ShipUpdatedSubscriptionVariables>(ShipUpdatedDocument, options);
      }
export type ShipUpdatedSubscriptionHookResult = ReturnType<typeof useShipUpdatedSubscription>;
export type ShipUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ShipUpdatedSubscription>;
export const ShipVoyageNamingRuleRelationUpdatedDocument = gql`
    subscription shipVoyageNamingRuleRelationUpdated($org: String!) {
  shipVoyageNamingRuleRelationUpdated(topic: $org) {
    event
    shipVoyageNamingRuleRelation {
      id
      shipId
      ruleId
      voyageNamingRuleByRuleId {
        id
        ...VoyageNamingRule_Admin
      }
    }
  }
}
    ${VoyageNamingRule_AdminFragmentDoc}`;

/**
 * __useShipVoyageNamingRuleRelationUpdatedSubscription__
 *
 * To run a query within a React component, call `useShipVoyageNamingRuleRelationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipVoyageNamingRuleRelationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipVoyageNamingRuleRelationUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useShipVoyageNamingRuleRelationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ShipVoyageNamingRuleRelationUpdatedSubscription, Types.ShipVoyageNamingRuleRelationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ShipVoyageNamingRuleRelationUpdatedSubscription, Types.ShipVoyageNamingRuleRelationUpdatedSubscriptionVariables>(ShipVoyageNamingRuleRelationUpdatedDocument, options);
      }
export type ShipVoyageNamingRuleRelationUpdatedSubscriptionHookResult = ReturnType<typeof useShipVoyageNamingRuleRelationUpdatedSubscription>;
export type ShipVoyageNamingRuleRelationUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ShipVoyageNamingRuleRelationUpdatedSubscription>;
export const TransactionalCommitDocument = gql`
    subscription TransactionalCommit($org: String!) {
  transactionalCommit(topic: $org) {
    event
    userId
  }
}
    `;

/**
 * __useTransactionalCommitSubscription__
 *
 * To run a query within a React component, call `useTransactionalCommitSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTransactionalCommitSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionalCommitSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useTransactionalCommitSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.TransactionalCommitSubscription, Types.TransactionalCommitSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.TransactionalCommitSubscription, Types.TransactionalCommitSubscriptionVariables>(TransactionalCommitDocument, options);
      }
export type TransactionalCommitSubscriptionHookResult = ReturnType<typeof useTransactionalCommitSubscription>;
export type TransactionalCommitSubscriptionResult = Apollo.SubscriptionResult<Types.TransactionalCommitSubscription>;
export const VesselReservationUpdatedDocument = gql`
    subscription VesselReservationUpdated($org: String!) {
  vesselReservationUpdated(topic: $org) {
    event
    vesselReservation {
      id
      ...VesselReservation
    }
  }
}
    ${VesselReservationFragmentDoc}`;

/**
 * __useVesselReservationUpdatedSubscription__
 *
 * To run a query within a React component, call `useVesselReservationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVesselReservationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVesselReservationUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useVesselReservationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.VesselReservationUpdatedSubscription, Types.VesselReservationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.VesselReservationUpdatedSubscription, Types.VesselReservationUpdatedSubscriptionVariables>(VesselReservationUpdatedDocument, options);
      }
export type VesselReservationUpdatedSubscriptionHookResult = ReturnType<typeof useVesselReservationUpdatedSubscription>;
export type VesselReservationUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.VesselReservationUpdatedSubscription>;
export const ExtraFreightUpdatedDocument = gql`
    subscription ExtraFreightUpdated($org: String!) {
  voyageCharterExtraFreightUpdated(topic: $org) {
    event
    extraFreight {
      id
      voyageCharterId
      ...SpotForm_ExtraFreight
    }
  }
}
    ${SpotForm_ExtraFreightFragmentDoc}`;

/**
 * __useExtraFreightUpdatedSubscription__
 *
 * To run a query within a React component, call `useExtraFreightUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExtraFreightUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtraFreightUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useExtraFreightUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ExtraFreightUpdatedSubscription, Types.ExtraFreightUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ExtraFreightUpdatedSubscription, Types.ExtraFreightUpdatedSubscriptionVariables>(ExtraFreightUpdatedDocument, options);
      }
export type ExtraFreightUpdatedSubscriptionHookResult = ReturnType<typeof useExtraFreightUpdatedSubscription>;
export type ExtraFreightUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ExtraFreightUpdatedSubscription>;
export const WorldscaleFreightUpdatedDocument = gql`
    subscription WorldscaleFreightUpdated($org: String!) {
  worldscaleFreightUpdated(topic: $org) {
    event
    worldscaleFreight {
      id
      ...WorldscaleFreight_Admin
    }
  }
}
    ${WorldscaleFreight_AdminFragmentDoc}`;

/**
 * __useWorldscaleFreightUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorldscaleFreightUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorldscaleFreightUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorldscaleFreightUpdatedSubscription({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useWorldscaleFreightUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.WorldscaleFreightUpdatedSubscription, Types.WorldscaleFreightUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.WorldscaleFreightUpdatedSubscription, Types.WorldscaleFreightUpdatedSubscriptionVariables>(WorldscaleFreightUpdatedDocument, options);
      }
export type WorldscaleFreightUpdatedSubscriptionHookResult = ReturnType<typeof useWorldscaleFreightUpdatedSubscription>;
export type WorldscaleFreightUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.WorldscaleFreightUpdatedSubscription>;